/*!
 * enquire.min.js
 */
/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!(function (e, t, n) {
  var i = window.matchMedia;
  "undefined" != typeof module && module.exports
    ? (module.exports = n(i))
    : "function" == typeof define && define.amd
    ? define(function () {
        return (t[e] = n(i));
      })
    : (t[e] = n(i));
})("enquire", this, function (e) {
  "use strict";
  function t(e, t) {
    var n,
      i = 0,
      o = e.length;
    for (i; o > i && ((n = t(e[i], i)), n !== !1); i++);
  }
  function n(e) {
    return "[object Array]" === Object.prototype.toString.apply(e);
  }
  function i(e) {
    return "function" == typeof e;
  }
  function o(e) {
    (this.options = e), !e.deferSetup && this.setup();
  }
  function r(t, n) {
    (this.query = t),
      (this.isUnconditional = n),
      (this.handlers = []),
      (this.mql = e(t));
    var i = this;
    (this.listener = function (e) {
      (i.mql = e), i.assess();
    }),
      this.mql.addListener(this.listener);
  }
  function s() {
    if (!e)
      throw new Error(
        "matchMedia not present, legacy browsers require a polyfill"
      );
    (this.queries = {}), (this.browserIsIncapable = !e("only all").matches);
  }
  return (
    (o.prototype = {
      setup: function () {
        this.options.setup && this.options.setup(), (this.initialised = !0);
      },
      on: function () {
        !this.initialised && this.setup(),
          this.options.match && this.options.match();
      },
      off: function () {
        this.options.unmatch && this.options.unmatch();
      },
      destroy: function () {
        this.options.destroy ? this.options.destroy() : this.off();
      },
      equals: function (e) {
        return this.options === e || this.options.match === e;
      },
    }),
    (r.prototype = {
      addHandler: function (e) {
        var t = new o(e);
        this.handlers.push(t), this.matches() && t.on();
      },
      removeHandler: function (e) {
        var n = this.handlers;
        t(n, function (t, i) {
          return t.equals(e) ? (t.destroy(), !n.splice(i, 1)) : void 0;
        });
      },
      matches: function () {
        return this.mql.matches || this.isUnconditional;
      },
      clear: function () {
        t(this.handlers, function (e) {
          e.destroy();
        }),
          this.mql.removeListener(this.listener),
          (this.handlers.length = 0);
      },
      assess: function () {
        var e = this.matches() ? "on" : "off";
        t(this.handlers, function (t) {
          t[e]();
        });
      },
    }),
    (s.prototype = {
      register: function (e, o, s) {
        var a = this.queries,
          l = s && this.browserIsIncapable;
        return (
          a[e] || (a[e] = new r(e, l)),
          i(o) && (o = { match: o }),
          n(o) || (o = [o]),
          t(o, function (t) {
            i(t) && (t = { match: t }), a[e].addHandler(t);
          }),
          this
        );
      },
      unregister: function (e, t) {
        var n = this.queries[e];
        return (
          n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])),
          this
        );
      },
    }),
    new s()
  );
})
/*!
 * jquery.min.js
 */,
  /*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
  !(function (e, t) {
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e.document
          ? t(e, !0)
          : function (e) {
              if (!e.document)
                throw new Error("jQuery requires a window with a document");
              return t(e);
            })
      : t(e);
  })("undefined" != typeof window ? window : this, function (e, t) {
    function n(e) {
      var t = !!e && "length" in e && e.length,
        n = re.type(e);
      return (
        "function" !== n &&
        !re.isWindow(e) &&
        ("array" === n ||
          0 === t ||
          ("number" == typeof t && t > 0 && t - 1 in e))
      );
    }
    function i(e, t, n) {
      if (re.isFunction(t))
        return re.grep(e, function (e, i) {
          return !!t.call(e, i, e) !== n;
        });
      if (t.nodeType)
        return re.grep(e, function (e) {
          return (e === t) !== n;
        });
      if ("string" == typeof t) {
        if (ve.test(t)) return re.filter(t, e, n);
        t = re.filter(t, e);
      }
      return re.grep(e, function (e) {
        return K.call(t, e) > -1 !== n;
      });
    }
    function o(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType; );
      return e;
    }
    function r(e) {
      var t = {};
      return (
        re.each(e.match(xe) || [], function (e, n) {
          t[n] = !0;
        }),
        t
      );
    }
    function s() {
      G.removeEventListener("DOMContentLoaded", s),
        e.removeEventListener("load", s),
        re.ready();
    }
    function a() {
      this.expando = re.expando + a.uid++;
    }
    function l(e, t, n) {
      var i;
      if (void 0 === n && 1 === e.nodeType)
        if (
          ((i = "data-" + t.replace(Ae, "-$&").toLowerCase()),
          (n = e.getAttribute(i)),
          "string" == typeof n)
        ) {
          try {
            n =
              "true" === n ||
              ("false" !== n &&
                ("null" === n
                  ? null
                  : +n + "" === n
                  ? +n
                  : Ee.test(n)
                  ? re.parseJSON(n)
                  : n));
          } catch (e) {}
          $e.set(e, t, n);
        } else n = void 0;
      return n;
    }
    function u(e, t, n, i) {
      var o,
        r = 1,
        s = 20,
        a = i
          ? function () {
              return i.cur();
            }
          : function () {
              return re.css(e, t, "");
            },
        l = a(),
        u = (n && n[3]) || (re.cssNumber[t] ? "" : "px"),
        c = (re.cssNumber[t] || ("px" !== u && +l)) && Ne.exec(re.css(e, t));
      if (c && c[3] !== u) {
        (u = u || c[3]), (n = n || []), (c = +l || 1);
        do (r = r || ".5"), (c /= r), re.style(e, t, c + u);
        while (r !== (r = a() / l) && 1 !== r && --s);
      }
      return (
        n &&
          ((c = +c || +l || 0),
          (o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
          i && ((i.unit = u), (i.start = c), (i.end = o))),
        o
      );
    }
    function c(e, t) {
      var n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : [];
      return void 0 === t || (t && re.nodeName(e, t)) ? re.merge([e], n) : n;
    }
    function d(e, t) {
      for (var n = 0, i = e.length; i > n; n++)
        Ce.set(e[n], "globalEval", !t || Ce.get(t[n], "globalEval"));
    }
    function p(e, t, n, i, o) {
      for (
        var r,
          s,
          a,
          l,
          u,
          p,
          f = t.createDocumentFragment(),
          h = [],
          v = 0,
          g = e.length;
        g > v;
        v++
      )
        if (((r = e[v]), r || 0 === r))
          if ("object" === re.type(r)) re.merge(h, r.nodeType ? [r] : r);
          else if (_e.test(r)) {
            for (
              s = s || f.appendChild(t.createElement("div")),
                a = (qe.exec(r) || ["", ""])[1].toLowerCase(),
                l = Le[a] || Le._default,
                s.innerHTML = l[1] + re.htmlPrefilter(r) + l[2],
                p = l[0];
              p--;

            )
              s = s.lastChild;
            re.merge(h, s.childNodes), (s = f.firstChild), (s.textContent = "");
          } else h.push(t.createTextNode(r));
      for (f.textContent = "", v = 0; (r = h[v++]); )
        if (i && re.inArray(r, i) > -1) o && o.push(r);
        else if (
          ((u = re.contains(r.ownerDocument, r)),
          (s = c(f.appendChild(r), "script")),
          u && d(s),
          n)
        )
          for (p = 0; (r = s[p++]); ) Pe.test(r.type || "") && n.push(r);
      return f;
    }
    function f() {
      return !0;
    }
    function h() {
      return !1;
    }
    function v() {
      try {
        return G.activeElement;
      } catch (e) {}
    }
    function g(e, t, n, i, o, r) {
      var s, a;
      if ("object" == typeof t) {
        "string" != typeof n && ((i = i || n), (n = void 0));
        for (a in t) g(e, a, n, i, t[a], r);
        return e;
      }
      if (
        (null == i && null == o
          ? ((o = n), (i = n = void 0))
          : null == o &&
            ("string" == typeof n
              ? ((o = i), (i = void 0))
              : ((o = i), (i = n), (n = void 0))),
        o === !1)
      )
        o = h;
      else if (!o) return e;
      return (
        1 === r &&
          ((s = o),
          (o = function (e) {
            return re().off(e), s.apply(this, arguments);
          }),
          (o.guid = s.guid || (s.guid = re.guid++))),
        e.each(function () {
          re.event.add(this, t, o, i, n);
        })
      );
    }
    function m(e, t) {
      return re.nodeName(e, "table") &&
        re.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr")
        ? e.getElementsByTagName("tbody")[0] ||
            e.appendChild(e.ownerDocument.createElement("tbody"))
        : e;
    }
    function y(e) {
      return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function b(e) {
      var t = Be.exec(e.type);
      return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
    }
    function w(e, t) {
      var n, i, o, r, s, a, l, u;
      if (1 === t.nodeType) {
        if (
          Ce.hasData(e) &&
          ((r = Ce.access(e)), (s = Ce.set(t, r)), (u = r.events))
        ) {
          delete s.handle, (s.events = {});
          for (o in u)
            for (n = 0, i = u[o].length; i > n; n++)
              re.event.add(t, o, u[o][n]);
        }
        $e.hasData(e) &&
          ((a = $e.access(e)), (l = re.extend({}, a)), $e.set(t, l));
      }
    }
    function x(e, t) {
      var n = t.nodeName.toLowerCase();
      "input" === n && He.test(e.type)
        ? (t.checked = e.checked)
        : ("input" !== n && "textarea" !== n) ||
          (t.defaultValue = e.defaultValue);
    }
    function k(e, t, n, i) {
      t = J.apply([], t);
      var o,
        r,
        s,
        a,
        l,
        u,
        d = 0,
        f = e.length,
        h = f - 1,
        v = t[0],
        g = re.isFunction(v);
      if (g || (f > 1 && "string" == typeof v && !ie.checkClone && We.test(v)))
        return e.each(function (o) {
          var r = e.eq(o);
          g && (t[0] = v.call(this, o, r.html())), k(r, t, n, i);
        });
      if (
        f &&
        ((o = p(t, e[0].ownerDocument, !1, e, i)),
        (r = o.firstChild),
        1 === o.childNodes.length && (o = r),
        r || i)
      ) {
        for (s = re.map(c(o, "script"), y), a = s.length; f > d; d++)
          (l = o),
            d !== h &&
              ((l = re.clone(l, !0, !0)), a && re.merge(s, c(l, "script"))),
            n.call(e[d], l, d);
        if (a)
          for (
            u = s[s.length - 1].ownerDocument, re.map(s, b), d = 0;
            a > d;
            d++
          )
            (l = s[d]),
              Pe.test(l.type || "") &&
                !Ce.access(l, "globalEval") &&
                re.contains(u, l) &&
                (l.src
                  ? re._evalUrl && re._evalUrl(l.src)
                  : re.globalEval(l.textContent.replace(Ue, "")));
      }
      return e;
    }
    function T(e, t, n) {
      for (var i, o = t ? re.filter(t, e) : e, r = 0; null != (i = o[r]); r++)
        n || 1 !== i.nodeType || re.cleanData(c(i)),
          i.parentNode &&
            (n && re.contains(i.ownerDocument, i) && d(c(i, "script")),
            i.parentNode.removeChild(i));
      return e;
    }
    function S(e, t) {
      var n = re(t.createElement(e)).appendTo(t.body),
        i = re.css(n[0], "display");
      return n.detach(), i;
    }
    function C(e) {
      var t = G,
        n = Ye[e];
      return (
        n ||
          ((n = S(e, t)),
          ("none" !== n && n) ||
            ((Xe = (
              Xe || re("<iframe frameborder='0' width='0' height='0'/>")
            ).appendTo(t.documentElement)),
            (t = Xe[0].contentDocument),
            t.write(),
            t.close(),
            (n = S(e, t)),
            Xe.detach()),
          (Ye[e] = n)),
        n
      );
    }
    function $(e, t, n) {
      var i,
        o,
        r,
        s,
        a = e.style;
      return (
        (n = n || Qe(e)),
        (s = n ? n.getPropertyValue(t) || n[t] : void 0),
        ("" !== s && void 0 !== s) ||
          re.contains(e.ownerDocument, e) ||
          (s = re.style(e, t)),
        n &&
          !ie.pixelMarginRight() &&
          Ge.test(s) &&
          Ve.test(t) &&
          ((i = a.width),
          (o = a.minWidth),
          (r = a.maxWidth),
          (a.minWidth = a.maxWidth = a.width = s),
          (s = n.width),
          (a.width = i),
          (a.minWidth = o),
          (a.maxWidth = r)),
        void 0 !== s ? s + "" : s
      );
    }
    function E(e, t) {
      return {
        get: function () {
          return e()
            ? void delete this.get
            : (this.get = t).apply(this, arguments);
        },
      };
    }
    function A(e) {
      if (e in it) return e;
      for (var t = e[0].toUpperCase() + e.slice(1), n = nt.length; n--; )
        if (((e = nt[n] + t), e in it)) return e;
    }
    function j(e, t, n) {
      var i = Ne.exec(t);
      return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
    }
    function N(e, t, n, i, o) {
      for (
        var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0,
          s = 0;
        4 > r;
        r += 2
      )
        "margin" === n && (s += re.css(e, n + De[r], !0, o)),
          i
            ? ("content" === n && (s -= re.css(e, "padding" + De[r], !0, o)),
              "margin" !== n &&
                (s -= re.css(e, "border" + De[r] + "Width", !0, o)))
            : ((s += re.css(e, "padding" + De[r], !0, o)),
              "padding" !== n &&
                (s += re.css(e, "border" + De[r] + "Width", !0, o)));
      return s;
    }
    function D(t, n, i) {
      var o = !0,
        r = "width" === n ? t.offsetWidth : t.offsetHeight,
        s = Qe(t),
        a = "border-box" === re.css(t, "boxSizing", !1, s);
      if (
        (G.msFullscreenElement &&
          e.top !== e &&
          t.getClientRects().length &&
          (r = Math.round(100 * t.getBoundingClientRect()[n])),
        0 >= r || null == r)
      ) {
        if (
          ((r = $(t, n, s)),
          (0 > r || null == r) && (r = t.style[n]),
          Ge.test(r))
        )
          return r;
        (o = a && (ie.boxSizingReliable() || r === t.style[n])),
          (r = parseFloat(r) || 0);
      }
      return r + N(t, n, i || (a ? "border" : "content"), o, s) + "px";
    }
    function O(e, t) {
      for (var n, i, o, r = [], s = 0, a = e.length; a > s; s++)
        (i = e[s]),
          i.style &&
            ((r[s] = Ce.get(i, "olddisplay")),
            (n = i.style.display),
            t
              ? (r[s] || "none" !== n || (i.style.display = ""),
                "" === i.style.display &&
                  Oe(i) &&
                  (r[s] = Ce.access(i, "olddisplay", C(i.nodeName))))
              : ((o = Oe(i)),
                ("none" === n && o) ||
                  Ce.set(i, "olddisplay", o ? n : re.css(i, "display"))));
      for (s = 0; a > s; s++)
        (i = e[s]),
          i.style &&
            ((t && "none" !== i.style.display && "" !== i.style.display) ||
              (i.style.display = t ? r[s] || "" : "none"));
      return e;
    }
    function H(e, t, n, i, o) {
      return new H.prototype.init(e, t, n, i, o);
    }
    function q() {
      return (
        e.setTimeout(function () {
          ot = void 0;
        }),
        (ot = re.now())
      );
    }
    function P(e, t) {
      var n,
        i = 0,
        o = { height: e };
      for (t = t ? 1 : 0; 4 > i; i += 2 - t)
        (n = De[i]), (o["margin" + n] = o["padding" + n] = e);
      return t && (o.opacity = o.width = e), o;
    }
    function L(e, t, n) {
      for (
        var i,
          o = (I.tweeners[t] || []).concat(I.tweeners["*"]),
          r = 0,
          s = o.length;
        s > r;
        r++
      )
        if ((i = o[r].call(n, t, e))) return i;
    }
    function _(e, t, n) {
      var i,
        o,
        r,
        s,
        a,
        l,
        u,
        c,
        d = this,
        p = {},
        f = e.style,
        h = e.nodeType && Oe(e),
        v = Ce.get(e, "fxshow");
      n.queue ||
        ((a = re._queueHooks(e, "fx")),
        null == a.unqueued &&
          ((a.unqueued = 0),
          (l = a.empty.fire),
          (a.empty.fire = function () {
            a.unqueued || l();
          })),
        a.unqueued++,
        d.always(function () {
          d.always(function () {
            a.unqueued--, re.queue(e, "fx").length || a.empty.fire();
          });
        })),
        1 === e.nodeType &&
          ("height" in t || "width" in t) &&
          ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
          (u = re.css(e, "display")),
          (c = "none" === u ? Ce.get(e, "olddisplay") || C(e.nodeName) : u),
          "inline" === c &&
            "none" === re.css(e, "float") &&
            (f.display = "inline-block")),
        n.overflow &&
          ((f.overflow = "hidden"),
          d.always(function () {
            (f.overflow = n.overflow[0]),
              (f.overflowX = n.overflow[1]),
              (f.overflowY = n.overflow[2]);
          }));
      for (i in t)
        if (((o = t[i]), st.exec(o))) {
          if (
            (delete t[i],
            (r = r || "toggle" === o),
            o === (h ? "hide" : "show"))
          ) {
            if ("show" !== o || !v || void 0 === v[i]) continue;
            h = !0;
          }
          p[i] = (v && v[i]) || re.style(e, i);
        } else u = void 0;
      if (re.isEmptyObject(p))
        "inline" === ("none" === u ? C(e.nodeName) : u) && (f.display = u);
      else {
        v ? "hidden" in v && (h = v.hidden) : (v = Ce.access(e, "fxshow", {})),
          r && (v.hidden = !h),
          h
            ? re(e).show()
            : d.done(function () {
                re(e).hide();
              }),
          d.done(function () {
            var t;
            Ce.remove(e, "fxshow");
            for (t in p) re.style(e, t, p[t]);
          });
        for (i in p)
          (s = L(h ? v[i] : 0, i, d)),
            i in v ||
              ((v[i] = s.start),
              h &&
                ((s.end = s.start),
                (s.start = "width" === i || "height" === i ? 1 : 0)));
      }
    }
    function z(e, t) {
      var n, i, o, r, s;
      for (n in e)
        if (
          ((i = re.camelCase(n)),
          (o = t[i]),
          (r = e[n]),
          re.isArray(r) && ((o = r[1]), (r = e[n] = r[0])),
          n !== i && ((e[i] = r), delete e[n]),
          (s = re.cssHooks[i]),
          s && "expand" in s)
        ) {
          (r = s.expand(r)), delete e[i];
          for (n in r) n in e || ((e[n] = r[n]), (t[n] = o));
        } else t[i] = o;
    }
    function I(e, t, n) {
      var i,
        o,
        r = 0,
        s = I.prefilters.length,
        a = re.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (o) return !1;
          for (
            var t = ot || q(),
              n = Math.max(0, u.startTime + u.duration - t),
              i = n / u.duration || 0,
              r = 1 - i,
              s = 0,
              l = u.tweens.length;
            l > s;
            s++
          )
            u.tweens[s].run(r);
          return (
            a.notifyWith(e, [u, r, n]),
            1 > r && l ? n : (a.resolveWith(e, [u]), !1)
          );
        },
        u = a.promise({
          elem: e,
          props: re.extend({}, t),
          opts: re.extend(
            !0,
            { specialEasing: {}, easing: re.easing._default },
            n
          ),
          originalProperties: t,
          originalOptions: n,
          startTime: ot || q(),
          duration: n.duration,
          tweens: [],
          createTween: function (t, n) {
            var i = re.Tween(
              e,
              u.opts,
              t,
              n,
              u.opts.specialEasing[t] || u.opts.easing
            );
            return u.tweens.push(i), i;
          },
          stop: function (t) {
            var n = 0,
              i = t ? u.tweens.length : 0;
            if (o) return this;
            for (o = !0; i > n; n++) u.tweens[n].run(1);
            return (
              t
                ? (a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u, t]))
                : a.rejectWith(e, [u, t]),
              this
            );
          },
        }),
        c = u.props;
      for (z(c, u.opts.specialEasing); s > r; r++)
        if ((i = I.prefilters[r].call(u, e, c, u.opts)))
          return (
            re.isFunction(i.stop) &&
              (re._queueHooks(u.elem, u.opts.queue).stop = re.proxy(i.stop, i)),
            i
          );
      return (
        re.map(c, L, u),
        re.isFunction(u.opts.start) && u.opts.start.call(e, u),
        re.fx.timer(re.extend(l, { elem: e, anim: u, queue: u.opts.queue })),
        u
          .progress(u.opts.progress)
          .done(u.opts.done, u.opts.complete)
          .fail(u.opts.fail)
          .always(u.opts.always)
      );
    }
    function F(e) {
      return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function M(e) {
      return function (t, n) {
        "string" != typeof t && ((n = t), (t = "*"));
        var i,
          o = 0,
          r = t.toLowerCase().match(xe) || [];
        if (re.isFunction(n))
          for (; (i = r[o++]); )
            "+" === i[0]
              ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
              : (e[i] = e[i] || []).push(n);
      };
    }
    function R(e, t, n, i) {
      function o(a) {
        var l;
        return (
          (r[a] = !0),
          re.each(e[a] || [], function (e, a) {
            var u = a(t, n, i);
            return "string" != typeof u || s || r[u]
              ? s
                ? !(l = u)
                : void 0
              : (t.dataTypes.unshift(u), o(u), !1);
          }),
          l
        );
      }
      var r = {},
        s = e === $t;
      return o(t.dataTypes[0]) || (!r["*"] && o("*"));
    }
    function W(e, t) {
      var n,
        i,
        o = re.ajaxSettings.flatOptions || {};
      for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
      return i && re.extend(!0, e, i), e;
    }
    function B(e, t, n) {
      for (var i, o, r, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
        l.shift(),
          void 0 === i &&
            (i = e.mimeType || t.getResponseHeader("Content-Type"));
      if (i)
        for (o in a)
          if (a[o] && a[o].test(i)) {
            l.unshift(o);
            break;
          }
      if (l[0] in n) r = l[0];
      else {
        for (o in n) {
          if (!l[0] || e.converters[o + " " + l[0]]) {
            r = o;
            break;
          }
          s || (s = o);
        }
        r = r || s;
      }
      return r ? (r !== l[0] && l.unshift(r), n[r]) : void 0;
    }
    function U(e, t, n, i) {
      var o,
        r,
        s,
        a,
        l,
        u = {},
        c = e.dataTypes.slice();
      if (c[1]) for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
      for (r = c.shift(); r; )
        if (
          (e.responseFields[r] && (n[e.responseFields[r]] = t),
          !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
          (l = r),
          (r = c.shift()))
        )
          if ("*" === r) r = l;
          else if ("*" !== l && l !== r) {
            if (((s = u[l + " " + r] || u["* " + r]), !s))
              for (o in u)
                if (
                  ((a = o.split(" ")),
                  a[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]]))
                ) {
                  s === !0
                    ? (s = u[o])
                    : u[o] !== !0 && ((r = a[0]), c.unshift(a[1]));
                  break;
                }
            if (s !== !0)
              if (s && e.throws) t = s(t);
              else
                try {
                  t = s(t);
                } catch (e) {
                  return {
                    state: "parsererror",
                    error: s ? e : "No conversion from " + l + " to " + r,
                  };
                }
          }
      return { state: "success", data: t };
    }
    function X(e, t, n, i) {
      var o;
      if (re.isArray(t))
        re.each(t, function (t, o) {
          n || Nt.test(e)
            ? i(e, o)
            : X(
                e + "[" + ("object" == typeof o && null != o ? t : "") + "]",
                o,
                n,
                i
              );
        });
      else if (n || "object" !== re.type(t)) i(e, t);
      else for (o in t) X(e + "[" + o + "]", t[o], n, i);
    }
    function Y(e) {
      return re.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
    }
    var V = [],
      G = e.document,
      Q = V.slice,
      J = V.concat,
      Z = V.push,
      K = V.indexOf,
      ee = {},
      te = ee.toString,
      ne = ee.hasOwnProperty,
      ie = {},
      oe = "2.2.3",
      re = function (e, t) {
        return new re.fn.init(e, t);
      },
      se = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      ae = /^-ms-/,
      le = /-([\da-z])/gi,
      ue = function (e, t) {
        return t.toUpperCase();
      };
    (re.fn = re.prototype =
      {
        jquery: oe,
        constructor: re,
        selector: "",
        length: 0,
        toArray: function () {
          return Q.call(this);
        },
        get: function (e) {
          return null != e
            ? 0 > e
              ? this[e + this.length]
              : this[e]
            : Q.call(this);
        },
        pushStack: function (e) {
          var t = re.merge(this.constructor(), e);
          return (t.prevObject = this), (t.context = this.context), t;
        },
        each: function (e) {
          return re.each(this, e);
        },
        map: function (e) {
          return this.pushStack(
            re.map(this, function (t, n) {
              return e.call(t, n, t);
            })
          );
        },
        slice: function () {
          return this.pushStack(Q.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (e) {
          var t = this.length,
            n = +e + (0 > e ? t : 0);
          return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: Z,
        sort: V.sort,
        splice: V.splice,
      }),
      (re.extend = re.fn.extend =
        function () {
          var e,
            t,
            n,
            i,
            o,
            r,
            s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            u = !1;
          for (
            "boolean" == typeof s && ((u = s), (s = arguments[a] || {}), a++),
              "object" == typeof s || re.isFunction(s) || (s = {}),
              a === l && ((s = this), a--);
            l > a;
            a++
          )
            if (null != (e = arguments[a]))
              for (t in e)
                (n = s[t]),
                  (i = e[t]),
                  s !== i &&
                    (u && i && (re.isPlainObject(i) || (o = re.isArray(i)))
                      ? (o
                          ? ((o = !1), (r = n && re.isArray(n) ? n : []))
                          : (r = n && re.isPlainObject(n) ? n : {}),
                        (s[t] = re.extend(u, r, i)))
                      : void 0 !== i && (s[t] = i));
          return s;
        }),
      re.extend({
        expando: "jQuery" + (oe + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (e) {
          throw new Error(e);
        },
        noop: function () {},
        isFunction: function (e) {
          return "function" === re.type(e);
        },
        isArray: Array.isArray,
        isWindow: function (e) {
          return null != e && e === e.window;
        },
        isNumeric: function (e) {
          var t = e && e.toString();
          return !re.isArray(e) && t - parseFloat(t) + 1 >= 0;
        },
        isPlainObject: function (e) {
          var t;
          if ("object" !== re.type(e) || e.nodeType || re.isWindow(e))
            return !1;
          if (
            e.constructor &&
            !ne.call(e, "constructor") &&
            !ne.call(e.constructor.prototype || {}, "isPrototypeOf")
          )
            return !1;
          for (t in e);
          return void 0 === t || ne.call(e, t);
        },
        isEmptyObject: function (e) {
          var t;
          for (t in e) return !1;
          return !0;
        },
        type: function (e) {
          return null == e
            ? e + ""
            : "object" == typeof e || "function" == typeof e
            ? ee[te.call(e)] || "object"
            : typeof e;
        },
        globalEval: function (e) {
          var t,
            n = eval;
          (e = re.trim(e)),
            e &&
              (1 === e.indexOf("use strict")
                ? ((t = G.createElement("script")),
                  (t.text = e),
                  G.head.appendChild(t).parentNode.removeChild(t))
                : n(e));
        },
        camelCase: function (e) {
          return e.replace(ae, "ms-").replace(le, ue);
        },
        nodeName: function (e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        },
        each: function (e, t) {
          var i,
            o = 0;
          if (n(e))
            for (i = e.length; i > o && t.call(e[o], o, e[o]) !== !1; o++);
          else for (o in e) if (t.call(e[o], o, e[o]) === !1) break;
          return e;
        },
        trim: function (e) {
          return null == e ? "" : (e + "").replace(se, "");
        },
        makeArray: function (e, t) {
          var i = t || [];
          return (
            null != e &&
              (n(Object(e))
                ? re.merge(i, "string" == typeof e ? [e] : e)
                : Z.call(i, e)),
            i
          );
        },
        inArray: function (e, t, n) {
          return null == t ? -1 : K.call(t, e, n);
        },
        merge: function (e, t) {
          for (var n = +t.length, i = 0, o = e.length; n > i; i++)
            e[o++] = t[i];
          return (e.length = o), e;
        },
        grep: function (e, t, n) {
          for (var i, o = [], r = 0, s = e.length, a = !n; s > r; r++)
            (i = !t(e[r], r)), i !== a && o.push(e[r]);
          return o;
        },
        map: function (e, t, i) {
          var o,
            r,
            s = 0,
            a = [];
          if (n(e))
            for (o = e.length; o > s; s++)
              (r = t(e[s], s, i)), null != r && a.push(r);
          else for (s in e) (r = t(e[s], s, i)), null != r && a.push(r);
          return J.apply([], a);
        },
        guid: 1,
        proxy: function (e, t) {
          var n, i, o;
          return (
            "string" == typeof t && ((n = e[t]), (t = e), (e = n)),
            re.isFunction(e)
              ? ((i = Q.call(arguments, 2)),
                (o = function () {
                  return e.apply(t || this, i.concat(Q.call(arguments)));
                }),
                (o.guid = e.guid = e.guid || re.guid++),
                o)
              : void 0
          );
        },
        now: Date.now,
        support: ie,
      }),
      "function" == typeof Symbol &&
        (re.fn[Symbol.iterator] = V[Symbol.iterator]),
      re.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (e, t) {
          ee["[object " + t + "]"] = t.toLowerCase();
        }
      );
    var ce = (function (e) {
      function t(e, t, n, i) {
        var o,
          r,
          s,
          a,
          l,
          u,
          d,
          f,
          h = t && t.ownerDocument,
          v = t ? t.nodeType : 9;
        if (
          ((n = n || []),
          "string" != typeof e || !e || (1 !== v && 9 !== v && 11 !== v))
        )
          return n;
        if (
          !i &&
          ((t ? t.ownerDocument || t : F) !== O && D(t), (t = t || O), q)
        ) {
          if (11 !== v && (u = me.exec(e)))
            if ((o = u[1])) {
              if (9 === v) {
                if (!(s = t.getElementById(o))) return n;
                if (s.id === o) return n.push(s), n;
              } else if (
                h &&
                (s = h.getElementById(o)) &&
                z(t, s) &&
                s.id === o
              )
                return n.push(s), n;
            } else {
              if (u[2]) return Z.apply(n, t.getElementsByTagName(e)), n;
              if (
                (o = u[3]) &&
                x.getElementsByClassName &&
                t.getElementsByClassName
              )
                return Z.apply(n, t.getElementsByClassName(o)), n;
            }
          if (x.qsa && !U[e + " "] && (!P || !P.test(e))) {
            if (1 !== v) (h = t), (f = e);
            else if ("object" !== t.nodeName.toLowerCase()) {
              for (
                (a = t.getAttribute("id"))
                  ? (a = a.replace(be, "\\$&"))
                  : t.setAttribute("id", (a = I)),
                  d = C(e),
                  r = d.length,
                  l = pe.test(a) ? "#" + a : "[id='" + a + "']";
                r--;

              )
                d[r] = l + " " + p(d[r]);
              (f = d.join(",")), (h = (ye.test(e) && c(t.parentNode)) || t);
            }
            if (f)
              try {
                return Z.apply(n, h.querySelectorAll(f)), n;
              } catch (e) {
              } finally {
                a === I && t.removeAttribute("id");
              }
          }
        }
        return E(e.replace(ae, "$1"), t, n, i);
      }
      function n() {
        function e(n, i) {
          return (
            t.push(n + " ") > k.cacheLength && delete e[t.shift()],
            (e[n + " "] = i)
          );
        }
        var t = [];
        return e;
      }
      function i(e) {
        return (e[I] = !0), e;
      }
      function o(e) {
        var t = O.createElement("div");
        try {
          return !!e(t);
        } catch (e) {
          return !1;
        } finally {
          t.parentNode && t.parentNode.removeChild(t), (t = null);
        }
      }
      function r(e, t) {
        for (var n = e.split("|"), i = n.length; i--; ) k.attrHandle[n[i]] = t;
      }
      function s(e, t) {
        var n = t && e,
          i =
            n &&
            1 === e.nodeType &&
            1 === t.nodeType &&
            (~t.sourceIndex || Y) - (~e.sourceIndex || Y);
        if (i) return i;
        if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
        return e ? 1 : -1;
      }
      function a(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return "input" === n && t.type === e;
        };
      }
      function l(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return ("input" === n || "button" === n) && t.type === e;
        };
      }
      function u(e) {
        return i(function (t) {
          return (
            (t = +t),
            i(function (n, i) {
              for (var o, r = e([], n.length, t), s = r.length; s--; )
                n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
            })
          );
        });
      }
      function c(e) {
        return e && "undefined" != typeof e.getElementsByTagName && e;
      }
      function d() {}
      function p(e) {
        for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
        return i;
      }
      function f(e, t, n) {
        var i = t.dir,
          o = n && "parentNode" === i,
          r = R++;
        return t.first
          ? function (t, n, r) {
              for (; (t = t[i]); ) if (1 === t.nodeType || o) return e(t, n, r);
            }
          : function (t, n, s) {
              var a,
                l,
                u,
                c = [M, r];
              if (s) {
                for (; (t = t[i]); )
                  if ((1 === t.nodeType || o) && e(t, n, s)) return !0;
              } else
                for (; (t = t[i]); )
                  if (1 === t.nodeType || o) {
                    if (
                      ((u = t[I] || (t[I] = {})),
                      (l = u[t.uniqueID] || (u[t.uniqueID] = {})),
                      (a = l[i]) && a[0] === M && a[1] === r)
                    )
                      return (c[2] = a[2]);
                    if (((l[i] = c), (c[2] = e(t, n, s)))) return !0;
                  }
            };
      }
      function h(e) {
        return e.length > 1
          ? function (t, n, i) {
              for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
              return !0;
            }
          : e[0];
      }
      function v(e, n, i) {
        for (var o = 0, r = n.length; r > o; o++) t(e, n[o], i);
        return i;
      }
      function g(e, t, n, i, o) {
        for (var r, s = [], a = 0, l = e.length, u = null != t; l > a; a++)
          (r = e[a]) && ((n && !n(r, i, o)) || (s.push(r), u && t.push(a)));
        return s;
      }
      function m(e, t, n, o, r, s) {
        return (
          o && !o[I] && (o = m(o)),
          r && !r[I] && (r = m(r, s)),
          i(function (i, s, a, l) {
            var u,
              c,
              d,
              p = [],
              f = [],
              h = s.length,
              m = i || v(t || "*", a.nodeType ? [a] : a, []),
              y = !e || (!i && t) ? m : g(m, p, e, a, l),
              b = n ? (r || (i ? e : h || o) ? [] : s) : y;
            if ((n && n(y, b, a, l), o))
              for (u = g(b, f), o(u, [], a, l), c = u.length; c--; )
                (d = u[c]) && (b[f[c]] = !(y[f[c]] = d));
            if (i) {
              if (r || e) {
                if (r) {
                  for (u = [], c = b.length; c--; )
                    (d = b[c]) && u.push((y[c] = d));
                  r(null, (b = []), u, l);
                }
                for (c = b.length; c--; )
                  (d = b[c]) &&
                    (u = r ? ee(i, d) : p[c]) > -1 &&
                    (i[u] = !(s[u] = d));
              }
            } else (b = g(b === s ? b.splice(h, b.length) : b)), r ? r(null, s, b, l) : Z.apply(s, b);
          })
        );
      }
      function y(e) {
        for (
          var t,
            n,
            i,
            o = e.length,
            r = k.relative[e[0].type],
            s = r || k.relative[" "],
            a = r ? 1 : 0,
            l = f(
              function (e) {
                return e === t;
              },
              s,
              !0
            ),
            u = f(
              function (e) {
                return ee(t, e) > -1;
              },
              s,
              !0
            ),
            c = [
              function (e, n, i) {
                var o =
                  (!r && (i || n !== A)) ||
                  ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
                return (t = null), o;
              },
            ];
          o > a;
          a++
        )
          if ((n = k.relative[e[a].type])) c = [f(h(c), n)];
          else {
            if (((n = k.filter[e[a].type].apply(null, e[a].matches)), n[I])) {
              for (i = ++a; o > i && !k.relative[e[i].type]; i++);
              return m(
                a > 1 && h(c),
                a > 1 &&
                  p(
                    e
                      .slice(0, a - 1)
                      .concat({ value: " " === e[a - 2].type ? "*" : "" })
                  ).replace(ae, "$1"),
                n,
                i > a && y(e.slice(a, i)),
                o > i && y((e = e.slice(i))),
                o > i && p(e)
              );
            }
            c.push(n);
          }
        return h(c);
      }
      function b(e, n) {
        var o = n.length > 0,
          r = e.length > 0,
          s = function (i, s, a, l, u) {
            var c,
              d,
              p,
              f = 0,
              h = "0",
              v = i && [],
              m = [],
              y = A,
              b = i || (r && k.find.TAG("*", u)),
              w = (M += null == y ? 1 : Math.random() || 0.1),
              x = b.length;
            for (
              u && (A = s === O || s || u);
              h !== x && null != (c = b[h]);
              h++
            ) {
              if (r && c) {
                for (
                  d = 0, s || c.ownerDocument === O || (D(c), (a = !q));
                  (p = e[d++]);

                )
                  if (p(c, s || O, a)) {
                    l.push(c);
                    break;
                  }
                u && (M = w);
              }
              o && ((c = !p && c) && f--, i && v.push(c));
            }
            if (((f += h), o && h !== f)) {
              for (d = 0; (p = n[d++]); ) p(v, m, s, a);
              if (i) {
                if (f > 0) for (; h--; ) v[h] || m[h] || (m[h] = Q.call(l));
                m = g(m);
              }
              Z.apply(l, m),
                u && !i && m.length > 0 && f + n.length > 1 && t.uniqueSort(l);
            }
            return u && ((M = w), (A = y)), v;
          };
        return o ? i(s) : s;
      }
      var w,
        x,
        k,
        T,
        S,
        C,
        $,
        E,
        A,
        j,
        N,
        D,
        O,
        H,
        q,
        P,
        L,
        _,
        z,
        I = "sizzle" + 1 * new Date(),
        F = e.document,
        M = 0,
        R = 0,
        W = n(),
        B = n(),
        U = n(),
        X = function (e, t) {
          return e === t && (N = !0), 0;
        },
        Y = 1 << 31,
        V = {}.hasOwnProperty,
        G = [],
        Q = G.pop,
        J = G.push,
        Z = G.push,
        K = G.slice,
        ee = function (e, t) {
          for (var n = 0, i = e.length; i > n; n++) if (e[n] === t) return n;
          return -1;
        },
        te =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        ne = "[\\x20\\t\\r\\n\\f]",
        ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        oe =
          "\\[" +
          ne +
          "*(" +
          ie +
          ")(?:" +
          ne +
          "*([*^$|!~]?=)" +
          ne +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          ie +
          "))|)" +
          ne +
          "*\\]",
        re =
          ":(" +
          ie +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          oe +
          ")*)|.*)\\)|)",
        se = new RegExp(ne + "+", "g"),
        ae = new RegExp(
          "^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$",
          "g"
        ),
        le = new RegExp("^" + ne + "*," + ne + "*"),
        ue = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
        ce = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
        de = new RegExp(re),
        pe = new RegExp("^" + ie + "$"),
        fe = {
          ID: new RegExp("^#(" + ie + ")"),
          CLASS: new RegExp("^\\.(" + ie + ")"),
          TAG: new RegExp("^(" + ie + "|[*])"),
          ATTR: new RegExp("^" + oe),
          PSEUDO: new RegExp("^" + re),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              ne +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              ne +
              "*(?:([+-]|)" +
              ne +
              "*(\\d+)|))" +
              ne +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + te + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              ne +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              ne +
              "*((?:-\\d)?\\d*)" +
              ne +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        he = /^(?:input|select|textarea|button)$/i,
        ve = /^h\d$/i,
        ge = /^[^{]+\{\s*\[native \w/,
        me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ye = /[+~]/,
        be = /'|\\/g,
        we = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
        xe = function (e, t, n) {
          var i = "0x" + t - 65536;
          return i !== i || n
            ? t
            : 0 > i
            ? String.fromCharCode(i + 65536)
            : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
        },
        ke = function () {
          D();
        };
      try {
        Z.apply((G = K.call(F.childNodes)), F.childNodes),
          G[F.childNodes.length].nodeType;
      } catch (e) {
        Z = {
          apply: G.length
            ? function (e, t) {
                J.apply(e, K.call(t));
              }
            : function (e, t) {
                for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                e.length = n - 1;
              },
        };
      }
      (x = t.support = {}),
        (S = t.isXML =
          function (e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName;
          }),
        (D = t.setDocument =
          function (e) {
            var t,
              n,
              i = e ? e.ownerDocument || e : F;
            return i !== O && 9 === i.nodeType && i.documentElement
              ? ((O = i),
                (H = O.documentElement),
                (q = !S(O)),
                (n = O.defaultView) &&
                  n.top !== n &&
                  (n.addEventListener
                    ? n.addEventListener("unload", ke, !1)
                    : n.attachEvent && n.attachEvent("onunload", ke)),
                (x.attributes = o(function (e) {
                  return (e.className = "i"), !e.getAttribute("className");
                })),
                (x.getElementsByTagName = o(function (e) {
                  return (
                    e.appendChild(O.createComment("")),
                    !e.getElementsByTagName("*").length
                  );
                })),
                (x.getElementsByClassName = ge.test(O.getElementsByClassName)),
                (x.getById = o(function (e) {
                  return (
                    (H.appendChild(e).id = I),
                    !O.getElementsByName || !O.getElementsByName(I).length
                  );
                })),
                x.getById
                  ? ((k.find.ID = function (e, t) {
                      if ("undefined" != typeof t.getElementById && q) {
                        var n = t.getElementById(e);
                        return n ? [n] : [];
                      }
                    }),
                    (k.filter.ID = function (e) {
                      var t = e.replace(we, xe);
                      return function (e) {
                        return e.getAttribute("id") === t;
                      };
                    }))
                  : (delete k.find.ID,
                    (k.filter.ID = function (e) {
                      var t = e.replace(we, xe);
                      return function (e) {
                        var n =
                          "undefined" != typeof e.getAttributeNode &&
                          e.getAttributeNode("id");
                        return n && n.value === t;
                      };
                    })),
                (k.find.TAG = x.getElementsByTagName
                  ? function (e, t) {
                      return "undefined" != typeof t.getElementsByTagName
                        ? t.getElementsByTagName(e)
                        : x.qsa
                        ? t.querySelectorAll(e)
                        : void 0;
                    }
                  : function (e, t) {
                      var n,
                        i = [],
                        o = 0,
                        r = t.getElementsByTagName(e);
                      if ("*" === e) {
                        for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                        return i;
                      }
                      return r;
                    }),
                (k.find.CLASS =
                  x.getElementsByClassName &&
                  function (e, t) {
                    return "undefined" != typeof t.getElementsByClassName && q
                      ? t.getElementsByClassName(e)
                      : void 0;
                  }),
                (L = []),
                (P = []),
                (x.qsa = ge.test(O.querySelectorAll)) &&
                  (o(function (e) {
                    (H.appendChild(e).innerHTML =
                      "<a id='" +
                      I +
                      "'></a><select id='" +
                      I +
                      "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                      e.querySelectorAll("[msallowcapture^='']").length &&
                        P.push("[*^$]=" + ne + "*(?:''|\"\")"),
                      e.querySelectorAll("[selected]").length ||
                        P.push("\\[" + ne + "*(?:value|" + te + ")"),
                      e.querySelectorAll("[id~=" + I + "-]").length ||
                        P.push("~="),
                      e.querySelectorAll(":checked").length ||
                        P.push(":checked"),
                      e.querySelectorAll("a#" + I + "+*").length ||
                        P.push(".#.+[+~]");
                  }),
                  o(function (e) {
                    var t = O.createElement("input");
                    t.setAttribute("type", "hidden"),
                      e.appendChild(t).setAttribute("name", "D"),
                      e.querySelectorAll("[name=d]").length &&
                        P.push("name" + ne + "*[*^$|!~]?="),
                      e.querySelectorAll(":enabled").length ||
                        P.push(":enabled", ":disabled"),
                      e.querySelectorAll("*,:x"),
                      P.push(",.*:");
                  })),
                (x.matchesSelector = ge.test(
                  (_ =
                    H.matches ||
                    H.webkitMatchesSelector ||
                    H.mozMatchesSelector ||
                    H.oMatchesSelector ||
                    H.msMatchesSelector)
                )) &&
                  o(function (e) {
                    (x.disconnectedMatch = _.call(e, "div")),
                      _.call(e, "[s!='']:x"),
                      L.push("!=", re);
                  }),
                (P = P.length && new RegExp(P.join("|"))),
                (L = L.length && new RegExp(L.join("|"))),
                (t = ge.test(H.compareDocumentPosition)),
                (z =
                  t || ge.test(H.contains)
                    ? function (e, t) {
                        var n = 9 === e.nodeType ? e.documentElement : e,
                          i = t && t.parentNode;
                        return (
                          e === i ||
                          !(
                            !i ||
                            1 !== i.nodeType ||
                            !(n.contains
                              ? n.contains(i)
                              : e.compareDocumentPosition &&
                                16 & e.compareDocumentPosition(i))
                          )
                        );
                      }
                    : function (e, t) {
                        if (t)
                          for (; (t = t.parentNode); ) if (t === e) return !0;
                        return !1;
                      }),
                (X = t
                  ? function (e, t) {
                      if (e === t) return (N = !0), 0;
                      var n =
                        !e.compareDocumentPosition - !t.compareDocumentPosition;
                      return n
                        ? n
                        : ((n =
                            (e.ownerDocument || e) === (t.ownerDocument || t)
                              ? e.compareDocumentPosition(t)
                              : 1),
                          1 & n ||
                          (!x.sortDetached &&
                            t.compareDocumentPosition(e) === n)
                            ? e === O || (e.ownerDocument === F && z(F, e))
                              ? -1
                              : t === O || (t.ownerDocument === F && z(F, t))
                              ? 1
                              : j
                              ? ee(j, e) - ee(j, t)
                              : 0
                            : 4 & n
                            ? -1
                            : 1);
                    }
                  : function (e, t) {
                      if (e === t) return (N = !0), 0;
                      var n,
                        i = 0,
                        o = e.parentNode,
                        r = t.parentNode,
                        a = [e],
                        l = [t];
                      if (!o || !r)
                        return e === O
                          ? -1
                          : t === O
                          ? 1
                          : o
                          ? -1
                          : r
                          ? 1
                          : j
                          ? ee(j, e) - ee(j, t)
                          : 0;
                      if (o === r) return s(e, t);
                      for (n = e; (n = n.parentNode); ) a.unshift(n);
                      for (n = t; (n = n.parentNode); ) l.unshift(n);
                      for (; a[i] === l[i]; ) i++;
                      return i
                        ? s(a[i], l[i])
                        : a[i] === F
                        ? -1
                        : l[i] === F
                        ? 1
                        : 0;
                    }),
                O)
              : O;
          }),
        (t.matches = function (e, n) {
          return t(e, null, null, n);
        }),
        (t.matchesSelector = function (e, n) {
          if (
            ((e.ownerDocument || e) !== O && D(e),
            (n = n.replace(ce, "='$1']")),
            x.matchesSelector &&
              q &&
              !U[n + " "] &&
              (!L || !L.test(n)) &&
              (!P || !P.test(n)))
          )
            try {
              var i = _.call(e, n);
              if (
                i ||
                x.disconnectedMatch ||
                (e.document && 11 !== e.document.nodeType)
              )
                return i;
            } catch (e) {}
          return t(n, O, null, [e]).length > 0;
        }),
        (t.contains = function (e, t) {
          return (e.ownerDocument || e) !== O && D(e), z(e, t);
        }),
        (t.attr = function (e, t) {
          (e.ownerDocument || e) !== O && D(e);
          var n = k.attrHandle[t.toLowerCase()],
            i =
              n && V.call(k.attrHandle, t.toLowerCase()) ? n(e, t, !q) : void 0;
          return void 0 !== i
            ? i
            : x.attributes || !q
            ? e.getAttribute(t)
            : (i = e.getAttributeNode(t)) && i.specified
            ? i.value
            : null;
        }),
        (t.error = function (e) {
          throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (t.uniqueSort = function (e) {
          var t,
            n = [],
            i = 0,
            o = 0;
          if (
            ((N = !x.detectDuplicates),
            (j = !x.sortStable && e.slice(0)),
            e.sort(X),
            N)
          ) {
            for (; (t = e[o++]); ) t === e[o] && (i = n.push(o));
            for (; i--; ) e.splice(n[i], 1);
          }
          return (j = null), e;
        }),
        (T = t.getText =
          function (e) {
            var t,
              n = "",
              i = 0,
              o = e.nodeType;
            if (o) {
              if (1 === o || 9 === o || 11 === o) {
                if ("string" == typeof e.textContent) return e.textContent;
                for (e = e.firstChild; e; e = e.nextSibling) n += T(e);
              } else if (3 === o || 4 === o) return e.nodeValue;
            } else for (; (t = e[i++]); ) n += T(t);
            return n;
          }),
        (k = t.selectors =
          {
            cacheLength: 50,
            createPseudo: i,
            match: fe,
            attrHandle: {},
            find: {},
            relative: {
              ">": { dir: "parentNode", first: !0 },
              " ": { dir: "parentNode" },
              "+": { dir: "previousSibling", first: !0 },
              "~": { dir: "previousSibling" },
            },
            preFilter: {
              ATTR: function (e) {
                return (
                  (e[1] = e[1].replace(we, xe)),
                  (e[3] = (e[3] || e[4] || e[5] || "").replace(we, xe)),
                  "~=" === e[2] && (e[3] = " " + e[3] + " "),
                  e.slice(0, 4)
                );
              },
              CHILD: function (e) {
                return (
                  (e[1] = e[1].toLowerCase()),
                  "nth" === e[1].slice(0, 3)
                    ? (e[3] || t.error(e[0]),
                      (e[4] = +(e[4]
                        ? e[5] + (e[6] || 1)
                        : 2 * ("even" === e[3] || "odd" === e[3]))),
                      (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                    : e[3] && t.error(e[0]),
                  e
                );
              },
              PSEUDO: function (e) {
                var t,
                  n = !e[6] && e[2];
                return fe.CHILD.test(e[0])
                  ? null
                  : (e[3]
                      ? (e[2] = e[4] || e[5] || "")
                      : n &&
                        de.test(n) &&
                        (t = C(n, !0)) &&
                        (t = n.indexOf(")", n.length - t) - n.length) &&
                        ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                    e.slice(0, 3));
              },
            },
            filter: {
              TAG: function (e) {
                var t = e.replace(we, xe).toLowerCase();
                return "*" === e
                  ? function () {
                      return !0;
                    }
                  : function (e) {
                      return e.nodeName && e.nodeName.toLowerCase() === t;
                    };
              },
              CLASS: function (e) {
                var t = W[e + " "];
                return (
                  t ||
                  ((t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) &&
                    W(e, function (e) {
                      return t.test(
                        ("string" == typeof e.className && e.className) ||
                          ("undefined" != typeof e.getAttribute &&
                            e.getAttribute("class")) ||
                          ""
                      );
                    }))
                );
              },
              ATTR: function (e, n, i) {
                return function (o) {
                  var r = t.attr(o, e);
                  return null == r
                    ? "!=" === n
                    : !n ||
                        ((r += ""),
                        "=" === n
                          ? r === i
                          : "!=" === n
                          ? r !== i
                          : "^=" === n
                          ? i && 0 === r.indexOf(i)
                          : "*=" === n
                          ? i && r.indexOf(i) > -1
                          : "$=" === n
                          ? i && r.slice(-i.length) === i
                          : "~=" === n
                          ? (" " + r.replace(se, " ") + " ").indexOf(i) > -1
                          : "|=" === n &&
                            (r === i || r.slice(0, i.length + 1) === i + "-"));
                };
              },
              CHILD: function (e, t, n, i, o) {
                var r = "nth" !== e.slice(0, 3),
                  s = "last" !== e.slice(-4),
                  a = "of-type" === t;
                return 1 === i && 0 === o
                  ? function (e) {
                      return !!e.parentNode;
                    }
                  : function (t, n, l) {
                      var u,
                        c,
                        d,
                        p,
                        f,
                        h,
                        v = r !== s ? "nextSibling" : "previousSibling",
                        g = t.parentNode,
                        m = a && t.nodeName.toLowerCase(),
                        y = !l && !a,
                        b = !1;
                      if (g) {
                        if (r) {
                          for (; v; ) {
                            for (p = t; (p = p[v]); )
                              if (
                                a
                                  ? p.nodeName.toLowerCase() === m
                                  : 1 === p.nodeType
                              )
                                return !1;
                            h = v = "only" === e && !h && "nextSibling";
                          }
                          return !0;
                        }
                        if (((h = [s ? g.firstChild : g.lastChild]), s && y)) {
                          for (
                            p = g,
                              d = p[I] || (p[I] = {}),
                              c = d[p.uniqueID] || (d[p.uniqueID] = {}),
                              u = c[e] || [],
                              f = u[0] === M && u[1],
                              b = f && u[2],
                              p = f && g.childNodes[f];
                            (p = (++f && p && p[v]) || (b = f = 0) || h.pop());

                          )
                            if (1 === p.nodeType && ++b && p === t) {
                              c[e] = [M, f, b];
                              break;
                            }
                        } else if (
                          (y &&
                            ((p = t),
                            (d = p[I] || (p[I] = {})),
                            (c = d[p.uniqueID] || (d[p.uniqueID] = {})),
                            (u = c[e] || []),
                            (f = u[0] === M && u[1]),
                            (b = f)),
                          b === !1)
                        )
                          for (
                            ;
                            (p =
                              (++f && p && p[v]) || (b = f = 0) || h.pop()) &&
                            ((a
                              ? p.nodeName.toLowerCase() !== m
                              : 1 !== p.nodeType) ||
                              !++b ||
                              (y &&
                                ((d = p[I] || (p[I] = {})),
                                (c = d[p.uniqueID] || (d[p.uniqueID] = {})),
                                (c[e] = [M, b])),
                              p !== t));

                          );
                        return (b -= o), b === i || (b % i === 0 && b / i >= 0);
                      }
                    };
              },
              PSEUDO: function (e, n) {
                var o,
                  r =
                    k.pseudos[e] ||
                    k.setFilters[e.toLowerCase()] ||
                    t.error("unsupported pseudo: " + e);
                return r[I]
                  ? r(n)
                  : r.length > 1
                  ? ((o = [e, e, "", n]),
                    k.setFilters.hasOwnProperty(e.toLowerCase())
                      ? i(function (e, t) {
                          for (var i, o = r(e, n), s = o.length; s--; )
                            (i = ee(e, o[s])), (e[i] = !(t[i] = o[s]));
                        })
                      : function (e) {
                          return r(e, 0, o);
                        })
                  : r;
              },
            },
            pseudos: {
              not: i(function (e) {
                var t = [],
                  n = [],
                  o = $(e.replace(ae, "$1"));
                return o[I]
                  ? i(function (e, t, n, i) {
                      for (var r, s = o(e, null, i, []), a = e.length; a--; )
                        (r = s[a]) && (e[a] = !(t[a] = r));
                    })
                  : function (e, i, r) {
                      return (
                        (t[0] = e), o(t, null, r, n), (t[0] = null), !n.pop()
                      );
                    };
              }),
              has: i(function (e) {
                return function (n) {
                  return t(e, n).length > 0;
                };
              }),
              contains: i(function (e) {
                return (
                  (e = e.replace(we, xe)),
                  function (t) {
                    return (
                      (t.textContent || t.innerText || T(t)).indexOf(e) > -1
                    );
                  }
                );
              }),
              lang: i(function (e) {
                return (
                  pe.test(e || "") || t.error("unsupported lang: " + e),
                  (e = e.replace(we, xe).toLowerCase()),
                  function (t) {
                    var n;
                    do
                      if (
                        (n = q
                          ? t.lang
                          : t.getAttribute("xml:lang") ||
                            t.getAttribute("lang"))
                      )
                        return (
                          (n = n.toLowerCase()),
                          n === e || 0 === n.indexOf(e + "-")
                        );
                    while ((t = t.parentNode) && 1 === t.nodeType);
                    return !1;
                  }
                );
              }),
              target: function (t) {
                var n = e.location && e.location.hash;
                return n && n.slice(1) === t.id;
              },
              root: function (e) {
                return e === H;
              },
              focus: function (e) {
                return (
                  e === O.activeElement &&
                  (!O.hasFocus || O.hasFocus()) &&
                  !!(e.type || e.href || ~e.tabIndex)
                );
              },
              enabled: function (e) {
                return e.disabled === !1;
              },
              disabled: function (e) {
                return e.disabled === !0;
              },
              checked: function (e) {
                var t = e.nodeName.toLowerCase();
                return (
                  ("input" === t && !!e.checked) ||
                  ("option" === t && !!e.selected)
                );
              },
              selected: function (e) {
                return (
                  e.parentNode && e.parentNode.selectedIndex, e.selected === !0
                );
              },
              empty: function (e) {
                for (e = e.firstChild; e; e = e.nextSibling)
                  if (e.nodeType < 6) return !1;
                return !0;
              },
              parent: function (e) {
                return !k.pseudos.empty(e);
              },
              header: function (e) {
                return ve.test(e.nodeName);
              },
              input: function (e) {
                return he.test(e.nodeName);
              },
              button: function (e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t && "button" === e.type) || "button" === t;
              },
              text: function (e) {
                var t;
                return (
                  "input" === e.nodeName.toLowerCase() &&
                  "text" === e.type &&
                  (null == (t = e.getAttribute("type")) ||
                    "text" === t.toLowerCase())
                );
              },
              first: u(function () {
                return [0];
              }),
              last: u(function (e, t) {
                return [t - 1];
              }),
              eq: u(function (e, t, n) {
                return [0 > n ? n + t : n];
              }),
              even: u(function (e, t) {
                for (var n = 0; t > n; n += 2) e.push(n);
                return e;
              }),
              odd: u(function (e, t) {
                for (var n = 1; t > n; n += 2) e.push(n);
                return e;
              }),
              lt: u(function (e, t, n) {
                for (var i = 0 > n ? n + t : n; --i >= 0; ) e.push(i);
                return e;
              }),
              gt: u(function (e, t, n) {
                for (var i = 0 > n ? n + t : n; ++i < t; ) e.push(i);
                return e;
              }),
            },
          }),
        (k.pseudos.nth = k.pseudos.eq);
      for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        k.pseudos[w] = a(w);
      for (w in { submit: !0, reset: !0 }) k.pseudos[w] = l(w);
      return (
        (d.prototype = k.filters = k.pseudos),
        (k.setFilters = new d()),
        (C = t.tokenize =
          function (e, n) {
            var i,
              o,
              r,
              s,
              a,
              l,
              u,
              c = B[e + " "];
            if (c) return n ? 0 : c.slice(0);
            for (a = e, l = [], u = k.preFilter; a; ) {
              (i && !(o = le.exec(a))) ||
                (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
                (i = !1),
                (o = ue.exec(a)) &&
                  ((i = o.shift()),
                  r.push({ value: i, type: o[0].replace(ae, " ") }),
                  (a = a.slice(i.length)));
              for (s in k.filter)
                !(o = fe[s].exec(a)) ||
                  (u[s] && !(o = u[s](o))) ||
                  ((i = o.shift()),
                  r.push({ value: i, type: s, matches: o }),
                  (a = a.slice(i.length)));
              if (!i) break;
            }
            return n ? a.length : a ? t.error(e) : B(e, l).slice(0);
          }),
        ($ = t.compile =
          function (e, t) {
            var n,
              i = [],
              o = [],
              r = U[e + " "];
            if (!r) {
              for (t || (t = C(e)), n = t.length; n--; )
                (r = y(t[n])), r[I] ? i.push(r) : o.push(r);
              (r = U(e, b(o, i))), (r.selector = e);
            }
            return r;
          }),
        (E = t.select =
          function (e, t, n, i) {
            var o,
              r,
              s,
              a,
              l,
              u = "function" == typeof e && e,
              d = !i && C((e = u.selector || e));
            if (((n = n || []), 1 === d.length)) {
              if (
                ((r = d[0] = d[0].slice(0)),
                r.length > 2 &&
                  "ID" === (s = r[0]).type &&
                  x.getById &&
                  9 === t.nodeType &&
                  q &&
                  k.relative[r[1].type])
              ) {
                if (
                  ((t = (k.find.ID(s.matches[0].replace(we, xe), t) || [])[0]),
                  !t)
                )
                  return n;
                u && (t = t.parentNode), (e = e.slice(r.shift().value.length));
              }
              for (
                o = fe.needsContext.test(e) ? 0 : r.length;
                o-- && ((s = r[o]), !k.relative[(a = s.type)]);

              )
                if (
                  (l = k.find[a]) &&
                  (i = l(
                    s.matches[0].replace(we, xe),
                    (ye.test(r[0].type) && c(t.parentNode)) || t
                  ))
                ) {
                  if ((r.splice(o, 1), (e = i.length && p(r)), !e))
                    return Z.apply(n, i), n;
                  break;
                }
            }
            return (
              (u || $(e, d))(
                i,
                t,
                !q,
                n,
                !t || (ye.test(e) && c(t.parentNode)) || t
              ),
              n
            );
          }),
        (x.sortStable = I.split("").sort(X).join("") === I),
        (x.detectDuplicates = !!N),
        D(),
        (x.sortDetached = o(function (e) {
          return 1 & e.compareDocumentPosition(O.createElement("div"));
        })),
        o(function (e) {
          return (
            (e.innerHTML = "<a href='#'></a>"),
            "#" === e.firstChild.getAttribute("href")
          );
        }) ||
          r("type|href|height|width", function (e, t, n) {
            return n
              ? void 0
              : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
          }),
        (x.attributes &&
          o(function (e) {
            return (
              (e.innerHTML = "<input/>"),
              e.firstChild.setAttribute("value", ""),
              "" === e.firstChild.getAttribute("value")
            );
          })) ||
          r("value", function (e, t, n) {
            return n || "input" !== e.nodeName.toLowerCase()
              ? void 0
              : e.defaultValue;
          }),
        o(function (e) {
          return null == e.getAttribute("disabled");
        }) ||
          r(te, function (e, t, n) {
            var i;
            return n
              ? void 0
              : e[t] === !0
              ? t.toLowerCase()
              : (i = e.getAttributeNode(t)) && i.specified
              ? i.value
              : null;
          }),
        t
      );
    })(e);
    (re.find = ce),
      (re.expr = ce.selectors),
      (re.expr[":"] = re.expr.pseudos),
      (re.uniqueSort = re.unique = ce.uniqueSort),
      (re.text = ce.getText),
      (re.isXMLDoc = ce.isXML),
      (re.contains = ce.contains);
    var de = function (e, t, n) {
        for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
          if (1 === e.nodeType) {
            if (o && re(e).is(n)) break;
            i.push(e);
          }
        return i;
      },
      pe = function (e, t) {
        for (var n = []; e; e = e.nextSibling)
          1 === e.nodeType && e !== t && n.push(e);
        return n;
      },
      fe = re.expr.match.needsContext,
      he = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
      ve = /^.[^:#\[\.,]*$/;
    (re.filter = function (e, t, n) {
      var i = t[0];
      return (
        n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === i.nodeType
          ? re.find.matchesSelector(i, e)
            ? [i]
            : []
          : re.find.matches(
              e,
              re.grep(t, function (e) {
                return 1 === e.nodeType;
              })
            )
      );
    }),
      re.fn.extend({
        find: function (e) {
          var t,
            n = this.length,
            i = [],
            o = this;
          if ("string" != typeof e)
            return this.pushStack(
              re(e).filter(function () {
                for (t = 0; n > t; t++) if (re.contains(o[t], this)) return !0;
              })
            );
          for (t = 0; n > t; t++) re.find(e, o[t], i);
          return (
            (i = this.pushStack(n > 1 ? re.unique(i) : i)),
            (i.selector = this.selector ? this.selector + " " + e : e),
            i
          );
        },
        filter: function (e) {
          return this.pushStack(i(this, e || [], !1));
        },
        not: function (e) {
          return this.pushStack(i(this, e || [], !0));
        },
        is: function (e) {
          return !!i(
            this,
            "string" == typeof e && fe.test(e) ? re(e) : e || [],
            !1
          ).length;
        },
      });
    var ge,
      me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      ye = (re.fn.init = function (e, t, n) {
        var i, o;
        if (!e) return this;
        if (((n = n || ge), "string" == typeof e)) {
          if (
            ((i =
              "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                ? [null, e, null]
                : me.exec(e)),
            !i || (!i[1] && t))
          )
            return !t || t.jquery
              ? (t || n).find(e)
              : this.constructor(t).find(e);
          if (i[1]) {
            if (
              ((t = t instanceof re ? t[0] : t),
              re.merge(
                this,
                re.parseHTML(
                  i[1],
                  t && t.nodeType ? t.ownerDocument || t : G,
                  !0
                )
              ),
              he.test(i[1]) && re.isPlainObject(t))
            )
              for (i in t)
                re.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            return this;
          }
          return (
            (o = G.getElementById(i[2])),
            o && o.parentNode && ((this.length = 1), (this[0] = o)),
            (this.context = G),
            (this.selector = e),
            this
          );
        }
        return e.nodeType
          ? ((this.context = this[0] = e), (this.length = 1), this)
          : re.isFunction(e)
          ? void 0 !== n.ready
            ? n.ready(e)
            : e(re)
          : (void 0 !== e.selector &&
              ((this.selector = e.selector), (this.context = e.context)),
            re.makeArray(e, this));
      });
    (ye.prototype = re.fn), (ge = re(G));
    var be = /^(?:parents|prev(?:Until|All))/,
      we = { children: !0, contents: !0, next: !0, prev: !0 };
    re.fn.extend({
      has: function (e) {
        var t = re(e, this),
          n = t.length;
        return this.filter(function () {
          for (var e = 0; n > e; e++) if (re.contains(this, t[e])) return !0;
        });
      },
      closest: function (e, t) {
        for (
          var n,
            i = 0,
            o = this.length,
            r = [],
            s =
              fe.test(e) || "string" != typeof e ? re(e, t || this.context) : 0;
          o > i;
          i++
        )
          for (n = this[i]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (s
                ? s.index(n) > -1
                : 1 === n.nodeType && re.find.matchesSelector(n, e))
            ) {
              r.push(n);
              break;
            }
        return this.pushStack(r.length > 1 ? re.uniqueSort(r) : r);
      },
      index: function (e) {
        return e
          ? "string" == typeof e
            ? K.call(re(e), this[0])
            : K.call(this, e.jquery ? e[0] : e)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (e, t) {
        return this.pushStack(re.uniqueSort(re.merge(this.get(), re(e, t))));
      },
      addBack: function (e) {
        return this.add(
          null == e ? this.prevObject : this.prevObject.filter(e)
        );
      },
    }),
      re.each(
        {
          parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
          },
          parents: function (e) {
            return de(e, "parentNode");
          },
          parentsUntil: function (e, t, n) {
            return de(e, "parentNode", n);
          },
          next: function (e) {
            return o(e, "nextSibling");
          },
          prev: function (e) {
            return o(e, "previousSibling");
          },
          nextAll: function (e) {
            return de(e, "nextSibling");
          },
          prevAll: function (e) {
            return de(e, "previousSibling");
          },
          nextUntil: function (e, t, n) {
            return de(e, "nextSibling", n);
          },
          prevUntil: function (e, t, n) {
            return de(e, "previousSibling", n);
          },
          siblings: function (e) {
            return pe((e.parentNode || {}).firstChild, e);
          },
          children: function (e) {
            return pe(e.firstChild);
          },
          contents: function (e) {
            return e.contentDocument || re.merge([], e.childNodes);
          },
        },
        function (e, t) {
          re.fn[e] = function (n, i) {
            var o = re.map(this, t, n);
            return (
              "Until" !== e.slice(-5) && (i = n),
              i && "string" == typeof i && (o = re.filter(i, o)),
              this.length > 1 &&
                (we[e] || re.uniqueSort(o), be.test(e) && o.reverse()),
              this.pushStack(o)
            );
          };
        }
      );
    var xe = /\S+/g;
    (re.Callbacks = function (e) {
      e = "string" == typeof e ? r(e) : re.extend({}, e);
      var t,
        n,
        i,
        o,
        s = [],
        a = [],
        l = -1,
        u = function () {
          for (o = e.once, i = t = !0; a.length; l = -1)
            for (n = a.shift(); ++l < s.length; )
              s[l].apply(n[0], n[1]) === !1 &&
                e.stopOnFalse &&
                ((l = s.length), (n = !1));
          e.memory || (n = !1), (t = !1), o && (s = n ? [] : "");
        },
        c = {
          add: function () {
            return (
              s &&
                (n && !t && ((l = s.length - 1), a.push(n)),
                (function t(n) {
                  re.each(n, function (n, i) {
                    re.isFunction(i)
                      ? (e.unique && c.has(i)) || s.push(i)
                      : i && i.length && "string" !== re.type(i) && t(i);
                  });
                })(arguments),
                n && !t && u()),
              this
            );
          },
          remove: function () {
            return (
              re.each(arguments, function (e, t) {
                for (var n; (n = re.inArray(t, s, n)) > -1; )
                  s.splice(n, 1), l >= n && l--;
              }),
              this
            );
          },
          has: function (e) {
            return e ? re.inArray(e, s) > -1 : s.length > 0;
          },
          empty: function () {
            return s && (s = []), this;
          },
          disable: function () {
            return (o = a = []), (s = n = ""), this;
          },
          disabled: function () {
            return !s;
          },
          lock: function () {
            return (o = a = []), n || (s = n = ""), this;
          },
          locked: function () {
            return !!o;
          },
          fireWith: function (e, n) {
            return (
              o ||
                ((n = n || []),
                (n = [e, n.slice ? n.slice() : n]),
                a.push(n),
                t || u()),
              this
            );
          },
          fire: function () {
            return c.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!i;
          },
        };
      return c;
    }),
      re.extend({
        Deferred: function (e) {
          var t = [
              ["resolve", "done", re.Callbacks("once memory"), "resolved"],
              ["reject", "fail", re.Callbacks("once memory"), "rejected"],
              ["notify", "progress", re.Callbacks("memory")],
            ],
            n = "pending",
            i = {
              state: function () {
                return n;
              },
              always: function () {
                return o.done(arguments).fail(arguments), this;
              },
              then: function () {
                var e = arguments;
                return re
                  .Deferred(function (n) {
                    re.each(t, function (t, r) {
                      var s = re.isFunction(e[t]) && e[t];
                      o[r[1]](function () {
                        var e = s && s.apply(this, arguments);
                        e && re.isFunction(e.promise)
                          ? e
                              .promise()
                              .progress(n.notify)
                              .done(n.resolve)
                              .fail(n.reject)
                          : n[r[0] + "With"](
                              this === i ? n.promise() : this,
                              s ? [e] : arguments
                            );
                      });
                    }),
                      (e = null);
                  })
                  .promise();
              },
              promise: function (e) {
                return null != e ? re.extend(e, i) : i;
              },
            },
            o = {};
          return (
            (i.pipe = i.then),
            re.each(t, function (e, r) {
              var s = r[2],
                a = r[3];
              (i[r[1]] = s.add),
                a &&
                  s.add(
                    function () {
                      n = a;
                    },
                    t[1 ^ e][2].disable,
                    t[2][2].lock
                  ),
                (o[r[0]] = function () {
                  return (
                    o[r[0] + "With"](this === o ? i : this, arguments), this
                  );
                }),
                (o[r[0] + "With"] = s.fireWith);
            }),
            i.promise(o),
            e && e.call(o, o),
            o
          );
        },
        when: function (e) {
          var t,
            n,
            i,
            o = 0,
            r = Q.call(arguments),
            s = r.length,
            a = 1 !== s || (e && re.isFunction(e.promise)) ? s : 0,
            l = 1 === a ? e : re.Deferred(),
            u = function (e, n, i) {
              return function (o) {
                (n[e] = this),
                  (i[e] = arguments.length > 1 ? Q.call(arguments) : o),
                  i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i);
              };
            };
          if (s > 1)
            for (
              t = new Array(s), n = new Array(s), i = new Array(s);
              s > o;
              o++
            )
              r[o] && re.isFunction(r[o].promise)
                ? r[o]
                    .promise()
                    .progress(u(o, n, t))
                    .done(u(o, i, r))
                    .fail(l.reject)
                : --a;
          return a || l.resolveWith(i, r), l.promise();
        },
      });
    var ke;
    (re.fn.ready = function (e) {
      return re.ready.promise().done(e), this;
    }),
      re.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function (e) {
          e ? re.readyWait++ : re.ready(!0);
        },
        ready: function (e) {
          (e === !0 ? --re.readyWait : re.isReady) ||
            ((re.isReady = !0),
            (e !== !0 && --re.readyWait > 0) ||
              (ke.resolveWith(G, [re]),
              re.fn.triggerHandler &&
                (re(G).triggerHandler("ready"), re(G).off("ready"))));
        },
      }),
      (re.ready.promise = function (t) {
        return (
          ke ||
            ((ke = re.Deferred()),
            "complete" === G.readyState ||
            ("loading" !== G.readyState && !G.documentElement.doScroll)
              ? e.setTimeout(re.ready)
              : (G.addEventListener("DOMContentLoaded", s),
                e.addEventListener("load", s))),
          ke.promise(t)
        );
      }),
      re.ready.promise();
    var Te = function (e, t, n, i, o, r, s) {
        var a = 0,
          l = e.length,
          u = null == n;
        if ("object" === re.type(n)) {
          o = !0;
          for (a in n) Te(e, t, a, n[a], !0, r, s);
        } else if (
          void 0 !== i &&
          ((o = !0),
          re.isFunction(i) || (s = !0),
          u &&
            (s
              ? (t.call(e, i), (t = null))
              : ((u = t),
                (t = function (e, t, n) {
                  return u.call(re(e), n);
                }))),
          t)
        )
          for (; l > a; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return o ? e : u ? t.call(e) : l ? t(e[0], n) : r;
      },
      Se = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
      };
    (a.uid = 1),
      (a.prototype = {
        register: function (e, t) {
          var n = t || {};
          return (
            e.nodeType
              ? (e[this.expando] = n)
              : Object.defineProperty(e, this.expando, {
                  value: n,
                  writable: !0,
                  configurable: !0,
                }),
            e[this.expando]
          );
        },
        cache: function (e) {
          if (!Se(e)) return {};
          var t = e[this.expando];
          return (
            t ||
              ((t = {}),
              Se(e) &&
                (e.nodeType
                  ? (e[this.expando] = t)
                  : Object.defineProperty(e, this.expando, {
                      value: t,
                      configurable: !0,
                    }))),
            t
          );
        },
        set: function (e, t, n) {
          var i,
            o = this.cache(e);
          if ("string" == typeof t) o[t] = n;
          else for (i in t) o[i] = t[i];
          return o;
        },
        get: function (e, t) {
          return void 0 === t
            ? this.cache(e)
            : e[this.expando] && e[this.expando][t];
        },
        access: function (e, t, n) {
          var i;
          return void 0 === t || (t && "string" == typeof t && void 0 === n)
            ? ((i = this.get(e, t)),
              void 0 !== i ? i : this.get(e, re.camelCase(t)))
            : (this.set(e, t, n), void 0 !== n ? n : t);
        },
        remove: function (e, t) {
          var n,
            i,
            o,
            r = e[this.expando];
          if (void 0 !== r) {
            if (void 0 === t) this.register(e);
            else {
              re.isArray(t)
                ? (i = t.concat(t.map(re.camelCase)))
                : ((o = re.camelCase(t)),
                  t in r
                    ? (i = [t, o])
                    : ((i = o), (i = i in r ? [i] : i.match(xe) || []))),
                (n = i.length);
              for (; n--; ) delete r[i[n]];
            }
            (void 0 === t || re.isEmptyObject(r)) &&
              (e.nodeType
                ? (e[this.expando] = void 0)
                : delete e[this.expando]);
          }
        },
        hasData: function (e) {
          var t = e[this.expando];
          return void 0 !== t && !re.isEmptyObject(t);
        },
      });
    var Ce = new a(),
      $e = new a(),
      Ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      Ae = /[A-Z]/g;
    re.extend({
      hasData: function (e) {
        return $e.hasData(e) || Ce.hasData(e);
      },
      data: function (e, t, n) {
        return $e.access(e, t, n);
      },
      removeData: function (e, t) {
        $e.remove(e, t);
      },
      _data: function (e, t, n) {
        return Ce.access(e, t, n);
      },
      _removeData: function (e, t) {
        Ce.remove(e, t);
      },
    }),
      re.fn.extend({
        data: function (e, t) {
          var n,
            i,
            o,
            r = this[0],
            s = r && r.attributes;
          if (void 0 === e) {
            if (
              this.length &&
              ((o = $e.get(r)), 1 === r.nodeType && !Ce.get(r, "hasDataAttrs"))
            ) {
              for (n = s.length; n--; )
                s[n] &&
                  ((i = s[n].name),
                  0 === i.indexOf("data-") &&
                    ((i = re.camelCase(i.slice(5))), l(r, i, o[i])));
              Ce.set(r, "hasDataAttrs", !0);
            }
            return o;
          }
          return "object" == typeof e
            ? this.each(function () {
                $e.set(this, e);
              })
            : Te(
                this,
                function (t) {
                  var n, i;
                  if (r && void 0 === t) {
                    if (
                      ((n =
                        $e.get(r, e) ||
                        $e.get(r, e.replace(Ae, "-$&").toLowerCase())),
                      void 0 !== n)
                    )
                      return n;
                    if (
                      ((i = re.camelCase(e)), (n = $e.get(r, i)), void 0 !== n)
                    )
                      return n;
                    if (((n = l(r, i, void 0)), void 0 !== n)) return n;
                  } else
                    (i = re.camelCase(e)),
                      this.each(function () {
                        var n = $e.get(this, i);
                        $e.set(this, i, t),
                          e.indexOf("-") > -1 &&
                            void 0 !== n &&
                            $e.set(this, e, t);
                      });
                },
                null,
                t,
                arguments.length > 1,
                null,
                !0
              );
        },
        removeData: function (e) {
          return this.each(function () {
            $e.remove(this, e);
          });
        },
      }),
      re.extend({
        queue: function (e, t, n) {
          var i;
          return e
            ? ((t = (t || "fx") + "queue"),
              (i = Ce.get(e, t)),
              n &&
                (!i || re.isArray(n)
                  ? (i = Ce.access(e, t, re.makeArray(n)))
                  : i.push(n)),
              i || [])
            : void 0;
        },
        dequeue: function (e, t) {
          t = t || "fx";
          var n = re.queue(e, t),
            i = n.length,
            o = n.shift(),
            r = re._queueHooks(e, t),
            s = function () {
              re.dequeue(e, t);
            };
          "inprogress" === o && ((o = n.shift()), i--),
            o &&
              ("fx" === t && n.unshift("inprogress"),
              delete r.stop,
              o.call(e, s, r)),
            !i && r && r.empty.fire();
        },
        _queueHooks: function (e, t) {
          var n = t + "queueHooks";
          return (
            Ce.get(e, n) ||
            Ce.access(e, n, {
              empty: re.Callbacks("once memory").add(function () {
                Ce.remove(e, [t + "queue", n]);
              }),
            })
          );
        },
      }),
      re.fn.extend({
        queue: function (e, t) {
          var n = 2;
          return (
            "string" != typeof e && ((t = e), (e = "fx"), n--),
            arguments.length < n
              ? re.queue(this[0], e)
              : void 0 === t
              ? this
              : this.each(function () {
                  var n = re.queue(this, e, t);
                  re._queueHooks(this, e),
                    "fx" === e && "inprogress" !== n[0] && re.dequeue(this, e);
                })
          );
        },
        dequeue: function (e) {
          return this.each(function () {
            re.dequeue(this, e);
          });
        },
        clearQueue: function (e) {
          return this.queue(e || "fx", []);
        },
        promise: function (e, t) {
          var n,
            i = 1,
            o = re.Deferred(),
            r = this,
            s = this.length,
            a = function () {
              --i || o.resolveWith(r, [r]);
            };
          for (
            "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
            s--;

          )
            (n = Ce.get(r[s], e + "queueHooks")),
              n && n.empty && (i++, n.empty.add(a));
          return a(), o.promise(t);
        },
      });
    var je = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      Ne = new RegExp("^(?:([+-])=|)(" + je + ")([a-z%]*)$", "i"),
      De = ["Top", "Right", "Bottom", "Left"],
      Oe = function (e, t) {
        return (
          (e = t || e),
          "none" === re.css(e, "display") || !re.contains(e.ownerDocument, e)
        );
      },
      He = /^(?:checkbox|radio)$/i,
      qe = /<([\w:-]+)/,
      Pe = /^$|\/(?:java|ecma)script/i,
      Le = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
      };
    (Le.optgroup = Le.option),
      (Le.tbody = Le.tfoot = Le.colgroup = Le.caption = Le.thead),
      (Le.th = Le.td);
    var _e = /<|&#?\w+;/;
    !(function () {
      var e = G.createDocumentFragment(),
        t = e.appendChild(G.createElement("div")),
        n = G.createElement("input");
      n.setAttribute("type", "radio"),
        n.setAttribute("checked", "checked"),
        n.setAttribute("name", "t"),
        t.appendChild(n),
        (ie.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (t.innerHTML = "<textarea>x</textarea>"),
        (ie.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue);
    })();
    var ze = /^key/,
      Ie = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Fe = /^([^.]*)(?:\.(.+)|)/;
    (re.event = {
      global: {},
      add: function (e, t, n, i, o) {
        var r,
          s,
          a,
          l,
          u,
          c,
          d,
          p,
          f,
          h,
          v,
          g = Ce.get(e);
        if (g)
          for (
            n.handler && ((r = n), (n = r.handler), (o = r.selector)),
              n.guid || (n.guid = re.guid++),
              (l = g.events) || (l = g.events = {}),
              (s = g.handle) ||
                (s = g.handle =
                  function (t) {
                    return "undefined" != typeof re &&
                      re.event.triggered !== t.type
                      ? re.event.dispatch.apply(e, arguments)
                      : void 0;
                  }),
              t = (t || "").match(xe) || [""],
              u = t.length;
            u--;

          )
            (a = Fe.exec(t[u]) || []),
              (f = v = a[1]),
              (h = (a[2] || "").split(".").sort()),
              f &&
                ((d = re.event.special[f] || {}),
                (f = (o ? d.delegateType : d.bindType) || f),
                (d = re.event.special[f] || {}),
                (c = re.extend(
                  {
                    type: f,
                    origType: v,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: o,
                    needsContext: o && re.expr.match.needsContext.test(o),
                    namespace: h.join("."),
                  },
                  r
                )),
                (p = l[f]) ||
                  ((p = l[f] = []),
                  (p.delegateCount = 0),
                  (d.setup && d.setup.call(e, i, h, s) !== !1) ||
                    (e.addEventListener && e.addEventListener(f, s))),
                d.add &&
                  (d.add.call(e, c),
                  c.handler.guid || (c.handler.guid = n.guid)),
                o ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                (re.event.global[f] = !0));
      },
      remove: function (e, t, n, i, o) {
        var r,
          s,
          a,
          l,
          u,
          c,
          d,
          p,
          f,
          h,
          v,
          g = Ce.hasData(e) && Ce.get(e);
        if (g && (l = g.events)) {
          for (t = (t || "").match(xe) || [""], u = t.length; u--; )
            if (
              ((a = Fe.exec(t[u]) || []),
              (f = v = a[1]),
              (h = (a[2] || "").split(".").sort()),
              f)
            ) {
              for (
                d = re.event.special[f] || {},
                  f = (i ? d.delegateType : d.bindType) || f,
                  p = l[f] || [],
                  a =
                    a[2] &&
                    new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  s = r = p.length;
                r--;

              )
                (c = p[r]),
                  (!o && v !== c.origType) ||
                    (n && n.guid !== c.guid) ||
                    (a && !a.test(c.namespace)) ||
                    (i && i !== c.selector && ("**" !== i || !c.selector)) ||
                    (p.splice(r, 1),
                    c.selector && p.delegateCount--,
                    d.remove && d.remove.call(e, c));
              s &&
                !p.length &&
                ((d.teardown && d.teardown.call(e, h, g.handle) !== !1) ||
                  re.removeEvent(e, f, g.handle),
                delete l[f]);
            } else for (f in l) re.event.remove(e, f + t[u], n, i, !0);
          re.isEmptyObject(l) && Ce.remove(e, "handle events");
        }
      },
      dispatch: function (e) {
        e = re.event.fix(e);
        var t,
          n,
          i,
          o,
          r,
          s = [],
          a = Q.call(arguments),
          l = (Ce.get(this, "events") || {})[e.type] || [],
          u = re.event.special[e.type] || {};
        if (
          ((a[0] = e),
          (e.delegateTarget = this),
          !u.preDispatch || u.preDispatch.call(this, e) !== !1)
        ) {
          for (
            s = re.event.handlers.call(this, e, l), t = 0;
            (o = s[t++]) && !e.isPropagationStopped();

          )
            for (
              e.currentTarget = o.elem, n = 0;
              (r = o.handlers[n++]) && !e.isImmediatePropagationStopped();

            )
              (e.rnamespace && !e.rnamespace.test(r.namespace)) ||
                ((e.handleObj = r),
                (e.data = r.data),
                (i = (
                  (re.event.special[r.origType] || {}).handle || r.handler
                ).apply(o.elem, a)),
                void 0 !== i &&
                  (e.result = i) === !1 &&
                  (e.preventDefault(), e.stopPropagation()));
          return u.postDispatch && u.postDispatch.call(this, e), e.result;
        }
      },
      handlers: function (e, t) {
        var n,
          i,
          o,
          r,
          s = [],
          a = t.delegateCount,
          l = e.target;
        if (
          a &&
          l.nodeType &&
          ("click" !== e.type || isNaN(e.button) || e.button < 1)
        )
          for (; l !== this; l = l.parentNode || this)
            if (1 === l.nodeType && (l.disabled !== !0 || "click" !== e.type)) {
              for (i = [], n = 0; a > n; n++)
                (r = t[n]),
                  (o = r.selector + " "),
                  void 0 === i[o] &&
                    (i[o] = r.needsContext
                      ? re(o, this).index(l) > -1
                      : re.find(o, this, null, [l]).length),
                  i[o] && i.push(r);
              i.length && s.push({ elem: l, handlers: i });
            }
        return a < t.length && s.push({ elem: this, handlers: t.slice(a) }), s;
      },
      props:
        "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
          " "
        ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e, t) {
          return (
            null == e.which &&
              (e.which = null != t.charCode ? t.charCode : t.keyCode),
            e
          );
        },
      },
      mouseHooks: {
        props:
          "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
            " "
          ),
        filter: function (e, t) {
          var n,
            i,
            o,
            r = t.button;
          return (
            null == e.pageX &&
              null != t.clientX &&
              ((n = e.target.ownerDocument || G),
              (i = n.documentElement),
              (o = n.body),
              (e.pageX =
                t.clientX +
                ((i && i.scrollLeft) || (o && o.scrollLeft) || 0) -
                ((i && i.clientLeft) || (o && o.clientLeft) || 0)),
              (e.pageY =
                t.clientY +
                ((i && i.scrollTop) || (o && o.scrollTop) || 0) -
                ((i && i.clientTop) || (o && o.clientTop) || 0))),
            e.which ||
              void 0 === r ||
              (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0),
            e
          );
        },
      },
      fix: function (e) {
        if (e[re.expando]) return e;
        var t,
          n,
          i,
          o = e.type,
          r = e,
          s = this.fixHooks[o];
        for (
          s ||
            (this.fixHooks[o] = s =
              Ie.test(o) ? this.mouseHooks : ze.test(o) ? this.keyHooks : {}),
            i = s.props ? this.props.concat(s.props) : this.props,
            e = new re.Event(r),
            t = i.length;
          t--;

        )
          (n = i[t]), (e[n] = r[n]);
        return (
          e.target || (e.target = G),
          3 === e.target.nodeType && (e.target = e.target.parentNode),
          s.filter ? s.filter(e, r) : e
        );
      },
      special: {
        load: { noBubble: !0 },
        focus: {
          trigger: function () {
            return this !== v() && this.focus ? (this.focus(), !1) : void 0;
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            return this === v() && this.blur ? (this.blur(), !1) : void 0;
          },
          delegateType: "focusout",
        },
        click: {
          trigger: function () {
            return "checkbox" === this.type &&
              this.click &&
              re.nodeName(this, "input")
              ? (this.click(), !1)
              : void 0;
          },
          _default: function (e) {
            return re.nodeName(e.target, "a");
          },
        },
        beforeunload: {
          postDispatch: function (e) {
            void 0 !== e.result &&
              e.originalEvent &&
              (e.originalEvent.returnValue = e.result);
          },
        },
      },
    }),
      (re.removeEvent = function (e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n);
      }),
      (re.Event = function (e, t) {
        return this instanceof re.Event
          ? (e && e.type
              ? ((this.originalEvent = e),
                (this.type = e.type),
                (this.isDefaultPrevented =
                  e.defaultPrevented ||
                  (void 0 === e.defaultPrevented && e.returnValue === !1)
                    ? f
                    : h))
              : (this.type = e),
            t && re.extend(this, t),
            (this.timeStamp = (e && e.timeStamp) || re.now()),
            void (this[re.expando] = !0))
          : new re.Event(e, t);
      }),
      (re.Event.prototype = {
        constructor: re.Event,
        isDefaultPrevented: h,
        isPropagationStopped: h,
        isImmediatePropagationStopped: h,
        preventDefault: function () {
          var e = this.originalEvent;
          (this.isDefaultPrevented = f), e && e.preventDefault();
        },
        stopPropagation: function () {
          var e = this.originalEvent;
          (this.isPropagationStopped = f), e && e.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var e = this.originalEvent;
          (this.isImmediatePropagationStopped = f),
            e && e.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      re.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (e, t) {
          re.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function (e) {
              var n,
                i = this,
                o = e.relatedTarget,
                r = e.handleObj;
              return (
                (o && (o === i || re.contains(i, o))) ||
                  ((e.type = r.origType),
                  (n = r.handler.apply(this, arguments)),
                  (e.type = t)),
                n
              );
            },
          };
        }
      ),
      re.fn.extend({
        on: function (e, t, n, i) {
          return g(this, e, t, n, i);
        },
        one: function (e, t, n, i) {
          return g(this, e, t, n, i, 1);
        },
        off: function (e, t, n) {
          var i, o;
          if (e && e.preventDefault && e.handleObj)
            return (
              (i = e.handleObj),
              re(e.delegateTarget).off(
                i.namespace ? i.origType + "." + i.namespace : i.origType,
                i.selector,
                i.handler
              ),
              this
            );
          if ("object" == typeof e) {
            for (o in e) this.off(o, t, e[o]);
            return this;
          }
          return (
            (t !== !1 && "function" != typeof t) || ((n = t), (t = void 0)),
            n === !1 && (n = h),
            this.each(function () {
              re.event.remove(this, e, n, t);
            })
          );
        },
      });
    var Me =
        /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      Re = /<script|<style|<link/i,
      We = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Be = /^true\/(.*)/,
      Ue = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    re.extend({
      htmlPrefilter: function (e) {
        return e.replace(Me, "<$1></$2>");
      },
      clone: function (e, t, n) {
        var i,
          o,
          r,
          s,
          a = e.cloneNode(!0),
          l = re.contains(e.ownerDocument, e);
        if (
          !(
            ie.noCloneChecked ||
            (1 !== e.nodeType && 11 !== e.nodeType) ||
            re.isXMLDoc(e)
          )
        )
          for (s = c(a), r = c(e), i = 0, o = r.length; o > i; i++)
            x(r[i], s[i]);
        if (t)
          if (n)
            for (r = r || c(e), s = s || c(a), i = 0, o = r.length; o > i; i++)
              w(r[i], s[i]);
          else w(e, a);
        return (
          (s = c(a, "script")), s.length > 0 && d(s, !l && c(e, "script")), a
        );
      },
      cleanData: function (e) {
        for (
          var t, n, i, o = re.event.special, r = 0;
          void 0 !== (n = e[r]);
          r++
        )
          if (Se(n)) {
            if ((t = n[Ce.expando])) {
              if (t.events)
                for (i in t.events)
                  o[i] ? re.event.remove(n, i) : re.removeEvent(n, i, t.handle);
              n[Ce.expando] = void 0;
            }
            n[$e.expando] && (n[$e.expando] = void 0);
          }
      },
    }),
      re.fn.extend({
        domManip: k,
        detach: function (e) {
          return T(this, e, !0);
        },
        remove: function (e) {
          return T(this, e);
        },
        text: function (e) {
          return Te(
            this,
            function (e) {
              return void 0 === e
                ? re.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = e);
                  });
            },
            null,
            e,
            arguments.length
          );
        },
        append: function () {
          return k(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = m(this, e);
              t.appendChild(e);
            }
          });
        },
        prepend: function () {
          return k(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = m(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function () {
          return k(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function () {
          return k(this, arguments, function (e) {
            this.parentNode &&
              this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function () {
          for (var e, t = 0; null != (e = this[t]); t++)
            1 === e.nodeType && (re.cleanData(c(e, !1)), (e.textContent = ""));
          return this;
        },
        clone: function (e, t) {
          return (
            (e = null != e && e),
            (t = null == t ? e : t),
            this.map(function () {
              return re.clone(this, e, t);
            })
          );
        },
        html: function (e) {
          return Te(
            this,
            function (e) {
              var t = this[0] || {},
                n = 0,
                i = this.length;
              if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
              if (
                "string" == typeof e &&
                !Re.test(e) &&
                !Le[(qe.exec(e) || ["", ""])[1].toLowerCase()]
              ) {
                e = re.htmlPrefilter(e);
                try {
                  for (; i > n; n++)
                    (t = this[n] || {}),
                      1 === t.nodeType &&
                        (re.cleanData(c(t, !1)), (t.innerHTML = e));
                  t = 0;
                } catch (e) {}
              }
              t && this.empty().append(e);
            },
            null,
            e,
            arguments.length
          );
        },
        replaceWith: function () {
          var e = [];
          return k(
            this,
            arguments,
            function (t) {
              var n = this.parentNode;
              re.inArray(this, e) < 0 &&
                (re.cleanData(c(this)), n && n.replaceChild(t, this));
            },
            e
          );
        },
      }),
      re.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e, t) {
          re.fn[e] = function (e) {
            for (var n, i = [], o = re(e), r = o.length - 1, s = 0; r >= s; s++)
              (n = s === r ? this : this.clone(!0)),
                re(o[s])[t](n),
                Z.apply(i, n.get());
            return this.pushStack(i);
          };
        }
      );
    var Xe,
      Ye = { HTML: "block", BODY: "block" },
      Ve = /^margin/,
      Ge = new RegExp("^(" + je + ")(?!px)[a-z%]+$", "i"),
      Qe = function (t) {
        var n = t.ownerDocument.defaultView;
        return (n && n.opener) || (n = e), n.getComputedStyle(t);
      },
      Je = function (e, t, n, i) {
        var o,
          r,
          s = {};
        for (r in t) (s[r] = e.style[r]), (e.style[r] = t[r]);
        o = n.apply(e, i || []);
        for (r in t) e.style[r] = s[r];
        return o;
      },
      Ze = G.documentElement;
    !(function () {
      function t() {
        (a.style.cssText =
          "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
          (a.innerHTML = ""),
          Ze.appendChild(s);
        var t = e.getComputedStyle(a);
        (n = "1%" !== t.top),
          (r = "2px" === t.marginLeft),
          (i = "4px" === t.width),
          (a.style.marginRight = "50%"),
          (o = "4px" === t.marginRight),
          Ze.removeChild(s);
      }
      var n,
        i,
        o,
        r,
        s = G.createElement("div"),
        a = G.createElement("div");
      a.style &&
        ((a.style.backgroundClip = "content-box"),
        (a.cloneNode(!0).style.backgroundClip = ""),
        (ie.clearCloneStyle = "content-box" === a.style.backgroundClip),
        (s.style.cssText =
          "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
        s.appendChild(a),
        re.extend(ie, {
          pixelPosition: function () {
            return t(), n;
          },
          boxSizingReliable: function () {
            return null == i && t(), i;
          },
          pixelMarginRight: function () {
            return null == i && t(), o;
          },
          reliableMarginLeft: function () {
            return null == i && t(), r;
          },
          reliableMarginRight: function () {
            var t,
              n = a.appendChild(G.createElement("div"));
            return (
              (n.style.cssText = a.style.cssText =
                "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
              (n.style.marginRight = n.style.width = "0"),
              (a.style.width = "1px"),
              Ze.appendChild(s),
              (t = !parseFloat(e.getComputedStyle(n).marginRight)),
              Ze.removeChild(s),
              a.removeChild(n),
              t
            );
          },
        }));
    })();
    var Ke = /^(none|table(?!-c[ea]).+)/,
      et = { position: "absolute", visibility: "hidden", display: "block" },
      tt = { letterSpacing: "0", fontWeight: "400" },
      nt = ["Webkit", "O", "Moz", "ms"],
      it = G.createElement("div").style;
    re.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var n = $(e, "opacity");
              return "" === n ? "1" : n;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: { float: "cssFloat" },
      style: function (e, t, n, i) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var o,
            r,
            s,
            a = re.camelCase(t),
            l = e.style;
          return (
            (t = re.cssProps[a] || (re.cssProps[a] = A(a) || a)),
            (s = re.cssHooks[t] || re.cssHooks[a]),
            void 0 === n
              ? s && "get" in s && void 0 !== (o = s.get(e, !1, i))
                ? o
                : l[t]
              : ((r = typeof n),
                "string" === r &&
                  (o = Ne.exec(n)) &&
                  o[1] &&
                  ((n = u(e, t, o)), (r = "number")),
                void (
                  null != n &&
                  n === n &&
                  ("number" === r &&
                    (n += (o && o[3]) || (re.cssNumber[a] ? "" : "px")),
                  ie.clearCloneStyle ||
                    "" !== n ||
                    0 !== t.indexOf("background") ||
                    (l[t] = "inherit"),
                  (s && "set" in s && void 0 === (n = s.set(e, n, i))) ||
                    (l[t] = n))
                ))
          );
        }
      },
      css: function (e, t, n, i) {
        var o,
          r,
          s,
          a = re.camelCase(t);
        return (
          (t = re.cssProps[a] || (re.cssProps[a] = A(a) || a)),
          (s = re.cssHooks[t] || re.cssHooks[a]),
          s && "get" in s && (o = s.get(e, !0, n)),
          void 0 === o && (o = $(e, t, i)),
          "normal" === o && t in tt && (o = tt[t]),
          "" === n || n
            ? ((r = parseFloat(o)), n === !0 || isFinite(r) ? r || 0 : o)
            : o
        );
      },
    }),
      re.each(["height", "width"], function (e, t) {
        re.cssHooks[t] = {
          get: function (e, n, i) {
            return n
              ? Ke.test(re.css(e, "display")) && 0 === e.offsetWidth
                ? Je(e, et, function () {
                    return D(e, t, i);
                  })
                : D(e, t, i)
              : void 0;
          },
          set: function (e, n, i) {
            var o,
              r = i && Qe(e),
              s =
                i &&
                N(e, t, i, "border-box" === re.css(e, "boxSizing", !1, r), r);
            return (
              s &&
                (o = Ne.exec(n)) &&
                "px" !== (o[3] || "px") &&
                ((e.style[t] = n), (n = re.css(e, t))),
              j(e, n, s)
            );
          },
        };
      }),
      (re.cssHooks.marginLeft = E(ie.reliableMarginLeft, function (e, t) {
        return t
          ? (parseFloat($(e, "marginLeft")) ||
              e.getBoundingClientRect().left -
                Je(e, { marginLeft: 0 }, function () {
                  return e.getBoundingClientRect().left;
                })) + "px"
          : void 0;
      })),
      (re.cssHooks.marginRight = E(ie.reliableMarginRight, function (e, t) {
        return t
          ? Je(e, { display: "inline-block" }, $, [e, "marginRight"])
          : void 0;
      })),
      re.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
        (re.cssHooks[e + t] = {
          expand: function (n) {
            for (
              var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n];
              4 > i;
              i++
            )
              o[e + De[i] + t] = r[i] || r[i - 2] || r[0];
            return o;
          },
        }),
          Ve.test(e) || (re.cssHooks[e + t].set = j);
      }),
      re.fn.extend({
        css: function (e, t) {
          return Te(
            this,
            function (e, t, n) {
              var i,
                o,
                r = {},
                s = 0;
              if (re.isArray(t)) {
                for (i = Qe(e), o = t.length; o > s; s++)
                  r[t[s]] = re.css(e, t[s], !1, i);
                return r;
              }
              return void 0 !== n ? re.style(e, t, n) : re.css(e, t);
            },
            e,
            t,
            arguments.length > 1
          );
        },
        show: function () {
          return O(this, !0);
        },
        hide: function () {
          return O(this);
        },
        toggle: function (e) {
          return "boolean" == typeof e
            ? e
              ? this.show()
              : this.hide()
            : this.each(function () {
                Oe(this) ? re(this).show() : re(this).hide();
              });
        },
      }),
      (re.Tween = H),
      (H.prototype = {
        constructor: H,
        init: function (e, t, n, i, o, r) {
          (this.elem = e),
            (this.prop = n),
            (this.easing = o || re.easing._default),
            (this.options = t),
            (this.start = this.now = this.cur()),
            (this.end = i),
            (this.unit = r || (re.cssNumber[n] ? "" : "px"));
        },
        cur: function () {
          var e = H.propHooks[this.prop];
          return e && e.get ? e.get(this) : H.propHooks._default.get(this);
        },
        run: function (e) {
          var t,
            n = H.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = t =
                  re.easing[this.easing](
                    e,
                    this.options.duration * e,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = t = e),
            (this.now = (this.end - this.start) * t + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : H.propHooks._default.set(this),
            this
          );
        },
      }),
      (H.prototype.init.prototype = H.prototype),
      (H.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return 1 !== e.elem.nodeType ||
              (null != e.elem[e.prop] && null == e.elem.style[e.prop])
              ? e.elem[e.prop]
              : ((t = re.css(e.elem, e.prop, "")), t && "auto" !== t ? t : 0);
          },
          set: function (e) {
            re.fx.step[e.prop]
              ? re.fx.step[e.prop](e)
              : 1 !== e.elem.nodeType ||
                (null == e.elem.style[re.cssProps[e.prop]] &&
                  !re.cssHooks[e.prop])
              ? (e.elem[e.prop] = e.now)
              : re.style(e.elem, e.prop, e.now + e.unit);
          },
        },
      }),
      (H.propHooks.scrollTop = H.propHooks.scrollLeft =
        {
          set: function (e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
          },
        }),
      (re.easing = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (re.fx = H.prototype.init),
      (re.fx.step = {});
    var ot,
      rt,
      st = /^(?:toggle|show|hide)$/,
      at = /queueHooks$/;
    (re.Animation = re.extend(I, {
      tweeners: {
        "*": [
          function (e, t) {
            var n = this.createTween(e, t);
            return u(n.elem, e, Ne.exec(t), n), n;
          },
        ],
      },
      tweener: function (e, t) {
        re.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.match(xe));
        for (var n, i = 0, o = e.length; o > i; i++)
          (n = e[i]),
            (I.tweeners[n] = I.tweeners[n] || []),
            I.tweeners[n].unshift(t);
      },
      prefilters: [_],
      prefilter: function (e, t) {
        t ? I.prefilters.unshift(e) : I.prefilters.push(e);
      },
    })),
      (re.speed = function (e, t, n) {
        var i =
          e && "object" == typeof e
            ? re.extend({}, e)
            : {
                complete: n || (!n && t) || (re.isFunction(e) && e),
                duration: e,
                easing: (n && t) || (t && !re.isFunction(t) && t),
              };
        return (
          (i.duration = re.fx.off
            ? 0
            : "number" == typeof i.duration
            ? i.duration
            : i.duration in re.fx.speeds
            ? re.fx.speeds[i.duration]
            : re.fx.speeds._default),
          (null != i.queue && i.queue !== !0) || (i.queue = "fx"),
          (i.old = i.complete),
          (i.complete = function () {
            re.isFunction(i.old) && i.old.call(this),
              i.queue && re.dequeue(this, i.queue);
          }),
          i
        );
      }),
      re.fn.extend({
        fadeTo: function (e, t, n, i) {
          return this.filter(Oe)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: t }, e, n, i);
        },
        animate: function (e, t, n, i) {
          var o = re.isEmptyObject(e),
            r = re.speed(t, n, i),
            s = function () {
              var t = I(this, re.extend({}, e), r);
              (o || Ce.get(this, "finish")) && t.stop(!0);
            };
          return (
            (s.finish = s),
            o || r.queue === !1 ? this.each(s) : this.queue(r.queue, s)
          );
        },
        stop: function (e, t, n) {
          var i = function (e) {
            var t = e.stop;
            delete e.stop, t(n);
          };
          return (
            "string" != typeof e && ((n = t), (t = e), (e = void 0)),
            t && e !== !1 && this.queue(e || "fx", []),
            this.each(function () {
              var t = !0,
                o = null != e && e + "queueHooks",
                r = re.timers,
                s = Ce.get(this);
              if (o) s[o] && s[o].stop && i(s[o]);
              else for (o in s) s[o] && s[o].stop && at.test(o) && i(s[o]);
              for (o = r.length; o--; )
                r[o].elem !== this ||
                  (null != e && r[o].queue !== e) ||
                  (r[o].anim.stop(n), (t = !1), r.splice(o, 1));
              (!t && n) || re.dequeue(this, e);
            })
          );
        },
        finish: function (e) {
          return (
            e !== !1 && (e = e || "fx"),
            this.each(function () {
              var t,
                n = Ce.get(this),
                i = n[e + "queue"],
                o = n[e + "queueHooks"],
                r = re.timers,
                s = i ? i.length : 0;
              for (
                n.finish = !0,
                  re.queue(this, e, []),
                  o && o.stop && o.stop.call(this, !0),
                  t = r.length;
                t--;

              )
                r[t].elem === this &&
                  r[t].queue === e &&
                  (r[t].anim.stop(!0), r.splice(t, 1));
              for (t = 0; s > t; t++)
                i[t] && i[t].finish && i[t].finish.call(this);
              delete n.finish;
            })
          );
        },
      }),
      re.each(["toggle", "show", "hide"], function (e, t) {
        var n = re.fn[t];
        re.fn[t] = function (e, i, o) {
          return null == e || "boolean" == typeof e
            ? n.apply(this, arguments)
            : this.animate(P(t, !0), e, i, o);
        };
      }),
      re.each(
        {
          slideDown: P("show"),
          slideUp: P("hide"),
          slideToggle: P("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (e, t) {
          re.fn[e] = function (e, n, i) {
            return this.animate(t, e, n, i);
          };
        }
      ),
      (re.timers = []),
      (re.fx.tick = function () {
        var e,
          t = 0,
          n = re.timers;
        for (ot = re.now(); t < n.length; t++)
          (e = n[t]), e() || n[t] !== e || n.splice(t--, 1);
        n.length || re.fx.stop(), (ot = void 0);
      }),
      (re.fx.timer = function (e) {
        re.timers.push(e), e() ? re.fx.start() : re.timers.pop();
      }),
      (re.fx.interval = 13),
      (re.fx.start = function () {
        rt || (rt = e.setInterval(re.fx.tick, re.fx.interval));
      }),
      (re.fx.stop = function () {
        e.clearInterval(rt), (rt = null);
      }),
      (re.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (re.fn.delay = function (t, n) {
        return (
          (t = re.fx ? re.fx.speeds[t] || t : t),
          (n = n || "fx"),
          this.queue(n, function (n, i) {
            var o = e.setTimeout(n, t);
            i.stop = function () {
              e.clearTimeout(o);
            };
          })
        );
      }),
      (function () {
        var e = G.createElement("input"),
          t = G.createElement("select"),
          n = t.appendChild(G.createElement("option"));
        (e.type = "checkbox"),
          (ie.checkOn = "" !== e.value),
          (ie.optSelected = n.selected),
          (t.disabled = !0),
          (ie.optDisabled = !n.disabled),
          (e = G.createElement("input")),
          (e.value = "t"),
          (e.type = "radio"),
          (ie.radioValue = "t" === e.value);
      })();
    var lt,
      ut = re.expr.attrHandle;
    re.fn.extend({
      attr: function (e, t) {
        return Te(this, re.attr, e, t, arguments.length > 1);
      },
      removeAttr: function (e) {
        return this.each(function () {
          re.removeAttr(this, e);
        });
      },
    }),
      re.extend({
        attr: function (e, t, n) {
          var i,
            o,
            r = e.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return "undefined" == typeof e.getAttribute
              ? re.prop(e, t, n)
              : ((1 === r && re.isXMLDoc(e)) ||
                  ((t = t.toLowerCase()),
                  (o =
                    re.attrHooks[t] ||
                    (re.expr.match.bool.test(t) ? lt : void 0))),
                void 0 !== n
                  ? null === n
                    ? void re.removeAttr(e, t)
                    : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                    ? i
                    : (e.setAttribute(t, n + ""), n)
                  : o && "get" in o && null !== (i = o.get(e, t))
                  ? i
                  : ((i = re.find.attr(e, t)), null == i ? void 0 : i));
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              if (!ie.radioValue && "radio" === t && re.nodeName(e, "input")) {
                var n = e.value;
                return e.setAttribute("type", t), n && (e.value = n), t;
              }
            },
          },
        },
        removeAttr: function (e, t) {
          var n,
            i,
            o = 0,
            r = t && t.match(xe);
          if (r && 1 === e.nodeType)
            for (; (n = r[o++]); )
              (i = re.propFix[n] || n),
                re.expr.match.bool.test(n) && (e[i] = !1),
                e.removeAttribute(n);
        },
      }),
      (lt = {
        set: function (e, t, n) {
          return t === !1 ? re.removeAttr(e, n) : e.setAttribute(n, n), n;
        },
      }),
      re.each(re.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var n = ut[t] || re.find.attr;
        ut[t] = function (e, t, i) {
          var o, r;
          return (
            i ||
              ((r = ut[t]),
              (ut[t] = o),
              (o = null != n(e, t, i) ? t.toLowerCase() : null),
              (ut[t] = r)),
            o
          );
        };
      });
    var ct = /^(?:input|select|textarea|button)$/i,
      dt = /^(?:a|area)$/i;
    re.fn.extend({
      prop: function (e, t) {
        return Te(this, re.prop, e, t, arguments.length > 1);
      },
      removeProp: function (e) {
        return this.each(function () {
          delete this[re.propFix[e] || e];
        });
      },
    }),
      re.extend({
        prop: function (e, t, n) {
          var i,
            o,
            r = e.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return (
              (1 === r && re.isXMLDoc(e)) ||
                ((t = re.propFix[t] || t), (o = re.propHooks[t])),
              void 0 !== n
                ? o && "set" in o && void 0 !== (i = o.set(e, n, t))
                  ? i
                  : (e[t] = n)
                : o && "get" in o && null !== (i = o.get(e, t))
                ? i
                : e[t]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e) {
              var t = re.find.attr(e, "tabindex");
              return t
                ? parseInt(t, 10)
                : ct.test(e.nodeName) || (dt.test(e.nodeName) && e.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      ie.optSelected ||
        (re.propHooks.selected = {
          get: function (e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null;
          },
          set: function (e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
          },
        }),
      re.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          re.propFix[this.toLowerCase()] = this;
        }
      );
    var pt = /[\t\r\n\f]/g;
    re.fn.extend({
      addClass: function (e) {
        var t,
          n,
          i,
          o,
          r,
          s,
          a,
          l = 0;
        if (re.isFunction(e))
          return this.each(function (t) {
            re(this).addClass(e.call(this, t, F(this)));
          });
        if ("string" == typeof e && e)
          for (t = e.match(xe) || []; (n = this[l++]); )
            if (
              ((o = F(n)),
              (i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")))
            ) {
              for (s = 0; (r = t[s++]); )
                i.indexOf(" " + r + " ") < 0 && (i += r + " ");
              (a = re.trim(i)), o !== a && n.setAttribute("class", a);
            }
        return this;
      },
      removeClass: function (e) {
        var t,
          n,
          i,
          o,
          r,
          s,
          a,
          l = 0;
        if (re.isFunction(e))
          return this.each(function (t) {
            re(this).removeClass(e.call(this, t, F(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ("string" == typeof e && e)
          for (t = e.match(xe) || []; (n = this[l++]); )
            if (
              ((o = F(n)),
              (i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")))
            ) {
              for (s = 0; (r = t[s++]); )
                for (; i.indexOf(" " + r + " ") > -1; )
                  i = i.replace(" " + r + " ", " ");
              (a = re.trim(i)), o !== a && n.setAttribute("class", a);
            }
        return this;
      },
      toggleClass: function (e, t) {
        var n = typeof e;
        return "boolean" == typeof t && "string" === n
          ? t
            ? this.addClass(e)
            : this.removeClass(e)
          : re.isFunction(e)
          ? this.each(function (n) {
              re(this).toggleClass(e.call(this, n, F(this), t), t);
            })
          : this.each(function () {
              var t, i, o, r;
              if ("string" === n)
                for (i = 0, o = re(this), r = e.match(xe) || []; (t = r[i++]); )
                  o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
              else
                (void 0 !== e && "boolean" !== n) ||
                  ((t = F(this)),
                  t && Ce.set(this, "__className__", t),
                  this.setAttribute &&
                    this.setAttribute(
                      "class",
                      t || e === !1 ? "" : Ce.get(this, "__className__") || ""
                    ));
            });
      },
      hasClass: function (e) {
        var t,
          n,
          i = 0;
        for (t = " " + e + " "; (n = this[i++]); )
          if (
            1 === n.nodeType &&
            (" " + F(n) + " ").replace(pt, " ").indexOf(t) > -1
          )
            return !0;
        return !1;
      },
    });
    var ft = /\r/g,
      ht = /[\x20\t\r\n\f]+/g;
    re.fn.extend({
      val: function (e) {
        var t,
          n,
          i,
          o = this[0];
        return arguments.length
          ? ((i = re.isFunction(e)),
            this.each(function (n) {
              var o;
              1 === this.nodeType &&
                ((o = i ? e.call(this, n, re(this).val()) : e),
                null == o
                  ? (o = "")
                  : "number" == typeof o
                  ? (o += "")
                  : re.isArray(o) &&
                    (o = re.map(o, function (e) {
                      return null == e ? "" : e + "";
                    })),
                (t =
                  re.valHooks[this.type] ||
                  re.valHooks[this.nodeName.toLowerCase()]),
                (t && "set" in t && void 0 !== t.set(this, o, "value")) ||
                  (this.value = o));
            }))
          : o
          ? ((t = re.valHooks[o.type] || re.valHooks[o.nodeName.toLowerCase()]),
            t && "get" in t && void 0 !== (n = t.get(o, "value"))
              ? n
              : ((n = o.value),
                "string" == typeof n ? n.replace(ft, "") : null == n ? "" : n))
          : void 0;
      },
    }),
      re.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = re.find.attr(e, "value");
              return null != t ? t : re.trim(re.text(e)).replace(ht, " ");
            },
          },
          select: {
            get: function (e) {
              for (
                var t,
                  n,
                  i = e.options,
                  o = e.selectedIndex,
                  r = "select-one" === e.type || 0 > o,
                  s = r ? null : [],
                  a = r ? o + 1 : i.length,
                  l = 0 > o ? a : r ? o : 0;
                a > l;
                l++
              )
                if (
                  ((n = i[l]),
                  (n.selected || l === o) &&
                    (ie.optDisabled
                      ? !n.disabled
                      : null === n.getAttribute("disabled")) &&
                    (!n.parentNode.disabled ||
                      !re.nodeName(n.parentNode, "optgroup")))
                ) {
                  if (((t = re(n).val()), r)) return t;
                  s.push(t);
                }
              return s;
            },
            set: function (e, t) {
              for (
                var n, i, o = e.options, r = re.makeArray(t), s = o.length;
                s--;

              )
                (i = o[s]),
                  (i.selected =
                    re.inArray(re.valHooks.option.get(i), r) > -1) && (n = !0);
              return n || (e.selectedIndex = -1), r;
            },
          },
        },
      }),
      re.each(["radio", "checkbox"], function () {
        (re.valHooks[this] = {
          set: function (e, t) {
            return re.isArray(t)
              ? (e.checked = re.inArray(re(e).val(), t) > -1)
              : void 0;
          },
        }),
          ie.checkOn ||
            (re.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
      });
    var vt = /^(?:focusinfocus|focusoutblur)$/;
    re.extend(re.event, {
      trigger: function (t, n, i, o) {
        var r,
          s,
          a,
          l,
          u,
          c,
          d,
          p = [i || G],
          f = ne.call(t, "type") ? t.type : t,
          h = ne.call(t, "namespace") ? t.namespace.split(".") : [];
        if (
          ((s = a = i = i || G),
          3 !== i.nodeType &&
            8 !== i.nodeType &&
            !vt.test(f + re.event.triggered) &&
            (f.indexOf(".") > -1 &&
              ((h = f.split(".")), (f = h.shift()), h.sort()),
            (u = f.indexOf(":") < 0 && "on" + f),
            (t = t[re.expando]
              ? t
              : new re.Event(f, "object" == typeof t && t)),
            (t.isTrigger = o ? 2 : 3),
            (t.namespace = h.join(".")),
            (t.rnamespace = t.namespace
              ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (t.result = void 0),
            t.target || (t.target = i),
            (n = null == n ? [t] : re.makeArray(n, [t])),
            (d = re.event.special[f] || {}),
            o || !d.trigger || d.trigger.apply(i, n) !== !1))
        ) {
          if (!o && !d.noBubble && !re.isWindow(i)) {
            for (
              l = d.delegateType || f, vt.test(l + f) || (s = s.parentNode);
              s;
              s = s.parentNode
            )
              p.push(s), (a = s);
            a === (i.ownerDocument || G) &&
              p.push(a.defaultView || a.parentWindow || e);
          }
          for (r = 0; (s = p[r++]) && !t.isPropagationStopped(); )
            (t.type = r > 1 ? l : d.bindType || f),
              (c = (Ce.get(s, "events") || {})[t.type] && Ce.get(s, "handle")),
              c && c.apply(s, n),
              (c = u && s[u]),
              c &&
                c.apply &&
                Se(s) &&
                ((t.result = c.apply(s, n)),
                t.result === !1 && t.preventDefault());
          return (
            (t.type = f),
            o ||
              t.isDefaultPrevented() ||
              (d._default && d._default.apply(p.pop(), n) !== !1) ||
              !Se(i) ||
              (u &&
                re.isFunction(i[f]) &&
                !re.isWindow(i) &&
                ((a = i[u]),
                a && (i[u] = null),
                (re.event.triggered = f),
                i[f](),
                (re.event.triggered = void 0),
                a && (i[u] = a))),
            t.result
          );
        }
      },
      simulate: function (e, t, n) {
        var i = re.extend(new re.Event(), n, { type: e, isSimulated: !0 });
        re.event.trigger(i, null, t),
          i.isDefaultPrevented() && n.preventDefault();
      },
    }),
      re.fn.extend({
        trigger: function (e, t) {
          return this.each(function () {
            re.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, t) {
          var n = this[0];
          return n ? re.event.trigger(e, t, n, !0) : void 0;
        },
      }),
      re.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (e, t) {
          re.fn[t] = function (e, n) {
            return arguments.length > 0
              ? this.on(t, null, e, n)
              : this.trigger(t);
          };
        }
      ),
      re.fn.extend({
        hover: function (e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        },
      }),
      (ie.focusin = "onfocusin" in e),
      ie.focusin ||
        re.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
          var n = function (e) {
            re.event.simulate(t, e.target, re.event.fix(e));
          };
          re.event.special[t] = {
            setup: function () {
              var i = this.ownerDocument || this,
                o = Ce.access(i, t);
              o || i.addEventListener(e, n, !0), Ce.access(i, t, (o || 0) + 1);
            },
            teardown: function () {
              var i = this.ownerDocument || this,
                o = Ce.access(i, t) - 1;
              o
                ? Ce.access(i, t, o)
                : (i.removeEventListener(e, n, !0), Ce.remove(i, t));
            },
          };
        });
    var gt = e.location,
      mt = re.now(),
      yt = /\?/;
    (re.parseJSON = function (e) {
      return JSON.parse(e + "");
    }),
      (re.parseXML = function (t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
          n = new e.DOMParser().parseFromString(t, "text/xml");
        } catch (e) {
          n = void 0;
        }
        return (
          (n && !n.getElementsByTagName("parsererror").length) ||
            re.error("Invalid XML: " + t),
          n
        );
      });
    var bt = /#.*$/,
      wt = /([?&])_=[^&]*/,
      xt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      kt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Tt = /^(?:GET|HEAD)$/,
      St = /^\/\//,
      Ct = {},
      $t = {},
      Et = "*/".concat("*"),
      At = G.createElement("a");
    (At.href = gt.href),
      re.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: gt.href,
          type: "GET",
          isLocal: kt.test(gt.protocol),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": Et,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON",
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": re.parseJSON,
            "text xml": re.parseXML,
          },
          flatOptions: { url: !0, context: !0 },
        },
        ajaxSetup: function (e, t) {
          return t ? W(W(e, re.ajaxSettings), t) : W(re.ajaxSettings, e);
        },
        ajaxPrefilter: M(Ct),
        ajaxTransport: M($t),
        ajax: function (t, n) {
          function i(t, n, i, a) {
            var u,
              d,
              y,
              b,
              x,
              T = n;
            2 !== w &&
              ((w = 2),
              l && e.clearTimeout(l),
              (o = void 0),
              (s = a || ""),
              (k.readyState = t > 0 ? 4 : 0),
              (u = (t >= 200 && 300 > t) || 304 === t),
              i && (b = B(p, k, i)),
              (b = U(p, b, k, u)),
              u
                ? (p.ifModified &&
                    ((x = k.getResponseHeader("Last-Modified")),
                    x && (re.lastModified[r] = x),
                    (x = k.getResponseHeader("etag")),
                    x && (re.etag[r] = x)),
                  204 === t || "HEAD" === p.type
                    ? (T = "nocontent")
                    : 304 === t
                    ? (T = "notmodified")
                    : ((T = b.state), (d = b.data), (y = b.error), (u = !y)))
                : ((y = T), (!t && T) || ((T = "error"), 0 > t && (t = 0))),
              (k.status = t),
              (k.statusText = (n || T) + ""),
              u ? v.resolveWith(f, [d, T, k]) : v.rejectWith(f, [k, T, y]),
              k.statusCode(m),
              (m = void 0),
              c &&
                h.trigger(u ? "ajaxSuccess" : "ajaxError", [k, p, u ? d : y]),
              g.fireWith(f, [k, T]),
              c &&
                (h.trigger("ajaxComplete", [k, p]),
                --re.active || re.event.trigger("ajaxStop")));
          }
          "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
          var o,
            r,
            s,
            a,
            l,
            u,
            c,
            d,
            p = re.ajaxSetup({}, n),
            f = p.context || p,
            h = p.context && (f.nodeType || f.jquery) ? re(f) : re.event,
            v = re.Deferred(),
            g = re.Callbacks("once memory"),
            m = p.statusCode || {},
            y = {},
            b = {},
            w = 0,
            x = "canceled",
            k = {
              readyState: 0,
              getResponseHeader: function (e) {
                var t;
                if (2 === w) {
                  if (!a)
                    for (a = {}; (t = xt.exec(s)); )
                      a[t[1].toLowerCase()] = t[2];
                  t = a[e.toLowerCase()];
                }
                return null == t ? null : t;
              },
              getAllResponseHeaders: function () {
                return 2 === w ? s : null;
              },
              setRequestHeader: function (e, t) {
                var n = e.toLowerCase();
                return w || ((e = b[n] = b[n] || e), (y[e] = t)), this;
              },
              overrideMimeType: function (e) {
                return w || (p.mimeType = e), this;
              },
              statusCode: function (e) {
                var t;
                if (e)
                  if (2 > w) for (t in e) m[t] = [m[t], e[t]];
                  else k.always(e[k.status]);
                return this;
              },
              abort: function (e) {
                var t = e || x;
                return o && o.abort(t), i(0, t), this;
              },
            };
          if (
            ((v.promise(k).complete = g.add),
            (k.success = k.done),
            (k.error = k.fail),
            (p.url = ((t || p.url || gt.href) + "")
              .replace(bt, "")
              .replace(St, gt.protocol + "//")),
            (p.type = n.method || n.type || p.method || p.type),
            (p.dataTypes = re
              .trim(p.dataType || "*")
              .toLowerCase()
              .match(xe) || [""]),
            null == p.crossDomain)
          ) {
            u = G.createElement("a");
            try {
              (u.href = p.url),
                (u.href = u.href),
                (p.crossDomain =
                  At.protocol + "//" + At.host != u.protocol + "//" + u.host);
            } catch (e) {
              p.crossDomain = !0;
            }
          }
          if (
            (p.data &&
              p.processData &&
              "string" != typeof p.data &&
              (p.data = re.param(p.data, p.traditional)),
            R(Ct, p, n, k),
            2 === w)
          )
            return k;
          (c = re.event && p.global),
            c && 0 === re.active++ && re.event.trigger("ajaxStart"),
            (p.type = p.type.toUpperCase()),
            (p.hasContent = !Tt.test(p.type)),
            (r = p.url),
            p.hasContent ||
              (p.data &&
                ((r = p.url += (yt.test(r) ? "&" : "?") + p.data),
                delete p.data),
              p.cache === !1 &&
                (p.url = wt.test(r)
                  ? r.replace(wt, "$1_=" + mt++)
                  : r + (yt.test(r) ? "&" : "?") + "_=" + mt++)),
            p.ifModified &&
              (re.lastModified[r] &&
                k.setRequestHeader("If-Modified-Since", re.lastModified[r]),
              re.etag[r] && k.setRequestHeader("If-None-Match", re.etag[r])),
            ((p.data && p.hasContent && p.contentType !== !1) ||
              n.contentType) &&
              k.setRequestHeader("Content-Type", p.contentType),
            k.setRequestHeader(
              "Accept",
              p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                ? p.accepts[p.dataTypes[0]] +
                    ("*" !== p.dataTypes[0] ? ", " + Et + "; q=0.01" : "")
                : p.accepts["*"]
            );
          for (d in p.headers) k.setRequestHeader(d, p.headers[d]);
          if (p.beforeSend && (p.beforeSend.call(f, k, p) === !1 || 2 === w))
            return k.abort();
          x = "abort";
          for (d in { success: 1, error: 1, complete: 1 }) k[d](p[d]);
          if ((o = R($t, p, n, k))) {
            if (
              ((k.readyState = 1), c && h.trigger("ajaxSend", [k, p]), 2 === w)
            )
              return k;
            p.async &&
              p.timeout > 0 &&
              (l = e.setTimeout(function () {
                k.abort("timeout");
              }, p.timeout));
            try {
              (w = 1), o.send(y, i);
            } catch (e) {
              if (!(2 > w)) throw e;
              i(-1, e);
            }
          } else i(-1, "No Transport");
          return k;
        },
        getJSON: function (e, t, n) {
          return re.get(e, t, n, "json");
        },
        getScript: function (e, t) {
          return re.get(e, void 0, t, "script");
        },
      }),
      re.each(["get", "post"], function (e, t) {
        re[t] = function (e, n, i, o) {
          return (
            re.isFunction(n) && ((o = o || i), (i = n), (n = void 0)),
            re.ajax(
              re.extend(
                { url: e, type: t, dataType: o, data: n, success: i },
                re.isPlainObject(e) && e
              )
            )
          );
        };
      }),
      (re._evalUrl = function (e) {
        return re.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          async: !1,
          global: !1,
          throws: !0,
        });
      }),
      re.fn.extend({
        wrapAll: function (e) {
          var t;
          return re.isFunction(e)
            ? this.each(function (t) {
                re(this).wrapAll(e.call(this, t));
              })
            : (this[0] &&
                ((t = re(e, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && t.insertBefore(this[0]),
                t
                  .map(function () {
                    for (var e = this; e.firstElementChild; )
                      e = e.firstElementChild;
                    return e;
                  })
                  .append(this)),
              this);
        },
        wrapInner: function (e) {
          return re.isFunction(e)
            ? this.each(function (t) {
                re(this).wrapInner(e.call(this, t));
              })
            : this.each(function () {
                var t = re(this),
                  n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e);
              });
        },
        wrap: function (e) {
          var t = re.isFunction(e);
          return this.each(function (n) {
            re(this).wrapAll(t ? e.call(this, n) : e);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              re.nodeName(this, "body") ||
                re(this).replaceWith(this.childNodes);
            })
            .end();
        },
      }),
      (re.expr.filters.hidden = function (e) {
        return !re.expr.filters.visible(e);
      }),
      (re.expr.filters.visible = function (e) {
        return (
          e.offsetWidth > 0 ||
          e.offsetHeight > 0 ||
          e.getClientRects().length > 0
        );
      });
    var jt = /%20/g,
      Nt = /\[\]$/,
      Dt = /\r?\n/g,
      Ot = /^(?:submit|button|image|reset|file)$/i,
      Ht = /^(?:input|select|textarea|keygen)/i;
    (re.param = function (e, t) {
      var n,
        i = [],
        o = function (e, t) {
          (t = re.isFunction(t) ? t() : null == t ? "" : t),
            (i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
        };
      if (
        (void 0 === t && (t = re.ajaxSettings && re.ajaxSettings.traditional),
        re.isArray(e) || (e.jquery && !re.isPlainObject(e)))
      )
        re.each(e, function () {
          o(this.name, this.value);
        });
      else for (n in e) X(n, e[n], t, o);
      return i.join("&").replace(jt, "+");
    }),
      re.fn.extend({
        serialize: function () {
          return re.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var e = re.prop(this, "elements");
            return e ? re.makeArray(e) : this;
          })
            .filter(function () {
              var e = this.type;
              return (
                this.name &&
                !re(this).is(":disabled") &&
                Ht.test(this.nodeName) &&
                !Ot.test(e) &&
                (this.checked || !He.test(e))
              );
            })
            .map(function (e, t) {
              var n = re(this).val();
              return null == n
                ? null
                : re.isArray(n)
                ? re.map(n, function (e) {
                    return { name: t.name, value: e.replace(Dt, "\r\n") };
                  })
                : { name: t.name, value: n.replace(Dt, "\r\n") };
            })
            .get();
        },
      }),
      (re.ajaxSettings.xhr = function () {
        try {
          return new e.XMLHttpRequest();
        } catch (e) {}
      });
    var qt = { 0: 200, 1223: 204 },
      Pt = re.ajaxSettings.xhr();
    (ie.cors = !!Pt && "withCredentials" in Pt),
      (ie.ajax = Pt = !!Pt),
      re.ajaxTransport(function (t) {
        var n, i;
        return ie.cors || (Pt && !t.crossDomain)
          ? {
              send: function (o, r) {
                var s,
                  a = t.xhr();
                if (
                  (a.open(t.type, t.url, t.async, t.username, t.password),
                  t.xhrFields)
                )
                  for (s in t.xhrFields) a[s] = t.xhrFields[s];
                t.mimeType &&
                  a.overrideMimeType &&
                  a.overrideMimeType(t.mimeType),
                  t.crossDomain ||
                    o["X-Requested-With"] ||
                    (o["X-Requested-With"] = "XMLHttpRequest");
                for (s in o) a.setRequestHeader(s, o[s]);
                (n = function (e) {
                  return function () {
                    n &&
                      ((n =
                        i =
                        a.onload =
                        a.onerror =
                        a.onabort =
                        a.onreadystatechange =
                          null),
                      "abort" === e
                        ? a.abort()
                        : "error" === e
                        ? "number" != typeof a.status
                          ? r(0, "error")
                          : r(a.status, a.statusText)
                        : r(
                            qt[a.status] || a.status,
                            a.statusText,
                            "text" !== (a.responseType || "text") ||
                              "string" != typeof a.responseText
                              ? { binary: a.response }
                              : { text: a.responseText },
                            a.getAllResponseHeaders()
                          ));
                  };
                }),
                  (a.onload = n()),
                  (i = a.onerror = n("error")),
                  void 0 !== a.onabort
                    ? (a.onabort = i)
                    : (a.onreadystatechange = function () {
                        4 === a.readyState &&
                          e.setTimeout(function () {
                            n && i();
                          });
                      }),
                  (n = n("abort"));
                try {
                  a.send((t.hasContent && t.data) || null);
                } catch (e) {
                  if (n) throw e;
                }
              },
              abort: function () {
                n && n();
              },
            }
          : void 0;
      }),
      re.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (e) {
            return re.globalEval(e), e;
          },
        },
      }),
      re.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }),
      re.ajaxTransport("script", function (e) {
        if (e.crossDomain) {
          var t, n;
          return {
            send: function (i, o) {
              (t = re("<script>")
                .prop({ charset: e.scriptCharset, src: e.url })
                .on(
                  "load error",
                  (n = function (e) {
                    t.remove(),
                      (n = null),
                      e && o("error" === e.type ? 404 : 200, e.type);
                  })
                )),
                G.head.appendChild(t[0]);
            },
            abort: function () {
              n && n();
            },
          };
        }
      });
    var Lt = [],
      _t = /(=)\?(?=&|$)|\?\?/;
    re.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = Lt.pop() || re.expando + "_" + mt++;
        return (this[e] = !0), e;
      },
    }),
      re.ajaxPrefilter("json jsonp", function (t, n, i) {
        var o,
          r,
          s,
          a =
            t.jsonp !== !1 &&
            (_t.test(t.url)
              ? "url"
              : "string" == typeof t.data &&
                0 ===
                  (t.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                _t.test(t.data) &&
                "data");
        return a || "jsonp" === t.dataTypes[0]
          ? ((o = t.jsonpCallback =
              re.isFunction(t.jsonpCallback)
                ? t.jsonpCallback()
                : t.jsonpCallback),
            a
              ? (t[a] = t[a].replace(_t, "$1" + o))
              : t.jsonp !== !1 &&
                (t.url += (yt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
            (t.converters["script json"] = function () {
              return s || re.error(o + " was not called"), s[0];
            }),
            (t.dataTypes[0] = "json"),
            (r = e[o]),
            (e[o] = function () {
              s = arguments;
            }),
            i.always(function () {
              void 0 === r ? re(e).removeProp(o) : (e[o] = r),
                t[o] && ((t.jsonpCallback = n.jsonpCallback), Lt.push(o)),
                s && re.isFunction(r) && r(s[0]),
                (s = r = void 0);
            }),
            "script")
          : void 0;
      }),
      (re.parseHTML = function (e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && ((n = t), (t = !1)), (t = t || G);
        var i = he.exec(e),
          o = !n && [];
        return i
          ? [t.createElement(i[1])]
          : ((i = p([e], t, o)),
            o && o.length && re(o).remove(),
            re.merge([], i.childNodes));
      });
    var zt = re.fn.load;
    (re.fn.load = function (e, t, n) {
      if ("string" != typeof e && zt) return zt.apply(this, arguments);
      var i,
        o,
        r,
        s = this,
        a = e.indexOf(" ");
      return (
        a > -1 && ((i = re.trim(e.slice(a))), (e = e.slice(0, a))),
        re.isFunction(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (o = "POST"),
        s.length > 0 &&
          re
            .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
            .done(function (e) {
              (r = arguments),
                s.html(i ? re("<div>").append(re.parseHTML(e)).find(i) : e);
            })
            .always(
              n &&
                function (e, t) {
                  s.each(function () {
                    n.apply(this, r || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
      re.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e, t) {
          re.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      (re.expr.filters.animated = function (e) {
        return re.grep(re.timers, function (t) {
          return e === t.elem;
        }).length;
      }),
      (re.offset = {
        setOffset: function (e, t, n) {
          var i,
            o,
            r,
            s,
            a,
            l,
            u,
            c = re.css(e, "position"),
            d = re(e),
            p = {};
          "static" === c && (e.style.position = "relative"),
            (a = d.offset()),
            (r = re.css(e, "top")),
            (l = re.css(e, "left")),
            (u =
              ("absolute" === c || "fixed" === c) &&
              (r + l).indexOf("auto") > -1),
            u
              ? ((i = d.position()), (s = i.top), (o = i.left))
              : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
            re.isFunction(t) && (t = t.call(e, n, re.extend({}, a))),
            null != t.top && (p.top = t.top - a.top + s),
            null != t.left && (p.left = t.left - a.left + o),
            "using" in t ? t.using.call(e, p) : d.css(p);
        },
      }),
      re.fn.extend({
        offset: function (e) {
          if (arguments.length)
            return void 0 === e
              ? this
              : this.each(function (t) {
                  re.offset.setOffset(this, e, t);
                });
          var t,
            n,
            i = this[0],
            o = { top: 0, left: 0 },
            r = i && i.ownerDocument;
          return r
            ? ((t = r.documentElement),
              re.contains(t, i)
                ? ((o = i.getBoundingClientRect()),
                  (n = Y(r)),
                  {
                    top: o.top + n.pageYOffset - t.clientTop,
                    left: o.left + n.pageXOffset - t.clientLeft,
                  })
                : o)
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e,
              t,
              n = this[0],
              i = { top: 0, left: 0 };
            return (
              "fixed" === re.css(n, "position")
                ? (t = n.getBoundingClientRect())
                : ((e = this.offsetParent()),
                  (t = this.offset()),
                  re.nodeName(e[0], "html") || (i = e.offset()),
                  (i.top += re.css(e[0], "borderTopWidth", !0)),
                  (i.left += re.css(e[0], "borderLeftWidth", !0))),
              {
                top: t.top - i.top - re.css(n, "marginTop", !0),
                left: t.left - i.left - re.css(n, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent;
              e && "static" === re.css(e, "position");

            )
              e = e.offsetParent;
            return e || Ze;
          });
        },
      }),
      re.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (e, t) {
          var n = "pageYOffset" === t;
          re.fn[e] = function (i) {
            return Te(
              this,
              function (e, i, o) {
                var r = Y(e);
                return void 0 === o
                  ? r
                    ? r[t]
                    : e[i]
                  : void (r
                      ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset)
                      : (e[i] = o));
              },
              e,
              i,
              arguments.length
            );
          };
        }
      ),
      re.each(["top", "left"], function (e, t) {
        re.cssHooks[t] = E(ie.pixelPosition, function (e, n) {
          return n
            ? ((n = $(e, t)), Ge.test(n) ? re(e).position()[t] + "px" : n)
            : void 0;
        });
      }),
      re.each({ Height: "height", Width: "width" }, function (e, t) {
        re.each(
          { padding: "inner" + e, content: t, "": "outer" + e },
          function (n, i) {
            re.fn[i] = function (i, o) {
              var r = arguments.length && (n || "boolean" != typeof i),
                s = n || (i === !0 || o === !0 ? "margin" : "border");
              return Te(
                this,
                function (t, n, i) {
                  var o;
                  return re.isWindow(t)
                    ? t.document.documentElement["client" + e]
                    : 9 === t.nodeType
                    ? ((o = t.documentElement),
                      Math.max(
                        t.body["scroll" + e],
                        o["scroll" + e],
                        t.body["offset" + e],
                        o["offset" + e],
                        o["client" + e]
                      ))
                    : void 0 === i
                    ? re.css(t, n, s)
                    : re.style(t, n, i, s);
                },
                t,
                r ? i : void 0,
                r,
                null
              );
            };
          }
        );
      }),
      re.fn.extend({
        bind: function (e, t, n) {
          return this.on(e, null, t, n);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, n, i) {
          return this.on(t, e, n, i);
        },
        undelegate: function (e, t, n) {
          return 1 === arguments.length
            ? this.off(e, "**")
            : this.off(t, e || "**", n);
        },
        size: function () {
          return this.length;
        },
      }),
      (re.fn.andSelf = re.fn.addBack),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return re;
        });
    var It = e.jQuery,
      Ft = e.$;
    return (
      (re.noConflict = function (t) {
        return (
          e.$ === re && (e.$ = Ft), t && e.jQuery === re && (e.jQuery = It), re
        );
      }),
      t || (e.jQuery = e.$ = re),
      re
    );
  })
  /*!
   * jquery.zoom.min.js
   */,
  /*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
  (function (e) {
    var t = {
      url: !1,
      callback: !1,
      target: !1,
      duration: 120,
      on: "mouseover",
      touch: !0,
      onZoomIn: !1,
      onZoomOut: !1,
      magnify: 1,
    };
    (e.zoom = function (t, n, i, o) {
      var r,
        s,
        a,
        l,
        u,
        c,
        d,
        p = e(t),
        f = p.css("position"),
        h = e(n);
      return (
        (t.style.position = /(absolute|fixed)/.test(f) ? f : "relative"),
        (t.style.overflow = "hidden"),
        (i.style.width = i.style.height = ""),
        e(i)
          .addClass("zoomImg")
          .css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * o,
            height: i.height * o,
            border: "none",
            maxWidth: "none",
            maxHeight: "none",
          })
          .appendTo(t),
        {
          init: function () {
            (s = p.outerWidth()),
              (r = p.outerHeight()),
              n === t
                ? ((l = s), (a = r))
                : ((l = h.outerWidth()), (a = h.outerHeight())),
              (u = (i.width - s) / l),
              (c = (i.height - r) / a),
              (d = h.offset());
          },
          move: function (e) {
            var t = e.pageX - d.left,
              n = e.pageY - d.top;
            (n = Math.max(Math.min(n, a), 0)),
              (t = Math.max(Math.min(t, l), 0)),
              (i.style.left = t * -u + "px"),
              (i.style.top = n * -c + "px");
          },
        }
      );
    }),
      (e.fn.zoom = function (n) {
        return this.each(function () {
          var i = e.extend({}, t, n || {}),
            o = (i.target && e(i.target)[0]) || this,
            r = this,
            s = e(r),
            a = document.createElement("img"),
            l = e(a),
            u = "mousemove.zoom",
            c = !1,
            d = !1;
          if (!i.url) {
            var p = r.querySelector("img");
            if (
              (p &&
                (i.url = p.getAttribute("data-src") || p.currentSrc || p.src),
              !i.url)
            )
              return;
          }
          s.one(
            "zoom.destroy",
            function (e, t) {
              s.off(".zoom"),
                (o.style.position = e),
                (o.style.overflow = t),
                (a.onload = null),
                l.remove();
            }.bind(this, o.style.position, o.style.overflow)
          ),
            (a.onload = function () {
              function t(t) {
                p.init(),
                  p.move(t),
                  l
                    .stop()
                    .fadeTo(
                      e.support.opacity ? i.duration : 0,
                      1,
                      !!e.isFunction(i.onZoomIn) && i.onZoomIn.call(a)
                    );
              }
              function n() {
                l.stop().fadeTo(
                  i.duration,
                  0,
                  !!e.isFunction(i.onZoomOut) && i.onZoomOut.call(a)
                );
              }
              var p = e.zoom(o, r, a, i.magnify);
              "grab" === i.on
                ? s.on("mousedown.zoom", function (i) {
                    1 === i.which &&
                      (e(document).one("mouseup.zoom", function () {
                        n(), e(document).off(u, p.move);
                      }),
                      t(i),
                      e(document).on(u, p.move),
                      i.preventDefault());
                  })
                : "click" === i.on
                ? s.on("click.zoom", function (i) {
                    return c
                      ? void 0
                      : ((c = !0),
                        t(i),
                        e(document).on(u, p.move),
                        e(document).one("click.zoom", function () {
                          n(), (c = !1), e(document).off(u, p.move);
                        }),
                        !1);
                  })
                : "toggle" === i.on
                ? s.on("click.zoom", function (e) {
                    c ? n() : t(e), (c = !c);
                  })
                : "mouseover" === i.on &&
                  (p.init(),
                  s
                    .on("mouseenter.zoom", t)
                    .on("mouseleave.zoom", n)
                    .on(u, p.move)),
                i.touch &&
                  s
                    .on("touchstart.zoom", function (e) {
                      e.preventDefault(),
                        d
                          ? ((d = !1), n())
                          : ((d = !0),
                            t(
                              e.originalEvent.touches[0] ||
                                e.originalEvent.changedTouches[0]
                            ));
                    })
                    .on("touchmove.zoom", function (e) {
                      e.preventDefault(),
                        p.move(
                          e.originalEvent.touches[0] ||
                            e.originalEvent.changedTouches[0]
                        );
                    })
                    .on("touchend.zoom", function (e) {
                      e.preventDefault(), d && ((d = !1), n());
                    }),
                e.isFunction(i.callback) && i.callback.call(a);
            }),
            a.setAttribute("role", "presentation"),
            (a.alt = ""),
            (a.src = i.url);
        });
      }),
      (e.fn.zoom.defaults = t);
  })(window.jQuery),
  function () {
    function e(e, t) {
      for (var n = -1, i = t.length, o = e.length; ++n < i; ) e[o + n] = t[n];
      return e;
    }
    function t(e, t, n) {
      for (var i = -1, o = e.length; ++i < o; ) {
        var r = e[i],
          s = t(r);
        if (null != s && (a === le ? s === s : n(s, a)))
          var a = s,
            l = r;
      }
      return l;
    }
    function n(e, t, n) {
      var i;
      return (
        n(e, function (e, n, o) {
          return t(e, n, o) ? ((i = e), !1) : void 0;
        }),
        i
      );
    }
    function i(e, t, n, i, o) {
      return (
        o(e, function (e, o, r) {
          n = i ? ((i = !1), e) : t(n, e, o, r);
        }),
        n
      );
    }
    function o(e, t) {
      return T(t, function (t) {
        return e[t];
      });
    }
    function r(e) {
      return e && e.Object === Object ? e : null;
    }
    function s(e) {
      return fe[e];
    }
    function a(e) {
      var t = !1;
      if (null != e && "function" != typeof e.toString)
        try {
          t = !!(e + "");
        } catch (e) {}
      return t;
    }
    function l(e, t) {
      return (
        (e = "number" == typeof e || pe.test(e) ? +e : -1),
        e > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e
      );
    }
    function u(e) {
      if (Z(e) && !Re(e)) {
        if (e instanceof c) return e;
        if (Se.call(e, "__wrapped__")) {
          var t = new c(e.__wrapped__, e.__chain__);
          return (t.__actions__ = A(e.__actions__)), t;
        }
      }
      return new c(e);
    }
    function c(e, t) {
      (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t);
    }
    function d(e, t, n, i) {
      var o;
      return (
        (o = e === le) ||
          ((o = Te[n]),
          (o = (e === o || (e !== e && o !== o)) && !Se.call(i, n))),
        o ? t : e
      );
    }
    function p(e) {
      return J(e) ? Ne(e) : {};
    }
    function f(e, t, n) {
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return setTimeout(function () {
        e.apply(le, n);
      }, t);
    }
    function h(e, t) {
      var n = !0;
      return (
        Pe(e, function (e, i, o) {
          return (n = !!t(e, i, o));
        }),
        n
      );
    }
    function v(e, t) {
      var n = [];
      return (
        Pe(e, function (e, i, o) {
          t(e, i, o) && n.push(e);
        }),
        n
      );
    }
    function g(t, n, i, o) {
      o || (o = []);
      for (var r = -1, s = t.length; ++r < s; ) {
        var a = t[r];
        n > 0 && Z(a) && V(a) && (i || Re(a) || Y(a))
          ? n > 1
            ? g(a, n - 1, i, o)
            : e(o, a)
          : i || (o[o.length] = a);
      }
      return o;
    }
    function m(e, t) {
      return e && Le(e, t, ie);
    }
    function y(e, t) {
      return v(t, function (t) {
        return G(e[t]);
      });
    }
    function b(e, t, n, i, o) {
      return (
        e === t ||
        (null == e || null == t || (!J(e) && !Z(t))
          ? e !== e && t !== t
          : w(e, t, b, n, i, o))
      );
    }
    function w(e, t, n, i, o, r) {
      var s = Re(e),
        l = Re(t),
        u = "[object Array]",
        c = "[object Array]";
      s ||
        ((u = $e.call(e)),
        "[object Arguments]" == u && (u = "[object Object]")),
        l ||
          ((c = $e.call(t)),
          "[object Arguments]" == c && (c = "[object Object]"));
      var d = "[object Object]" == u && !a(e),
        l = "[object Object]" == c && !a(t);
      return !(c = u == c) || s || d
        ? 2 & o ||
          ((u = d && Se.call(e, "__wrapped__")),
          (l = l && Se.call(t, "__wrapped__")),
          !u && !l)
          ? !!c &&
            (r || (r = []),
            (u = M(r, function (t) {
              return t[0] === e;
            })) && u[1]
              ? u[1] == t
              : (r.push([e, t]),
                (t = (s ? P : _)(e, t, n, i, o, r)),
                r.pop(),
                t))
          : n(u ? e.value() : e, l ? t.value() : t, i, o, r)
        : L(e, t, u);
    }
    function x(e) {
      var t = typeof e;
      return "function" == t ? e : null == e ? se : ("object" == t ? S : $)(e);
    }
    function k(e) {
      e = null == e ? e : Object(e);
      var t,
        n = [];
      for (t in e) n.push(t);
      return n;
    }
    function T(e, t) {
      var n = -1,
        i = V(e) ? Array(e.length) : [];
      return (
        Pe(e, function (e, o, r) {
          i[++n] = t(e, o, r);
        }),
        i
      );
    }
    function S(e) {
      var t = ie(e);
      return function (n) {
        var i = t.length;
        if (null == n) return !i;
        for (n = Object(n); i--; ) {
          var o = t[i];
          if (!(o in n && b(e[o], n[o], le, 3))) return !1;
        }
        return !0;
      };
    }
    function C(e, t) {
      return (
        (e = Object(e)),
        W(
          t,
          function (t, n) {
            return n in e && (t[n] = e[n]), t;
          },
          {}
        )
      );
    }
    function $(e) {
      return function (t) {
        return null == t ? le : t[e];
      };
    }
    function E(e, t, n) {
      var i = -1,
        o = e.length;
      for (
        0 > t && (t = -t > o ? 0 : o + t),
          n = n > o ? o : n,
          0 > n && (n += o),
          o = t > n ? 0 : (n - t) >>> 0,
          t >>>= 0,
          n = Array(o);
        ++i < o;

      )
        n[i] = e[i + t];
      return n;
    }
    function A(e) {
      return E(e, 0, e.length);
    }
    function j(e, t) {
      var n;
      return (
        Pe(e, function (e, i, o) {
          return (n = t(e, i, o)), !n;
        }),
        !!n
      );
    }
    function N(t, n) {
      return W(
        n,
        function (t, n) {
          return n.func.apply(n.thisArg, e([t], n.args));
        },
        t
      );
    }
    function D(e, t, n, i) {
      n || (n = {});
      for (var o = -1, r = t.length; ++o < r; ) {
        var s = t[o],
          a = i ? i(n[s], e[s], s, n, e) : e[s],
          l = n,
          u = l[s];
        (Se.call(l, s) &&
          (u === a || (u !== u && a !== a)) &&
          (a !== le || s in l)) ||
          (l[s] = a);
      }
      return n;
    }
    function O(e) {
      return U(function (t, n) {
        var i = -1,
          o = n.length,
          r = o > 1 ? n[o - 1] : le,
          r = "function" == typeof r ? (o--, r) : le;
        for (t = Object(t); ++i < o; ) {
          var s = n[i];
          s && e(t, s, i, r);
        }
        return t;
      });
    }
    function H(e) {
      return function () {
        var t = arguments,
          n = p(e.prototype),
          t = e.apply(n, t);
        return J(t) ? t : n;
      };
    }
    function q(e, t, n) {
      function i() {
        for (
          var r = -1,
            s = arguments.length,
            a = -1,
            l = n.length,
            u = Array(l + s),
            c = this && this !== xe && this instanceof i ? o : e;
          ++a < l;

        )
          u[a] = n[a];
        for (; s--; ) u[a++] = arguments[++r];
        return c.apply(t, u);
      }
      if ("function" != typeof e) throw new TypeError("Expected a function");
      var o = H(e);
      return i;
    }
    function P(e, t, n, i, o, r) {
      var s = -1,
        a = 1 & o,
        l = e.length,
        u = t.length;
      if (l != u && !(2 & o && u > l)) return !1;
      for (u = !0; ++s < l; ) {
        var c = e[s],
          d = t[s];
        if (void 0 !== le) {
          u = !1;
          break;
        }
        if (a) {
          if (
            !j(t, function (e) {
              return c === e || n(c, e, i, o, r);
            })
          ) {
            u = !1;
            break;
          }
        } else if (c !== d && !n(c, d, i, o, r)) {
          u = !1;
          break;
        }
      }
      return u;
    }
    function L(e, t, n) {
      switch (n) {
        case "[object Boolean]":
        case "[object Date]":
          return +e == +t;
        case "[object Error]":
          return e.name == t.name && e.message == t.message;
        case "[object Number]":
          return e != +e ? t != +t : e == +t;
        case "[object RegExp]":
        case "[object String]":
          return e == t + "";
      }
      return !1;
    }
    function _(e, t, n, i, o, r) {
      var s = 2 & o,
        a = ie(e),
        l = a.length,
        u = ie(t).length;
      if (l != u && !s) return !1;
      for (var c = l; c--; ) {
        var d = a[c];
        if (!(s ? d in t : Se.call(t, d))) return !1;
      }
      for (u = !0; ++c < l; ) {
        var d = a[c],
          p = e[d],
          f = t[d];
        if (void 0 !== le || (p !== f && !n(p, f, i, o, r))) {
          u = !1;
          break;
        }
        s || (s = "constructor" == d);
      }
      return (
        u &&
          !s &&
          ((n = e.constructor),
          (i = t.constructor),
          n != i &&
            "constructor" in e &&
            "constructor" in t &&
            !(
              "function" == typeof n &&
              n instanceof n &&
              "function" == typeof i &&
              i instanceof i
            ) &&
            (u = !1)),
        u
      );
    }
    function z(e) {
      var t = e ? e.length : le;
      if (Q(t) && (Re(e) || ee(e) || Y(e))) {
        e = String;
        for (var n = -1, i = Array(t); ++n < t; ) i[n] = e(n);
        t = i;
      } else t = null;
      return t;
    }
    function I(e) {
      var t = e && e.constructor,
        t = (G(t) && t.prototype) || Te;
      return e === t;
    }
    function F(e) {
      return e ? e[0] : le;
    }
    function M(e, t) {
      return n(e, x(t), Pe);
    }
    function R(e, t) {
      return Pe(e, "function" == typeof t ? t : se);
    }
    function W(e, t, n) {
      return i(e, x(t), n, 3 > arguments.length, Pe);
    }
    function B(e, t) {
      var n;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      return (
        (e = We(e)),
        function () {
          return (
            0 < --e && (n = t.apply(this, arguments)), 1 >= e && (t = le), n
          );
        }
      );
    }
    function U(e) {
      var t;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return (
        (t = qe(t === le ? e.length - 1 : We(t), 0)),
        function () {
          for (
            var n = arguments, i = -1, o = qe(n.length - t, 0), r = Array(o);
            ++i < o;

          )
            r[i] = n[t + i];
          for (o = Array(t + 1), i = -1; ++i < t; ) o[i] = n[i];
          return (o[t] = r), e.apply(this, o);
        }
      );
    }
    function X(e, t) {
      return e > t;
    }
    function Y(e) {
      return (
        Z(e) &&
        V(e) &&
        Se.call(e, "callee") &&
        (!De.call(e, "callee") || "[object Arguments]" == $e.call(e))
      );
    }
    function V(e) {
      return null != e && !("function" == typeof e && G(e)) && Q(_e(e));
    }
    function G(e) {
      return (
        (e = J(e) ? $e.call(e) : ""),
        "[object Function]" == e || "[object GeneratorFunction]" == e
      );
    }
    function Q(e) {
      return (
        "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e
      );
    }
    function J(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function Z(e) {
      return !!e && "object" == typeof e;
    }
    function K(e) {
      return "number" == typeof e || (Z(e) && "[object Number]" == $e.call(e));
    }
    function ee(e) {
      return (
        "string" == typeof e ||
        (!Re(e) && Z(e) && "[object String]" == $e.call(e))
      );
    }
    function te(e, t) {
      return t > e;
    }
    function ne(e) {
      return "string" == typeof e ? e : null == e ? "" : e + "";
    }
    function ie(e) {
      var t = I(e);
      if (!t && !V(e)) return He(Object(e));
      var n,
        i = z(e),
        o = !!i,
        i = i || [],
        r = i.length;
      for (n in e)
        !Se.call(e, n) ||
          (o && ("length" == n || l(n, r))) ||
          (t && "constructor" == n) ||
          i.push(n);
      return i;
    }
    function oe(e) {
      for (
        var t = -1,
          n = I(e),
          i = k(e),
          o = i.length,
          r = z(e),
          s = !!r,
          r = r || [],
          a = r.length;
        ++t < o;

      ) {
        var u = i[t];
        (s && ("length" == u || l(u, a))) ||
          ("constructor" == u && (n || !Se.call(e, u))) ||
          r.push(u);
      }
      return r;
    }
    function re(e) {
      return e ? o(e, ie(e)) : [];
    }
    function se(e) {
      return e;
    }
    function ae(t, n, i) {
      var o = ie(n),
        r = y(n, o);
      null != i ||
        (J(n) && (r.length || !o.length)) ||
        ((i = n), (n = t), (t = this), (r = y(n, ie(n))));
      var s = !(J(i) && "chain" in i) || i.chain,
        a = G(t);
      return (
        Pe(r, function (i) {
          var o = n[i];
          (t[i] = o),
            a &&
              (t.prototype[i] = function () {
                var n = this.__chain__;
                if (s || n) {
                  var i = t(this.__wrapped__);
                  return (
                    (i.__actions__ = A(this.__actions__)).push({
                      func: o,
                      args: arguments,
                      thisArg: t,
                    }),
                    (i.__chain__ = n),
                    i
                  );
                }
                return o.apply(t, e([this.value()], arguments));
              });
        }),
        t
      );
    }
    var le,
      ue = 1 / 0,
      ce = /[&<>"'`]/g,
      de = RegExp(ce.source),
      pe = /^(?:0|[1-9]\d*)$/,
      fe = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "`": "&#96;",
      },
      he = { function: !0, object: !0 },
      ve = he[typeof exports] && exports && !exports.nodeType ? exports : le,
      ge = he[typeof module] && module && !module.nodeType ? module : le,
      me = ge && ge.exports === ve ? ve : le,
      ye = r(he[typeof self] && self),
      be = r(he[typeof window] && window),
      we = r(he[typeof this] && this),
      xe =
        r(ve && ge && "object" == typeof global && global) ||
        (be !== (we && we.window) && be) ||
        ye ||
        we ||
        Function("return this")(),
      ke = Array.prototype,
      Te = Object.prototype,
      Se = Te.hasOwnProperty,
      Ce = 0,
      $e = Te.toString,
      Ee = xe._,
      Ae = xe.Reflect,
      je = Ae ? Ae.f : le,
      Ne = Object.create,
      De = Te.propertyIsEnumerable,
      Oe = xe.isFinite,
      He = Object.keys,
      qe = Math.max,
      Pe = (function (e, t) {
        return function (n, i) {
          if (null == n) return n;
          if (!V(n)) return e(n, i);
          for (
            var o = n.length, r = t ? o : -1, s = Object(n);
            (t ? r-- : ++r < o) && !1 !== i(s[r], r, s);

          );
          return n;
        };
      })(m),
      Le = (function (e) {
        return function (t, n, i) {
          var o = -1,
            r = Object(t);
          i = i(t);
          for (var s = i.length; s--; ) {
            var a = i[e ? s : ++o];
            if (!1 === n(r[a], a, r)) break;
          }
          return t;
        };
      })();
    je &&
      !De.call({ valueOf: 1 }, "valueOf") &&
      (k = function (e) {
        e = je(e);
        for (var t, n = []; !(t = e.next()).done; ) n.push(t.value);
        return n;
      });
    var _e = $("length"),
      ze = U(function (t, n) {
        return (
          Re(t) || (t = null == t ? [] : [Object(t)]), g(n, 1), e(A(t), re)
        );
      }),
      Ie = U(function (e, t, n) {
        return q(e, t, n);
      }),
      Fe = U(function (e, t) {
        return f(e, 1, t);
      }),
      Me = U(function (e, t, n) {
        return f(e, Be(t) || 0, n);
      }),
      Re = Array.isArray,
      We = Number,
      Be = Number,
      Ue = O(function (e, t) {
        D(t, ie(t), e);
      }),
      Xe = O(function (e, t) {
        D(t, oe(t), e);
      }),
      Ye = O(function (e, t, n, i) {
        D(t, oe(t), e, i);
      }),
      Ve = U(function (e) {
        return e.push(le, d), Ye.apply(le, e);
      }),
      Ge = U(function (e, t) {
        return null == e ? {} : C(e, g(t, 1));
      }),
      Qe = x;
    (c.prototype = p(u.prototype)),
      (c.prototype.constructor = c),
      (u.assignIn = Xe),
      (u.before = B),
      (u.bind = Ie),
      (u.chain = function (e) {
        return (e = u(e)), (e.__chain__ = !0), e;
      }),
      (u.compact = function (e) {
        return v(e, Boolean);
      }),
      (u.concat = ze),
      (u.create = function (e, t) {
        var n = p(e);
        return t ? Ue(n, t) : n;
      }),
      (u.defaults = Ve),
      (u.defer = Fe),
      (u.delay = Me),
      (u.filter = function (e, t) {
        return v(e, x(t));
      }),
      (u.flatten = function (e) {
        return e && e.length ? g(e, 1) : [];
      }),
      (u.flattenDeep = function (e) {
        return e && e.length ? g(e, ue) : [];
      }),
      (u.iteratee = Qe),
      (u.keys = ie),
      (u.map = function (e, t) {
        return T(e, x(t));
      }),
      (u.matches = function (e) {
        return S(Ue({}, e));
      }),
      (u.mixin = ae),
      (u.negate = function (e) {
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return function () {
          return !e.apply(this, arguments);
        };
      }),
      (u.once = function (e) {
        return B(2, e);
      }),
      (u.pick = Ge),
      (u.slice = function (e, t, n) {
        var i = e ? e.length : 0;
        return (n = n === le ? i : +n), i ? E(e, null == t ? 0 : +t, n) : [];
      }),
      (u.sortBy = function (e, t) {
        var n = 0;
        return (
          (t = x(t)),
          T(
            T(e, function (e, i, o) {
              return { c: e, b: n++, a: t(e, i, o) };
            }).sort(function (e, t) {
              var n;
              e: {
                n = e.a;
                var i = t.a;
                if (n !== i) {
                  var o = null === n,
                    r = n === le,
                    s = n === n,
                    a = null === i,
                    l = i === le,
                    u = i === i;
                  if ((n > i && !a) || !s || (o && !l && u) || (r && u)) {
                    n = 1;
                    break e;
                  }
                  if ((i > n && !o) || !u || (a && !r && s) || (l && s)) {
                    n = -1;
                    break e;
                  }
                }
                n = 0;
              }
              return n || e.b - t.b;
            }),
            $("c")
          )
        );
      }),
      (u.tap = function (e, t) {
        return t(e), e;
      }),
      (u.thru = function (e, t) {
        return t(e);
      }),
      (u.toArray = function (e) {
        return V(e) ? (e.length ? A(e) : []) : re(e);
      }),
      (u.values = re),
      (u.extend = Xe),
      ae(u, u),
      (u.clone = function (e) {
        return J(e) ? (Re(e) ? A(e) : D(e, ie(e))) : e;
      }),
      (u.escape = function (e) {
        return (e = ne(e)) && de.test(e) ? e.replace(ce, s) : e;
      }),
      (u.every = function (e, t, n) {
        return (t = n ? le : t), h(e, x(t));
      }),
      (u.find = M),
      (u.forEach = R),
      (u.has = function (e, t) {
        return null != e && Se.call(e, t);
      }),
      (u.head = F),
      (u.identity = se),
      (u.indexOf = function (e, t, n) {
        var i = e ? e.length : 0;
        (n = "number" == typeof n ? (0 > n ? qe(i + n, 0) : n) : 0),
          (n = (n || 0) - 1);
        for (var o = t === t; ++n < i; ) {
          var r = e[n];
          if (o ? r === t : r !== r) return n;
        }
        return -1;
      }),
      (u.isArguments = Y),
      (u.isArray = Re),
      (u.isBoolean = function (e) {
        return (
          !0 === e || !1 === e || (Z(e) && "[object Boolean]" == $e.call(e))
        );
      }),
      (u.isDate = function (e) {
        return Z(e) && "[object Date]" == $e.call(e);
      }),
      (u.isEmpty = function (e) {
        if (V(e) && (Re(e) || ee(e) || G(e.splice) || Y(e))) return !e.length;
        for (var t in e) if (Se.call(e, t)) return !1;
        return !0;
      }),
      (u.isEqual = function (e, t) {
        return b(e, t);
      }),
      (u.isFinite = function (e) {
        return "number" == typeof e && Oe(e);
      }),
      (u.isFunction = G),
      (u.isNaN = function (e) {
        return K(e) && e != +e;
      }),
      (u.isNull = function (e) {
        return null === e;
      }),
      (u.isNumber = K),
      (u.isObject = J),
      (u.isRegExp = function (e) {
        return J(e) && "[object RegExp]" == $e.call(e);
      }),
      (u.isString = ee),
      (u.isUndefined = function (e) {
        return e === le;
      }),
      (u.last = function (e) {
        var t = e ? e.length : 0;
        return t ? e[t - 1] : le;
      }),
      (u.max = function (e) {
        return e && e.length ? t(e, se, X) : le;
      }),
      (u.min = function (e) {
        return e && e.length ? t(e, se, te) : le;
      }),
      (u.noConflict = function () {
        return xe._ === this && (xe._ = Ee), this;
      }),
      (u.noop = function () {}),
      (u.reduce = W),
      (u.result = function (e, t, n) {
        return (
          (t = null == e ? le : e[t]), t === le && (t = n), G(t) ? t.call(e) : t
        );
      }),
      (u.size = function (e) {
        return null == e ? 0 : ((e = V(e) ? e : ie(e)), e.length);
      }),
      (u.some = function (e, t, n) {
        return (t = n ? le : t), j(e, x(t));
      }),
      (u.uniqueId = function (e) {
        var t = ++Ce;
        return ne(e) + t;
      }),
      (u.each = R),
      (u.first = F),
      ae(
        u,
        (function () {
          var e = {};
          return (
            m(u, function (t, n) {
              Se.call(u.prototype, n) || (e[n] = t);
            }),
            e
          );
        })(),
        { chain: !1 }
      ),
      (u.VERSION = "4.5.1"),
      Pe(
        "pop join replace reverse split push shift sort splice unshift".split(
          " "
        ),
        function (e) {
          var t = (/^(?:replace|split)$/.test(e) ? String.prototype : ke)[e],
            n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
            i = /^(?:pop|join|replace|shift)$/.test(e);
          u.prototype[e] = function () {
            var e = arguments;
            return i && !this.__chain__
              ? t.apply(this.value(), e)
              : this[n](function (n) {
                  return t.apply(n, e);
                });
          };
        }
      ),
      (u.prototype.toJSON =
        u.prototype.valueOf =
        u.prototype.value =
          function () {
            return N(this.__wrapped__, this.__actions__);
          }),
      ((be || ye || {})._ = u),
      "function" == typeof define && "object" == typeof define.amd && define.amd
        ? define(function () {
            return u;
          })
        : ve && ge
        ? (me && ((ge.exports = u)._ = u), (ve._ = u))
        : (xe._ = u);
  }.call(this)
  /*!
   * mobile-sniff.min.js
   */,
  !(function () {
    window.mobileCheck = function () {
      var e = !1;
      return (
        (function (t) {
          (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            t
          ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              t.substr(0, 4)
            )) &&
            (e = !0);
        })(navigator.userAgent || navigator.vendor || window.opera),
        e
      );
    };
  })()
  /*!
   * modernizr.min.js
   */,
  /*! modernizr 3.3.1 (Custom Build) | MIT *
   * https://modernizr.com/download/?-csstransforms-flexbox-svg-setclasses !*/
  !(function (e, t, n) {
    function i(e, t) {
      return typeof e === t;
    }
    function o() {
      var e, t, n, o, r, s, a;
      for (var l in b)
        if (b.hasOwnProperty(l)) {
          if (
            ((e = []),
            (t = b[l]),
            t.name &&
              (e.push(t.name.toLowerCase()),
              t.options && t.options.aliases && t.options.aliases.length))
          )
            for (n = 0; n < t.options.aliases.length; n++)
              e.push(t.options.aliases[n].toLowerCase());
          for (
            o = i(t.fn, "function") ? t.fn() : t.fn, r = 0;
            r < e.length;
            r++
          )
            (s = e[r]),
              (a = s.split(".")),
              1 === a.length
                ? (x[a[0]] = o)
                : (!x[a[0]] ||
                    x[a[0]] instanceof Boolean ||
                    (x[a[0]] = new Boolean(x[a[0]])),
                  (x[a[0]][a[1]] = o)),
              y.push((o ? "" : "no-") + a.join("-"));
        }
    }
    function r(e) {
      var t = k.className,
        n = x._config.classPrefix || "";
      if ((T && (t = t.baseVal), x._config.enableJSClass)) {
        var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
        t = t.replace(i, "$1" + n + "js$2");
      }
      x._config.enableClasses &&
        ((t += " " + n + e.join(" " + n)),
        T ? (k.className.baseVal = t) : (k.className = t));
    }
    function s(e, t) {
      return !!~("" + e).indexOf(t);
    }
    function a() {
      return "function" != typeof t.createElement
        ? t.createElement(arguments[0])
        : T
        ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
        : t.createElement.apply(t, arguments);
    }
    function l(e) {
      return e
        .replace(/([a-z])-([a-z])/g, function (e, t, n) {
          return t + n.toUpperCase();
        })
        .replace(/^-/, "");
    }
    function u(e, t) {
      return function () {
        return e.apply(t, arguments);
      };
    }
    function c(e, t, n) {
      var o;
      for (var r in e)
        if (e[r] in t)
          return n === !1
            ? e[r]
            : ((o = t[e[r]]), i(o, "function") ? u(o, n || t) : o);
      return !1;
    }
    function d(e) {
      return e
        .replace(/([A-Z])/g, function (e, t) {
          return "-" + t.toLowerCase();
        })
        .replace(/^ms-/, "-ms-");
    }
    function p() {
      var e = t.body;
      return e || ((e = a(T ? "svg" : "body")), (e.fake = !0)), e;
    }
    function f(e, n, i, o) {
      var r,
        s,
        l,
        u,
        c = "modernizr",
        d = a("div"),
        f = p();
      if (parseInt(i, 10))
        for (; i--; )
          (l = a("div")), (l.id = o ? o[i] : c + (i + 1)), d.appendChild(l);
      return (
        (r = a("style")),
        (r.type = "text/css"),
        (r.id = "s" + c),
        (f.fake ? f : d).appendChild(r),
        f.appendChild(d),
        r.styleSheet
          ? (r.styleSheet.cssText = e)
          : r.appendChild(t.createTextNode(e)),
        (d.id = c),
        f.fake &&
          ((f.style.background = ""),
          (f.style.overflow = "hidden"),
          (u = k.style.overflow),
          (k.style.overflow = "hidden"),
          k.appendChild(f)),
        (s = n(d, e)),
        f.fake
          ? (f.parentNode.removeChild(f),
            (k.style.overflow = u),
            k.offsetHeight)
          : d.parentNode.removeChild(d),
        !!s
      );
    }
    function h(t, i) {
      var o = t.length;
      if ("CSS" in e && "supports" in e.CSS) {
        for (; o--; ) if (e.CSS.supports(d(t[o]), i)) return !0;
        return !1;
      }
      if ("CSSSupportsRule" in e) {
        for (var r = []; o--; ) r.push("(" + d(t[o]) + ":" + i + ")");
        return (
          (r = r.join(" or ")),
          f(
            "@supports (" + r + ") { #modernizr { position: absolute; } }",
            function (e) {
              return "absolute" == getComputedStyle(e, null).position;
            }
          )
        );
      }
      return n;
    }
    function v(e, t, o, r) {
      function u() {
        d && (delete A.style, delete A.modElem);
      }
      if (((r = !i(r, "undefined") && r), !i(o, "undefined"))) {
        var c = h(e, o);
        if (!i(c, "undefined")) return c;
      }
      for (
        var d, p, f, v, g, m = ["modernizr", "tspan", "samp"];
        !A.style && m.length;

      )
        (d = !0), (A.modElem = a(m.shift())), (A.style = A.modElem.style);
      for (f = e.length, p = 0; f > p; p++)
        if (
          ((v = e[p]),
          (g = A.style[v]),
          s(v, "-") && (v = l(v)),
          A.style[v] !== n)
        ) {
          if (r || i(o, "undefined")) return u(), "pfx" != t || v;
          try {
            A.style[v] = o;
          } catch (e) {}
          if (A.style[v] != g) return u(), "pfx" != t || v;
        }
      return u(), !1;
    }
    function g(e, t, n, o, r) {
      var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + C.join(s + " ") + s).split(" ");
      return i(t, "string") || i(t, "undefined")
        ? v(a, t, o, r)
        : ((a = (e + " " + $.join(s + " ") + s).split(" ")), c(a, t, n));
    }
    function m(e, t, i) {
      return g(e, n, n, t, i);
    }
    var y = [],
      b = [],
      w = {
        _version: "3.3.1",
        _config: {
          classPrefix: "",
          enableClasses: !0,
          enableJSClass: !0,
          usePrefixes: !0,
        },
        _q: [],
        on: function (e, t) {
          var n = this;
          setTimeout(function () {
            t(n[e]);
          }, 0);
        },
        addTest: function (e, t, n) {
          b.push({ name: e, fn: t, options: n });
        },
        addAsyncTest: function (e) {
          b.push({ name: null, fn: e });
        },
      },
      x = function () {};
    (x.prototype = w),
      (x = new x()),
      x.addTest(
        "svg",
        !!t.createElementNS &&
          !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
      );
    var k = t.documentElement,
      T = "svg" === k.nodeName.toLowerCase(),
      S = "Moz O ms Webkit",
      C = w._config.usePrefixes ? S.split(" ") : [];
    w._cssomPrefixes = C;
    var $ = w._config.usePrefixes ? S.toLowerCase().split(" ") : [];
    w._domPrefixes = $;
    var E = { elem: a("modernizr") };
    x._q.push(function () {
      delete E.elem;
    });
    var A = { style: E.elem.style };
    x._q.unshift(function () {
      delete A.style;
    }),
      (w.testAllProps = g),
      (w.testAllProps = m),
      x.addTest("flexbox", m("flexBasis", "1px", !0)),
      x.addTest("csstransforms", function () {
        return (
          -1 === navigator.userAgent.indexOf("Android 2.") &&
          m("transform", "scale(1)", !0)
        );
      }),
      o(),
      r(y),
      delete w.addTest,
      delete w.addAsyncTest;
    for (var j = 0; j < x._q.length; j++) x._q[j]();
    e.Modernizr = x;
  })(window, document)
  /*!
   * prepare-transition.min.js
   */,
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  !(function (e) {
    e.fn.prepareTransition = function () {
      return this.each(function () {
        var t = e(this);
        t.one(
          "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
          function () {
            t.removeClass("is-transitioning");
          }
        );
        var n = [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ],
          i = 0;
        e.each(n, function (e, n) {
          i || (i = parseFloat(t.css(n)));
        }),
          0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
      });
    };
  })(jQuery)
  /*!
   * slick-slim.min.js
   */,
  !(function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (e) {
    "use strict";
    var t = window.Slick || {};
    (t = (function () {
      function t(t, i) {
        var o,
          r = this;
        (r.defaults = {
          accessibility: !0,
          appendArrows: e(t),
          appendDots: e(t),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button type="button" data-role="none" class="slick-prev" aria-label="Previous slide" tabindex="0" role="button">Previous slide</button>',
          nextArrow:
            '<button type="button" data-role="none" class="slick-next" aria-label="Next slide" tabindex="0" role="button">Next slide</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          cssEase: "ease",
          customPaging: function (t, n) {
            return e(
              '<button type="button" data-role="none" role="button" tabindex="0" />'
            ).text("Slide " + (n + 1));
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          initialSlide: 0,
          lazyLoad: !0,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (r.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          e.extend(r, r.initials),
          (r.activeBreakpoint = null),
          (r.animType = null),
          (r.animProp = null),
          (r.breakpoints = []),
          (r.breakpointSettings = []),
          (r.cssTransitions = !1),
          (r.focussed = !1),
          (r.interrupted = !1),
          (r.hidden = "hidden"),
          (r.paused = !0),
          (r.positionProp = null),
          (r.respondTo = null),
          (r.rowCount = 1),
          (r.shouldClick = !0),
          (r.$slider = e(t)),
          (r.$slidesCache = null),
          (r.transformType = null),
          (r.transitionType = null),
          (r.visibilityChange = "visibilitychange"),
          (r.windowWidth = 0),
          (r.windowTimer = null),
          (o = e(t).data("slick") || {}),
          (r.options = e.extend({}, r.defaults, i, o)),
          (r.currentSlide = r.options.initialSlide),
          (r.originalSettings = r.options),
          "undefined" != typeof document.mozHidden
            ? ((r.hidden = "mozHidden"),
              (r.visibilityChange = "mozvisibilitychange"))
            : "undefined" != typeof document.webkitHidden &&
              ((r.hidden = "webkitHidden"),
              (r.visibilityChange = "webkitvisibilitychange")),
          (r.autoPlay = e.proxy(r.autoPlay, r)),
          (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
          (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
          (r.changeSlide = e.proxy(r.changeSlide, r)),
          (r.clickHandler = e.proxy(r.clickHandler, r)),
          (r.selectHandler = e.proxy(r.selectHandler, r)),
          (r.setPosition = e.proxy(r.setPosition, r)),
          (r.swipeHandler = e.proxy(r.swipeHandler, r)),
          (r.dragHandler = e.proxy(r.dragHandler, r)),
          (r.keyHandler = e.proxy(r.keyHandler, r)),
          (r.instanceUid = n++),
          (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          r.init(!0);
      }
      var n = 0;
      return t;
    })()),
      (t.prototype.activateADA = function () {
        var e = this;
        e.$slides
          .add(e.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          e.$slideTrack
            .find(".slick-active")
            .attr({ "aria-hidden": "false" })
            .find("a, input, button, select")
            .attr({ tabindex: "0" });
      }),
      (t.prototype.animateSlide = function (t, n) {
        var i = {},
          o = this;
        o.options.rtl === !0 && (t = -t),
          o.transformsEnabled === !1
            ? o.$slideTrack.animate(
                { left: t },
                o.options.speed,
                o.options.easing,
                n
              )
            : o.cssTransitions === !1
            ? (o.options.rtl === !0 && (o.currentLeft = -o.currentLeft),
              e({ animStart: o.currentLeft }).animate(
                { animStart: t },
                {
                  duration: o.options.speed,
                  easing: o.options.easing,
                  step: function (e) {
                    (e = Math.ceil(e)),
                      (i[o.animType] = "translate(" + e + "px, 0px)"),
                      o.$slideTrack.css(i);
                  },
                  complete: function () {
                    n && n.call();
                  },
                }
              ))
            : (o.applyTransition(),
              (t = Math.ceil(t)),
              (i[o.animType] = "translate3d(" + t + "px, 0px, 0px)"),
              o.$slideTrack.css(i),
              n &&
                setTimeout(function () {
                  o.disableTransition(), n.call();
                }, o.options.speed));
      }),
      (t.prototype.getNavTarget = function () {
        var t = this,
          n = t.options.asNavFor;
        return n && null !== n && (n = e(n).not(t.$slider)), n;
      }),
      (t.prototype.asNavFor = function (t) {
        var n = this,
          i = n.getNavTarget();
        null !== i &&
          "object" == typeof i &&
          i.each(function () {
            var n = e(this).slick("getSlick");
            n.unslicked || n.slideHandler(t, !0);
          });
      }),
      (t.prototype.applyTransition = function (e) {
        var t = this,
          n = {};
        t.options.fade === !1
          ? (n[t.transitionType] =
              t.transformType +
              " " +
              t.options.speed +
              "ms " +
              t.options.cssEase)
          : (n[t.transitionType] =
              "opacity " + t.options.speed + "ms " + t.options.cssEase),
          t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
      }),
      (t.prototype.autoPlay = function () {
        var e = this;
        e.autoPlayClear(),
          e.slideCount > e.options.slidesToShow &&
            (e.autoPlayTimer = setInterval(
              e.autoPlayIterator,
              e.options.autoplaySpeed
            ));
      }),
      (t.prototype.autoPlayClear = function () {
        var e = this;
        e.autoPlayTimer && clearInterval(e.autoPlayTimer);
      }),
      (t.prototype.autoPlayIterator = function () {
        var e = this,
          t = e.currentSlide + e.options.slidesToScroll;
        e.paused || e.interrupted || e.focussed || e.slideHandler(t);
      }),
      (t.prototype.buildArrows = function () {
        var t = this;
        t.options.arrows === !0 &&
          ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
          (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
          t.slideCount > t.options.slidesToShow
            ? (t.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.htmlExpr.test(t.options.prevArrow) &&
                t.$prevArrow.prependTo(t.options.appendArrows),
              t.htmlExpr.test(t.options.nextArrow) &&
                t.$nextArrow.appendTo(t.options.appendArrows),
              t.options.infinite !== !0 &&
                t.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : t.$prevArrow
                .add(t.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (t.prototype.buildDots = function () {
        var t,
          n,
          i = this;
        if (i.options.dots === !0 && i.slideCount > i.options.slidesToShow) {
          for (
            i.$slider.addClass("slick-dotted"),
              n = e("<ul />").addClass(i.options.dotsClass),
              t = 0;
            t <= i.getDotCount();
            t += 1
          )
            n.append(
              e("<li />").append(i.options.customPaging.call(this, i, t))
            );
          (i.$dots = n.appendTo(i.options.appendDots)),
            i.$dots
              .find("li")
              .first()
              .addClass("slick-active")
              .attr("aria-hidden", "false");
        }
      }),
      (t.prototype.buildOut = function () {
        var t = this;
        (t.$slides = t.$slider
          .children(t.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.$slides.each(function (t, n) {
            e(n)
              .attr("data-slick-index", t)
              .data("originalStyling", e(n).attr("style") || "");
          }),
          t.$slider.addClass("slick-slider"),
          (t.$slideTrack =
            0 === t.slideCount
              ? e('<div class="slick-track"/>').appendTo(t.$slider)
              : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (t.$list = t.$slideTrack
            .wrap('<div aria-live="polite" class="slick-list"/>')
            .parent()),
          t.$slideTrack.css("opacity", 0),
          t.options.swipeToSlide === !0 && (t.options.slidesToScroll = 1),
          e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
          t.setupInfinite(),
          t.buildArrows(),
          t.buildDots(),
          t.updateDots(),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.options.draggable === !0 && t.$list.addClass("draggable");
      }),
      (t.prototype.buildRows = function () {
        var e,
          t,
          n,
          i,
          o,
          r,
          s,
          a = this;
        if (
          ((i = document.createDocumentFragment()),
          (r = a.$slider.children()),
          a.options.rows > 1)
        ) {
          for (
            s = a.options.slidesPerRow * a.options.rows,
              o = Math.ceil(r.length / s),
              e = 0;
            e < o;
            e++
          ) {
            var l = document.createElement("div");
            for (t = 0; t < a.options.rows; t++) {
              var u = document.createElement("div");
              for (n = 0; n < a.options.slidesPerRow; n++) {
                var c = e * s + (t * a.options.slidesPerRow + n);
                r.get(c) && u.appendChild(r.get(c));
              }
              l.appendChild(u);
            }
            i.appendChild(l);
          }
          a.$slider.empty().append(i),
            a.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (t.prototype.changeSlide = function (t, n) {
        var i,
          o,
          r,
          s = this,
          a = e(t.currentTarget);
        switch (
          (a.is("a") && t.preventDefault(),
          a.is("li") || (a = a.closest("li")),
          (r = s.slideCount % s.options.slidesToScroll !== 0),
          (i = r
            ? 0
            : (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
          t.data.message)
        ) {
          case "previous":
            (o =
              0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i),
              s.slideCount > s.options.slidesToShow &&
                s.slideHandler(s.currentSlide - o, !1, n);
            break;
          case "next":
            (o = 0 === i ? s.options.slidesToScroll : i),
              s.slideCount > s.options.slidesToShow &&
                s.slideHandler(s.currentSlide + o, !1, n);
            break;
          case "index":
            var l =
              0 === t.data.index
                ? 0
                : t.data.index || a.index() * s.options.slidesToScroll;
            s.slideHandler(s.checkNavigable(l), !1, n),
              a.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (t.prototype.checkNavigable = function (e) {
        var t,
          n,
          i = this;
        if (((t = i.getNavigableIndexes()), (n = 0), e > t[t.length - 1]))
          e = t[t.length - 1];
        else
          for (var o in t) {
            if (e < t[o]) {
              e = n;
              break;
            }
            n = t[o];
          }
        return e;
      }),
      (t.prototype.cleanUpEvents = function () {
        var t = this;
        t.options.dots &&
          null !== t.$dots &&
          e("li", t.$dots)
            .off("click.slick", t.changeSlide)
            .off("mouseenter.slick", e.proxy(t.interrupt, t, !0))
            .off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
          t.$slider.off("focus.slick blur.slick"),
          t.options.arrows === !0 &&
            t.slideCount > t.options.slidesToShow &&
            (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
            t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
          t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
          t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
          t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
          t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
          t.$list.off("click.slick", t.clickHandler),
          e(document).off(t.visibilityChange, t.visibility),
          t.cleanUpSlideEvents(),
          t.options.accessibility === !0 &&
            t.$list.off("keydown.slick", t.keyHandler),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().off("click.slick", t.selectHandler),
          e(window).off(
            "orientationchange.slick.slick-" + t.instanceUid,
            t.orientationChange
          ),
          e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
          e("[draggable!=true]", t.$slideTrack).off(
            "dragstart",
            t.preventDefault
          ),
          e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
          e(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition);
      }),
      (t.prototype.cleanUpSlideEvents = function () {
        var t = this;
        t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.cleanUpRows = function () {
        var e,
          t = this;
        t.options.rows > 1 &&
          ((e = t.$slides.children().children()),
          e.removeAttr("style"),
          t.$slider.empty().append(e));
      }),
      (t.prototype.clickHandler = function (e) {
        var t = this;
        t.shouldClick === !1 &&
          (e.stopImmediatePropagation(),
          e.stopPropagation(),
          e.preventDefault());
      }),
      (t.prototype.destroy = function (t) {
        var n = this;
        n.autoPlayClear(),
          (n.touchObject = {}),
          n.cleanUpEvents(),
          e(".slick-cloned", n.$slider).detach(),
          n.$dots && n.$dots.remove(),
          n.$prevArrow &&
            n.$prevArrow.length &&
            (n.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
          n.$nextArrow &&
            n.$nextArrow.length &&
            (n.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
          n.$slides &&
            (n.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                e(this).attr("style", e(this).data("originalStyling"));
              }),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.detach(),
            n.$list.detach(),
            n.$slider.append(n.$slides)),
          n.cleanUpRows(),
          n.$slider.removeClass("slick-slider"),
          n.$slider.removeClass("slick-initialized"),
          n.$slider.removeClass("slick-dotted"),
          (n.unslicked = !0),
          t || n.$slider.trigger("destroy", [n]);
      }),
      (t.prototype.disableTransition = function (e) {
        var t = this,
          n = {};
        (n[t.transitionType] = ""),
          t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
      }),
      (t.prototype.fadeSlide = function (e, t) {
        var n = this;
        n.cssTransitions === !1
          ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }),
            n.$slides
              .eq(e)
              .animate({ opacity: 1 }, n.options.speed, n.options.easing, t))
          : (n.applyTransition(e),
            n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
            t &&
              setTimeout(function () {
                n.disableTransition(e), t.call();
              }, n.options.speed));
      }),
      (t.prototype.fadeSlideOut = function (e) {
        var t = this;
        t.cssTransitions === !1
          ? t.$slides
              .eq(e)
              .animate(
                { opacity: 0, zIndex: t.options.zIndex - 2 },
                t.options.speed,
                t.options.easing
              )
          : (t.applyTransition(e),
            t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
      }),
      (t.prototype.filterSlides = t.prototype.slickFilter =
        function (e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
      (t.prototype.focusHandler = function () {
        var t = this;
        t.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (n) {
            n.stopImmediatePropagation();
            var i = e(this);
            setTimeout(function () {
              t.options.pauseOnFocus &&
                ((t.focussed = i.is(":focus")), t.autoPlay());
            }, 0);
          });
      }),
      (t.prototype.getCurrent = t.prototype.slickCurrentSlide =
        function () {
          var e = this;
          return e.currentSlide;
        }),
      (t.prototype.getDotCount = function () {
        for (var e = this, t = 0, n = 0, i = 0; t < e.slideCount; )
          ++i,
            (t = n + e.options.slidesToScroll),
            (n +=
              e.options.slidesToScroll <= e.options.slidesToShow
                ? e.options.slidesToScroll
                : e.options.slidesToShow);
        return i - 1;
      }),
      (t.prototype.getLeft = function (e) {
        var t,
          n,
          i = this,
          o = 0;
        return (
          (i.slideOffset = 0),
          (n = i.$slides.first().outerHeight(!0)),
          i.slideCount > i.options.slidesToShow &&
            ((i.slideOffset = i.slideWidth * i.options.slidesToShow * -1),
            (o = n * i.options.slidesToShow * -1)),
          i.slideCount % i.options.slidesToScroll !== 0 &&
            e + i.options.slidesToScroll > i.slideCount &&
            i.slideCount > i.options.slidesToShow &&
            (e > i.slideCount
              ? ((i.slideOffset =
                  (i.options.slidesToShow - (e - i.slideCount)) *
                  i.slideWidth *
                  -1),
                (o = (i.options.slidesToShow - (e - i.slideCount)) * n * -1))
              : ((i.slideOffset =
                  (i.slideCount % i.options.slidesToScroll) *
                  i.slideWidth *
                  -1),
                (o = (i.slideCount % i.options.slidesToScroll) * n * -1))),
          i.slideCount <= i.options.slidesToShow &&
            ((i.slideOffset = 0), (o = 0)),
          (t = e * i.slideWidth * -1 + i.slideOffset)
        );
      }),
      (t.prototype.getOption = t.prototype.slickGetOption =
        function (e) {
          var t = this;
          return t.options[e];
        }),
      (t.prototype.getNavigableIndexes = function () {
        var e,
          t = this,
          n = 0,
          i = 0,
          o = [];
        for (
          n = t.options.slidesToScroll * -1,
            i = t.options.slidesToScroll * -1,
            e = 2 * t.slideCount;
          n < e;

        )
          o.push(n),
            (n = i + t.options.slidesToScroll),
            (i +=
              t.options.slidesToScroll <= t.options.slidesToShow
                ? t.options.slidesToScroll
                : t.options.slidesToShow);
        return o;
      }),
      (t.prototype.getSlick = function () {
        return this;
      }),
      (t.prototype.getSlideCount = function () {
        var t,
          n,
          i,
          o = this;
        return (
          (i = 0),
          o.options.swipeToSlide === !0
            ? (o.$slideTrack.find(".slick-slide").each(function (t, r) {
                if (r.offsetLeft - i + e(r).outerWidth() / 2 > o.swipeLeft * -1)
                  return (n = r), !1;
              }),
              (t =
                Math.abs(e(n).attr("data-slick-index") - o.currentSlide) || 1))
            : o.options.slidesToScroll
        );
      }),
      (t.prototype.goTo = t.prototype.slickGoTo =
        function (e, t) {
          var n = this;
          n.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
        }),
      (t.prototype.init = function (t) {
        var n = this;
        e(n.$slider).hasClass("slick-initialized") ||
          (e(n.$slider).addClass("slick-initialized"),
          n.buildRows(),
          n.buildOut(),
          n.setProps(),
          n.startLoad(),
          n.loadSlider(),
          n.initializeEvents(),
          n.updateDots(),
          n.focusHandler()),
          t && n.$slider.trigger("init", [n]),
          n.options.accessibility === !0 && n.initADA(),
          n.options.autoplay && ((n.paused = !1), n.autoPlay());
      }),
      (t.prototype.initADA = function () {
        var t,
          n,
          i,
          o = this;
        o.$slides.not(o.$slideTrack.find(".slick-cloned")).each(function (r) {
          e(this).attr("role", "option");
          var s = Math.floor(r / o.options.slidesToShow);
          o.options.dots === !0 &&
            ((n = "" + o.instanceUid + s),
            (i = n),
            t === n && (n = "" + n + r),
            e(this)
              .attr("id", "slickSlide" + n)
              .attr("role", "tabpanel")
              .attr("aria-labelledby", "slickDot" + i),
            (t = "" + o.instanceUid + s));
        }),
          null !== o.$dots &&
            o.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (t) {
                e(this).attr({
                  role: "tab",
                  "aria-selected": "false",
                  "aria-controls": "slickSlide" + o.instanceUid + t,
                  id: "slickDot" + o.instanceUid + t,
                });
              })
              .first()
              .attr("aria-selected", "true"),
          o.activateADA();
      }),
      (t.prototype.initArrowEvents = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, e.changeSlide),
          e.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, e.changeSlide));
      }),
      (t.prototype.updateADA = function () {
        var e = this;
        null !== e.$dots &&
          (e.$dots.find("li").attr("aria-selected", "false"),
          e.$dots.find(".slick-active").attr("aria-selected", "true")),
          e.activateADA();
      }),
      (t.prototype.initArrowEvents = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, e.changeSlide),
          e.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, e.changeSlide));
      }),
      (t.prototype.initDotEvents = function () {
        var t = this;
        t.options.dots === !0 &&
          t.slideCount > t.options.slidesToShow &&
          e("li", t.$dots).on(
            "click.slick",
            { message: "index" },
            t.changeSlide
          ),
          t.options.dots === !0 &&
            t.options.pauseOnDotsHover === !0 &&
            e("li", t.$dots)
              .on("mouseenter.slick", e.proxy(t.interrupt, t, !0))
              .on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.initSlideEvents = function () {
        var t = this;
        t.options.pauseOnHover &&
          (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
      }),
      (t.prototype.initializeEvents = function () {
        var t = this;
        t.initArrowEvents(),
          t.initDotEvents(),
          t.initSlideEvents(),
          t.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on("click.slick", t.clickHandler),
          e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
          t.options.accessibility === !0 &&
            t.$list.on("keydown.slick", t.keyHandler),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          e(window).on(
            "orientationchange.slick.slick-" + t.instanceUid,
            e.proxy(t.orientationChange, t)
          ),
          e(window).on(
            "resize.slick.slick-" + t.instanceUid,
            e.proxy(t.resize, t)
          ),
          e("[draggable!=true]", t.$slideTrack).on(
            "dragstart",
            t.preventDefault
          ),
          e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
          e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
      }),
      (t.prototype.initUI = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.show(), e.$nextArrow.show()),
          e.options.dots === !0 &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.show();
      }),
      (t.prototype.keyHandler = function (e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === e.keyCode && t.options.accessibility === !0
            ? t.changeSlide({
                data: { message: t.options.rtl === !0 ? "next" : "previous" },
              })
            : 39 === e.keyCode &&
              t.options.accessibility === !0 &&
              t.changeSlide({
                data: { message: t.options.rtl === !0 ? "previous" : "next" },
              }));
      }),
      (t.prototype.lazyLoad = function () {
        function t(t) {
          e("img[data-lazy]", t).each(function () {
            var t = e(this),
              n = e(this).attr("data-lazy"),
              i = document.createElement("img");
            (i.onload = function () {
              t.animate({ opacity: 0 }, 100, function () {
                t.attr("src", n).animate({ opacity: 1 }, 200, function () {
                  t.removeAttr("data-lazy").removeClass("slick-loading");
                }),
                  s.$slider.trigger("lazyLoaded", [s, t, n]);
              });
            }),
              (i.onerror = function () {
                t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  s.$slider.trigger("lazyLoadError", [s, t, n]);
              }),
              (i.src = n);
          });
        }
        var n,
          i,
          o,
          r,
          s = this;
        (o = s.options.slidesToShow),
          (r = Math.ceil(o + s.options.slidesToShow)),
          s.options.fade === !0 && (o > 0 && o--, r <= s.slideCount && r++),
          (n = s.$slider.find(".slick-slide").slice(o, r)),
          t(n),
          s.slideCount <= s.options.slidesToShow
            ? ((i = s.$slider.find(".slick-slide")), t(i))
            : s.currentSlide >= s.slideCount - s.options.slidesToShow
            ? ((i = s.$slider
                .find(".slick-cloned")
                .slice(0, s.options.slidesToShow)),
              t(i))
            : 0 === s.currentSlide &&
              ((i = s.$slider
                .find(".slick-cloned")
                .slice(s.options.slidesToShow * -1)),
              t(i));
      }),
      (t.prototype.loadSlider = function () {
        var e = this;
        e.setPosition(),
          e.$slideTrack.css({ opacity: 1 }),
          e.$slider.removeClass("slick-loading"),
          e.initUI();
      }),
      (t.prototype.next = t.prototype.slickNext =
        function () {
          var e = this;
          e.changeSlide({ data: { message: "next" } });
        }),
      (t.prototype.orientationChange = function () {
        var e = this;
        e.setPosition();
      }),
      (t.prototype.pause = t.prototype.slickPause =
        function () {
          var e = this;
          e.autoPlayClear(), (e.paused = !0);
        }),
      (t.prototype.play = t.prototype.slickPlay =
        function () {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
      (t.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked ||
          (t.$slider.trigger("afterChange", [t, e]),
          (t.animating = !1),
          t.setPosition(),
          (t.swipeLeft = null),
          t.options.autoplay && t.autoPlay(),
          t.options.accessibility === !0 && t.updateADA());
      }),
      (t.prototype.prev = t.prototype.slickPrev =
        function () {
          var e = this;
          e.changeSlide({ data: { message: "previous" } });
        }),
      (t.prototype.preventDefault = function (e) {
        e.preventDefault();
      }),
      (t.prototype.refresh = function (t) {
        var n,
          i,
          o = this;
        (i = o.slideCount - o.options.slidesToShow),
          o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
          (n = o.currentSlide),
          o.destroy(!0),
          e.extend(o, o.initials, { currentSlide: n }),
          o.init(),
          t || o.changeSlide({ data: { message: "index", index: n } }, !1);
      }),
      (t.prototype.reinit = function () {
        var t = this;
        (t.$slides = t.$slideTrack
          .children(t.options.slide)
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.currentSlide >= t.slideCount &&
            0 !== t.currentSlide &&
            (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          t.setProps(),
          t.setupInfinite(),
          t.buildArrows(),
          t.initArrowEvents(),
          t.buildDots(),
          t.updateDots(),
          t.initDotEvents(),
          t.cleanUpSlideEvents(),
          t.initSlideEvents(),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.setPosition(),
          t.focusHandler(),
          (t.paused = !t.options.autoplay),
          t.autoPlay(),
          t.$slider.trigger("reInit", [t]);
      }),
      (t.prototype.resize = function () {
        var t = this;
        e(window).width() !== t.windowWidth &&
          (clearTimeout(t.windowDelay),
          (t.windowDelay = window.setTimeout(function () {
            (t.windowWidth = e(window).width()), t.unslicked || t.setPosition();
          }, 50)));
      }),
      (t.prototype.setCSS = function (e) {
        var t,
          n,
          i = this,
          o = {};
        i.options.rtl === !0 && (e = -e),
          (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
          (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
          (o[i.positionProp] = e),
          i.transformsEnabled === !1
            ? i.$slideTrack.css(o)
            : ((o = {}),
              i.cssTransitions === !1
                ? ((o[i.animType] = "translate(" + t + ", " + n + ")"),
                  i.$slideTrack.css(o))
                : ((o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"),
                  i.$slideTrack.css(o)));
      }),
      (t.prototype.setDimensions = function () {
        var e = this;
        (e.listWidth = e.$list.width()),
          (e.listHeight = e.$list.height()),
          (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
          e.$slideTrack.width(
            Math.ceil(
              e.slideWidth * e.$slideTrack.children(".slick-slide").length
            )
          );
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
      }),
      (t.prototype.setFade = function () {
        var t,
          n = this;
        n.$slides.each(function (i, o) {
          (t = n.slideWidth * i * -1),
            n.options.rtl === !0
              ? e(o).css({
                  position: "relative",
                  right: t,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                })
              : e(o).css({
                  position: "relative",
                  left: t,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          n.$slides
            .eq(n.currentSlide)
            .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
      }),
      (t.prototype.setOption = t.prototype.slickSetOption =
        function () {
          var t,
            n,
            i,
            o = this,
            r = !1;
          "object" === e.type(arguments[0])
            ? ((t = arguments[0]), (r = arguments[1]), (i = "multiple"))
            : "string" === e.type(arguments[0]) &&
              ((t = arguments[0]),
              (n = arguments[1]),
              (r = arguments[2]),
              "undefined" != typeof arguments[1] && (i = "single")),
            "single" === i
              ? (o.options[t] = n)
              : "multiple" === i &&
                e.each(t, function (e, t) {
                  o.options[e] = t;
                }),
            r && (o.unload(), o.reinit());
        }),
      (t.prototype.setPosition = function () {
        var e = this;
        e.setDimensions(),
          e.options.fade === !1
            ? e.setCSS(e.getLeft(e.currentSlide))
            : e.setFade(),
          e.$slider.trigger("setPosition", [e]);
      }),
      (t.prototype.setProps = function () {
        var e = this,
          t = document.body.style;
        (e.positionProp = "left"),
          e.$slider.removeClass("slick-vertical"),
          (void 0 === t.WebkitTransition &&
            void 0 === t.MozTransition &&
            void 0 === t.msTransition) ||
            (e.options.useCSS === !0 && (e.cssTransitions = !0)),
          e.options.fade &&
            ("number" == typeof e.options.zIndex
              ? e.options.zIndex < 3 && (e.options.zIndex = 3)
              : (e.options.zIndex = e.defaults.zIndex)),
          void 0 !== t.OTransform &&
            ((e.animType = "OTransform"),
            (e.transformType = "-o-transform"),
            (e.transitionType = "OTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.MozTransform &&
            ((e.animType = "MozTransform"),
            (e.transformType = "-moz-transform"),
            (e.transitionType = "MozTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.MozPerspective &&
              (e.animType = !1)),
          void 0 !== t.webkitTransform &&
            ((e.animType = "webkitTransform"),
            (e.transformType = "-webkit-transform"),
            (e.transitionType = "webkitTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.msTransform &&
            ((e.animType = "msTransform"),
            (e.transformType = "-ms-transform"),
            (e.transitionType = "msTransition"),
            void 0 === t.msTransform && (e.animType = !1)),
          void 0 !== t.transform &&
            e.animType !== !1 &&
            ((e.animType = "transform"),
            (e.transformType = "transform"),
            (e.transitionType = "transition")),
          (e.transformsEnabled =
            e.options.useTransform && null !== e.animType && e.animType !== !1);
      }),
      (t.prototype.setSlideClasses = function (e) {
        var t,
          n,
          i,
          o = this;
        (t = o.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
          o.$slides.eq(e).addClass("slick-current"),
          e >= 0 && e <= o.slideCount - o.options.slidesToShow
            ? o.$slides
                .slice(e, e + o.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : t.length <= o.options.slidesToShow
            ? t.addClass("slick-active").attr("aria-hidden", "false")
            : ((i = o.slideCount % o.options.slidesToShow),
              (n = o.options.slidesToShow + e),
              o.options.slidesToShow == o.options.slidesToScroll &&
              o.slideCount - e < o.options.slidesToShow
                ? t
                    .slice(n - (o.options.slidesToShow - i), n + i)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : t
                    .slice(n, n + o.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
          o.options.lazyLoad === !0 && o.lazyLoad();
      }),
      (t.prototype.setupInfinite = function () {
        var t,
          n,
          i,
          o = this;
        if (
          o.options.fade === !1 &&
          ((n = null), o.slideCount > o.options.slidesToShow)
        ) {
          for (
            i = o.options.slidesToShow, t = o.slideCount;
            t > o.slideCount - i;
            t -= 1
          )
            (n = t - 1),
              e(o.$slides[n])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", n - o.slideCount)
                .prependTo(o.$slideTrack)
                .addClass("slick-cloned");
          for (t = 0; t < i; t += 1)
            (n = t),
              e(o.$slides[n])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", n + o.slideCount)
                .appendTo(o.$slideTrack)
                .addClass("slick-cloned");
          o.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              e(this).attr("id", "");
            });
        }
      }),
      (t.prototype.interrupt = function (e) {
        var t = this;
        e || t.autoPlay(), (t.interrupted = e);
      }),
      (t.prototype.selectHandler = function (t) {
        var n = this,
          i = e(t.target).is(".slick-slide")
            ? e(t.target)
            : e(t.target).parents(".slick-slide"),
          o = parseInt(i.attr("data-slick-index"));
        return (
          o || (o = 0),
          n.slideCount <= n.options.slidesToShow
            ? (n.setSlideClasses(o), void n.asNavFor(o))
            : void n.slideHandler(o)
        );
      }),
      (t.prototype.slideHandler = function (e, t, n) {
        var i,
          o,
          r,
          s,
          a,
          l = null,
          u = this;
        if (
          ((t = t || !1),
          (u.animating !== !0 || u.options.waitForAnimate !== !0) &&
            !(
              (u.options.fade === !0 && u.currentSlide === e) ||
              u.slideCount <= u.options.slidesToShow
            ))
        )
          return (
            t === !1 && u.asNavFor(e),
            (i = e),
            (l = u.getLeft(i)),
            (s = u.getLeft(u.currentSlide)),
            (u.currentLeft = null === u.swipeLeft ? s : u.swipeLeft),
            u.options.autoplay && clearInterval(u.autoPlayTimer),
            (o =
              i < 0
                ? u.slideCount % u.options.slidesToScroll !== 0
                  ? u.slideCount - (u.slideCount % u.options.slidesToScroll)
                  : u.slideCount + i
                : i >= u.slideCount
                ? u.slideCount % u.options.slidesToScroll !== 0
                  ? 0
                  : i - u.slideCount
                : i),
            (u.animating = !0),
            u.$slider.trigger("beforeChange", [u, u.currentSlide, o]),
            (r = u.currentSlide),
            (u.currentSlide = o),
            u.setSlideClasses(u.currentSlide),
            u.options.asNavFor &&
              ((a = u.getNavTarget()),
              (a = a.slick("getSlick")),
              a.slideCount <= a.options.slidesToShow &&
                a.setSlideClasses(u.currentSlide)),
            u.updateDots(),
            u.options.fade === !0
              ? void (n !== !0
                  ? (u.fadeSlideOut(r),
                    u.fadeSlide(o, function () {
                      u.postSlide(o);
                    }))
                  : u.postSlide(o))
              : void (n !== !0
                  ? u.animateSlide(l, function () {
                      u.postSlide(o);
                    })
                  : u.postSlide(o))
          );
      }),
      (t.prototype.startLoad = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.hide(), e.$nextArrow.hide()),
          e.options.dots === !0 &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.hide(),
          e.$slider.addClass("slick-loading");
      }),
      (t.prototype.swipeDirection = function () {
        var e,
          t,
          n,
          i,
          o = this;
        return (
          (e = o.touchObject.startX - o.touchObject.curX),
          (t = o.touchObject.startY - o.touchObject.curY),
          (n = Math.atan2(t, e)),
          (i = Math.round((180 * n) / Math.PI)),
          i < 0 && (i = 360 - Math.abs(i)),
          i <= 45 && i >= 0
            ? o.options.rtl === !1
              ? "left"
              : "right"
            : i <= 360 && i >= 315
            ? o.options.rtl === !1
              ? "left"
              : "right"
            : i >= 135 && i <= 225
            ? o.options.rtl === !1
              ? "right"
              : "left"
            : "vertical"
        );
      }),
      (t.prototype.swipeEnd = function (e) {
        var t,
          n,
          i = this;
        if (
          ((i.dragging = !1),
          (i.interrupted = !1),
          (i.shouldClick = !(i.touchObject.swipeLength > 10)),
          void 0 === i.touchObject.curX)
        )
          return !1;
        if (
          (i.touchObject.edgeHit === !0 &&
            i.$slider.trigger("edge", [i, i.swipeDirection()]),
          i.touchObject.swipeLength >= i.touchObject.minSwipe)
        ) {
          switch ((n = i.swipeDirection())) {
            case "left":
            case "down":
              (t = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide + i.getSlideCount())
                : i.currentSlide + i.getSlideCount()),
                (i.currentDirection = 0);
              break;
            case "right":
            case "up":
              (t = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide - i.getSlideCount())
                : i.currentSlide - i.getSlideCount()),
                (i.currentDirection = 1);
          }
          "vertical" != n &&
            (i.slideHandler(t),
            (i.touchObject = {}),
            i.$slider.trigger("swipe", [i, n]));
        } else
          i.touchObject.startX !== i.touchObject.curX &&
            (i.slideHandler(i.currentSlide), (i.touchObject = {}));
      }),
      (t.prototype.swipeHandler = function (e) {
        var t = this;
        if (
          !(
            t.options.swipe === !1 ||
            ("ontouchend" in document && t.options.swipe === !1) ||
            (t.options.draggable === !1 && e.type.indexOf("mouse") !== -1)
          )
        )
          switch (
            ((t.touchObject.fingerCount =
              e.originalEvent && void 0 !== e.originalEvent.touches
                ? e.originalEvent.touches.length
                : 1),
            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
            e.data.action)
          ) {
            case "start":
              t.swipeStart(e);
              break;
            case "move":
              t.swipeMove(e);
              break;
            case "end":
              t.swipeEnd(e);
          }
      }),
      (t.prototype.swipeMove = function (e) {
        var t,
          n,
          i,
          o,
          r,
          s = this;
        return (
          (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
          !(!s.dragging || (r && 1 !== r.length)) &&
            ((t = s.getLeft(s.currentSlide)),
            (s.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
            (s.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
            (s.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))
            )),
            (n = s.swipeDirection()),
            "vertical" !== n
              ? (void 0 !== e.originalEvent &&
                  s.touchObject.swipeLength > 4 &&
                  e.preventDefault(),
                (o =
                  (s.options.rtl === !1 ? 1 : -1) *
                  (s.touchObject.curX > s.touchObject.startX ? 1 : -1)),
                s.options.verticalSwiping === !0 &&
                  (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
                (i = s.touchObject.swipeLength),
                (s.touchObject.edgeHit = !1),
                (s.swipeLeft = t + i * o),
                s.options.fade !== !0 &&
                  s.options.touchMove !== !1 &&
                  (s.animating === !0
                    ? ((s.swipeLeft = null), !1)
                    : void s.setCSS(s.swipeLeft)))
              : void 0)
        );
      }),
      (t.prototype.swipeStart = function (e) {
        var t,
          n = this;
        return (
          (n.interrupted = !0),
          1 !== n.touchObject.fingerCount ||
          n.slideCount <= n.options.slidesToShow
            ? ((n.touchObject = {}), !1)
            : (void 0 !== e.originalEvent &&
                void 0 !== e.originalEvent.touches &&
                (t = e.originalEvent.touches[0]),
              (n.touchObject.startX = n.touchObject.curX =
                void 0 !== t ? t.pageX : e.clientX),
              (n.touchObject.startY = n.touchObject.curY =
                void 0 !== t ? t.pageY : e.clientY),
              void (n.dragging = !0))
        );
      }),
      (t.prototype.unfilterSlides = t.prototype.slickUnfilter =
        function () {
          var e = this;
          null !== e.$slidesCache &&
            (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit());
        }),
      (t.prototype.unload = function () {
        var t = this;
        e(".slick-cloned", t.$slider).remove(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.htmlExpr.test(t.options.prevArrow) &&
            t.$prevArrow.remove(),
          t.$nextArrow &&
            t.htmlExpr.test(t.options.nextArrow) &&
            t.$nextArrow.remove(),
          t.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (t.prototype.unslick = function (e) {
        var t = this;
        t.$slider.trigger("unslick", [t, e]), t.destroy();
      }),
      (t.prototype.updateDots = function () {
        var e = this;
        null !== e.$dots &&
          (e.$dots.find("li").removeClass("slick-active"),
          e.$dots
            .find("li")
            .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
            .addClass("slick-active"));
      }),
      (t.prototype.visibility = function () {
        var e = this;
        e.options.autoplay &&
          (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
      }),
      (e.fn.slick = function () {
        var e,
          n,
          i = this,
          o = arguments[0],
          r = Array.prototype.slice.call(arguments, 1),
          s = i.length;
        for (e = 0; e < s; e++)
          if (
            ("object" == typeof o || "undefined" == typeof o
              ? (i[e].slick = new t(i[e], o))
              : (n = i[e].slick[o].apply(i[e].slick, r)),
            "undefined" != typeof n)
          )
            return n;
        return i;
      });
  })
  /*!
   * jquery.ba-throttle-debounce.min.js
   */,
  /*
   * jQuery throttle / debounce - v1.1 - 3/7/2010
   * http://benalman.com/projects/jquery-throttle-debounce-plugin/
   *
   * Copyright (c) 2010 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */
  (function (e, t) {
    var n,
      i = e.jQuery || e.Cowboy || (e.Cowboy = {});
    (i.throttle = n =
      function (e, n, o, r) {
        function s() {
          function i() {
            (l = +new Date()), o.apply(u, d);
          }
          function s() {
            a = t;
          }
          var u = this,
            c = +new Date() - l,
            d = arguments;
          r && !a && i(),
            a && clearTimeout(a),
            r === t && c > e
              ? i()
              : n !== !0 && (a = setTimeout(r ? s : i, r === t ? e - c : e));
        }
        var a,
          l = 0;
        return (
          "boolean" != typeof n && ((r = o), (o = n), (n = t)),
          i.guid && (s.guid = o.guid = o.guid || i.guid++),
          s
        );
      }),
      (i.debounce = function (e, i, o) {
        return o === t ? n(e, i, !1) : n(e, o, i !== !1);
      });
  })(this);
/**
 * responsive-tabs
 *
 * jQuery plugin that provides responsive tab functionality. The tabs transform to an accordion when it reaches a CSS breakpoint.
 *
 * @author Jelle Kralt
 * @version v1.6.3
 * @license MIT
 */
!(function (t, s, a) {
  function e(s, a) {
    (this.element = s),
      (this.$element = t(s)),
      (this.tabs = []),
      (this.state = ""),
      (this.rotateInterval = 0),
      (this.$queue = t({})),
      (this.options = t.extend({}, o, a)),
      this.init();
  }
  var o = {
    active: null,
    event: "click",
    disabled: [],
    collapsible: "accordion",
    startCollapsed: !1,
    rotate: !1,
    setHash: !1,
    animation: "default",
    animationQueue: !1,
    duration: 500,
    fluidHeight: !0,
    scrollToAccordion: !1,
    scrollToAccordionOnLoad: !0,
    scrollToAccordionOffset: 0,
    accordionTabElement: "<div></div>",
    navigationContainer: "",
    click: function () {},
    activate: function () {},
    deactivate: function () {},
    load: function () {},
    activateState: function () {},
    classes: {
      stateDefault: "r-tabs-state-default",
      stateActive: "r-tabs-state-active",
      stateDisabled: "r-tabs-state-disabled",
      stateExcluded: "r-tabs-state-excluded",
      container: "r-tabs",
      ul: "r-tabs-nav",
      tab: "r-tabs-tab",
      anchor: "r-tabs-anchor",
      panel: "r-tabs-panel",
      accordionTitle: "r-tabs-accordion-title",
    },
  };
  (e.prototype.init = function () {
    var a = this;
    (this.tabs = this._loadElements()),
      this._loadClasses(),
      this._loadEvents(),
      t(s).on("resize", function (t) {
        a._setState(t), a.options.fluidHeight !== !0 && a._equaliseHeights();
      }),
      t(s).on("hashchange", function (t) {
        var e = a._getTabRefBySelector(s.location.hash),
          o = a._getTab(e);
        e >= 0 &&
          !o._ignoreHashChange &&
          !o.disabled &&
          a._openTab(t, a._getTab(e), !0);
      }),
      this.options.rotate !== !1 && this.startRotation(),
      this.options.fluidHeight !== !0 && a._equaliseHeights(),
      this.$element.bind("tabs-click", function (t, s) {
        a.options.click.call(this, t, s);
      }),
      this.$element.bind("tabs-activate", function (t, s) {
        a.options.activate.call(this, t, s);
      }),
      this.$element.bind("tabs-deactivate", function (t, s) {
        a.options.deactivate.call(this, t, s);
      }),
      this.$element.bind("tabs-activate-state", function (t, s) {
        a.options.activateState.call(this, t, s);
      }),
      this.$element.bind("tabs-load", function (t) {
        var s;
        a._setState(t),
          a.options.startCollapsed === !0 ||
            ("accordion" === a.options.startCollapsed &&
              "accordion" === a.state) ||
            ((s = a._getStartTab()),
            a._openTab(t, s),
            a.options.load.call(this, t, s));
      }),
      this.$element.trigger("tabs-load");
  }),
    (e.prototype._loadElements = function () {
      var s = this,
        a =
          "" === s.options.navigationContainer
            ? this.$element.children("ul:first")
            : this.$element
                .find(s.options.navigationContainer)
                .children("ul:first"),
        e = [],
        o = 0;
      return (
        this.$element.addClass(s.options.classes.container),
        a.addClass(s.options.classes.ul),
        t("li", a).each(function () {
          var a,
            i,
            n,
            l,
            r,
            c = t(this),
            h = c.hasClass(s.options.classes.stateExcluded);
          if (!h) {
            (a = t("a", c)),
              (r = a.attr("href")),
              (i = t(r)),
              (n = t(s.options.accordionTabElement).insertBefore(i)),
              (l = t("<a></a>").attr("href", r).html(a.html()).appendTo(n));
            var p = {
              _ignoreHashChange: !1,
              id: o,
              disabled: -1 !== t.inArray(o, s.options.disabled),
              tab: t(this),
              anchor: t("a", c),
              panel: i,
              selector: r,
              accordionTab: n,
              accordionAnchor: l,
              active: !1,
            };
            o++, e.push(p);
          }
        }),
        e
      );
    }),
    (e.prototype._loadClasses = function () {
      for (var t = 0; t < this.tabs.length; t++)
        this.tabs[t].tab
          .addClass(this.options.classes.stateDefault)
          .addClass(this.options.classes.tab),
          this.tabs[t].anchor.addClass(this.options.classes.anchor),
          this.tabs[t].panel
            .addClass(this.options.classes.stateDefault)
            .addClass(this.options.classes.panel),
          this.tabs[t].accordionTab.addClass(
            this.options.classes.accordionTitle
          ),
          this.tabs[t].accordionAnchor.addClass(this.options.classes.anchor),
          this.tabs[t].disabled &&
            (this.tabs[t].tab
              .removeClass(this.options.classes.stateDefault)
              .addClass(this.options.classes.stateDisabled),
            this.tabs[t].accordionTab
              .removeClass(this.options.classes.stateDefault)
              .addClass(this.options.classes.stateDisabled));
    }),
    (e.prototype._loadEvents = function () {
      for (
        var t = this,
          a = function (a) {
            var e = t._getCurrentTab(),
              o = a.data.tab;
            a.preventDefault(),
              o.tab.trigger("tabs-click", o),
              o.disabled ||
                (t.options.setHash &&
                  (history.pushState
                    ? (s.location.origin ||
                        (s.location.origin =
                          s.location.protocol +
                          "//" +
                          s.location.hostname +
                          (s.location.port ? ":" + s.location.port : "")),
                      history.pushState(
                        null,
                        null,
                        s.location.origin +
                          s.location.pathname +
                          s.location.search +
                          o.selector
                      ))
                    : (s.location.hash = o.selector)),
                (a.data.tab._ignoreHashChange = !0),
                (e !== o || t._isCollapisble()) &&
                  (t._closeTab(a, e),
                  (e === o && t._isCollapisble()) || t._openTab(a, o, !1, !0)));
          },
          e = 0;
        e < this.tabs.length;
        e++
      )
        this.tabs[e].anchor.on(t.options.event, { tab: t.tabs[e] }, a),
          this.tabs[e].accordionAnchor.on(
            t.options.event,
            { tab: t.tabs[e] },
            a
          );
    }),
    (e.prototype._getStartTab = function () {
      var t,
        a = this._getTabRefBySelector(s.location.hash);
      return (t =
        a >= 0 && !this._getTab(a).disabled
          ? this._getTab(a)
          : this.options.active > 0 &&
            !this._getTab(this.options.active).disabled
          ? this._getTab(this.options.active)
          : this._getTab(0));
    }),
    (e.prototype._setState = function (s) {
      var e,
        o = t("ul:first", this.$element),
        i = this.state,
        n = "string" == typeof this.options.startCollapsed;
      o.is(":visible") ? (this.state = "tabs") : (this.state = "accordion"),
        this.state !== i &&
          (this.$element.trigger("tabs-activate-state", {
            oldState: i,
            newState: this.state,
          }),
          i &&
            n &&
            this.options.startCollapsed !== this.state &&
            this._getCurrentTab() === a &&
            ((e = this._getStartTab(s)), this._openTab(s, e)));
    }),
    (e.prototype._openTab = function (s, a, e, o) {
      var i,
        n = this;
      e && this._closeTab(s, this._getCurrentTab()),
        o && this.rotateInterval > 0 && this.stopRotation(),
        (a.active = !0),
        a.tab
          .removeClass(n.options.classes.stateDefault)
          .addClass(n.options.classes.stateActive),
        a.accordionTab
          .removeClass(n.options.classes.stateDefault)
          .addClass(n.options.classes.stateActive),
        n._doTransition(a.panel, n.options.animation, "open", function () {
          var e = "tabs-load" !== s.type || n.options.scrollToAccordionOnLoad;
          a.panel
            .removeClass(n.options.classes.stateDefault)
            .addClass(n.options.classes.stateActive),
            "accordion" !== n.getState() ||
              !n.options.scrollToAccordion ||
              (n._isInView(a.accordionTab) &&
                "default" === n.options.animation) ||
              !e ||
              ((i =
                a.accordionTab.offset().top -
                n.options.scrollToAccordionOffset),
              "default" !== n.options.animation && n.options.duration > 0
                ? t("html, body").animate({ scrollTop: i }, n.options.duration)
                : t("html, body").scrollTop(i));
        }),
        this.$element.trigger("tabs-activate", a);
    }),
    (e.prototype._closeTab = function (t, s) {
      var e,
        o = this,
        i = "string" == typeof o.options.animationQueue;
      s !== a &&
        ((e =
          i && o.getState() === o.options.animationQueue
            ? !0
            : i
            ? !1
            : o.options.animationQueue),
        (s.active = !1),
        s.tab
          .removeClass(o.options.classes.stateActive)
          .addClass(o.options.classes.stateDefault),
        o._doTransition(
          s.panel,
          o.options.animation,
          "close",
          function () {
            s.accordionTab
              .removeClass(o.options.classes.stateActive)
              .addClass(o.options.classes.stateDefault),
              s.panel
                .removeClass(o.options.classes.stateActive)
                .addClass(o.options.classes.stateDefault);
          },
          !e
        ),
        this.$element.trigger("tabs-deactivate", s));
    }),
    (e.prototype._doTransition = function (t, s, a, e, o) {
      var i,
        n = this;
      switch (s) {
        case "slide":
          i = "open" === a ? "slideDown" : "slideUp";
          break;
        case "fade":
          i = "open" === a ? "fadeIn" : "fadeOut";
          break;
        default:
          (i = "open" === a ? "show" : "hide"), (n.options.duration = 0);
      }
      this.$queue.queue("responsive-tabs", function (o) {
        t[i]({
          duration: n.options.duration,
          complete: function () {
            e.call(t, s, a), o();
          },
        });
      }),
        ("open" === a || o) && this.$queue.dequeue("responsive-tabs");
    }),
    (e.prototype._isCollapisble = function () {
      return (
        ("boolean" == typeof this.options.collapsible &&
          this.options.collapsible) ||
        ("string" == typeof this.options.collapsible &&
          this.options.collapsible === this.getState())
      );
    }),
    (e.prototype._getTab = function (t) {
      return this.tabs[t];
    }),
    (e.prototype._getTabRefBySelector = function (t) {
      for (var s = 0; s < this.tabs.length; s++)
        if (this.tabs[s].selector === t) return s;
      return -1;
    }),
    (e.prototype._getCurrentTab = function () {
      return this._getTab(this._getCurrentTabRef());
    }),
    (e.prototype._getNextTabRef = function (t) {
      var s = t || this._getCurrentTabRef(),
        a = s === this.tabs.length - 1 ? 0 : s + 1;
      return this._getTab(a).disabled ? this._getNextTabRef(a) : a;
    }),
    (e.prototype._getPreviousTabRef = function () {
      return 0 === this._getCurrentTabRef()
        ? this.tabs.length - 1
        : this._getCurrentTabRef() - 1;
    }),
    (e.prototype._getCurrentTabRef = function () {
      for (var t = 0; t < this.tabs.length; t++)
        if (this.tabs[t].active) return t;
      return -1;
    }),
    (e.prototype._equaliseHeights = function () {
      var s = 0;
      t.each(
        t.map(this.tabs, function (t) {
          return (
            (s = Math.max(s, t.panel.css("minHeight", "").height())), t.panel
          );
        }),
        function () {
          this.css("minHeight", s);
        }
      );
    }),
    (e.prototype._isInView = function (a) {
      var e = t(s).scrollTop(),
        o = e + t(s).height(),
        i = a.offset().top,
        n = i + a.height();
      return o >= n && i >= e;
    }),
    (e.prototype.activate = function (t, s) {
      var a = jQuery.Event("tabs-activate"),
        e = this._getTab(t);
      e.disabled || this._openTab(a, e, !0, s || !0);
    }),
    (e.prototype.deactivate = function (t) {
      var s = jQuery.Event("tabs-dectivate"),
        a = this._getTab(t);
      a.disabled || this._closeTab(s, a);
    }),
    (e.prototype.enable = function (t) {
      var s = this._getTab(t);
      s &&
        ((s.disabled = !1),
        s.tab
          .addClass(this.options.classes.stateDefault)
          .removeClass(this.options.classes.stateDisabled),
        s.accordionTab
          .addClass(this.options.classes.stateDefault)
          .removeClass(this.options.classes.stateDisabled));
    }),
    (e.prototype.disable = function (t) {
      var s = this._getTab(t);
      s &&
        ((s.disabled = !0),
        s.tab
          .removeClass(this.options.classes.stateDefault)
          .addClass(this.options.classes.stateDisabled),
        s.accordionTab
          .removeClass(this.options.classes.stateDefault)
          .addClass(this.options.classes.stateDisabled));
    }),
    (e.prototype.getState = function () {
      return this.state;
    }),
    (e.prototype.startRotation = function (s) {
      var a = this;
      if (!(this.tabs.length > this.options.disabled.length))
        throw new Error("Rotation is not possible if all tabs are disabled");
      this.rotateInterval = setInterval(function () {
        var t = jQuery.Event("rotate");
        a._openTab(t, a._getTab(a._getNextTabRef()), !0);
      }, s || (t.isNumeric(a.options.rotate) ? a.options.rotate : 4e3));
    }),
    (e.prototype.stopRotation = function () {
      s.clearInterval(this.rotateInterval), (this.rotateInterval = 0);
    }),
    (e.prototype.option = function (t, s) {
      return s && (this.options[t] = s), this.options[t];
    }),
    (t.fn.responsiveTabs = function (s) {
      var o,
        i = arguments;
      return s === a || "object" == typeof s
        ? this.each(function () {
            t.data(this, "responsivetabs") ||
              t.data(this, "responsivetabs", new e(this, s));
          })
        : "string" == typeof s && "_" !== s[0] && "init" !== s
        ? ((o = t.data(this[0], "responsivetabs")),
          "destroy" === s && t.data(this, "responsivetabs", null),
          o instanceof e && "function" == typeof o[s]
            ? o[s].apply(o, Array.prototype.slice.call(i, 1))
            : this)
        : void 0;
    });
})(jQuery, window);
/**
 * plyr
 */
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define("Plyr", t)
    : (e.Plyr = t());
})(this, function () {
  "use strict";
  var e =
    "undefined" != typeof window
      ? window
      : "undefined" != typeof global
      ? global
      : "undefined" != typeof self
      ? self
      : {};
  function t(e, t) {
    return e((t = { exports: {} }), t.exports), t.exports;
  }
  var n = t(function (e) {
      var t = (e.exports =
        "undefined" != typeof window && window.Math == Math
          ? window
          : "undefined" != typeof self && self.Math == Math
          ? self
          : Function("return this")());
      "number" == typeof __g && (__g = t);
    }),
    i = t(function (e) {
      var t = (e.exports = { version: "2.5.3" });
      "number" == typeof __e && (__e = t);
    }),
    r =
      (i.version,
      function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      }),
    s = function (e) {
      if (!r(e)) throw TypeError(e + " is not an object!");
      return e;
    },
    o = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    },
    a = !o(function () {
      return (
        7 !=
        Object.defineProperty({}, "a", {
          get: function () {
            return 7;
          },
        }).a
      );
    }),
    l = n.document,
    c = r(l) && r(l.createElement),
    u = function (e) {
      return c ? l.createElement(e) : {};
    },
    d =
      !a &&
      !o(function () {
        return (
          7 !=
          Object.defineProperty(u("div"), "a", {
            get: function () {
              return 7;
            },
          }).a
        );
      }),
    h = function (e, t) {
      if (!r(e)) return e;
      var n, i;
      if (t && "function" == typeof (n = e.toString) && !r((i = n.call(e))))
        return i;
      if ("function" == typeof (n = e.valueOf) && !r((i = n.call(e)))) return i;
      if (!t && "function" == typeof (n = e.toString) && !r((i = n.call(e))))
        return i;
      throw TypeError("Can't convert object to primitive value");
    },
    f = Object.defineProperty,
    p = {
      f: a
        ? Object.defineProperty
        : function (e, t, n) {
            if ((s(e), (t = h(t, !0)), s(n), d))
              try {
                return f(e, t, n);
              } catch (e) {}
            if ("get" in n || "set" in n)
              throw TypeError("Accessors not supported!");
            return "value" in n && (e[t] = n.value), e;
          },
    },
    g = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t,
      };
    },
    m = a
      ? function (e, t, n) {
          return p.f(e, t, g(1, n));
        }
      : function (e, t, n) {
          return (e[t] = n), e;
        },
    y = {}.hasOwnProperty,
    v = function (e, t) {
      return y.call(e, t);
    },
    b = 0,
    w = Math.random(),
    E = function (e) {
      return "Symbol(".concat(
        void 0 === e ? "" : e,
        ")_",
        (++b + w).toString(36)
      );
    },
    k = t(function (e) {
      var t = E("src"),
        r = Function.toString,
        s = ("" + r).split("toString");
      (i.inspectSource = function (e) {
        return r.call(e);
      }),
        (e.exports = function (e, i, r, o) {
          var a = "function" == typeof r;
          a && (v(r, "name") || m(r, "name", i)),
            e[i] !== r &&
              (a && (v(r, t) || m(r, t, e[i] ? "" + e[i] : s.join(String(i)))),
              e === n
                ? (e[i] = r)
                : o
                ? e[i]
                  ? (e[i] = r)
                  : m(e, i, r)
                : (delete e[i], m(e, i, r)));
        })(Function.prototype, "toString", function () {
          return ("function" == typeof this && this[t]) || r.call(this);
        });
    }),
    T = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    },
    S = function (e, t, n) {
      if ((T(e), void 0 === t)) return e;
      switch (n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };
        case 2:
          return function (n, i) {
            return e.call(t, n, i);
          };
        case 3:
          return function (n, i, r) {
            return e.call(t, n, i, r);
          };
      }
      return function () {
        return e.apply(t, arguments);
      };
    },
    A = function (e, t, r) {
      var s,
        o,
        a,
        l,
        c = e & A.F,
        u = e & A.G,
        d = e & A.S,
        h = e & A.P,
        f = e & A.B,
        p = u ? n : d ? n[t] || (n[t] = {}) : (n[t] || {}).prototype,
        g = u ? i : i[t] || (i[t] = {}),
        y = g.prototype || (g.prototype = {});
      for (s in (u && (r = t), r))
        (a = ((o = !c && p && void 0 !== p[s]) ? p : r)[s]),
          (l =
            f && o
              ? S(a, n)
              : h && "function" == typeof a
              ? S(Function.call, a)
              : a),
          p && k(p, s, a, e & A.U),
          g[s] != a && m(g, s, l),
          h && y[s] != a && (y[s] = a);
    };
  (n.core = i),
    (A.F = 1),
    (A.G = 2),
    (A.S = 4),
    (A.P = 8),
    (A.B = 16),
    (A.W = 32),
    (A.U = 64),
    (A.R = 128);
  for (
    var C,
      _ = A,
      P = E("typed_array"),
      x = E("view"),
      M = !(!n.ArrayBuffer || !n.DataView),
      L = M,
      N = 0,
      O =
        "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(
          ","
        );
    N < 9;

  )
    (C = n[O[N++]]) ? (m(C.prototype, P, !0), m(C.prototype, x, !0)) : (L = !1);
  var I = { ABV: M, CONSTR: L, TYPED: P, VIEW: x },
    j = function (e, t, n) {
      for (var i in t) k(e, i, t[i], n);
      return e;
    },
    F = function (e, t, n, i) {
      if (!(e instanceof t) || (void 0 !== i && i in e))
        throw TypeError(n + ": incorrect invocation!");
      return e;
    },
    R = Math.ceil,
    q = Math.floor,
    B = function (e) {
      return isNaN((e = +e)) ? 0 : (e > 0 ? q : R)(e);
    },
    V = Math.min,
    D = function (e) {
      return e > 0 ? V(B(e), 9007199254740991) : 0;
    },
    U = function (e) {
      if (void 0 === e) return 0;
      var t = B(e),
        n = D(t);
      if (t !== n) throw RangeError("Wrong length!");
      return n;
    },
    H = {}.toString,
    W = function (e) {
      return H.call(e).slice(8, -1);
    },
    z = Object("z").propertyIsEnumerable(0)
      ? Object
      : function (e) {
          return "String" == W(e) ? e.split("") : Object(e);
        },
    G = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on  " + e);
      return e;
    },
    K = function (e) {
      return z(G(e));
    },
    Y = Math.max,
    Q = Math.min,
    J = function (e, t) {
      return (e = B(e)) < 0 ? Y(e + t, 0) : Q(e, t);
    },
    $ = function (e) {
      return function (t, n, i) {
        var r,
          s = K(t),
          o = D(s.length),
          a = J(i, o);
        if (e && n != n) {
          for (; o > a; ) if ((r = s[a++]) != r) return !0;
        } else
          for (; o > a; a++)
            if ((e || a in s) && s[a] === n) return e || a || 0;
        return !e && -1;
      };
    },
    X = n["__core-js_shared__"] || (n["__core-js_shared__"] = {}),
    Z = function (e) {
      return X[e] || (X[e] = {});
    },
    ee = Z("keys"),
    te = function (e) {
      return ee[e] || (ee[e] = E(e));
    },
    ne = $(!1),
    ie = te("IE_PROTO"),
    re = function (e, t) {
      var n,
        i = K(e),
        r = 0,
        s = [];
      for (n in i) n != ie && v(i, n) && s.push(n);
      for (; t.length > r; ) v(i, (n = t[r++])) && (~ne(s, n) || s.push(n));
      return s;
    },
    se =
      "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
        ","
      ),
    oe = se.concat("length", "prototype"),
    ae = {
      f:
        Object.getOwnPropertyNames ||
        function (e) {
          return re(e, oe);
        },
    },
    le = function (e) {
      return Object(G(e));
    },
    ce = function (e) {
      for (
        var t = le(this),
          n = D(t.length),
          i = arguments.length,
          r = J(i > 1 ? arguments[1] : void 0, n),
          s = i > 2 ? arguments[2] : void 0,
          o = void 0 === s ? n : J(s, n);
        o > r;

      )
        t[r++] = e;
      return t;
    },
    ue = t(function (e) {
      var t = Z("wks"),
        i = n.Symbol,
        r = "function" == typeof i;
      (e.exports = function (e) {
        return t[e] || (t[e] = (r && i[e]) || (r ? i : E)("Symbol." + e));
      }).store = t;
    }),
    de = p.f,
    he = ue("toStringTag"),
    fe = function (e, t, n) {
      e &&
        !v((e = n ? e : e.prototype), he) &&
        de(e, he, { configurable: !0, value: t });
    },
    pe = t(function (e, t) {
      var i = ae.f,
        r = p.f,
        s = "prototype",
        l = "Wrong index!",
        c = n.ArrayBuffer,
        u = n.DataView,
        d = n.Math,
        h = n.RangeError,
        f = n.Infinity,
        g = c,
        y = d.abs,
        v = d.pow,
        b = d.floor,
        w = d.log,
        E = d.LN2,
        k = a ? "_b" : "buffer",
        T = a ? "_l" : "byteLength",
        S = a ? "_o" : "byteOffset";
      function A(e, t, n) {
        var i,
          r,
          s,
          o = new Array(n),
          a = 8 * n - t - 1,
          l = (1 << a) - 1,
          c = l >> 1,
          u = 23 === t ? v(2, -24) - v(2, -77) : 0,
          d = 0,
          h = e < 0 || (0 === e && 1 / e < 0) ? 1 : 0;
        for (
          (e = y(e)) != e || e === f
            ? ((r = e != e ? 1 : 0), (i = l))
            : ((i = b(w(e) / E)),
              e * (s = v(2, -i)) < 1 && (i--, (s *= 2)),
              (e += i + c >= 1 ? u / s : u * v(2, 1 - c)) * s >= 2 &&
                (i++, (s /= 2)),
              i + c >= l
                ? ((r = 0), (i = l))
                : i + c >= 1
                ? ((r = (e * s - 1) * v(2, t)), (i += c))
                : ((r = e * v(2, c - 1) * v(2, t)), (i = 0)));
          t >= 8;
          o[d++] = 255 & r, r /= 256, t -= 8
        );
        for (
          i = (i << t) | r, a += t;
          a > 0;
          o[d++] = 255 & i, i /= 256, a -= 8
        );
        return (o[--d] |= 128 * h), o;
      }
      function C(e, t, n) {
        var i,
          r = 8 * n - t - 1,
          s = (1 << r) - 1,
          o = s >> 1,
          a = r - 7,
          l = n - 1,
          c = e[l--],
          u = 127 & c;
        for (c >>= 7; a > 0; u = 256 * u + e[l], l--, a -= 8);
        for (
          i = u & ((1 << -a) - 1), u >>= -a, a += t;
          a > 0;
          i = 256 * i + e[l], l--, a -= 8
        );
        if (0 === u) u = 1 - o;
        else {
          if (u === s) return i ? NaN : c ? -f : f;
          (i += v(2, t)), (u -= o);
        }
        return (c ? -1 : 1) * i * v(2, u - t);
      }
      function _(e) {
        return (e[3] << 24) | (e[2] << 16) | (e[1] << 8) | e[0];
      }
      function P(e) {
        return [255 & e];
      }
      function x(e) {
        return [255 & e, (e >> 8) & 255];
      }
      function M(e) {
        return [255 & e, (e >> 8) & 255, (e >> 16) & 255, (e >> 24) & 255];
      }
      function L(e) {
        return A(e, 52, 8);
      }
      function N(e) {
        return A(e, 23, 4);
      }
      function O(e, t, n) {
        r(e[s], t, {
          get: function () {
            return this[n];
          },
        });
      }
      function R(e, t, n, i) {
        var r = U(+n);
        if (r + t > e[T]) throw h(l);
        var s = e[k]._b,
          o = r + e[S],
          a = s.slice(o, o + t);
        return i ? a : a.reverse();
      }
      function q(e, t, n, i, r, s) {
        var o = U(+n);
        if (o + t > e[T]) throw h(l);
        for (var a = e[k]._b, c = o + e[S], u = i(+r), d = 0; d < t; d++)
          a[c + d] = u[s ? d : t - d - 1];
      }
      if (I.ABV) {
        if (
          !o(function () {
            c(1);
          }) ||
          !o(function () {
            new c(-1);
          }) ||
          o(function () {
            return new c(), new c(1.5), new c(NaN), "ArrayBuffer" != c.name;
          })
        ) {
          for (
            var V,
              H = ((c = function (e) {
                return F(this, c), new g(U(e));
              })[s] = g[s]),
              W = i(g),
              z = 0;
            W.length > z;

          )
            (V = W[z++]) in c || m(c, V, g[V]);
          H.constructor = c;
        }
        var G = new u(new c(2)),
          K = u[s].setInt8;
        G.setInt8(0, 2147483648),
          G.setInt8(1, 2147483649),
          (!G.getInt8(0) && G.getInt8(1)) ||
            j(
              u[s],
              {
                setInt8: function (e, t) {
                  K.call(this, e, (t << 24) >> 24);
                },
                setUint8: function (e, t) {
                  K.call(this, e, (t << 24) >> 24);
                },
              },
              !0
            );
      } else
        (c = function (e) {
          F(this, c, "ArrayBuffer");
          var t = U(e);
          (this._b = ce.call(new Array(t), 0)), (this[T] = t);
        }),
          (u = function (e, t, n) {
            F(this, u, "DataView"), F(e, c, "DataView");
            var i = e[T],
              r = B(t);
            if (r < 0 || r > i) throw h("Wrong offset!");
            if (r + (n = void 0 === n ? i - r : D(n)) > i)
              throw h("Wrong length!");
            (this[k] = e), (this[S] = r), (this[T] = n);
          }),
          a &&
            (O(c, "byteLength", "_l"),
            O(u, "buffer", "_b"),
            O(u, "byteLength", "_l"),
            O(u, "byteOffset", "_o")),
          j(u[s], {
            getInt8: function (e) {
              return (R(this, 1, e)[0] << 24) >> 24;
            },
            getUint8: function (e) {
              return R(this, 1, e)[0];
            },
            getInt16: function (e) {
              var t = R(this, 2, e, arguments[1]);
              return (((t[1] << 8) | t[0]) << 16) >> 16;
            },
            getUint16: function (e) {
              var t = R(this, 2, e, arguments[1]);
              return (t[1] << 8) | t[0];
            },
            getInt32: function (e) {
              return _(R(this, 4, e, arguments[1]));
            },
            getUint32: function (e) {
              return _(R(this, 4, e, arguments[1])) >>> 0;
            },
            getFloat32: function (e) {
              return C(R(this, 4, e, arguments[1]), 23, 4);
            },
            getFloat64: function (e) {
              return C(R(this, 8, e, arguments[1]), 52, 8);
            },
            setInt8: function (e, t) {
              q(this, 1, e, P, t);
            },
            setUint8: function (e, t) {
              q(this, 1, e, P, t);
            },
            setInt16: function (e, t) {
              q(this, 2, e, x, t, arguments[2]);
            },
            setUint16: function (e, t) {
              q(this, 2, e, x, t, arguments[2]);
            },
            setInt32: function (e, t) {
              q(this, 4, e, M, t, arguments[2]);
            },
            setUint32: function (e, t) {
              q(this, 4, e, M, t, arguments[2]);
            },
            setFloat32: function (e, t) {
              q(this, 4, e, N, t, arguments[2]);
            },
            setFloat64: function (e, t) {
              q(this, 8, e, L, t, arguments[2]);
            },
          });
      fe(c, "ArrayBuffer"),
        fe(u, "DataView"),
        m(u[s], I.VIEW, !0),
        (t.ArrayBuffer = c),
        (t.DataView = u);
    }),
    ge = ue("species"),
    me = function (e, t) {
      var n,
        i = s(e).constructor;
      return void 0 === i || void 0 == (n = s(i)[ge]) ? t : T(n);
    },
    ye = ue("species"),
    ve = function (e) {
      var t = n[e];
      a &&
        t &&
        !t[ye] &&
        p.f(t, ye, {
          configurable: !0,
          get: function () {
            return this;
          },
        });
    },
    be = n.ArrayBuffer,
    we = pe.ArrayBuffer,
    Ee = pe.DataView,
    ke = I.ABV && be.isView,
    Te = we.prototype.slice,
    Se = I.VIEW;
  _(_.G + _.W + _.F * (be !== we), { ArrayBuffer: we }),
    _(_.S + _.F * !I.CONSTR, "ArrayBuffer", {
      isView: function (e) {
        return (ke && ke(e)) || (r(e) && Se in e);
      },
    }),
    _(
      _.P +
        _.U +
        _.F *
          o(function () {
            return !new we(2).slice(1, void 0).byteLength;
          }),
      "ArrayBuffer",
      {
        slice: function (e, t) {
          if (void 0 !== Te && void 0 === t) return Te.call(s(this), e);
          for (
            var n = s(this).byteLength,
              i = J(e, n),
              r = J(void 0 === t ? n : t, n),
              o = new (me(this, we))(D(r - i)),
              a = new Ee(this),
              l = new Ee(o),
              c = 0;
            i < r;

          )
            l.setUint8(c++, a.getUint8(i++));
          return o;
        },
      }
    ),
    ve("ArrayBuffer");
  var Ae = ue("toStringTag"),
    Ce =
      "Arguments" ==
      W(
        (function () {
          return arguments;
        })()
      ),
    _e = function (e) {
      var t, n, i;
      return void 0 === e
        ? "Undefined"
        : null === e
        ? "Null"
        : "string" ==
          typeof (n = (function (e, t) {
            try {
              return e[t];
            } catch (e) {}
          })((t = Object(e)), Ae))
        ? n
        : Ce
        ? W(t)
        : "Object" == (i = W(t)) && "function" == typeof t.callee
        ? "Arguments"
        : i;
    },
    Pe = {},
    xe = ue("iterator"),
    Me = Array.prototype,
    Le = function (e) {
      return void 0 !== e && (Pe.Array === e || Me[xe] === e);
    },
    Ne =
      Object.keys ||
      function (e) {
        return re(e, se);
      },
    Oe = a
      ? Object.defineProperties
      : function (e, t) {
          s(e);
          for (var n, i = Ne(t), r = i.length, o = 0; r > o; )
            p.f(e, (n = i[o++]), t[n]);
          return e;
        },
    Ie = n.document,
    je = Ie && Ie.documentElement,
    Fe = te("IE_PROTO"),
    Re = function () {},
    qe = function () {
      var e,
        t = u("iframe"),
        n = se.length;
      for (
        t.style.display = "none",
          je.appendChild(t),
          t.src = "javascript:",
          (e = t.contentWindow.document).open(),
          e.write("<script>document.F=Object</script>"),
          e.close(),
          qe = e.F;
        n--;

      )
        delete qe.prototype[se[n]];
      return qe();
    },
    Be =
      Object.create ||
      function (e, t) {
        var n;
        return (
          null !== e
            ? ((Re.prototype = s(e)),
              (n = new Re()),
              (Re.prototype = null),
              (n[Fe] = e))
            : (n = qe()),
          void 0 === t ? n : Oe(n, t)
        );
      },
    Ve = te("IE_PROTO"),
    De = Object.prototype,
    Ue =
      Object.getPrototypeOf ||
      function (e) {
        return (
          (e = le(e)),
          v(e, Ve)
            ? e[Ve]
            : "function" == typeof e.constructor && e instanceof e.constructor
            ? e.constructor.prototype
            : e instanceof Object
            ? De
            : null
        );
      },
    He = ue("iterator"),
    We = (i.getIteratorMethod = function (e) {
      if (void 0 != e) return e[He] || e["@@iterator"] || Pe[_e(e)];
    }),
    ze =
      Array.isArray ||
      function (e) {
        return "Array" == W(e);
      },
    Ge = ue("species"),
    Ke = function (e, t) {
      return new ((function (e) {
        var t;
        return (
          ze(e) &&
            ("function" != typeof (t = e.constructor) ||
              (t !== Array && !ze(t.prototype)) ||
              (t = void 0),
            r(t) && null === (t = t[Ge]) && (t = void 0)),
          void 0 === t ? Array : t
        );
      })(e))(t);
    },
    Ye = function (e, t) {
      var n = 1 == e,
        i = 2 == e,
        r = 3 == e,
        s = 4 == e,
        o = 6 == e,
        a = 5 == e || o,
        l = t || Ke;
      return function (t, c, u) {
        for (
          var d,
            h,
            f = le(t),
            p = z(f),
            g = S(c, u, 3),
            m = D(p.length),
            y = 0,
            v = n ? l(t, m) : i ? l(t, 0) : void 0;
          m > y;
          y++
        )
          if ((a || y in p) && ((h = g((d = p[y]), y, f)), e))
            if (n) v[y] = h;
            else if (h)
              switch (e) {
                case 3:
                  return !0;
                case 5:
                  return d;
                case 6:
                  return y;
                case 2:
                  v.push(d);
              }
            else if (s) return !1;
        return o ? -1 : r || s ? s : v;
      };
    },
    Qe = ue("unscopables"),
    Je = Array.prototype;
  void 0 == Je[Qe] && m(Je, Qe, {});
  var $e = function (e) {
      Je[Qe][e] = !0;
    },
    Xe = function (e, t) {
      return { value: t, done: !!e };
    },
    Ze = {};
  m(Ze, ue("iterator"), function () {
    return this;
  });
  var et = function (e, t, n) {
      (e.prototype = Be(Ze, { next: g(1, n) })), fe(e, t + " Iterator");
    },
    tt = ue("iterator"),
    nt = !([].keys && "next" in [].keys()),
    it = function () {
      return this;
    },
    rt = function (e, t, n, i, r, s, o) {
      et(n, t, i);
      var a,
        l,
        c,
        u = function (e) {
          if (!nt && e in p) return p[e];
          switch (e) {
            case "keys":
            case "values":
              return function () {
                return new n(this, e);
              };
          }
          return function () {
            return new n(this, e);
          };
        },
        d = t + " Iterator",
        h = "values" == r,
        f = !1,
        p = e.prototype,
        g = p[tt] || p["@@iterator"] || (r && p[r]),
        y = (!nt && g) || u(r),
        b = r ? (h ? u("entries") : y) : void 0,
        w = ("Array" == t && p.entries) || g;
      if (
        (w &&
          (c = Ue(w.call(new e()))) !== Object.prototype &&
          c.next &&
          (fe(c, d, !0), v(c, tt) || m(c, tt, it)),
        h &&
          g &&
          "values" !== g.name &&
          ((f = !0),
          (y = function () {
            return g.call(this);
          })),
        (nt || f || !p[tt]) && m(p, tt, y),
        (Pe[t] = y),
        (Pe[d] = it),
        r)
      )
        if (
          ((a = {
            values: h ? y : u("values"),
            keys: s ? y : u("keys"),
            entries: b,
          }),
          o)
        )
          for (l in a) l in p || k(p, l, a[l]);
        else _(_.P + _.F * (nt || f), t, a);
      return a;
    },
    st = rt(
      Array,
      "Array",
      function (e, t) {
        (this._t = K(e)), (this._i = 0), (this._k = t);
      },
      function () {
        var e = this._t,
          t = this._k,
          n = this._i++;
        return !e || n >= e.length
          ? ((this._t = void 0), Xe(1))
          : Xe(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
      },
      "values"
    );
  (Pe.Arguments = Pe.Array), $e("keys"), $e("values"), $e("entries");
  var ot = ue("iterator"),
    at = !1;
  try {
    [7][ot]().return = function () {
      at = !0;
    };
  } catch (e) {}
  var lt = function (e, t) {
      if (!t && !at) return !1;
      var n = !1;
      try {
        var i = [7],
          r = i[ot]();
        (r.next = function () {
          return { done: (n = !0) };
        }),
          (i[ot] = function () {
            return r;
          }),
          e(i);
      } catch (e) {}
      return n;
    },
    ct =
      [].copyWithin ||
      function (e, t) {
        var n = le(this),
          i = D(n.length),
          r = J(e, i),
          s = J(t, i),
          o = arguments.length > 2 ? arguments[2] : void 0,
          a = Math.min((void 0 === o ? i : J(o, i)) - s, i - r),
          l = 1;
        for (
          s < r && r < s + a && ((l = -1), (s += a - 1), (r += a - 1));
          a-- > 0;

        )
          s in n ? (n[r] = n[s]) : delete n[r], (r += l), (s += l);
        return n;
      },
    ut = { f: {}.propertyIsEnumerable },
    dt = Object.getOwnPropertyDescriptor,
    ht = {
      f: a
        ? dt
        : function (e, t) {
            if (((e = K(e)), (t = h(t, !0)), d))
              try {
                return dt(e, t);
              } catch (e) {}
            if (v(e, t)) return g(!ut.f.call(e, t), e[t]);
          },
    },
    ft = t(function (e) {
      if (a) {
        var t = n,
          i = o,
          s = _,
          l = I,
          c = pe,
          u = S,
          d = F,
          f = g,
          y = m,
          b = j,
          w = B,
          k = D,
          T = U,
          A = J,
          C = h,
          P = v,
          x = _e,
          M = r,
          L = le,
          N = Le,
          O = Be,
          R = Ue,
          q = ae.f,
          V = We,
          H = E,
          W = ue,
          z = Ye,
          G = $,
          K = me,
          Y = st,
          Q = Pe,
          X = lt,
          Z = ve,
          ee = ce,
          te = ct,
          ne = p,
          ie = ht,
          re = ne.f,
          se = ie.f,
          oe = t.RangeError,
          de = t.TypeError,
          he = t.Uint8Array,
          fe = Array.prototype,
          ge = c.ArrayBuffer,
          ye = c.DataView,
          be = z(0),
          we = z(2),
          Ee = z(3),
          ke = z(4),
          Te = z(5),
          Se = z(6),
          Ae = G(!0),
          Ce = G(!1),
          xe = Y.values,
          Me = Y.keys,
          Ne = Y.entries,
          Oe = fe.lastIndexOf,
          Ie = fe.reduce,
          je = fe.reduceRight,
          Fe = fe.join,
          Re = fe.sort,
          qe = fe.slice,
          Ve = fe.toString,
          De = fe.toLocaleString,
          He = W("iterator"),
          ze = W("toStringTag"),
          Ge = H("typed_constructor"),
          Ke = H("def_constructor"),
          Qe = l.CONSTR,
          Je = l.TYPED,
          $e = l.VIEW,
          Xe = z(1, function (e, t) {
            return it(K(e, e[Ke]), t);
          }),
          Ze = i(function () {
            return 1 === new he(new Uint16Array([1]).buffer)[0];
          }),
          et =
            !!he &&
            !!he.prototype.set &&
            i(function () {
              new he(1).set({});
            }),
          tt = function (e, t) {
            var n = w(e);
            if (n < 0 || n % t) throw oe("Wrong offset!");
            return n;
          },
          nt = function (e) {
            if (M(e) && Je in e) return e;
            throw de(e + " is not a typed array!");
          },
          it = function (e, t) {
            if (!(M(e) && Ge in e))
              throw de("It is not a typed array constructor!");
            return new e(t);
          },
          rt = function (e, t) {
            return ot(K(e, e[Ke]), t);
          },
          ot = function (e, t) {
            for (var n = 0, i = t.length, r = it(e, i); i > n; ) r[n] = t[n++];
            return r;
          },
          at = function (e, t, n) {
            re(e, t, {
              get: function () {
                return this._d[n];
              },
            });
          },
          ut = function (e) {
            var t,
              n,
              i,
              r,
              s,
              o,
              a = L(e),
              l = arguments.length,
              c = l > 1 ? arguments[1] : void 0,
              d = void 0 !== c,
              h = V(a);
            if (void 0 != h && !N(h)) {
              for (o = h.call(a), i = [], t = 0; !(s = o.next()).done; t++)
                i.push(s.value);
              a = i;
            }
            for (
              d && l > 2 && (c = u(c, arguments[2], 2)),
                t = 0,
                n = k(a.length),
                r = it(this, n);
              n > t;
              t++
            )
              r[t] = d ? c(a[t], t) : a[t];
            return r;
          },
          dt = function () {
            for (var e = 0, t = arguments.length, n = it(this, t); t > e; )
              n[e] = arguments[e++];
            return n;
          },
          ft =
            !!he &&
            i(function () {
              De.call(new he(1));
            }),
          pt = function () {
            return De.apply(ft ? qe.call(nt(this)) : nt(this), arguments);
          },
          gt = {
            copyWithin: function (e, t) {
              return te.call(
                nt(this),
                e,
                t,
                arguments.length > 2 ? arguments[2] : void 0
              );
            },
            every: function (e) {
              return ke(
                nt(this),
                e,
                arguments.length > 1 ? arguments[1] : void 0
              );
            },
            fill: function (e) {
              return ee.apply(nt(this), arguments);
            },
            filter: function (e) {
              return rt(
                this,
                we(nt(this), e, arguments.length > 1 ? arguments[1] : void 0)
              );
            },
            find: function (e) {
              return Te(
                nt(this),
                e,
                arguments.length > 1 ? arguments[1] : void 0
              );
            },
            findIndex: function (e) {
              return Se(
                nt(this),
                e,
                arguments.length > 1 ? arguments[1] : void 0
              );
            },
            forEach: function (e) {
              be(nt(this), e, arguments.length > 1 ? arguments[1] : void 0);
            },
            indexOf: function (e) {
              return Ce(
                nt(this),
                e,
                arguments.length > 1 ? arguments[1] : void 0
              );
            },
            includes: function (e) {
              return Ae(
                nt(this),
                e,
                arguments.length > 1 ? arguments[1] : void 0
              );
            },
            join: function (e) {
              return Fe.apply(nt(this), arguments);
            },
            lastIndexOf: function (e) {
              return Oe.apply(nt(this), arguments);
            },
            map: function (e) {
              return Xe(
                nt(this),
                e,
                arguments.length > 1 ? arguments[1] : void 0
              );
            },
            reduce: function (e) {
              return Ie.apply(nt(this), arguments);
            },
            reduceRight: function (e) {
              return je.apply(nt(this), arguments);
            },
            reverse: function () {
              for (
                var e, t = nt(this).length, n = Math.floor(t / 2), i = 0;
                i < n;

              )
                (e = this[i]), (this[i++] = this[--t]), (this[t] = e);
              return this;
            },
            some: function (e) {
              return Ee(
                nt(this),
                e,
                arguments.length > 1 ? arguments[1] : void 0
              );
            },
            sort: function (e) {
              return Re.call(nt(this), e);
            },
            subarray: function (e, t) {
              var n = nt(this),
                i = n.length,
                r = A(e, i);
              return new (K(n, n[Ke]))(
                n.buffer,
                n.byteOffset + r * n.BYTES_PER_ELEMENT,
                k((void 0 === t ? i : A(t, i)) - r)
              );
            },
          },
          mt = function (e, t) {
            return rt(this, qe.call(nt(this), e, t));
          },
          yt = function (e) {
            nt(this);
            var t = tt(arguments[1], 1),
              n = this.length,
              i = L(e),
              r = k(i.length),
              s = 0;
            if (r + t > n) throw oe("Wrong length!");
            for (; s < r; ) this[t + s] = i[s++];
          },
          vt = {
            entries: function () {
              return Ne.call(nt(this));
            },
            keys: function () {
              return Me.call(nt(this));
            },
            values: function () {
              return xe.call(nt(this));
            },
          },
          bt = function (e, t) {
            return (
              M(e) &&
              e[Je] &&
              "symbol" != typeof t &&
              t in e &&
              String(+t) == String(t)
            );
          },
          wt = function (e, t) {
            return bt(e, (t = C(t, !0))) ? f(2, e[t]) : se(e, t);
          },
          Et = function (e, t, n) {
            return !(bt(e, (t = C(t, !0))) && M(n) && P(n, "value")) ||
              P(n, "get") ||
              P(n, "set") ||
              n.configurable ||
              (P(n, "writable") && !n.writable) ||
              (P(n, "enumerable") && !n.enumerable)
              ? re(e, t, n)
              : ((e[t] = n.value), e);
          };
        Qe || ((ie.f = wt), (ne.f = Et)),
          s(s.S + s.F * !Qe, "Object", {
            getOwnPropertyDescriptor: wt,
            defineProperty: Et,
          }),
          i(function () {
            Ve.call({});
          }) &&
            (Ve = De =
              function () {
                return Fe.call(this);
              });
        var kt = b({}, gt);
        b(kt, vt),
          y(kt, He, vt.values),
          b(kt, {
            slice: mt,
            set: yt,
            constructor: function () {},
            toString: Ve,
            toLocaleString: pt,
          }),
          at(kt, "buffer", "b"),
          at(kt, "byteOffset", "o"),
          at(kt, "byteLength", "l"),
          at(kt, "length", "e"),
          re(kt, ze, {
            get: function () {
              return this[Je];
            },
          }),
          (e.exports = function (e, n, r, o) {
            var a = e + ((o = !!o) ? "Clamped" : "") + "Array",
              c = "get" + e,
              u = "set" + e,
              h = t[a],
              f = h || {},
              p = h && R(h),
              g = !h || !l.ABV,
              m = {},
              v = h && h.prototype,
              b = function (e, t) {
                re(e, t, {
                  get: function () {
                    return (function (e, t) {
                      var i = e._d;
                      return i.v[c](t * n + i.o, Ze);
                    })(this, t);
                  },
                  set: function (e) {
                    return (function (e, t, i) {
                      var r = e._d;
                      o &&
                        (i =
                          (i = Math.round(i)) < 0
                            ? 0
                            : i > 255
                            ? 255
                            : 255 & i),
                        r.v[u](t * n + r.o, i, Ze);
                    })(this, t, e);
                  },
                  enumerable: !0,
                });
              };
            g
              ? ((h = r(function (e, t, i, r) {
                  d(e, h, a, "_d");
                  var s,
                    o,
                    l,
                    c,
                    u = 0,
                    f = 0;
                  if (M(t)) {
                    if (
                      !(
                        t instanceof ge ||
                        "ArrayBuffer" == (c = x(t)) ||
                        "SharedArrayBuffer" == c
                      )
                    )
                      return Je in t ? ot(h, t) : ut.call(h, t);
                    (s = t), (f = tt(i, n));
                    var p = t.byteLength;
                    if (void 0 === r) {
                      if (p % n) throw oe("Wrong length!");
                      if ((o = p - f) < 0) throw oe("Wrong length!");
                    } else if ((o = k(r) * n) + f > p)
                      throw oe("Wrong length!");
                    l = o / n;
                  } else (l = T(t)), (s = new ge((o = l * n)));
                  for (
                    y(e, "_d", { b: s, o: f, l: o, e: l, v: new ye(s) });
                    u < l;

                  )
                    b(e, u++);
                })),
                (v = h.prototype = O(kt)),
                y(v, "constructor", h))
              : (i(function () {
                  h(1);
                }) &&
                  i(function () {
                    new h(-1);
                  }) &&
                  X(function (e) {
                    new h(), new h(null), new h(1.5), new h(e);
                  }, !0)) ||
                ((h = r(function (e, t, i, r) {
                  var s;
                  return (
                    d(e, h, a),
                    M(t)
                      ? t instanceof ge ||
                        "ArrayBuffer" == (s = x(t)) ||
                        "SharedArrayBuffer" == s
                        ? void 0 !== r
                          ? new f(t, tt(i, n), r)
                          : void 0 !== i
                          ? new f(t, tt(i, n))
                          : new f(t)
                        : Je in t
                        ? ot(h, t)
                        : ut.call(h, t)
                      : new f(T(t))
                  );
                })),
                be(
                  p !== Function.prototype ? q(f).concat(q(p)) : q(f),
                  function (e) {
                    e in h || y(h, e, f[e]);
                  }
                ),
                (h.prototype = v),
                (v.constructor = h));
            var w = v[He],
              E = !!w && ("values" == w.name || void 0 == w.name),
              S = vt.values;
            y(h, Ge, !0),
              y(v, Je, a),
              y(v, $e, !0),
              y(v, Ke, h),
              (o ? new h(1)[ze] == a : ze in v) ||
                re(v, ze, {
                  get: function () {
                    return a;
                  },
                }),
              (m[a] = h),
              s(s.G + s.W + s.F * (h != f), m),
              s(s.S, a, { BYTES_PER_ELEMENT: n }),
              s(
                s.S +
                  s.F *
                    i(function () {
                      f.of.call(h, 1);
                    }),
                a,
                { from: ut, of: dt }
              ),
              "BYTES_PER_ELEMENT" in v || y(v, "BYTES_PER_ELEMENT", n),
              s(s.P, a, gt),
              Z(a),
              s(s.P + s.F * et, a, { set: yt }),
              s(s.P + s.F * !E, a, vt),
              v.toString != Ve && (v.toString = Ve),
              s(
                s.P +
                  s.F *
                    i(function () {
                      new h(1).slice();
                    }),
                a,
                { slice: mt }
              ),
              s(
                s.P +
                  s.F *
                    (i(function () {
                      return (
                        [1, 2].toLocaleString() !=
                        new h([1, 2]).toLocaleString()
                      );
                    }) ||
                      !i(function () {
                        v.toLocaleString.call([1, 2]);
                      })),
                a,
                { toLocaleString: pt }
              ),
              (Q[a] = E ? w : S),
              E || y(v, He, S);
          });
      } else e.exports = function () {};
    });
  ft("Int8", 1, function (e) {
    return function (t, n, i) {
      return e(this, t, n, i);
    };
  }),
    ft("Uint8", 1, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    }),
    ft(
      "Uint8",
      1,
      function (e) {
        return function (t, n, i) {
          return e(this, t, n, i);
        };
      },
      !0
    ),
    ft("Int16", 2, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    }),
    ft("Uint16", 2, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    }),
    ft("Int32", 4, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    }),
    ft("Uint32", 4, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    }),
    ft("Float32", 4, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    }),
    ft("Float64", 8, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  var pt = function (e, t, n, i) {
      try {
        return i ? t(s(n)[0], n[1]) : t(n);
      } catch (t) {
        var r = e.return;
        throw (void 0 !== r && s(r.call(e)), t);
      }
    },
    gt = t(function (e) {
      var t = {},
        n = {},
        i = (e.exports = function (e, i, r, o, a) {
          var l,
            c,
            u,
            d,
            h = a
              ? function () {
                  return e;
                }
              : We(e),
            f = S(r, o, i ? 2 : 1),
            p = 0;
          if ("function" != typeof h) throw TypeError(e + " is not iterable!");
          if (Le(h)) {
            for (l = D(e.length); l > p; p++)
              if (
                (d = i ? f(s((c = e[p]))[0], c[1]) : f(e[p])) === t ||
                d === n
              )
                return d;
          } else
            for (u = h.call(e); !(c = u.next()).done; )
              if ((d = pt(u, f, c.value, i)) === t || d === n) return d;
        });
      (i.BREAK = t), (i.RETURN = n);
    }),
    mt = t(function (e) {
      var t = E("meta"),
        n = p.f,
        i = 0,
        s =
          Object.isExtensible ||
          function () {
            return !0;
          },
        a = !o(function () {
          return s(Object.preventExtensions({}));
        }),
        l = function (e) {
          n(e, t, { value: { i: "O" + ++i, w: {} } });
        },
        c = (e.exports = {
          KEY: t,
          NEED: !1,
          fastKey: function (e, n) {
            if (!r(e))
              return "symbol" == typeof e
                ? e
                : ("string" == typeof e ? "S" : "P") + e;
            if (!v(e, t)) {
              if (!s(e)) return "F";
              if (!n) return "E";
              l(e);
            }
            return e[t].i;
          },
          getWeak: function (e, n) {
            if (!v(e, t)) {
              if (!s(e)) return !0;
              if (!n) return !1;
              l(e);
            }
            return e[t].w;
          },
          onFreeze: function (e) {
            return a && c.NEED && s(e) && !v(e, t) && l(e), e;
          },
        });
    }),
    yt =
      (mt.KEY,
      mt.NEED,
      mt.fastKey,
      mt.getWeak,
      mt.onFreeze,
      function (e, t) {
        if (!r(e) || e._t !== t)
          throw TypeError("Incompatible receiver, " + t + " required!");
        return e;
      }),
    vt = p.f,
    bt = mt.fastKey,
    wt = a ? "_s" : "size",
    Et = function (e, t) {
      var n,
        i = bt(t);
      if ("F" !== i) return e._i[i];
      for (n = e._f; n; n = n.n) if (n.k == t) return n;
    },
    kt = {
      getConstructor: function (e, t, n, i) {
        var r = e(function (e, s) {
          F(e, r, t, "_i"),
            (e._t = t),
            (e._i = Be(null)),
            (e._f = void 0),
            (e._l = void 0),
            (e[wt] = 0),
            void 0 != s && gt(s, n, e[i], e);
        });
        return (
          j(r.prototype, {
            clear: function () {
              for (var e = yt(this, t), n = e._i, i = e._f; i; i = i.n)
                (i.r = !0), i.p && (i.p = i.p.n = void 0), delete n[i.i];
              (e._f = e._l = void 0), (e[wt] = 0);
            },
            delete: function (e) {
              var n = yt(this, t),
                i = Et(n, e);
              if (i) {
                var r = i.n,
                  s = i.p;
                delete n._i[i.i],
                  (i.r = !0),
                  s && (s.n = r),
                  r && (r.p = s),
                  n._f == i && (n._f = r),
                  n._l == i && (n._l = s),
                  n[wt]--;
              }
              return !!i;
            },
            forEach: function (e) {
              yt(this, t);
              for (
                var n,
                  i = S(e, arguments.length > 1 ? arguments[1] : void 0, 3);
                (n = n ? n.n : this._f);

              )
                for (i(n.v, n.k, this); n && n.r; ) n = n.p;
            },
            has: function (e) {
              return !!Et(yt(this, t), e);
            },
          }),
          a &&
            vt(r.prototype, "size", {
              get: function () {
                return yt(this, t)[wt];
              },
            }),
          r
        );
      },
      def: function (e, t, n) {
        var i,
          r,
          s = Et(e, t);
        return (
          s
            ? (s.v = n)
            : ((e._l = s =
                {
                  i: (r = bt(t, !0)),
                  k: t,
                  v: n,
                  p: (i = e._l),
                  n: void 0,
                  r: !1,
                }),
              e._f || (e._f = s),
              i && (i.n = s),
              e[wt]++,
              "F" !== r && (e._i[r] = s)),
          e
        );
      },
      getEntry: Et,
      setStrong: function (e, t, n) {
        rt(
          e,
          t,
          function (e, n) {
            (this._t = yt(e, t)), (this._k = n), (this._l = void 0);
          },
          function () {
            for (var e = this._k, t = this._l; t && t.r; ) t = t.p;
            return this._t && (this._l = t = t ? t.n : this._t._f)
              ? Xe(0, "keys" == e ? t.k : "values" == e ? t.v : [t.k, t.v])
              : ((this._t = void 0), Xe(1));
          },
          n ? "entries" : "values",
          !n,
          !0
        ),
          ve(t);
      },
    },
    Tt = function (e, t) {
      if ((s(e), !r(t) && null !== t))
        throw TypeError(t + ": can't set as prototype!");
    },
    St = {
      set:
        Object.setPrototypeOf ||
        ("__proto__" in {}
          ? (function (e, t, n) {
              try {
                (n = S(
                  Function.call,
                  ht.f(Object.prototype, "__proto__").set,
                  2
                ))(e, []),
                  (t = !(e instanceof Array));
              } catch (e) {
                t = !0;
              }
              return function (e, i) {
                return Tt(e, i), t ? (e.__proto__ = i) : n(e, i), e;
              };
            })({}, !1)
          : void 0),
      check: Tt,
    },
    At = St.set,
    Ct = function (e, t, i, s, a, l) {
      var c = n[e],
        u = c,
        d = a ? "set" : "add",
        h = u && u.prototype,
        f = {},
        p = function (e) {
          var t = h[e];
          k(
            h,
            e,
            "delete" == e
              ? function (e) {
                  return !(l && !r(e)) && t.call(this, 0 === e ? 0 : e);
                }
              : "has" == e
              ? function (e) {
                  return !(l && !r(e)) && t.call(this, 0 === e ? 0 : e);
                }
              : "get" == e
              ? function (e) {
                  return l && !r(e) ? void 0 : t.call(this, 0 === e ? 0 : e);
                }
              : "add" == e
              ? function (e) {
                  return t.call(this, 0 === e ? 0 : e), this;
                }
              : function (e, n) {
                  return t.call(this, 0 === e ? 0 : e, n), this;
                }
          );
        };
      if (
        "function" == typeof u &&
        (l ||
          (h.forEach &&
            !o(function () {
              new u().entries().next();
            })))
      ) {
        var g = new u(),
          m = g[d](l ? {} : -0, 1) != g,
          y = o(function () {
            g.has(1);
          }),
          v = lt(function (e) {
            new u(e);
          }),
          b =
            !l &&
            o(function () {
              for (var e = new u(), t = 5; t--; ) e[d](t, t);
              return !e.has(-0);
            });
        v ||
          (((u = t(function (t, n) {
            F(t, u, e);
            var i = (function (e, t, n) {
              var i,
                s = t.constructor;
              return (
                s !== n &&
                  "function" == typeof s &&
                  (i = s.prototype) !== n.prototype &&
                  r(i) &&
                  At &&
                  At(e, i),
                e
              );
            })(new c(), t, u);
            return void 0 != n && gt(n, a, i[d], i), i;
          })).prototype = h),
          (h.constructor = u)),
          (y || b) && (p("delete"), p("has"), a && p("get")),
          (b || m) && p(d),
          l && h.clear && delete h.clear;
      } else
        (u = s.getConstructor(t, e, a, d)), j(u.prototype, i), (mt.NEED = !0);
      return (
        fe(u, e),
        (f[e] = u),
        _(_.G + _.W + _.F * (u != c), f),
        l || s.setStrong(u, e, a),
        u
      );
    },
    _t =
      (Ct(
        "Map",
        function (e) {
          return function () {
            return e(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        },
        {
          get: function (e) {
            var t = kt.getEntry(yt(this, "Map"), e);
            return t && t.v;
          },
          set: function (e, t) {
            return kt.def(yt(this, "Map"), 0 === e ? 0 : e, t);
          },
        },
        kt,
        !0
      ),
      Ct(
        "Set",
        function (e) {
          return function () {
            return e(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        },
        {
          add: function (e) {
            return kt.def(yt(this, "Set"), (e = 0 === e ? 0 : e), e);
          },
        },
        kt
      ),
      { f: Object.getOwnPropertySymbols }),
    Pt = Object.assign,
    xt =
      !Pt ||
      o(function () {
        var e = {},
          t = {},
          n = Symbol(),
          i = "abcdefghijklmnopqrst";
        return (
          (e[n] = 7),
          i.split("").forEach(function (e) {
            t[e] = e;
          }),
          7 != Pt({}, e)[n] || Object.keys(Pt({}, t)).join("") != i
        );
      })
        ? function (e, t) {
            for (
              var n = le(e), i = arguments.length, r = 1, s = _t.f, o = ut.f;
              i > r;

            )
              for (
                var a,
                  l = z(arguments[r++]),
                  c = s ? Ne(l).concat(s(l)) : Ne(l),
                  u = c.length,
                  d = 0;
                u > d;

              )
                o.call(l, (a = c[d++])) && (n[a] = l[a]);
            return n;
          }
        : Pt,
    Mt = mt.getWeak,
    Lt = Ye(5),
    Nt = Ye(6),
    Ot = 0,
    It = function (e) {
      return e._l || (e._l = new jt());
    },
    jt = function () {
      this.a = [];
    },
    Ft = function (e, t) {
      return Lt(e.a, function (e) {
        return e[0] === t;
      });
    };
  jt.prototype = {
    get: function (e) {
      var t = Ft(this, e);
      if (t) return t[1];
    },
    has: function (e) {
      return !!Ft(this, e);
    },
    set: function (e, t) {
      var n = Ft(this, e);
      n ? (n[1] = t) : this.a.push([e, t]);
    },
    delete: function (e) {
      var t = Nt(this.a, function (t) {
        return t[0] === e;
      });
      return ~t && this.a.splice(t, 1), !!~t;
    },
  };
  var Rt = {
    getConstructor: function (e, t, n, i) {
      var s = e(function (e, r) {
        F(e, s, t, "_i"),
          (e._t = t),
          (e._i = Ot++),
          (e._l = void 0),
          void 0 != r && gt(r, n, e[i], e);
      });
      return (
        j(s.prototype, {
          delete: function (e) {
            if (!r(e)) return !1;
            var n = Mt(e);
            return !0 === n
              ? It(yt(this, t)).delete(e)
              : n && v(n, this._i) && delete n[this._i];
          },
          has: function (e) {
            if (!r(e)) return !1;
            var n = Mt(e);
            return !0 === n ? It(yt(this, t)).has(e) : n && v(n, this._i);
          },
        }),
        s
      );
    },
    def: function (e, t, n) {
      var i = Mt(s(t), !0);
      return !0 === i ? It(e).set(t, n) : (i[e._i] = n), e;
    },
    ufstore: It,
  };
  t(function (e) {
    var t,
      n = Ye(0),
      i = mt.getWeak,
      s = Object.isExtensible,
      a = Rt.ufstore,
      l = {},
      c = function (e) {
        return function () {
          return e(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      },
      u = {
        get: function (e) {
          if (r(e)) {
            var t = i(e);
            return !0 === t
              ? a(yt(this, "WeakMap")).get(e)
              : t
              ? t[this._i]
              : void 0;
          }
        },
        set: function (e, t) {
          return Rt.def(yt(this, "WeakMap"), e, t);
        },
      },
      d = (e.exports = Ct("WeakMap", c, u, Rt, !0, !0));
    o(function () {
      return 7 != new d().set((Object.freeze || Object)(l), 7).get(l);
    }) &&
      ((t = Rt.getConstructor(c, "WeakMap")),
      xt(t.prototype, u),
      (mt.NEED = !0),
      n(["delete", "has", "get", "set"], function (e) {
        var n = d.prototype,
          i = n[e];
        k(n, e, function (n, o) {
          if (r(n) && !s(n)) {
            this._f || (this._f = new t());
            var a = this._f[e](n, o);
            return "set" == e ? this : a;
          }
          return i.call(this, n, o);
        });
      }));
  });
  Ct(
    "WeakSet",
    function (e) {
      return function () {
        return e(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    },
    {
      add: function (e) {
        return Rt.def(yt(this, "WeakSet"), e, !0);
      },
    },
    Rt,
    !1,
    !0
  );
  var qt = (n.Reflect || {}).apply,
    Bt = Function.apply;
  _(
    _.S +
      _.F *
        !o(function () {
          qt(function () {});
        }),
    "Reflect",
    {
      apply: function (e, t, n) {
        var i = T(e),
          r = s(n);
        return qt ? qt(i, t, r) : Bt.call(i, t, r);
      },
    }
  );
  var Vt = function (e, t, n) {
      var i = void 0 === n;
      switch (t.length) {
        case 0:
          return i ? e() : e.call(n);
        case 1:
          return i ? e(t[0]) : e.call(n, t[0]);
        case 2:
          return i ? e(t[0], t[1]) : e.call(n, t[0], t[1]);
        case 3:
          return i ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);
        case 4:
          return i
            ? e(t[0], t[1], t[2], t[3])
            : e.call(n, t[0], t[1], t[2], t[3]);
      }
      return e.apply(n, t);
    },
    Dt = [].slice,
    Ut = {},
    Ht =
      Function.bind ||
      function (e) {
        var t = T(this),
          n = Dt.call(arguments, 1),
          i = function () {
            var r = n.concat(Dt.call(arguments));
            return this instanceof i
              ? (function (e, t, n) {
                  if (!(t in Ut)) {
                    for (var i = [], r = 0; r < t; r++) i[r] = "a[" + r + "]";
                    Ut[t] = Function(
                      "F,a",
                      "return new F(" + i.join(",") + ")"
                    );
                  }
                  return Ut[t](e, n);
                })(t, r.length, r)
              : Vt(t, r, e);
          };
        return r(t.prototype) && (i.prototype = t.prototype), i;
      },
    Wt = (n.Reflect || {}).construct,
    zt = o(function () {
      function e() {}
      return !(Wt(function () {}, [], e) instanceof e);
    }),
    Gt = !o(function () {
      Wt(function () {});
    });
  _(_.S + _.F * (zt || Gt), "Reflect", {
    construct: function (e, t) {
      T(e), s(t);
      var n = arguments.length < 3 ? e : T(arguments[2]);
      if (Gt && !zt) return Wt(e, t, n);
      if (e == n) {
        switch (t.length) {
          case 0:
            return new e();
          case 1:
            return new e(t[0]);
          case 2:
            return new e(t[0], t[1]);
          case 3:
            return new e(t[0], t[1], t[2]);
          case 4:
            return new e(t[0], t[1], t[2], t[3]);
        }
        var i = [null];
        return i.push.apply(i, t), new (Ht.apply(e, i))();
      }
      var o = n.prototype,
        a = Be(r(o) ? o : Object.prototype),
        l = Function.apply.call(e, a, t);
      return r(l) ? l : a;
    },
  }),
    _(
      _.S +
        _.F *
          o(function () {
            Reflect.defineProperty(p.f({}, 1, { value: 1 }), 1, { value: 2 });
          }),
      "Reflect",
      {
        defineProperty: function (e, t, n) {
          s(e), (t = h(t, !0)), s(n);
          try {
            return p.f(e, t, n), !0;
          } catch (e) {
            return !1;
          }
        },
      }
    );
  var Kt = ht.f;
  _(_.S, "Reflect", {
    deleteProperty: function (e, t) {
      var n = Kt(s(e), t);
      return !(n && !n.configurable) && delete e[t];
    },
  }),
    _(_.S, "Reflect", {
      get: function e(t, n) {
        var i,
          o,
          a = arguments.length < 3 ? t : arguments[2];
        return s(t) === a
          ? t[n]
          : (i = ht.f(t, n))
          ? v(i, "value")
            ? i.value
            : void 0 !== i.get
            ? i.get.call(a)
            : void 0
          : r((o = Ue(t)))
          ? e(o, n, a)
          : void 0;
      },
    }),
    _(_.S, "Reflect", {
      getOwnPropertyDescriptor: function (e, t) {
        return ht.f(s(e), t);
      },
    }),
    _(_.S, "Reflect", {
      getPrototypeOf: function (e) {
        return Ue(s(e));
      },
    }),
    _(_.S, "Reflect", {
      has: function (e, t) {
        return t in e;
      },
    });
  var Yt = Object.isExtensible;
  _(_.S, "Reflect", {
    isExtensible: function (e) {
      return s(e), !Yt || Yt(e);
    },
  });
  var Qt = n.Reflect,
    Jt =
      (Qt && Qt.ownKeys) ||
      function (e) {
        var t = ae.f(s(e)),
          n = _t.f;
        return n ? t.concat(n(e)) : t;
      };
  _(_.S, "Reflect", { ownKeys: Jt });
  var $t = Object.preventExtensions;
  _(_.S, "Reflect", {
    preventExtensions: function (e) {
      s(e);
      try {
        return $t && $t(e), !0;
      } catch (e) {
        return !1;
      }
    },
  }),
    _(_.S, "Reflect", {
      set: function e(t, n, i) {
        var o,
          a,
          l = arguments.length < 4 ? t : arguments[3],
          c = ht.f(s(t), n);
        if (!c) {
          if (r((a = Ue(t)))) return e(a, n, i, l);
          c = g(0);
        }
        return v(c, "value")
          ? !(
              !1 === c.writable ||
              !r(l) ||
              (((o = ht.f(l, n) || g(0)).value = i), p.f(l, n, o), 0)
            )
          : void 0 !== c.set && (c.set.call(l, i), !0);
      },
    }),
    St &&
      _(_.S, "Reflect", {
        setPrototypeOf: function (e, t) {
          St.check(e, t);
          try {
            return St.set(e, t), !0;
          } catch (e) {
            return !1;
          }
        },
      });
  var Xt,
    Zt,
    en,
    tn = n.process,
    nn = n.setImmediate,
    rn = n.clearImmediate,
    sn = n.MessageChannel,
    on = n.Dispatch,
    an = 0,
    ln = {},
    cn = function () {
      var e = +this;
      if (ln.hasOwnProperty(e)) {
        var t = ln[e];
        delete ln[e], t();
      }
    },
    un = function (e) {
      cn.call(e.data);
    };
  (nn && rn) ||
    ((nn = function (e) {
      for (var t = [], n = 1; arguments.length > n; ) t.push(arguments[n++]);
      return (
        (ln[++an] = function () {
          Vt("function" == typeof e ? e : Function(e), t);
        }),
        Xt(an),
        an
      );
    }),
    (rn = function (e) {
      delete ln[e];
    }),
    "process" == W(tn)
      ? (Xt = function (e) {
          tn.nextTick(S(cn, e, 1));
        })
      : on && on.now
      ? (Xt = function (e) {
          on.now(S(cn, e, 1));
        })
      : sn
      ? ((en = (Zt = new sn()).port2),
        (Zt.port1.onmessage = un),
        (Xt = S(en.postMessage, en, 1)))
      : n.addEventListener &&
        "function" == typeof postMessage &&
        !n.importScripts
      ? ((Xt = function (e) {
          n.postMessage(e + "", "*");
        }),
        n.addEventListener("message", un, !1))
      : (Xt =
          "onreadystatechange" in u("script")
            ? function (e) {
                je.appendChild(u("script")).onreadystatechange = function () {
                  je.removeChild(this), cn.call(e);
                };
              }
            : function (e) {
                setTimeout(S(cn, e, 1), 0);
              }));
  var dn = { set: nn, clear: rn },
    hn = dn.set,
    fn = n.MutationObserver || n.WebKitMutationObserver,
    pn = n.process,
    gn = n.Promise,
    mn = "process" == W(pn);
  var yn,
    vn,
    bn,
    wn,
    En = {
      f: function (e) {
        return new (function (e) {
          var t, n;
          (this.promise = new e(function (e, i) {
            if (void 0 !== t || void 0 !== n)
              throw TypeError("Bad Promise constructor");
            (t = e), (n = i);
          })),
            (this.resolve = T(t)),
            (this.reject = T(n));
        })(e);
      },
    },
    kn = function (e) {
      try {
        return { e: !1, v: e() };
      } catch (e) {
        return { e: !0, v: e };
      }
    },
    Tn = dn.set,
    Sn = (function () {
      var e,
        t,
        i,
        r = function () {
          var n, r;
          for (mn && (n = pn.domain) && n.exit(); e; ) {
            (r = e.fn), (e = e.next);
            try {
              r();
            } catch (n) {
              throw (e ? i() : (t = void 0), n);
            }
          }
          (t = void 0), n && n.enter();
        };
      if (mn)
        i = function () {
          pn.nextTick(r);
        };
      else if (!fn || (n.navigator && n.navigator.standalone))
        if (gn && gn.resolve) {
          var s = gn.resolve();
          i = function () {
            s.then(r);
          };
        } else
          i = function () {
            hn.call(n, r);
          };
      else {
        var o = !0,
          a = document.createTextNode("");
        new fn(r).observe(a, { characterData: !0 }),
          (i = function () {
            a.data = o = !o;
          });
      }
      return function (n) {
        var r = { fn: n, next: void 0 };
        t && (t.next = r), e || ((e = r), i()), (t = r);
      };
    })(),
    An = n.TypeError,
    Cn = n.process,
    _n = n.Promise,
    Pn = "process" == _e(Cn),
    xn = function () {},
    Mn = (vn = En.f),
    Ln = !!(function () {
      try {
        var e = _n.resolve(1),
          t = ((e.constructor = {})[ue("species")] = function (e) {
            e(xn, xn);
          });
        return (
          (Pn || "function" == typeof PromiseRejectionEvent) &&
          e.then(xn) instanceof t
        );
      } catch (e) {}
    })(),
    Nn = function (e) {
      var t;
      return !(!r(e) || "function" != typeof (t = e.then)) && t;
    },
    On = function (e, t) {
      if (!e._n) {
        e._n = !0;
        var n = e._c;
        Sn(function () {
          for (
            var i = e._v,
              r = 1 == e._s,
              s = 0,
              o = function (t) {
                var n,
                  s,
                  o = r ? t.ok : t.fail,
                  a = t.resolve,
                  l = t.reject,
                  c = t.domain;
                try {
                  o
                    ? (r || (2 == e._h && Fn(e), (e._h = 1)),
                      !0 === o
                        ? (n = i)
                        : (c && c.enter(), (n = o(i)), c && c.exit()),
                      n === t.promise
                        ? l(An("Promise-chain cycle"))
                        : (s = Nn(n))
                        ? s.call(n, a, l)
                        : a(n))
                    : l(i);
                } catch (e) {
                  l(e);
                }
              };
            n.length > s;

          )
            o(n[s++]);
          (e._c = []), (e._n = !1), t && !e._h && In(e);
        });
      }
    },
    In = function (e) {
      Tn.call(n, function () {
        var t,
          i,
          r,
          s = e._v,
          o = jn(e);
        if (
          (o &&
            ((t = kn(function () {
              Pn
                ? Cn.emit("unhandledRejection", s, e)
                : (i = n.onunhandledrejection)
                ? i({ promise: e, reason: s })
                : (r = n.console) &&
                  r.error &&
                  r.error("Unhandled promise rejection", s);
            })),
            (e._h = Pn || jn(e) ? 2 : 1)),
          (e._a = void 0),
          o && t.e)
        )
          throw t.v;
      });
    },
    jn = function (e) {
      return 1 !== e._h && 0 === (e._a || e._c).length;
    },
    Fn = function (e) {
      Tn.call(n, function () {
        var t;
        Pn
          ? Cn.emit("rejectionHandled", e)
          : (t = n.onrejectionhandled) && t({ promise: e, reason: e._v });
      });
    },
    Rn = function (e) {
      var t = this;
      t._d ||
        ((t._d = !0),
        ((t = t._w || t)._v = e),
        (t._s = 2),
        t._a || (t._a = t._c.slice()),
        On(t, !0));
    },
    qn = function (e) {
      var t,
        n = this;
      if (!n._d) {
        (n._d = !0), (n = n._w || n);
        try {
          if (n === e) throw An("Promise can't be resolved itself");
          (t = Nn(e))
            ? Sn(function () {
                var i = { _w: n, _d: !1 };
                try {
                  t.call(e, S(qn, i, 1), S(Rn, i, 1));
                } catch (e) {
                  Rn.call(i, e);
                }
              })
            : ((n._v = e), (n._s = 1), On(n, !1));
        } catch (e) {
          Rn.call({ _w: n, _d: !1 }, e);
        }
      }
    };
  Ln ||
    ((_n = function (e) {
      F(this, _n, "Promise", "_h"), T(e), yn.call(this);
      try {
        e(S(qn, this, 1), S(Rn, this, 1));
      } catch (e) {
        Rn.call(this, e);
      }
    }),
    ((yn = function (e) {
      (this._c = []),
        (this._a = void 0),
        (this._s = 0),
        (this._d = !1),
        (this._v = void 0),
        (this._h = 0),
        (this._n = !1);
    }).prototype = j(_n.prototype, {
      then: function (e, t) {
        var n = Mn(me(this, _n));
        return (
          (n.ok = "function" != typeof e || e),
          (n.fail = "function" == typeof t && t),
          (n.domain = Pn ? Cn.domain : void 0),
          this._c.push(n),
          this._a && this._a.push(n),
          this._s && On(this, !1),
          n.promise
        );
      },
      catch: function (e) {
        return this.then(void 0, e);
      },
    })),
    (bn = function () {
      var e = new yn();
      (this.promise = e),
        (this.resolve = S(qn, e, 1)),
        (this.reject = S(Rn, e, 1));
    }),
    (En.f = Mn =
      function (e) {
        return e === _n || e === wn ? new bn(e) : vn(e);
      })),
    _(_.G + _.W + _.F * !Ln, { Promise: _n }),
    fe(_n, "Promise"),
    ve("Promise"),
    (wn = i.Promise),
    _(_.S + _.F * !Ln, "Promise", {
      reject: function (e) {
        var t = Mn(this);
        return (0, t.reject)(e), t.promise;
      },
    }),
    _(_.S + _.F * !Ln, "Promise", {
      resolve: function (e) {
        return (function (e, t) {
          if ((s(e), r(t) && t.constructor === e)) return t;
          var n = En.f(e);
          return (0, n.resolve)(t), n.promise;
        })(this, e);
      },
    }),
    _(
      _.S +
        _.F *
          !(
            Ln &&
            lt(function (e) {
              _n.all(e).catch(xn);
            })
          ),
      "Promise",
      {
        all: function (e) {
          var t = this,
            n = Mn(t),
            i = n.resolve,
            r = n.reject,
            s = kn(function () {
              var n = [],
                s = 0,
                o = 1;
              gt(e, !1, function (e) {
                var a = s++,
                  l = !1;
                n.push(void 0),
                  o++,
                  t.resolve(e).then(function (e) {
                    l || ((l = !0), (n[a] = e), --o || i(n));
                  }, r);
              }),
                --o || i(n);
            });
          return s.e && r(s.v), n.promise;
        },
        race: function (e) {
          var t = this,
            n = Mn(t),
            i = n.reject,
            r = kn(function () {
              gt(e, !1, function (e) {
                t.resolve(e).then(n.resolve, i);
              });
            });
          return r.e && i(r.v), n.promise;
        },
      }
    );
  var Bn = { f: ue },
    Vn = p.f,
    Dn = function (e) {
      var t = i.Symbol || (i.Symbol = n.Symbol || {});
      "_" == e.charAt(0) || e in t || Vn(t, e, { value: Bn.f(e) });
    },
    Un = ae.f,
    Hn = {}.toString,
    Wn =
      "object" == typeof window && window && Object.getOwnPropertyNames
        ? Object.getOwnPropertyNames(window)
        : [],
    zn = {
      f: function (e) {
        return Wn && "[object Window]" == Hn.call(e)
          ? (function (e) {
              try {
                return Un(e);
              } catch (e) {
                return Wn.slice();
              }
            })(e)
          : Un(K(e));
      },
    },
    Gn = mt.KEY,
    Kn = ht.f,
    Yn = p.f,
    Qn = zn.f,
    Jn = n.Symbol,
    $n = n.JSON,
    Xn = $n && $n.stringify,
    Zn = ue("_hidden"),
    ei = ue("toPrimitive"),
    ti = {}.propertyIsEnumerable,
    ni = Z("symbol-registry"),
    ii = Z("symbols"),
    ri = Z("op-symbols"),
    si = Object.prototype,
    oi = "function" == typeof Jn,
    ai = n.QObject,
    li = !ai || !ai.prototype || !ai.prototype.findChild,
    ci =
      a &&
      o(function () {
        return (
          7 !=
          Be(
            Yn({}, "a", {
              get: function () {
                return Yn(this, "a", { value: 7 }).a;
              },
            })
          ).a
        );
      })
        ? function (e, t, n) {
            var i = Kn(si, t);
            i && delete si[t], Yn(e, t, n), i && e !== si && Yn(si, t, i);
          }
        : Yn,
    ui = function (e) {
      var t = (ii[e] = Be(Jn.prototype));
      return (t._k = e), t;
    },
    di =
      oi && "symbol" == typeof Jn.iterator
        ? function (e) {
            return "symbol" == typeof e;
          }
        : function (e) {
            return e instanceof Jn;
          },
    hi = function (e, t, n) {
      return (
        e === si && hi(ri, t, n),
        s(e),
        (t = h(t, !0)),
        s(n),
        v(ii, t)
          ? (n.enumerable
              ? (v(e, Zn) && e[Zn][t] && (e[Zn][t] = !1),
                (n = Be(n, { enumerable: g(0, !1) })))
              : (v(e, Zn) || Yn(e, Zn, g(1, {})), (e[Zn][t] = !0)),
            ci(e, t, n))
          : Yn(e, t, n)
      );
    },
    fi = function (e, t) {
      s(e);
      for (
        var n,
          i = (function (e) {
            var t = Ne(e),
              n = _t.f;
            if (n)
              for (var i, r = n(e), s = ut.f, o = 0; r.length > o; )
                s.call(e, (i = r[o++])) && t.push(i);
            return t;
          })((t = K(t))),
          r = 0,
          o = i.length;
        o > r;

      )
        hi(e, (n = i[r++]), t[n]);
      return e;
    },
    pi = function (e) {
      var t = ti.call(this, (e = h(e, !0)));
      return (
        !(this === si && v(ii, e) && !v(ri, e)) &&
        (!(t || !v(this, e) || !v(ii, e) || (v(this, Zn) && this[Zn][e])) || t)
      );
    },
    gi = function (e, t) {
      if (((e = K(e)), (t = h(t, !0)), e !== si || !v(ii, t) || v(ri, t))) {
        var n = Kn(e, t);
        return (
          !n || !v(ii, t) || (v(e, Zn) && e[Zn][t]) || (n.enumerable = !0), n
        );
      }
    },
    mi = function (e) {
      for (var t, n = Qn(K(e)), i = [], r = 0; n.length > r; )
        v(ii, (t = n[r++])) || t == Zn || t == Gn || i.push(t);
      return i;
    },
    yi = function (e) {
      for (
        var t, n = e === si, i = Qn(n ? ri : K(e)), r = [], s = 0;
        i.length > s;

      )
        !v(ii, (t = i[s++])) || (n && !v(si, t)) || r.push(ii[t]);
      return r;
    };
  oi ||
    (k(
      (Jn = function () {
        if (this instanceof Jn) throw TypeError("Symbol is not a constructor!");
        var e = E(arguments.length > 0 ? arguments[0] : void 0),
          t = function (n) {
            this === si && t.call(ri, n),
              v(this, Zn) && v(this[Zn], e) && (this[Zn][e] = !1),
              ci(this, e, g(1, n));
          };
        return a && li && ci(si, e, { configurable: !0, set: t }), ui(e);
      }).prototype,
      "toString",
      function () {
        return this._k;
      }
    ),
    (ht.f = gi),
    (p.f = hi),
    (ae.f = zn.f = mi),
    (ut.f = pi),
    (_t.f = yi),
    a && k(si, "propertyIsEnumerable", pi, !0),
    (Bn.f = function (e) {
      return ui(ue(e));
    })),
    _(_.G + _.W + _.F * !oi, { Symbol: Jn });
  for (
    var vi =
        "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
          ","
        ),
      bi = 0;
    vi.length > bi;

  )
    ue(vi[bi++]);
  for (var wi = Ne(ue.store), Ei = 0; wi.length > Ei; ) Dn(wi[Ei++]);
  _(_.S + _.F * !oi, "Symbol", {
    for: function (e) {
      return v(ni, (e += "")) ? ni[e] : (ni[e] = Jn(e));
    },
    keyFor: function (e) {
      if (!di(e)) throw TypeError(e + " is not a symbol!");
      for (var t in ni) if (ni[t] === e) return t;
    },
    useSetter: function () {
      li = !0;
    },
    useSimple: function () {
      li = !1;
    },
  }),
    _(_.S + _.F * !oi, "Object", {
      create: function (e, t) {
        return void 0 === t ? Be(e) : fi(Be(e), t);
      },
      defineProperty: hi,
      defineProperties: fi,
      getOwnPropertyDescriptor: gi,
      getOwnPropertyNames: mi,
      getOwnPropertySymbols: yi,
    }),
    $n &&
      _(
        _.S +
          _.F *
            (!oi ||
              o(function () {
                var e = Jn();
                return (
                  "[null]" != Xn([e]) ||
                  "{}" != Xn({ a: e }) ||
                  "{}" != Xn(Object(e))
                );
              })),
        "JSON",
        {
          stringify: function (e) {
            for (var t, n, i = [e], s = 1; arguments.length > s; )
              i.push(arguments[s++]);
            if (((n = t = i[1]), (r(t) || void 0 !== e) && !di(e)))
              return (
                ze(t) ||
                  (t = function (e, t) {
                    if (
                      ("function" == typeof n && (t = n.call(this, e, t)),
                      !di(t))
                    )
                      return t;
                  }),
                (i[1] = t),
                Xn.apply($n, i)
              );
          },
        }
      ),
    Jn.prototype[ei] || m(Jn.prototype, ei, Jn.prototype.valueOf),
    fe(Jn, "Symbol"),
    fe(Math, "Math", !0),
    fe(n.JSON, "JSON", !0);
  var ki = function (e, t) {
      var n = (i.Object || {})[e] || Object[e],
        r = {};
      (r[e] = t(n)),
        _(
          _.S +
            _.F *
              o(function () {
                n(1);
              }),
          "Object",
          r
        );
    },
    Ti = mt.onFreeze;
  ki("freeze", function (e) {
    return function (t) {
      return e && r(t) ? e(Ti(t)) : t;
    };
  });
  var Si = mt.onFreeze;
  ki("seal", function (e) {
    return function (t) {
      return e && r(t) ? e(Si(t)) : t;
    };
  });
  var Ai = mt.onFreeze;
  ki("preventExtensions", function (e) {
    return function (t) {
      return e && r(t) ? e(Ai(t)) : t;
    };
  }),
    ki("isFrozen", function (e) {
      return function (t) {
        return !r(t) || (!!e && e(t));
      };
    }),
    ki("isSealed", function (e) {
      return function (t) {
        return !r(t) || (!!e && e(t));
      };
    }),
    ki("isExtensible", function (e) {
      return function (t) {
        return !!r(t) && (!e || e(t));
      };
    });
  var Ci = ht.f;
  ki("getOwnPropertyDescriptor", function () {
    return function (e, t) {
      return Ci(K(e), t);
    };
  }),
    ki("getPrototypeOf", function () {
      return function (e) {
        return Ue(le(e));
      };
    }),
    ki("keys", function () {
      return function (e) {
        return Ne(le(e));
      };
    }),
    ki("getOwnPropertyNames", function () {
      return zn.f;
    }),
    _(_.S + _.F, "Object", { assign: xt });
  var _i =
    Object.is ||
    function (e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    };
  _(_.S, "Object", { is: _i });
  var Pi = p.f,
    xi = Function.prototype,
    Mi = /^\s*function ([^ (]*)/;
  "name" in xi ||
    (a &&
      Pi(xi, "name", {
        configurable: !0,
        get: function () {
          try {
            return ("" + this).match(Mi)[1];
          } catch (e) {
            return "";
          }
        },
      })),
    _(_.S, "String", {
      raw: function (e) {
        for (
          var t = K(e.raw),
            n = D(t.length),
            i = arguments.length,
            r = [],
            s = 0;
          n > s;

        )
          r.push(String(t[s++])), s < i && r.push(String(arguments[s]));
        return r.join("");
      },
    });
  var Li = String.fromCharCode,
    Ni = String.fromCodePoint;
  _(_.S + _.F * (!!Ni && 1 != Ni.length), "String", {
    fromCodePoint: function (e) {
      for (var t, n = [], i = arguments.length, r = 0; i > r; ) {
        if (((t = +arguments[r++]), J(t, 1114111) !== t))
          throw RangeError(t + " is not a valid code point");
        n.push(
          t < 65536
            ? Li(t)
            : Li(55296 + ((t -= 65536) >> 10), (t % 1024) + 56320)
        );
      }
      return n.join("");
    },
  });
  var Oi,
    Ii =
      ((Oi = !1),
      function (e, t) {
        var n,
          i,
          r = String(G(e)),
          s = B(t),
          o = r.length;
        return s < 0 || s >= o
          ? Oi
            ? ""
            : void 0
          : (n = r.charCodeAt(s)) < 55296 ||
            n > 56319 ||
            s + 1 === o ||
            (i = r.charCodeAt(s + 1)) < 56320 ||
            i > 57343
          ? Oi
            ? r.charAt(s)
            : n
          : Oi
          ? r.slice(s, s + 2)
          : i - 56320 + ((n - 55296) << 10) + 65536;
      });
  _(_.P, "String", {
    codePointAt: function (e) {
      return Ii(this, e);
    },
  });
  var ji = function (e) {
    var t = String(G(this)),
      n = "",
      i = B(e);
    if (i < 0 || i == 1 / 0) throw RangeError("Count can't be negative");
    for (; i > 0; (i >>>= 1) && (t += t)) 1 & i && (n += t);
    return n;
  };
  _(_.P, "String", { repeat: ji });
  var Fi = ue("match"),
    Ri = function (e) {
      var t;
      return r(e) && (void 0 !== (t = e[Fi]) ? !!t : "RegExp" == W(e));
    },
    qi = function (e, t, n) {
      if (Ri(t)) throw TypeError("String#" + n + " doesn't accept regex!");
      return String(G(e));
    },
    Bi = ue("match"),
    Vi = function (e) {
      var t = /./;
      try {
        "/./"[e](t);
      } catch (n) {
        try {
          return (t[Bi] = !1), !"/./"[e](t);
        } catch (e) {}
      }
      return !0;
    },
    Di = "".startsWith;
  _(_.P + _.F * Vi("startsWith"), "String", {
    startsWith: function (e) {
      var t = qi(this, e, "startsWith"),
        n = D(Math.min(arguments.length > 1 ? arguments[1] : void 0, t.length)),
        i = String(e);
      return Di ? Di.call(t, i, n) : t.slice(n, n + i.length) === i;
    },
  });
  var Ui = "".endsWith;
  _(_.P + _.F * Vi("endsWith"), "String", {
    endsWith: function (e) {
      var t = qi(this, e, "endsWith"),
        n = arguments.length > 1 ? arguments[1] : void 0,
        i = D(t.length),
        r = void 0 === n ? i : Math.min(D(n), i),
        s = String(e);
      return Ui ? Ui.call(t, s, r) : t.slice(r - s.length, r) === s;
    },
  });
  _(_.P + _.F * Vi("includes"), "String", {
    includes: function (e) {
      return !!~qi(this, e, "includes").indexOf(
        e,
        arguments.length > 1 ? arguments[1] : void 0
      );
    },
  });
  a &&
    "g" != /./g.flags &&
    p.f(RegExp.prototype, "flags", {
      configurable: !0,
      get: function () {
        var e = s(this),
          t = "";
        return (
          e.global && (t += "g"),
          e.ignoreCase && (t += "i"),
          e.multiline && (t += "m"),
          e.unicode && (t += "u"),
          e.sticky && (t += "y"),
          t
        );
      },
    });
  var Hi = function (e, t, n) {
    var i = ue(e),
      r = n(G, i, ""[e]),
      s = r[0],
      a = r[1];
    o(function () {
      var t = {};
      return (
        (t[i] = function () {
          return 7;
        }),
        7 != ""[e](t)
      );
    }) &&
      (k(String.prototype, e, s),
      m(
        RegExp.prototype,
        i,
        2 == t
          ? function (e, t) {
              return a.call(e, this, t);
            }
          : function (e) {
              return a.call(e, this);
            }
      ));
  };
  Hi("match", 1, function (e, t, n) {
    return [
      function (n) {
        var i = e(this),
          r = void 0 == n ? void 0 : n[t];
        return void 0 !== r ? r.call(n, i) : new RegExp(n)[t](String(i));
      },
      n,
    ];
  }),
    Hi("replace", 2, function (e, t, n) {
      return [
        function (i, r) {
          var s = e(this),
            o = void 0 == i ? void 0 : i[t];
          return void 0 !== o ? o.call(i, s, r) : n.call(String(s), i, r);
        },
        n,
      ];
    }),
    Hi("split", 2, function (e, t, n) {
      var i = Ri,
        r = n,
        s = [].push;
      if (
        "c" == "abbc".split(/(b)*/)[1] ||
        4 != "test".split(/(?:)/, -1).length ||
        2 != "ab".split(/(?:ab)*/).length ||
        4 != ".".split(/(.?)(.?)/).length ||
        ".".split(/()()/).length > 1 ||
        "".split(/.?/).length
      ) {
        var o = void 0 === /()??/.exec("")[1];
        n = function (e, t) {
          var n = String(this);
          if (void 0 === e && 0 === t) return [];
          if (!i(e)) return r.call(n, e, t);
          var a,
            l,
            c,
            u,
            d,
            h = [],
            f =
              (e.ignoreCase ? "i" : "") +
              (e.multiline ? "m" : "") +
              (e.unicode ? "u" : "") +
              (e.sticky ? "y" : ""),
            p = 0,
            g = void 0 === t ? 4294967295 : t >>> 0,
            m = new RegExp(e.source, f + "g");
          for (
            o || (a = new RegExp("^" + m.source + "$(?!\\s)", f));
            (l = m.exec(n)) &&
            !(
              (c = l.index + l[0].length) > p &&
              (h.push(n.slice(p, l.index)),
              !o &&
                l.length > 1 &&
                l[0].replace(a, function () {
                  for (d = 1; d < arguments.length - 2; d++)
                    void 0 === arguments[d] && (l[d] = void 0);
                }),
              l.length > 1 && l.index < n.length && s.apply(h, l.slice(1)),
              (u = l[0].length),
              (p = c),
              h.length >= g)
            );

          )
            m.lastIndex === l.index && m.lastIndex++;
          return (
            p === n.length
              ? (!u && m.test("")) || h.push("")
              : h.push(n.slice(p)),
            h.length > g ? h.slice(0, g) : h
          );
        };
      } else
        "0".split(void 0, 0).length &&
          (n = function (e, t) {
            return void 0 === e && 0 === t ? [] : r.call(this, e, t);
          });
      return [
        function (i, r) {
          var s = e(this),
            o = void 0 == i ? void 0 : i[t];
          return void 0 !== o ? o.call(i, s, r) : n.call(String(s), i, r);
        },
        n,
      ];
    }),
    Hi("search", 1, function (e, t, n) {
      return [
        function (n) {
          var i = e(this),
            r = void 0 == n ? void 0 : n[t];
          return void 0 !== r ? r.call(n, i) : new RegExp(n)[t](String(i));
        },
        n,
      ];
    });
  var Wi = function (e, t, n) {
    t in e ? p.f(e, t, g(0, n)) : (e[t] = n);
  };
  _(_.S + _.F * !lt(function (e) {}), "Array", {
    from: function (e) {
      var t,
        n,
        i,
        r,
        s = le(e),
        o = "function" == typeof this ? this : Array,
        a = arguments.length,
        l = a > 1 ? arguments[1] : void 0,
        c = void 0 !== l,
        u = 0,
        d = We(s);
      if (
        (c && (l = S(l, a > 2 ? arguments[2] : void 0, 2)),
        void 0 == d || (o == Array && Le(d)))
      )
        for (n = new o((t = D(s.length))); t > u; u++)
          Wi(n, u, c ? l(s[u], u) : s[u]);
      else
        for (r = d.call(s), n = new o(); !(i = r.next()).done; u++)
          Wi(n, u, c ? pt(r, l, [i.value, u], !0) : i.value);
      return (n.length = u), n;
    },
  }),
    _(
      _.S +
        _.F *
          o(function () {
            function e() {}
            return !(Array.of.call(e) instanceof e);
          }),
      "Array",
      {
        of: function () {
          for (
            var e = 0,
              t = arguments.length,
              n = new ("function" == typeof this ? this : Array)(t);
            t > e;

          )
            Wi(n, e, arguments[e++]);
          return (n.length = t), n;
        },
      }
    ),
    _(_.P, "Array", { copyWithin: ct }),
    $e("copyWithin");
  var zi = Ye(5),
    Gi = !0;
  "find" in [] &&
    Array(1).find(function () {
      Gi = !1;
    }),
    _(_.P + _.F * Gi, "Array", {
      find: function (e) {
        return zi(this, e, arguments.length > 1 ? arguments[1] : void 0);
      },
    }),
    $e("find");
  var Ki = Ye(6),
    Yi = !0;
  "findIndex" in [] &&
    Array(1).findIndex(function () {
      Yi = !1;
    }),
    _(_.P + _.F * Yi, "Array", {
      findIndex: function (e) {
        return Ki(this, e, arguments.length > 1 ? arguments[1] : void 0);
      },
    }),
    $e("findIndex"),
    _(_.P, "Array", { fill: ce }),
    $e("fill");
  var Qi = n.isFinite;
  _(_.S, "Number", {
    isFinite: function (e) {
      return "number" == typeof e && Qi(e);
    },
  });
  var Ji = Math.floor,
    $i = function (e) {
      return !r(e) && isFinite(e) && Ji(e) === e;
    };
  _(_.S, "Number", { isInteger: $i });
  var Xi = Math.abs;
  _(_.S, "Number", {
    isSafeInteger: function (e) {
      return $i(e) && Xi(e) <= 9007199254740991;
    },
  }),
    _(_.S, "Number", {
      isNaN: function (e) {
        return e != e;
      },
    }),
    _(_.S, "Number", { EPSILON: Math.pow(2, -52) }),
    _(_.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 }),
    _(_.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 });
  var Zi =
      Math.log1p ||
      function (e) {
        return (e = +e) > -1e-8 && e < 1e-8 ? e - (e * e) / 2 : Math.log(1 + e);
      },
    er = Math.sqrt,
    tr = Math.acosh;
  _(
    _.S +
      _.F *
        !(tr && 710 == Math.floor(tr(Number.MAX_VALUE)) && tr(1 / 0) == 1 / 0),
    "Math",
    {
      acosh: function (e) {
        return (e = +e) < 1
          ? NaN
          : e > 94906265.62425156
          ? Math.log(e) + Math.LN2
          : Zi(e - 1 + er(e - 1) * er(e + 1));
      },
    }
  );
  var nr = Math.asinh;
  _(_.S + _.F * !(nr && 1 / nr(0) > 0), "Math", {
    asinh: function e(t) {
      return isFinite((t = +t)) && 0 != t
        ? t < 0
          ? -e(-t)
          : Math.log(t + Math.sqrt(t * t + 1))
        : t;
    },
  });
  var ir = Math.atanh;
  _(_.S + _.F * !(ir && 1 / ir(-0) < 0), "Math", {
    atanh: function (e) {
      return 0 == (e = +e) ? e : Math.log((1 + e) / (1 - e)) / 2;
    },
  });
  var rr =
    Math.sign ||
    function (e) {
      return 0 == (e = +e) || e != e ? e : e < 0 ? -1 : 1;
    };
  _(_.S, "Math", {
    cbrt: function (e) {
      return rr((e = +e)) * Math.pow(Math.abs(e), 1 / 3);
    },
  }),
    _(_.S, "Math", {
      clz32: function (e) {
        return (e >>>= 0)
          ? 31 - Math.floor(Math.log(e + 0.5) * Math.LOG2E)
          : 32;
      },
    });
  var sr = Math.exp;
  _(_.S, "Math", {
    cosh: function (e) {
      return (sr((e = +e)) + sr(-e)) / 2;
    },
  });
  var or = Math.expm1,
    ar =
      !or ||
      or(10) > 22025.465794806718 ||
      or(10) < 22025.465794806718 ||
      -2e-17 != or(-2e-17)
        ? function (e) {
            return 0 == (e = +e)
              ? e
              : e > -1e-6 && e < 1e-6
              ? e + (e * e) / 2
              : Math.exp(e) - 1;
          }
        : or;
  _(_.S + _.F * (ar != Math.expm1), "Math", { expm1: ar });
  var lr = Math.pow,
    cr = lr(2, -52),
    ur = lr(2, -23),
    dr = lr(2, 127) * (2 - ur),
    hr = lr(2, -126),
    fr =
      Math.fround ||
      function (e) {
        var t,
          n,
          i = Math.abs(e),
          r = rr(e);
        return i < hr
          ? r * (i / hr / ur + 1 / cr - 1 / cr) * hr * ur
          : (n = (t = (1 + ur / cr) * i) - (t - i)) > dr || n != n
          ? r * (1 / 0)
          : r * n;
      };
  _(_.S, "Math", { fround: fr });
  var pr = Math.abs;
  _(_.S, "Math", {
    hypot: function (e, t) {
      for (var n, i, r = 0, s = 0, o = arguments.length, a = 0; s < o; )
        a < (n = pr(arguments[s++]))
          ? ((r = r * (i = a / n) * i + 1), (a = n))
          : (r += n > 0 ? (i = n / a) * i : n);
      return a === 1 / 0 ? 1 / 0 : a * Math.sqrt(r);
    },
  });
  var gr = Math.imul;
  _(
    _.S +
      _.F *
        o(function () {
          return -5 != gr(4294967295, 5) || 2 != gr.length;
        }),
    "Math",
    {
      imul: function (e, t) {
        var n = +e,
          i = +t,
          r = 65535 & n,
          s = 65535 & i;
        return (
          0 |
          (r * s +
            ((((65535 & (n >>> 16)) * s + r * (65535 & (i >>> 16))) << 16) >>>
              0))
        );
      },
    }
  ),
    _(_.S, "Math", { log1p: Zi }),
    _(_.S, "Math", {
      log10: function (e) {
        return Math.log(e) * Math.LOG10E;
      },
    }),
    _(_.S, "Math", {
      log2: function (e) {
        return Math.log(e) / Math.LN2;
      },
    }),
    _(_.S, "Math", { sign: rr });
  var mr = Math.exp;
  _(
    _.S +
      _.F *
        o(function () {
          return -2e-17 != !Math.sinh(-2e-17);
        }),
    "Math",
    {
      sinh: function (e) {
        return Math.abs((e = +e)) < 1
          ? (ar(e) - ar(-e)) / 2
          : (mr(e - 1) - mr(-e - 1)) * (Math.E / 2);
      },
    }
  );
  var yr = Math.exp;
  _(_.S, "Math", {
    tanh: function (e) {
      var t = ar((e = +e)),
        n = ar(-e);
      return t == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (t - n) / (yr(e) + yr(-e));
    },
  }),
    _(_.S, "Math", {
      trunc: function (e) {
        return (e > 0 ? Math.floor : Math.ceil)(e);
      },
    });
  var vr = $(!0);
  _(_.P, "Array", {
    includes: function (e) {
      return vr(this, e, arguments.length > 1 ? arguments[1] : void 0);
    },
  }),
    $e("includes");
  var br = ut.f,
    wr = function (e) {
      return function (t) {
        for (var n, i = K(t), r = Ne(i), s = r.length, o = 0, a = []; s > o; )
          br.call(i, (n = r[o++])) && a.push(e ? [n, i[n]] : i[n]);
        return a;
      };
    },
    Er = wr(!1);
  _(_.S, "Object", {
    values: function (e) {
      return Er(e);
    },
  });
  var kr = wr(!0);
  _(_.S, "Object", {
    entries: function (e) {
      return kr(e);
    },
  }),
    _(_.S, "Object", {
      getOwnPropertyDescriptors: function (e) {
        for (
          var t, n, i = K(e), r = ht.f, s = Jt(i), o = {}, a = 0;
          s.length > a;

        )
          void 0 !== (n = r(i, (t = s[a++]))) && Wi(o, t, n);
        return o;
      },
    });
  var Tr = function (e, t, n, i) {
      var r = String(G(e)),
        s = r.length,
        o = void 0 === n ? " " : String(n),
        a = D(t);
      if (a <= s || "" == o) return r;
      var l = a - s,
        c = ji.call(o, Math.ceil(l / o.length));
      return c.length > l && (c = c.slice(0, l)), i ? c + r : r + c;
    },
    Sr = n.navigator,
    Ar = (Sr && Sr.userAgent) || "";
  _(_.P + _.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(Ar), "String", {
    padStart: function (e) {
      return Tr(this, e, arguments.length > 1 ? arguments[1] : void 0, !0);
    },
  }),
    _(_.P + _.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(Ar), "String", {
      padEnd: function (e) {
        return Tr(this, e, arguments.length > 1 ? arguments[1] : void 0, !1);
      },
    });
  var Cr = [].slice,
    _r = /MSIE .\./.test(Ar),
    Pr = function (e) {
      return function (t, n) {
        var i = arguments.length > 2,
          r = !!i && Cr.call(arguments, 2);
        return e(
          i
            ? function () {
                ("function" == typeof t ? t : Function(t)).apply(this, r);
              }
            : t,
          n
        );
      };
    };
  _(_.G + _.B + _.F * _r, {
    setTimeout: Pr(n.setTimeout),
    setInterval: Pr(n.setInterval),
  }),
    _(_.G + _.B, { setImmediate: dn.set, clearImmediate: dn.clear });
  for (
    var xr = ue("iterator"),
      Mr = ue("toStringTag"),
      Lr = Pe.Array,
      Nr = {
        CSSRuleList: !0,
        CSSStyleDeclaration: !1,
        CSSValueList: !1,
        ClientRectList: !1,
        DOMRectList: !1,
        DOMStringList: !1,
        DOMTokenList: !0,
        DataTransferItemList: !1,
        FileList: !1,
        HTMLAllCollection: !1,
        HTMLCollection: !1,
        HTMLFormElement: !1,
        HTMLSelectElement: !1,
        MediaList: !0,
        MimeTypeArray: !1,
        NamedNodeMap: !1,
        NodeList: !0,
        PaintRequestList: !1,
        Plugin: !1,
        PluginArray: !1,
        SVGLengthList: !1,
        SVGNumberList: !1,
        SVGPathSegList: !1,
        SVGPointList: !1,
        SVGStringList: !1,
        SVGTransformList: !1,
        SourceBufferList: !1,
        StyleSheetList: !0,
        TextTrackCueList: !1,
        TextTrackList: !1,
        TouchList: !1,
      },
      Or = Ne(Nr),
      Ir = 0;
    Ir < Or.length;
    Ir++
  ) {
    var jr,
      Fr = Or[Ir],
      Rr = Nr[Fr],
      qr = n[Fr],
      Br = qr && qr.prototype;
    if (
      Br &&
      (Br[xr] || m(Br, xr, Lr), Br[Mr] || m(Br, Mr, Fr), (Pe[Fr] = Lr), Rr)
    )
      for (jr in st) Br[jr] || k(Br, jr, st[jr], !0);
  }
  t(function (t) {
    !(function (e) {
      var n,
        i = Object.prototype,
        r = i.hasOwnProperty,
        s = "function" == typeof Symbol ? Symbol : {},
        o = s.iterator || "@@iterator",
        a = s.asyncIterator || "@@asyncIterator",
        l = s.toStringTag || "@@toStringTag",
        c = e.regeneratorRuntime;
      if (c) t.exports = c;
      else {
        (c = e.regeneratorRuntime = t.exports).wrap = b;
        var u = "suspendedStart",
          d = "suspendedYield",
          h = "executing",
          f = "completed",
          p = {},
          g = {};
        g[o] = function () {
          return this;
        };
        var m = Object.getPrototypeOf,
          y = m && m(m(M([])));
        y && y !== i && r.call(y, o) && (g = y);
        var v = (T.prototype = E.prototype = Object.create(g));
        (k.prototype = v.constructor = T),
          (T.constructor = k),
          (T[l] = k.displayName = "GeneratorFunction"),
          (c.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === k || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (c.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, T)
                : ((e.__proto__ = T), l in e || (e[l] = "GeneratorFunction")),
              (e.prototype = Object.create(v)),
              e
            );
          }),
          (c.awrap = function (e) {
            return { __await: e };
          }),
          S(A.prototype),
          (A.prototype[a] = function () {
            return this;
          }),
          (c.AsyncIterator = A),
          (c.async = function (e, t, n, i) {
            var r = new A(b(e, t, n, i));
            return c.isGeneratorFunction(t)
              ? r
              : r.next().then(function (e) {
                  return e.done ? e.value : r.next();
                });
          }),
          S(v),
          (v[l] = "Generator"),
          (v[o] = function () {
            return this;
          }),
          (v.toString = function () {
            return "[object Generator]";
          }),
          (c.keys = function (e) {
            var t = [];
            for (var n in e) t.push(n);
            return (
              t.reverse(),
              function n() {
                for (; t.length; ) {
                  var i = t.pop();
                  if (i in e) return (n.value = i), (n.done = !1), n;
                }
                return (n.done = !0), n;
              }
            );
          }),
          (c.values = M),
          (x.prototype = {
            constructor: x,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = n),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = n),
                this.tryEntries.forEach(P),
                !e)
              )
                for (var t in this)
                  "t" === t.charAt(0) &&
                    r.call(this, t) &&
                    !isNaN(+t.slice(1)) &&
                    (this[t] = n);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var t = this;
              function i(i, r) {
                return (
                  (a.type = "throw"),
                  (a.arg = e),
                  (t.next = i),
                  r && ((t.method = "next"), (t.arg = n)),
                  !!r
                );
              }
              for (var s = this.tryEntries.length - 1; s >= 0; --s) {
                var o = this.tryEntries[s],
                  a = o.completion;
                if ("root" === o.tryLoc) return i("end");
                if (o.tryLoc <= this.prev) {
                  var l = r.call(o, "catchLoc"),
                    c = r.call(o, "finallyLoc");
                  if (l && c) {
                    if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return i(o.finallyLoc);
                  } else if (l) {
                    if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return i(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (
                  i.tryLoc <= this.prev &&
                  r.call(i, "finallyLoc") &&
                  this.prev < i.finallyLoc
                ) {
                  var s = i;
                  break;
                }
              }
              s &&
                ("break" === e || "continue" === e) &&
                s.tryLoc <= t &&
                t <= s.finallyLoc &&
                (s = null);
              var o = s ? s.completion : {};
              return (
                (o.type = e),
                (o.arg = t),
                s
                  ? ((this.method = "next"), (this.next = s.finallyLoc), p)
                  : this.complete(o)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                  ? ((this.rval = this.arg = e.arg),
                    (this.method = "return"),
                    (this.next = "end"))
                  : "normal" === e.type && t && (this.next = t),
                p
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), P(n), p;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var i = n.completion;
                  if ("throw" === i.type) {
                    var r = i.arg;
                    P(n);
                  }
                  return r;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, t, i) {
              return (
                (this.delegate = { iterator: M(e), resultName: t, nextLoc: i }),
                "next" === this.method && (this.arg = n),
                p
              );
            },
          });
      }
      function b(e, t, n, i) {
        var r = t && t.prototype instanceof E ? t : E,
          s = Object.create(r.prototype),
          o = new x(i || []);
        return (
          (s._invoke = (function (e, t, n) {
            var i = u;
            return function (r, s) {
              if (i === h) throw new Error("Generator is already running");
              if (i === f) {
                if ("throw" === r) throw s;
                return L();
              }
              for (n.method = r, n.arg = s; ; ) {
                var o = n.delegate;
                if (o) {
                  var a = C(o, n);
                  if (a) {
                    if (a === p) continue;
                    return a;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (i === u) throw ((i = f), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                i = h;
                var l = w(e, t, n);
                if ("normal" === l.type) {
                  if (((i = n.done ? f : d), l.arg === p)) continue;
                  return { value: l.arg, done: n.done };
                }
                "throw" === l.type &&
                  ((i = f), (n.method = "throw"), (n.arg = l.arg));
              }
            };
          })(e, n, o)),
          s
        );
      }
      function w(e, t, n) {
        try {
          return { type: "normal", arg: e.call(t, n) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      function E() {}
      function k() {}
      function T() {}
      function S(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }
      function A(t) {
        function n(e, i, s, o) {
          var a = w(t[e], t, i);
          if ("throw" !== a.type) {
            var l = a.arg,
              c = l.value;
            return c && "object" == typeof c && r.call(c, "__await")
              ? Promise.resolve(c.__await).then(
                  function (e) {
                    n("next", e, s, o);
                  },
                  function (e) {
                    n("throw", e, s, o);
                  }
                )
              : Promise.resolve(c).then(function (e) {
                  (l.value = e), s(l);
                }, o);
          }
          o(a.arg);
        }
        var i;
        "object" == typeof e.process &&
          e.process.domain &&
          (n = e.process.domain.bind(n)),
          (this._invoke = function (e, t) {
            function r() {
              return new Promise(function (i, r) {
                n(e, t, i, r);
              });
            }
            return (i = i ? i.then(r, r) : r());
          });
      }
      function C(e, t) {
        var i = e.iterator[t.method];
        if (i === n) {
          if (((t.delegate = null), "throw" === t.method)) {
            if (
              e.iterator.return &&
              ((t.method = "return"),
              (t.arg = n),
              C(e, t),
              "throw" === t.method)
            )
              return p;
            (t.method = "throw"),
              (t.arg = new TypeError(
                "The iterator does not provide a 'throw' method"
              ));
          }
          return p;
        }
        var r = w(i, e.iterator, t.arg);
        if ("throw" === r.type)
          return (t.method = "throw"), (t.arg = r.arg), (t.delegate = null), p;
        var s = r.arg;
        return s
          ? s.done
            ? ((t[e.resultName] = s.value),
              (t.next = e.nextLoc),
              "return" !== t.method && ((t.method = "next"), (t.arg = n)),
              (t.delegate = null),
              p)
            : s
          : ((t.method = "throw"),
            (t.arg = new TypeError("iterator result is not an object")),
            (t.delegate = null),
            p);
      }
      function _(e) {
        var t = { tryLoc: e[0] };
        1 in e && (t.catchLoc = e[1]),
          2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
          this.tryEntries.push(t);
      }
      function P(e) {
        var t = e.completion || {};
        (t.type = "normal"), delete t.arg, (e.completion = t);
      }
      function x(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(_, this),
          this.reset(!0);
      }
      function M(e) {
        if (e) {
          var t = e[o];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var i = -1,
              s = function t() {
                for (; ++i < e.length; )
                  if (r.call(e, i)) return (t.value = e[i]), (t.done = !1), t;
                return (t.value = n), (t.done = !0), t;
              };
            return (s.next = s);
          }
        }
        return { next: L };
      }
      function L() {
        return { value: n, done: !0 };
      }
    })(
      "object" == typeof e
        ? e
        : "object" == typeof window
        ? window
        : "object" == typeof self
        ? self
        : e
    );
  });
  try {
    var Vr = new window.CustomEvent("test");
    if ((Vr.preventDefault(), !0 !== Vr.defaultPrevented))
      throw new Error("Could not prevent default");
  } catch (e) {
    var Dr = function (e, t) {
      var n, i;
      return (
        (t = t || { bubbles: !1, cancelable: !1, detail: void 0 }),
        (n = document.createEvent("CustomEvent")).initCustomEvent(
          e,
          t.bubbles,
          t.cancelable,
          t.detail
        ),
        (i = n.preventDefault),
        (n.preventDefault = function () {
          i.call(this);
          try {
            Object.defineProperty(this, "defaultPrevented", {
              get: function () {
                return !0;
              },
            });
          } catch (e) {
            this.defaultPrevented = !0;
          }
        }),
        n
      );
    };
    (Dr.prototype = window.Event.prototype), (window.CustomEvent = Dr);
  }
  var Ur,
    Hr = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
    Wr = { audio: "audio", video: "video" },
    zr = {
      enabled: !0,
      title: "",
      debug: !1,
      autoplay: !1,
      autopause: !0,
      seekTime: 10,
      volume: 1,
      muted: !1,
      duration: null,
      displayDuration: !0,
      invertTime: !0,
      toggleInvert: !0,
      ratio: "16:9",
      clickToPlay: !0,
      hideControls: !0,
      showPosterOnEnd: !1,
      disableContextMenu: !0,
      loadSprite: !0,
      iconPrefix: "plyr",
      iconUrl: "https://cdn.plyr.io/3.1.0/plyr.svg",
      blankVideo: "https://cdn.plyr.io/static/blank.mp4",
      quality: {
        default: 576,
        options: [
          4320,
          2880,
          2160,
          1440,
          1080,
          720,
          576,
          480,
          360,
          240,
          "default",
        ],
      },
      loop: { active: !1 },
      speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] },
      keyboard: { focused: !0, global: !1 },
      tooltips: { controls: !1, seek: !0 },
      captions: {
        active: !1,
        language: window.navigator.language.split("-")[0],
      },
      fullscreen: { enabled: !0, fallback: !0, iosNative: !1 },
      storage: { enabled: !0, key: "plyr" },
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
      settings: ["captions", "quality", "speed"],
      i18n: {
        restart: "Restart",
        rewind: "Rewind {seektime} secs",
        play: "Play",
        pause: "Pause",
        fastForward: "Forward {seektime} secs",
        seek: "Seek",
        played: "Played",
        buffered: "Buffered",
        currentTime: "Current time",
        duration: "Duration",
        volume: "Volume",
        mute: "Mute",
        unmute: "Unmute",
        enableCaptions: "Enable captions",
        disableCaptions: "Disable captions",
        enterFullscreen: "Enter fullscreen",
        exitFullscreen: "Exit fullscreen",
        frameTitle: "Player for {title}",
        captions: "Captions",
        settings: "Settings",
        speed: "Speed",
        quality: "Quality",
        loop: "Loop",
        start: "Start",
        end: "End",
        all: "All",
        reset: "Reset",
        disabled: "Disabled",
        advertisement: "Ad",
      },
      urls: {
        vimeo: { api: "https://player.vimeo.com/api/player.js" },
        youtube: { api: "https://www.youtube.com/iframe_api" },
        googleIMA: {
          api: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
        },
      },
      listeners: {
        seek: null,
        play: null,
        pause: null,
        restart: null,
        rewind: null,
        fastForward: null,
        mute: null,
        volume: null,
        captions: null,
        fullscreen: null,
        pip: null,
        airplay: null,
        speed: null,
        quality: null,
        loop: null,
        language: null,
      },
      events: [
        "ended",
        "progress",
        "stalled",
        "playing",
        "waiting",
        "canplay",
        "canplaythrough",
        "loadstart",
        "loadeddata",
        "loadedmetadata",
        "timeupdate",
        "volumechange",
        "play",
        "pause",
        "error",
        "seeking",
        "seeked",
        "emptied",
        "ratechange",
        "cuechange",
        "enterfullscreen",
        "exitfullscreen",
        "captionsenabled",
        "captionsdisabled",
        "languagechange",
        "controlshidden",
        "controlsshown",
        "ready",
        "statechange",
        "qualitychange",
        "qualityrequested",
        "adsloaded",
        "adscontentpause",
        "adscontentresume",
        "adstarted",
        "adsmidpoint",
        "adscomplete",
        "adsallcomplete",
        "adsimpression",
        "adsclick",
      ],
      selectors: {
        editable: "input, textarea, select, [contenteditable]",
        container: ".plyr",
        controls: { container: null, wrapper: ".plyr__controls" },
        labels: "[data-plyr]",
        buttons: {
          play: '[data-plyr="play"]',
          pause: '[data-plyr="pause"]',
          restart: '[data-plyr="restart"]',
          rewind: '[data-plyr="rewind"]',
          fastForward: '[data-plyr="fast-forward"]',
          mute: '[data-plyr="mute"]',
          captions: '[data-plyr="captions"]',
          fullscreen: '[data-plyr="fullscreen"]',
          pip: '[data-plyr="pip"]',
          airplay: '[data-plyr="airplay"]',
          settings: '[data-plyr="settings"]',
          loop: '[data-plyr="loop"]',
        },
        inputs: {
          seek: '[data-plyr="seek"]',
          volume: '[data-plyr="volume"]',
          speed: '[data-plyr="speed"]',
          language: '[data-plyr="language"]',
          quality: '[data-plyr="quality"]',
        },
        display: {
          currentTime: ".plyr__time--current",
          duration: ".plyr__time--duration",
          buffer: ".plyr__progress--buffer",
          played: ".plyr__progress--played",
          loop: ".plyr__progress--loop",
          volume: ".plyr__volume--display",
        },
        progress: ".plyr__progress",
        captions: ".plyr__captions",
        menu: { quality: ".js-plyr__menu__list--quality" },
      },
      classNames: {
        video: "plyr__video-wrapper",
        embed: "plyr__video-embed",
        ads: "plyr__ads",
        control: "plyr__control",
        type: "plyr--{0}",
        provider: "plyr--{0}",
        stopped: "plyr--stopped",
        playing: "plyr--playing",
        loading: "plyr--loading",
        error: "plyr--has-error",
        hover: "plyr--hover",
        tooltip: "plyr__tooltip",
        cues: "plyr__cues",
        hidden: "plyr__sr-only",
        hideControls: "plyr--hide-controls",
        isIos: "plyr--is-ios",
        isTouch: "plyr--is-touch",
        uiSupported: "plyr--full-ui",
        noTransition: "plyr--no-transition",
        menu: {
          value: "plyr__menu__value",
          badge: "plyr__badge",
          open: "plyr--menu-open",
        },
        captions: {
          enabled: "plyr--captions-enabled",
          active: "plyr--captions-active",
        },
        fullscreen: {
          enabled: "plyr--fullscreen-enabled",
          fallback: "plyr--fullscreen-fallback",
        },
        pip: { supported: "plyr--pip-supported", active: "plyr--pip-active" },
        airplay: {
          supported: "plyr--airplay-supported",
          active: "plyr--airplay-active",
        },
        tabFocus: "plyr__tab-focus",
      },
      attributes: {
        embed: { provider: "data-plyr-provider", id: "data-plyr-embed-id" },
      },
      keys: { google: null },
      ads: { enabled: !1, publisherId: "" },
    },
    Gr = t(function (e, t) {
      var n;
      (n = function () {
        var e = function () {},
          t = {},
          n = {},
          i = {};
        function r(e, t) {
          if (e) {
            var r = i[e];
            if (((n[e] = t), r)) for (; r.length; ) r[0](e, t), r.splice(0, 1);
          }
        }
        function s(t, n) {
          t.call && (t = { success: t }),
            n.length ? (t.error || e)(n) : (t.success || e)(t);
        }
        function o(t, n, i, r) {
          var s,
            a,
            l = document,
            c = i.async,
            u = (i.numRetries || 0) + 1,
            d = i.before || e,
            h = t.replace(/^(css|img)!/, "");
          (r = r || 0),
            /(^css!|\.css$)/.test(t)
              ? ((s = !0),
                ((a = l.createElement("link")).rel = "stylesheet"),
                (a.href = h))
              : /(^img!|\.(png|gif|jpg|svg)$)/.test(t)
              ? ((a = l.createElement("img")).src = h)
              : (((a = l.createElement("script")).src = t),
                (a.async = void 0 === c || c)),
            (a.onload =
              a.onerror =
              a.onbeforeload =
                function (e) {
                  var l = e.type[0];
                  if (s && "hideFocus" in a)
                    try {
                      a.sheet.cssText.length || (l = "e");
                    } catch (e) {
                      l = "e";
                    }
                  if ("e" == l && (r += 1) < u) return o(t, n, i, r);
                  n(t, l, e.defaultPrevented);
                }),
            !1 !== d(t, a) && l.head.appendChild(a);
        }
        function a(e, n, i) {
          var a, l;
          if ((n && n.trim && (a = n), (l = (a ? i : n) || {}), a)) {
            if (a in t) throw "LoadJS";
            t[a] = !0;
          }
          !(function (e, t, n) {
            var i,
              r,
              s = (e = e.push ? e : [e]).length,
              a = s,
              l = [];
            for (
              i = function (e, n, i) {
                if (("e" == n && l.push(e), "b" == n)) {
                  if (!i) return;
                  l.push(e);
                }
                --s || t(l);
              },
                r = 0;
              r < a;
              r++
            )
              o(e[r], i, n);
          })(
            e,
            function (e) {
              s(l, e), r(a, e);
            },
            l
          );
        }
        return (
          (a.ready = function (e, t) {
            return (
              (function (e, t) {
                var r,
                  s,
                  o,
                  a = [],
                  l = (e = e.push ? e : [e]).length,
                  c = l;
                for (
                  r = function (e, n) {
                    n.length && a.push(e), --c || t(a);
                  };
                  l--;

                )
                  (s = e[l]),
                    (o = n[s]) ? r(s, o) : (i[s] = i[s] || []).push(r);
              })(e, function (e) {
                s(t, e);
              }),
              a
            );
          }),
          (a.done = function (e) {
            r(e, []);
          }),
          (a.reset = function () {
            (t = {}), (n = {}), (i = {});
          }),
          (a.isDefined = function (e) {
            return e in t;
          }),
          a
        );
      }),
        (e.exports = n());
    }),
    Kr = function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    },
    Yr = (function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      return function (t, n, i) {
        return n && e(t.prototype, n), i && e(t, i), t;
      };
    })(),
    Qr = function (e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    },
    Jr = (function () {
      return function (e, t) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e))
          return (function (e, t) {
            var n = [],
              i = !0,
              r = !1,
              s = void 0;
            try {
              for (
                var o, a = e[Symbol.iterator]();
                !(i = (o = a.next()).done) &&
                (n.push(o.value), !t || n.length !== t);
                i = !0
              );
            } catch (e) {
              (r = !0), (s = e);
            } finally {
              try {
                !i && a.return && a.return();
              } finally {
                if (r) throw s;
              }
            }
            return n;
          })(e, t);
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance"
        );
      };
    })(),
    $r = {
      is: {
        plyr: function (e) {
          return this.instanceof(e, window.Plyr);
        },
        object: function (e) {
          return this.getConstructor(e) === Object;
        },
        number: function (e) {
          return this.getConstructor(e) === Number && !Number.isNaN(e);
        },
        string: function (e) {
          return this.getConstructor(e) === String;
        },
        boolean: function (e) {
          return this.getConstructor(e) === Boolean;
        },
        function: function (e) {
          return this.getConstructor(e) === Function;
        },
        array: function (e) {
          return !this.nullOrUndefined(e) && Array.isArray(e);
        },
        weakMap: function (e) {
          return this.instanceof(e, window.WeakMap);
        },
        nodeList: function (e) {
          return this.instanceof(e, window.NodeList);
        },
        element: function (e) {
          return this.instanceof(e, window.Element);
        },
        textNode: function (e) {
          return this.getConstructor(e) === Text;
        },
        event: function (e) {
          return this.instanceof(e, window.Event);
        },
        cue: function (e) {
          return (
            this.instanceof(e, window.TextTrackCue) ||
            this.instanceof(e, window.VTTCue)
          );
        },
        track: function (e) {
          return (
            this.instanceof(e, TextTrack) ||
            (!this.nullOrUndefined(e) && this.string(e.kind))
          );
        },
        url: function (e) {
          return (
            !this.nullOrUndefined(e) &&
            /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/.test(
              e
            )
          );
        },
        nullOrUndefined: function (e) {
          return null === e || void 0 === e;
        },
        empty: function (e) {
          return (
            this.nullOrUndefined(e) ||
            ((this.string(e) || this.array(e) || this.nodeList(e)) &&
              !e.length) ||
            (this.object(e) && !Object.keys(e).length)
          );
        },
        instanceof: function (e, t) {
          return Boolean(e && t && e instanceof t);
        },
        getConstructor: function (e) {
          return this.nullOrUndefined(e) ? null : e.constructor;
        },
      },
      getBrowser: function () {
        return {
          isIE: !!document.documentMode,
          isWebkit:
            "WebkitAppearance" in document.documentElement.style &&
            !/Edge/.test(navigator.userAgent),
          isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
          isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform),
        };
      },
      fetch: function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : "text";
        return new Promise(function (n, i) {
          try {
            var r = new XMLHttpRequest();
            if (!("withCredentials" in r)) return;
            r.addEventListener("load", function () {
              if ("text" === t)
                try {
                  n(JSON.parse(r.responseText));
                } catch (e) {
                  n(r.responseText);
                }
              else n(r.response);
            }),
              r.addEventListener("error", function () {
                throw new Error(r.statusText);
              }),
              r.open("GET", e, !0),
              (r.responseType = t),
              r.send();
          } catch (e) {
            i(e);
          }
        });
      },
      loadScript: function (e) {
        return new Promise(function (t, n) {
          Gr(e, { success: t, error: n });
        });
      },
      loadSprite: function (e, t) {
        if ($r.is.string(e)) {
          var n = $r.is.string(t),
            i = function () {
              return document.querySelectorAll("#" + t).length;
            };
          if (!n || !i()) {
            var r = document.createElement("div");
            if (
              ($r.toggleHidden(r, !0), n && r.setAttribute("id", t), Xr.storage)
            ) {
              var s = window.localStorage.getItem("cache-" + t);
              if (null !== s) {
                var o = JSON.parse(s);
                return void a.call(r, o.content);
              }
            }
            $r.fetch(e)
              .then(function (e) {
                $r.is.empty(e) ||
                  (Xr.storage &&
                    window.localStorage.setItem(
                      "cache-" + t,
                      JSON.stringify({ content: e })
                    ),
                  a.call(r, e));
              })
              .catch(function () {});
          }
        }
        function a(e) {
          (n && i()) ||
            ((this.innerHTML = e),
            document.body.insertBefore(this, document.body.childNodes[0]));
        }
      },
      generateId: function (e) {
        return e + "-" + Math.floor(1e4 * Math.random());
      },
      wrap: function (e, t) {
        var n = e.length ? e : [e];
        Array.from(n)
          .reverse()
          .forEach(function (e, n) {
            var i = n > 0 ? t.cloneNode(!0) : t,
              r = e.parentNode,
              s = e.nextSibling;
            i.appendChild(e), s ? r.insertBefore(i, s) : r.appendChild(i);
          });
      },
      createElement: function (e, t, n) {
        var i = document.createElement(e);
        return (
          $r.is.object(t) && $r.setAttributes(i, t),
          $r.is.string(n) && (i.textContent = n),
          i
        );
      },
      insertAfter: function (e, t) {
        t.parentNode.insertBefore(e, t.nextSibling);
      },
      insertElement: function (e, t, n, i) {
        t.appendChild($r.createElement(e, n, i));
      },
      removeElement: function (e) {
        $r.is.element(e) &&
          $r.is.element(e.parentNode) &&
          ($r.is.nodeList(e) || $r.is.array(e)
            ? Array.from(e).forEach($r.removeElement)
            : e.parentNode.removeChild(e));
      },
      emptyElement: function (e) {
        for (var t = e.childNodes.length; t > 0; )
          e.removeChild(e.lastChild), (t -= 1);
      },
      replaceElement: function (e, t) {
        return $r.is.element(t) &&
          $r.is.element(t.parentNode) &&
          $r.is.element(e)
          ? (t.parentNode.replaceChild(e, t), e)
          : null;
      },
      setAttributes: function (e, t) {
        $r.is.element(e) &&
          !$r.is.empty(t) &&
          Object.entries(t).forEach(function (t) {
            var n = Jr(t, 2),
              i = n[0],
              r = n[1];
            e.setAttribute(i, r);
          });
      },
      getAttributesFromSelector: function (e, t) {
        if (!$r.is.string(e) || $r.is.empty(e)) return {};
        var n = {},
          i = t;
        return (
          e.split(",").forEach(function (e) {
            var t = e.trim(),
              r = t.replace(".", ""),
              s = t.replace(/[[\]]/g, "").split("="),
              o = s[0],
              a = s.length > 1 ? s[1].replace(/["']/g, "") : "";
            switch (t.charAt(0)) {
              case ".":
                $r.is.object(i) &&
                  $r.is.string(i.class) &&
                  (i.class += " " + r),
                  (n.class = r);
                break;
              case "#":
                n.id = t.replace("#", "");
                break;
              case "[":
                n[o] = a;
            }
          }),
          n
        );
      },
      toggleClass: function (e, t, n) {
        if ($r.is.element(e)) {
          var i = e.classList.contains(t);
          return e.classList[n ? "add" : "remove"](t), (n && !i) || (!n && i);
        }
        return null;
      },
      hasClass: function (e, t) {
        return $r.is.element(e) && e.classList.contains(t);
      },
      toggleHidden: function (e, t) {
        $r.is.element(e) &&
          (t ? e.setAttribute("hidden", "") : e.removeAttribute("hidden"));
      },
      matches: function (e, t) {
        var n = { Element: Element };
        var i =
          n.matches ||
          n.webkitMatchesSelector ||
          n.mozMatchesSelector ||
          n.msMatchesSelector ||
          function () {
            return Array.from(document.querySelectorAll(t)).includes(this);
          };
        return i.call(e, t);
      },
      getElements: function (e) {
        return this.elements.container.querySelectorAll(e);
      },
      getElement: function (e) {
        return this.elements.container.querySelector(e);
      },
      findElements: function () {
        try {
          return (
            (this.elements.controls = $r.getElement.call(
              this,
              this.config.selectors.controls.wrapper
            )),
            (this.elements.buttons = {
              play: $r.getElements.call(
                this,
                this.config.selectors.buttons.play
              ),
              pause: $r.getElement.call(
                this,
                this.config.selectors.buttons.pause
              ),
              restart: $r.getElement.call(
                this,
                this.config.selectors.buttons.restart
              ),
              rewind: $r.getElement.call(
                this,
                this.config.selectors.buttons.rewind
              ),
              fastForward: $r.getElement.call(
                this,
                this.config.selectors.buttons.fastForward
              ),
              mute: $r.getElement.call(
                this,
                this.config.selectors.buttons.mute
              ),
              pip: $r.getElement.call(this, this.config.selectors.buttons.pip),
              airplay: $r.getElement.call(
                this,
                this.config.selectors.buttons.airplay
              ),
              settings: $r.getElement.call(
                this,
                this.config.selectors.buttons.settings
              ),
              captions: $r.getElement.call(
                this,
                this.config.selectors.buttons.captions
              ),
              fullscreen: $r.getElement.call(
                this,
                this.config.selectors.buttons.fullscreen
              ),
            }),
            (this.elements.progress = $r.getElement.call(
              this,
              this.config.selectors.progress
            )),
            (this.elements.inputs = {
              seek: $r.getElement.call(this, this.config.selectors.inputs.seek),
              volume: $r.getElement.call(
                this,
                this.config.selectors.inputs.volume
              ),
            }),
            (this.elements.display = {
              buffer: $r.getElement.call(
                this,
                this.config.selectors.display.buffer
              ),
              duration: $r.getElement.call(
                this,
                this.config.selectors.display.duration
              ),
              currentTime: $r.getElement.call(
                this,
                this.config.selectors.display.currentTime
              ),
            }),
            $r.is.element(this.elements.progress) &&
              (this.elements.display.seekTooltip =
                this.elements.progress.querySelector(
                  "." + this.config.classNames.tooltip
                )),
            !0
          );
        } catch (e) {
          return (
            this.debug.warn(
              "It looks like there is a problem with your custom controls HTML",
              e
            ),
            this.toggleNativeControls(!0),
            !1
          );
        }
      },
      getFocusElement: function () {
        var e = document.activeElement;
        return (e =
          e && e !== document.body ? document.querySelector(":focus") : null);
      },
      trapFocus: function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null,
          t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if ($r.is.element(e)) {
          var n = $r.getElements.call(
              this,
              "button:not(:disabled), input:not(:disabled), [tabindex]"
            ),
            i = n[0],
            r = n[n.length - 1],
            s = function (e) {
              if ("Tab" === e.key && 9 === e.keyCode) {
                var t = $r.getFocusElement();
                t !== r || e.shiftKey
                  ? t === i && e.shiftKey && (r.focus(), e.preventDefault())
                  : (i.focus(), e.preventDefault());
              }
            };
          t
            ? $r.on(this.elements.container, "keydown", s, !1)
            : $r.off(this.elements.container, "keydown", s, !1);
        }
      },
      toggleListener: function (e, t, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          r =
            !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
          s = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
        if (!$r.is.empty(e) && !$r.is.empty(t) && $r.is.function(n))
          if ($r.is.nodeList(e) || $r.is.array(e))
            Array.from(e).forEach(function (e) {
              e instanceof Node &&
                $r.toggleListener.call(null, e, t, n, i, r, s);
            });
          else {
            var o = t.split(" "),
              a = s;
            Xr.passiveListeners && (a = { passive: r, capture: s }),
              o.forEach(function (t) {
                e[i ? "addEventListener" : "removeEventListener"](t, n, a);
              });
          }
      },
      on: function (e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments[2],
          i =
            !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        $r.toggleListener(e, t, n, !0, i, r);
      },
      off: function (e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments[2],
          i =
            !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        $r.toggleListener(e, t, n, !1, i, r);
      },
      dispatchEvent: function (e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i =
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        if ($r.is.element(e) && !$r.is.empty(t)) {
          var r = new CustomEvent(t, {
            bubbles: n,
            detail: Object.assign({}, i, {
              plyr: $r.is.plyr(this) ? this : null,
            }),
          });
          e.dispatchEvent(r);
        }
      },
      toggleState: function (e, t) {
        if ($r.is.array(e) || $r.is.nodeList(e))
          Array.from(e).forEach(function (e) {
            return $r.toggleState(e, t);
          });
        else if ($r.is.element(e)) {
          var n = "true" === e.getAttribute("aria-pressed"),
            i = $r.is.boolean(t) ? t : !n;
          e.setAttribute("aria-pressed", i);
        }
      },
      getPercentage: function (e, t) {
        return 0 === e || 0 === t || Number.isNaN(e) || Number.isNaN(t)
          ? 0
          : ((e / t) * 100).toFixed(2);
      },
      getHours: function (e) {
        return parseInt((e / 60 / 60) % 60, 10);
      },
      getMinutes: function (e) {
        return parseInt((e / 60) % 60, 10);
      },
      getSeconds: function (e) {
        return parseInt(e % 60, 10);
      },
      formatTime: function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!$r.is.number(e)) return this.formatTime(null, t, n);
        var i = function (e) {
            return ("0" + e).slice(-2);
          },
          r = this.getHours(e),
          s = this.getMinutes(e),
          o = this.getSeconds(e);
        return (
          t || r > 0 ? (r += ":") : (r = ""),
          (n ? "-" : "") + r + i(s) + ":" + i(o)
        );
      },
      replaceAll: function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
        return e.replace(
          new RegExp(
            t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"),
            "g"
          ),
          n.toString()
        );
      },
      toTitleCase: function () {
        return (
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
        )
          .toString()
          .replace(/\w\S*/g, function (e) {
            return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
          });
      },
      toPascalCase: function () {
        var e = (
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
        ).toString();
        return (
          (e = $r.replaceAll(e, "-", " ")),
          (e = $r.replaceAll(e, "_", " ")),
          (e = $r.toTitleCase(e)),
          $r.replaceAll(e, " ", "")
        );
      },
      toCamelCase: function () {
        var e = (
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
        ).toString();
        return (e = $r.toPascalCase(e)).charAt(0).toLowerCase() + e.slice(1);
      },
      extend: function () {
        for (
          var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {},
            t = arguments.length,
            n = Array(t > 1 ? t - 1 : 0),
            i = 1;
          i < t;
          i++
        )
          n[i - 1] = arguments[i];
        if (!n.length) return e;
        var r = n.shift();
        return $r.is.object(r)
          ? (Object.keys(r).forEach(function (t) {
              $r.is.object(r[t])
                ? (Object.keys(e).includes(t) ||
                    Object.assign(e, Qr({}, t, {})),
                  $r.extend(e[t], r[t]))
                : Object.assign(e, Qr({}, t, r[t]));
            }),
            $r.extend.apply(
              $r,
              [e].concat(
                (function (e) {
                  if (Array.isArray(e)) {
                    for (var t = 0, n = Array(e.length); t < e.length; t++)
                      n[t] = e[t];
                    return n;
                  }
                  return Array.from(e);
                })(n)
              )
            ))
          : e;
      },
      dedupe: function (e) {
        return $r.is.array(e)
          ? e.filter(function (t, n) {
              return e.indexOf(t) === n;
            })
          : e;
      },
      closest: function (e, t) {
        return $r.is.array(e) && e.length
          ? e.reduce(function (e, n) {
              return Math.abs(n - t) < Math.abs(e - t) ? n : e;
            })
          : null;
      },
      getProviderByUrl: function (e) {
        return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/.test(e)
          ? Hr.youtube
          : /^https?:\/\/player.vimeo.com\/video\/\d{8,}(?=\b|\/)/.test(e)
          ? Hr.vimeo
          : null;
      },
      parseYouTubeId: function (e) {
        if ($r.is.empty(e)) return null;
        return e.match(
          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
        )
          ? RegExp.$2
          : e;
      },
      parseVimeoId: function (e) {
        if ($r.is.empty(e)) return null;
        if ($r.is.number(Number(e))) return e;
        return e.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : e;
      },
      parseUrl: function (e) {
        var t = document.createElement("a");
        return (t.href = e), t;
      },
      getUrlParams: function (e) {
        var t = e;
        (e.startsWith("http://") || e.startsWith("https://")) &&
          (t = this.parseUrl(e).search);
        return this.is.empty(t)
          ? null
          : t
              .slice(t.indexOf("?") + 1)
              .split("&")
              .reduce(function (e, t) {
                var n = t.split("="),
                  i = Jr(n, 2),
                  r = i[0],
                  s = i[1];
                return Object.assign(e, Qr({}, r, decodeURIComponent(s)));
              }, {});
      },
      buildUrlParams: function (e) {
        return $r.is.object(e)
          ? Object.keys(e)
              .map(function (t) {
                return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
              })
              .join("&")
          : "";
      },
      stripHTML: function (e) {
        var t = document.createDocumentFragment(),
          n = document.createElement("div");
        return t.appendChild(n), (n.innerHTML = e), t.firstChild.innerText;
      },
      getAspectRatio: function (e, t) {
        var n = (function e(t, n) {
          return 0 === n ? t : e(n, t % n);
        })(e, t);
        return e / n + ":" + t / n;
      },
      get transitionEndEvent() {
        var e = document.createElement("span"),
          t = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend",
          },
          n = Object.keys(t).find(function (t) {
            return void 0 !== e.style[t];
          });
        return !!$r.is.string(n) && t[n];
      },
      repaint: function (e) {
        setTimeout(function () {
          $r.toggleHidden(e, !0), e.offsetHeight, $r.toggleHidden(e, !1);
        }, 0);
      },
    },
    Xr = {
      audio: "canPlayType" in document.createElement("audio"),
      video: "canPlayType" in document.createElement("video"),
      check: function (e, t, n) {
        var i = !1,
          r = !1,
          s = $r.getBrowser(),
          o = s.isIPhone && n && Xr.inline;
        switch (t + ":" + e) {
          case "html5:video":
            r = (i = Xr.video) && Xr.rangeInput && (!s.isIPhone || o);
            break;
          case "html5:audio":
            r = (i = Xr.audio) && Xr.rangeInput;
            break;
          case "youtube:video":
          case "vimeo:video":
            (i = !0), (r = Xr.rangeInput && (!s.isIPhone || o));
            break;
          default:
            r = (i = Xr.audio && Xr.video) && Xr.rangeInput;
        }
        return { api: i, ui: r };
      },
      pip:
        !$r.getBrowser().isIPhone &&
        $r.is.function($r.createElement("video").webkitSetPresentationMode),
      airplay: $r.is.function(window.WebKitPlaybackTargetAvailabilityEvent),
      inline: "playsInline" in document.createElement("video"),
      mime: function (e) {
        var t = this.media;
        try {
          if (!this.isHTML5 || !$r.is.function(t.canPlayType)) return !1;
          if (e.includes("codecs=")) return t.canPlayType(e).replace(/no/, "");
          if (this.isVideo)
            switch (e) {
              case "video/webm":
                return t
                  .canPlayType('video/webm; codecs="vp8, vorbis"')
                  .replace(/no/, "");
              case "video/mp4":
                return t
                  .canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"')
                  .replace(/no/, "");
              case "video/ogg":
                return t
                  .canPlayType('video/ogg; codecs="theora"')
                  .replace(/no/, "");
              default:
                return !1;
            }
          else if (this.isAudio)
            switch (e) {
              case "audio/mpeg":
                return t.canPlayType("audio/mpeg;").replace(/no/, "");
              case "audio/ogg":
                return t
                  .canPlayType('audio/ogg; codecs="vorbis"')
                  .replace(/no/, "");
              case "audio/wav":
                return t.canPlayType('audio/wav; codecs="1"').replace(/no/, "");
              default:
                return !1;
            }
        } catch (e) {
          return !1;
        }
        return !1;
      },
      textTracks: "textTracks" in document.createElement("video"),
      passiveListeners: (function () {
        var e = !1;
        try {
          var t = Object.defineProperty({}, "passive", {
            get: function () {
              return (e = !0), null;
            },
          });
          window.addEventListener("test", null, t);
        } catch (e) {}
        return e;
      })(),
      rangeInput:
        ((Ur = document.createElement("input")),
        (Ur.type = "range"),
        "range" === Ur.type),
      touch: "ontouchstart" in document.documentElement,
      transitions: !1 !== $r.transitionEndEvent,
      reducedMotion:
        "matchMedia" in window &&
        window.matchMedia("(prefers-reduced-motion)").matches,
    },
    Zr = function () {},
    es = (function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        Kr(this, e),
          (this.enabled = window.console && t),
          this.enabled && this.log("Debugging enabled");
      }
      return (
        Yr(e, [
          {
            key: "log",
            get: function () {
              return this.enabled
                ? Function.prototype.bind.call(console.log, console)
                : Zr;
            },
          },
          {
            key: "warn",
            get: function () {
              return this.enabled
                ? Function.prototype.bind.call(console.warn, console)
                : Zr;
            },
          },
          {
            key: "error",
            get: function () {
              return this.enabled
                ? Function.prototype.bind.call(console.error, console)
                : Zr;
            },
          },
        ]),
        e
      );
    })(),
    ts = $r.getBrowser();
  function ns() {
    if (this.enabled) {
      var e = this.player.elements.buttons.fullscreen;
      $r.is.element(e) && $r.toggleState(e, this.active),
        $r.dispatchEvent(
          this.target,
          this.active ? "enterfullscreen" : "exitfullscreen",
          !0
        ),
        ts.isIos || $r.trapFocus.call(this.player, this.target, this.active);
    }
  }
  function is() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    e
      ? (this.scrollPosition = {
          x: window.scrollX || 0,
          y: window.scrollY || 0,
        })
      : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y),
      (document.body.style.overflow = e ? "hidden" : ""),
      $r.toggleClass(
        this.target,
        this.player.config.classNames.fullscreen.fallback,
        e
      ),
      ns.call(this);
  }
  var rs = (function () {
      function e(t) {
        var n = this;
        Kr(this, e),
          (this.player = t),
          (this.prefix = e.prefix),
          (this.name = e.name),
          (this.scrollPosition = { x: 0, y: 0 }),
          $r.on(
            document,
            "ms" === this.prefix
              ? "MSFullscreenChange"
              : this.prefix + "fullscreenchange",
            function () {
              ns.call(n);
            }
          ),
          $r.on(this.player.elements.container, "dblclick", function (e) {
            n.player.elements.controls.contains(e.target) || n.toggle();
          }),
          this.update();
      }
      return (
        Yr(
          e,
          [
            {
              key: "update",
              value: function () {
                this.enabled
                  ? this.player.debug.log(
                      (e.native ? "Native" : "Fallback") + " fullscreen enabled"
                    )
                  : this.player.debug.log(
                      "Fullscreen not supported and fallback disabled"
                    ),
                  $r.toggleClass(
                    this.player.elements.container,
                    this.player.config.classNames.fullscreen.enabled,
                    this.enabled
                  );
              },
            },
            {
              key: "enter",
              value: function () {
                this.enabled &&
                  (ts.isIos && this.player.config.fullscreen.iosNative
                    ? this.player.playing && this.target.webkitEnterFullscreen()
                    : e.native
                    ? this.prefix
                      ? $r.is.empty(this.prefix) ||
                        this.target[this.prefix + "Request" + this.name]()
                      : this.target.requestFullscreen()
                    : is.call(this, !0));
              },
            },
            {
              key: "exit",
              value: function () {
                if (this.enabled)
                  if (ts.isIos && this.player.config.fullscreen.iosNative)
                    this.target.webkitExitFullscreen(), this.player.play();
                  else if (e.native)
                    if (this.prefix) {
                      if (!$r.is.empty(this.prefix)) {
                        var t = "moz" === this.prefix ? "Cancel" : "Exit";
                        document["" + this.prefix + t + this.name]();
                      }
                    } else document.cancelFullScreen();
                  else is.call(this, !1);
              },
            },
            {
              key: "toggle",
              value: function () {
                this.active ? this.exit() : this.enter();
              },
            },
            {
              key: "enabled",
              get: function () {
                return (
                  (e.native || this.player.config.fullscreen.fallback) &&
                  this.player.config.fullscreen.enabled &&
                  this.player.supported.ui &&
                  this.player.isVideo
                );
              },
            },
            {
              key: "active",
              get: function () {
                return (
                  !!this.enabled &&
                  (e.native
                    ? (this.prefix
                        ? document["" + this.prefix + this.name + "Element"]
                        : document.fullscreenElement) === this.target
                    : $r.hasClass(
                        this.target,
                        this.player.config.classNames.fullscreen.fallback
                      ))
                );
              },
            },
            {
              key: "target",
              get: function () {
                return ts.isIos && this.player.config.fullscreen.iosNative
                  ? this.player.media
                  : this.player.elements.container;
              },
            },
          ],
          [
            {
              key: "native",
              get: function () {
                return !!(
                  document.fullscreenEnabled ||
                  document.webkitFullscreenEnabled ||
                  document.mozFullScreenEnabled ||
                  document.msFullscreenEnabled
                );
              },
            },
            {
              key: "prefix",
              get: function () {
                if ($r.is.function(document.exitFullscreen)) return !1;
                var e = "";
                return (
                  ["webkit", "moz", "ms"].some(function (t) {
                    return (
                      !(
                        !$r.is.function(document[t + "ExitFullscreen"]) &&
                        !$r.is.function(document[t + "CancelFullScreen"])
                      ) && ((e = t), !0)
                    );
                  }),
                  e
                );
              },
            },
            {
              key: "name",
              get: function () {
                return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
              },
            },
          ]
        ),
        e
      );
    })(),
    ss = {
      setup: function () {
        if (this.supported.ui) {
          var e = this.storage.get("language");
          if (
            ($r.is.empty(e) || (this.captions.language = e),
            $r.is.empty(this.captions.language) &&
              (this.captions.language =
                this.config.captions.language.toLowerCase()),
            !$r.is.boolean(this.captions.active))
          ) {
            var t = this.storage.get("captions");
            $r.is.boolean(t)
              ? (this.captions.active = t)
              : (this.captions.active = this.config.captions.active);
          }
          if (
            !this.isVideo ||
            this.isYouTube ||
            (this.isHTML5 && !Xr.textTracks)
          )
            $r.is.array(this.config.controls) &&
              this.config.controls.includes("settings") &&
              this.config.settings.includes("captions") &&
              us.setCaptionsMenu.call(this);
          else {
            $r.is.element(this.elements.captions) ||
              ((this.elements.captions = $r.createElement(
                "div",
                $r.getAttributesFromSelector(this.config.selectors.captions)
              )),
              $r.insertAfter(this.elements.captions, this.elements.wrapper)),
              $r.toggleClass(
                this.elements.container,
                this.config.classNames.captions.enabled,
                !$r.is.empty(ss.getTracks.call(this))
              );
            var n = ss.getTracks.call(this);
            if (!$r.is.empty(n)) {
              if ($r.getBrowser().isIE && window.URL) {
                var i = this.media.querySelectorAll("track");
                Array.from(i).forEach(function (e) {
                  var t = e.getAttribute("src"),
                    n = $r.parseUrl(t);
                  n.hostname !== window.location.href.hostname &&
                    ["http:", "https:"].includes(n.protocol) &&
                    $r
                      .fetch(t, "blob")
                      .then(function (t) {
                        e.setAttribute("src", window.URL.createObjectURL(t));
                      })
                      .catch(function () {
                        $r.removeElement(e);
                      });
                });
              }
              ss.setLanguage.call(this),
                ss.show.call(this),
                $r.is.array(this.config.controls) &&
                  this.config.controls.includes("settings") &&
                  this.config.settings.includes("captions") &&
                  us.setCaptionsMenu.call(this);
            }
          }
        }
      },
      setLanguage: function () {
        var e = this;
        if (this.isHTML5 && this.isVideo) {
          ss.getTracks.call(this).forEach(function (t) {
            $r.on(t, "cuechange", function (t) {
              return ss.setCue.call(e, t);
            }),
              (t.mode = "hidden");
          });
          var t = ss.getCurrentTrack.call(this);
          $r.is.track(t) &&
            Array.from(t.activeCues || []).length &&
            ss.setCue.call(this, t);
        } else
          this.isVimeo &&
            this.captions.active &&
            this.embed.enableTextTrack(this.language);
      },
      getTracks: function () {
        return $r.is.nullOrUndefined(this.media)
          ? []
          : Array.from(this.media.textTracks || []).filter(function (e) {
              return ["captions", "subtitles"].includes(e.kind);
            });
      },
      getCurrentTrack: function () {
        var e = this;
        return ss.getTracks.call(this).find(function (t) {
          return t.language.toLowerCase() === e.language;
        });
      },
      setCue: function (e) {
        var t = $r.is.event(e) ? e.target : e,
          n = t.activeCues,
          i = n.length && n[0];
        t === ss.getCurrentTrack.call(this) &&
          ($r.is.cue(i)
            ? ss.setText.call(this, i.getCueAsHTML())
            : ss.setText.call(this, null),
          $r.dispatchEvent.call(this, this.media, "cuechange"));
      },
      setText: function (e) {
        if (this.supported.ui)
          if ($r.is.element(this.elements.captions)) {
            var t = $r.createElement("span");
            $r.emptyElement(this.elements.captions);
            var n = $r.is.nullOrUndefined(e) ? "" : e;
            $r.is.string(n) ? (t.textContent = n.trim()) : t.appendChild(n),
              this.elements.captions.appendChild(t);
          } else this.debug.warn("No captions element to render to");
      },
      show: function () {
        if ($r.is.element(this.elements.buttons.captions)) {
          var e = this.storage.get("captions");
          $r.is.boolean(e)
            ? (this.captions.active = e)
            : (e = this.config.captions.active),
            e &&
              ($r.toggleClass(
                this.elements.container,
                this.config.classNames.captions.active,
                !0
              ),
              $r.toggleState(this.elements.buttons.captions, !0));
        }
      },
    },
    os = function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if ($r.is.empty(e) || $r.is.empty(t) || !Object.keys(t.i18n).includes(e))
        return "";
      var n = t.i18n[e],
        i = { "{seektime}": t.seekTime, "{title}": t.title };
      return (
        Object.entries(i).forEach(function (e) {
          var t = Jr(e, 2),
            i = t[0],
            r = t[1];
          n = $r.replaceAll(n, i, r);
        }),
        n
      );
    },
    as = {
      addStyleHook: function () {
        $r.toggleClass(
          this.elements.container,
          this.config.selectors.container.replace(".", ""),
          !0
        ),
          $r.toggleClass(
            this.elements.container,
            this.config.classNames.uiSupported,
            this.supported.ui
          );
      },
      toggleNativeControls: function () {
        arguments.length > 0 &&
        void 0 !== arguments[0] &&
        arguments[0] &&
        this.isHTML5
          ? this.media.setAttribute("controls", "")
          : this.media.removeAttribute("controls");
      },
      build: function () {
        var e = this;
        if ((this.listeners.media(), !this.supported.ui))
          return (
            this.debug.warn(
              "Basic support only for " + this.provider + " " + this.type
            ),
            void as.toggleNativeControls.call(this, !0)
          );
        $r.is.element(this.elements.controls) ||
          (us.inject.call(this), this.listeners.controls()),
          $r.is.element(this.elements.controls) &&
            (as.toggleNativeControls.call(this),
            ss.setup.call(this),
            (this.volume = null),
            (this.muted = null),
            (this.speed = null),
            (this.loop = null),
            (this.quality = null),
            as.updateVolume.call(this),
            as.timeUpdate.call(this),
            as.checkPlaying.call(this),
            (this.ready = !0),
            setTimeout(function () {
              $r.dispatchEvent.call(e, e.media, "ready");
            }, 0),
            as.setTitle.call(this));
      },
      setTitle: function () {
        var e = os("play", this.config);
        if (
          ($r.is.string(this.config.title) &&
            !$r.is.empty(this.config.title) &&
            ((e += ", " + this.config.title),
            this.elements.container.setAttribute(
              "aria-label",
              this.config.title
            )),
          $r.is.nodeList(this.elements.buttons.play) &&
            Array.from(this.elements.buttons.play).forEach(function (t) {
              t.setAttribute("aria-label", e);
            }),
          this.isEmbed)
        ) {
          var t = $r.getElement.call(this, "iframe");
          if (!$r.is.element(t)) return;
          $r.is.empty(this.config.title) || this.config.title;
          t.setAttribute("title", os("frameTitle", this.config));
        }
      },
      checkPlaying: function () {
        $r.toggleClass(
          this.elements.container,
          this.config.classNames.playing,
          this.playing
        ),
          $r.toggleClass(
            this.elements.container,
            this.config.classNames.stopped,
            this.paused
          ),
          $r.toggleState(this.elements.buttons.play, this.playing),
          this.toggleControls(!this.playing);
      },
      checkLoading: function (e) {
        var t = this;
        (this.loading = ["stalled", "waiting"].includes(e.type)),
          clearTimeout(this.timers.loading),
          (this.timers.loading = setTimeout(
            function () {
              $r.toggleClass(
                t.elements.container,
                t.config.classNames.loading,
                t.loading
              ),
                t.toggleControls(t.loading);
            },
            this.loading ? 250 : 0
          ));
      },
      checkFailed: function () {
        var e = this;
        (this.failed = 3 === this.media.networkState),
          this.failed &&
            ($r.toggleClass(
              this.elements.container,
              this.config.classNames.loading,
              !1
            ),
            $r.toggleClass(
              this.elements.container,
              this.config.classNames.error,
              !0
            )),
          clearTimeout(this.timers.failed),
          (this.timers.loading = setTimeout(
            function () {
              $r.toggleClass(
                e.elements.container,
                e.config.classNames.loading,
                e.loading
              ),
                e.toggleControls(e.loading);
            },
            this.loading ? 250 : 0
          ));
      },
      updateVolume: function () {
        this.supported.ui &&
          ($r.is.element(this.elements.inputs.volume) &&
            as.setRange.call(
              this,
              this.elements.inputs.volume,
              this.muted ? 0 : this.volume
            ),
          $r.is.element(this.elements.buttons.mute) &&
            $r.toggleState(
              this.elements.buttons.mute,
              this.muted || 0 === this.volume
            ));
      },
      setRange: function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        $r.is.element(e) && ((e.value = t), us.updateRangeFill.call(this, e));
      },
      setProgress: function (e, t) {
        var n = $r.is.number(t) ? t : 0,
          i = $r.is.element(e) ? e : this.elements.display.buffer;
        if ($r.is.element(i)) {
          i.value = n;
          var r = i.getElementsByTagName("span")[0];
          $r.is.element(r) && (r.childNodes[0].nodeValue = n);
        }
      },
      updateProgress: function (e) {
        if (this.supported.ui && $r.is.event(e)) {
          var t = 0;
          if (e)
            switch (e.type) {
              case "timeupdate":
              case "seeking":
                (t = $r.getPercentage(this.currentTime, this.duration)),
                  "timeupdate" === e.type &&
                    as.setRange.call(this, this.elements.inputs.seek, t);
                break;
              case "playing":
              case "progress":
                as.setProgress.call(
                  this,
                  this.elements.display.buffer,
                  100 * this.buffered
                );
            }
        }
      },
      updateTimeDisplay: function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null,
          t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if ($r.is.element(e) && $r.is.number(t)) {
          var i = $r.getHours(this.duration) > 0;
          e.textContent = $r.formatTime(t, i, n);
        }
      },
      timeUpdate: function (e) {
        var t =
          !$r.is.element(this.elements.display.duration) &&
          this.config.invertTime;
        as.updateTimeDisplay.call(
          this,
          this.elements.display.currentTime,
          t ? this.duration - this.currentTime : this.currentTime,
          t
        ),
          (e && "timeupdate" === e.type && this.media.seeking) ||
            as.updateProgress.call(this, e);
      },
      durationUpdate: function () {
        if (this.supported.ui) {
          var e = $r.is.element(this.elements.display.duration);
          !e &&
            this.config.displayDuration &&
            this.paused &&
            as.updateTimeDisplay.call(
              this,
              this.elements.display.currentTime,
              this.duration
            ),
            e &&
              as.updateTimeDisplay.call(
                this,
                this.elements.display.duration,
                this.duration
              ),
            us.updateSeekTooltip.call(this);
        }
      },
    },
    ls = {
      getSources: function () {
        return this.isHTML5 ? this.media.querySelectorAll("source") : null;
      },
      getQualityOptions: function () {
        if (!this.isHTML5) return null;
        var e = ls.getSources.call(this);
        if ($r.is.empty(e)) return null;
        var t = Array.from(e).filter(function (e) {
          return !$r.is.empty(e.getAttribute("size"));
        });
        return $r.is.empty(t)
          ? null
          : $r.dedupe(
              t.map(function (e) {
                return Number(e.getAttribute("size"));
              })
            );
      },
      extend: function () {
        if (this.isHTML5) {
          var e = this;
          Object.defineProperty(e.media, "quality", {
            get: function () {
              var t = ls.getSources.call(e);
              if ($r.is.empty(t)) return null;
              var n = Array.from(t).filter(function (t) {
                return t.getAttribute("src") === e.source;
              });
              return $r.is.empty(n) ? null : Number(n[0].getAttribute("size"));
            },
            set: function (t) {
              var n = ls.getSources.call(e);
              if (!$r.is.empty(n)) {
                var i = Array.from(n).filter(function (e) {
                  return Number(e.getAttribute("size")) === t;
                });
                if (!$r.is.empty(i)) {
                  var r = i.filter(function (t) {
                    return Xr.mime.call(e, t.getAttribute("type"));
                  });
                  if (!$r.is.empty(r)) {
                    $r.dispatchEvent.call(e, e.media, "qualityrequested", !1, {
                      quality: t,
                    });
                    var s = e.currentTime,
                      o = e.playing;
                    (e.media.src = r[0].getAttribute("src")),
                      e.media.load(),
                      o && e.play(),
                      (e.currentTime = s),
                      $r.dispatchEvent.call(e, e.media, "qualitychange", !1, {
                        quality: t,
                      });
                  }
                }
              }
            },
          });
        }
      },
      cancelRequests: function () {
        this.isHTML5 &&
          ($r.removeElement(ls.getSources()),
          this.media.setAttribute("src", this.config.blankVideo),
          this.media.load(),
          this.debug.log("Cancelled network requests"));
      },
    },
    cs = $r.getBrowser(),
    us = {
      updateRangeFill: function (e) {
        if (cs.isWebkit) {
          var t = $r.is.event(e) ? e.target : e;
          $r.is.element(t) &&
            "range" === t.getAttribute("type") &&
            t.style.setProperty("--value", (t.value / t.max) * 100 + "%");
        }
      },
      getIconUrl: function () {
        return {
          url: this.config.iconUrl,
          absolute:
            0 === this.config.iconUrl.indexOf("http") ||
            (cs.isIE && !window.svg4everybody),
        };
      },
      createIcon: function (e, t) {
        var n = us.getIconUrl.call(this),
          i = (n.absolute ? "" : n.url) + "#" + this.config.iconPrefix,
          r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        $r.setAttributes(r, $r.extend(t, { role: "presentation" }));
        var s = document.createElementNS("http://www.w3.org/2000/svg", "use"),
          o = i + "-" + e;
        return (
          "href" in s
            ? s.setAttributeNS("http://www.w3.org/1999/xlink", "href", o)
            : s.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", o),
          r.appendChild(s),
          r
        );
      },
      createLabel: function (e, t) {
        var n = os(e, this.config),
          i = Object.assign({}, t);
        switch (e) {
          case "pip":
            n = "PIP";
            break;
          case "airplay":
            n = "AirPlay";
        }
        return (
          "class" in i
            ? (i.class += " " + this.config.classNames.hidden)
            : (i.class = this.config.classNames.hidden),
          $r.createElement("span", i, n)
        );
      },
      createBadge: function (e) {
        if ($r.is.empty(e)) return null;
        var t = $r.createElement("span", {
          class: this.config.classNames.menu.value,
        });
        return (
          t.appendChild(
            $r.createElement(
              "span",
              { class: this.config.classNames.menu.badge },
              e
            )
          ),
          t
        );
      },
      createButton: function (e, t) {
        var n = $r.createElement("button"),
          i = Object.assign({}, t),
          r = $r.toCamelCase(e),
          s = !1,
          o = void 0,
          a = void 0,
          l = void 0,
          c = void 0;
        switch (
          ("type" in i || (i.type = "button"),
          "class" in i
            ? i.class.includes(this.config.classNames.control) &&
              (i.class += " " + this.config.classNames.control)
            : (i.class = this.config.classNames.control),
          e)
        ) {
          case "play":
            (s = !0), (o = "play"), (l = "pause"), (a = "play"), (c = "pause");
            break;
          case "mute":
            (s = !0),
              (o = "mute"),
              (l = "unmute"),
              (a = "volume"),
              (c = "muted");
            break;
          case "captions":
            (s = !0),
              (o = "enableCaptions"),
              (l = "disableCaptions"),
              (a = "captions-off"),
              (c = "captions-on");
            break;
          case "fullscreen":
            (s = !0),
              (o = "enterFullscreen"),
              (l = "exitFullscreen"),
              (a = "enter-fullscreen"),
              (c = "exit-fullscreen");
            break;
          case "play-large":
            (i.class += " " + this.config.classNames.control + "--overlaid"),
              (r = "play"),
              (o = "play"),
              (a = "play");
            break;
          default:
            (o = r), (a = e);
        }
        return (
          s
            ? (n.appendChild(
                us.createIcon.call(this, c, { class: "icon--pressed" })
              ),
              n.appendChild(
                us.createIcon.call(this, a, { class: "icon--not-pressed" })
              ),
              n.appendChild(
                us.createLabel.call(this, l, { class: "label--pressed" })
              ),
              n.appendChild(
                us.createLabel.call(this, o, { class: "label--not-pressed" })
              ),
              (i["aria-pressed"] = !1),
              (i["aria-label"] = os(o, this.config)))
            : (n.appendChild(us.createIcon.call(this, a)),
              n.appendChild(us.createLabel.call(this, o))),
          $r.extend(
            i,
            $r.getAttributesFromSelector(this.config.selectors.buttons[r], i)
          ),
          $r.setAttributes(n, i),
          "play" === r
            ? ($r.is.array(this.elements.buttons[r]) ||
                (this.elements.buttons[r] = []),
              this.elements.buttons[r].push(n))
            : (this.elements.buttons[r] = n),
          n
        );
      },
      createRange: function (e, t) {
        var n = $r.createElement(
            "label",
            { for: t.id, class: this.config.classNames.hidden },
            os(e, this.config)
          ),
          i = $r.createElement(
            "input",
            $r.extend(
              $r.getAttributesFromSelector(this.config.selectors.inputs[e]),
              {
                type: "range",
                min: 0,
                max: 100,
                step: 0.01,
                value: 0,
                autocomplete: "off",
              },
              t
            )
          );
        return (
          (this.elements.inputs[e] = i),
          us.updateRangeFill.call(this, i),
          { label: n, input: i }
        );
      },
      createProgress: function (e, t) {
        var n = $r.createElement(
          "progress",
          $r.extend(
            $r.getAttributesFromSelector(this.config.selectors.display[e]),
            { min: 0, max: 100, value: 0 },
            t
          )
        );
        if ("volume" !== e) {
          n.appendChild($r.createElement("span", null, "0"));
          var i = "";
          switch (e) {
            case "played":
              i = os("played", this.config);
              break;
            case "buffer":
              i = os("buffered", this.config);
          }
          n.textContent = "% " + i.toLowerCase();
        }
        return (this.elements.display[e] = n), n;
      },
      createTime: function (e) {
        var t = $r.createElement("div", { class: "plyr__time" });
        return (
          t.appendChild(
            $r.createElement(
              "span",
              { class: this.config.classNames.hidden },
              os(e, this.config)
            )
          ),
          t.appendChild(
            $r.createElement(
              "span",
              $r.getAttributesFromSelector(this.config.selectors.display[e]),
              "00:00"
            )
          ),
          (this.elements.display[e] = t),
          t
        );
      },
      createMenuItem: function (e, t, n, i) {
        var r =
            arguments.length > 4 && void 0 !== arguments[4]
              ? arguments[4]
              : null,
          s = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
          o = $r.createElement("li"),
          a = $r.createElement("label", {
            class: this.config.classNames.control,
          }),
          l = $r.createElement(
            "input",
            $r.extend(
              $r.getAttributesFromSelector(this.config.selectors.inputs[n]),
              {
                type: "radio",
                name: "plyr-" + n,
                value: e,
                checked: s,
                class: "plyr__sr-only",
              }
            )
          ),
          c = $r.createElement("span", { "aria-hidden": !0 });
        a.appendChild(l),
          a.appendChild(c),
          a.insertAdjacentHTML("beforeend", i),
          $r.is.element(r) && a.appendChild(r),
          o.appendChild(a),
          t.appendChild(o);
      },
      updateSeekTooltip: function (e) {
        var t = this;
        if (
          this.config.tooltips.seek &&
          $r.is.element(this.elements.inputs.seek) &&
          $r.is.element(this.elements.display.seekTooltip) &&
          0 !== this.duration
        ) {
          var n = 0,
            i = this.elements.inputs.seek.getBoundingClientRect(),
            r = this.config.classNames.tooltip + "--visible",
            s = function (e) {
              $r.toggleClass(t.elements.display.seekTooltip, r, e);
            };
          if (this.touch) s(!1);
          else {
            if ($r.is.event(e)) n = (100 / i.width) * (e.pageX - i.left);
            else {
              if (!$r.hasClass(this.elements.display.seekTooltip, r)) return;
              n = parseFloat(this.elements.display.seekTooltip.style.left, 10);
            }
            n < 0 ? (n = 0) : n > 100 && (n = 100),
              as.updateTimeDisplay.call(
                this,
                this.elements.display.seekTooltip,
                (this.duration / 100) * n
              ),
              (this.elements.display.seekTooltip.style.left = n + "%"),
              $r.is.event(e) &&
                ["mouseenter", "mouseleave"].includes(e.type) &&
                s("mouseenter" === e.type);
          }
        }
      },
      toggleTab: function (e, t) {
        var n = this.elements.settings.tabs[e],
          i = this.elements.settings.panes[e];
        $r.toggleHidden(n, !t), $r.toggleHidden(i, !t);
      },
      setQualityMenu: function (e) {
        var t = this;
        if ($r.is.element(this.elements.settings.panes.quality)) {
          var n = this.elements.settings.panes.quality.querySelector("ul");
          $r.is.array(e) &&
            (this.options.quality = e.filter(function (e) {
              return t.config.quality.options.includes(e);
            }));
          var i =
            !$r.is.empty(this.options.quality) &&
            this.options.quality.length > 1;
          if ((us.toggleTab.call(this, "quality", i), i)) {
            $r.emptyElement(n);
            this.options.quality
              .sort(function (e, n) {
                var i = t.config.quality.options;
                return i.indexOf(e) > i.indexOf(n) ? 1 : -1;
              })
              .forEach(function (e) {
                var i = us.getLabel.call(t, "quality", e);
                us.createMenuItem.call(
                  t,
                  e,
                  n,
                  "quality",
                  i,
                  (function (e) {
                    var n = "";
                    switch (e) {
                      case 2160:
                        n = "4K";
                        break;
                      case 1440:
                      case 1080:
                      case 720:
                        n = "HD";
                        break;
                      case 576:
                        n = "SD";
                    }
                    return n.length ? us.createBadge.call(t, n) : null;
                  })(e)
                );
              }),
              us.updateSetting.call(this, "quality", n);
          }
        }
      },
      getLabel: function (e, t) {
        switch (e) {
          case "speed":
            return 1 === t ? "Normal" : t + "&times;";
          case "quality":
            return $r.is.number(t) ? t + "p" : $r.toTitleCase(t);
          case "captions":
            return us.getLanguage.call(this);
          default:
            return null;
        }
      },
      updateSetting: function (e, t, n) {
        var i = this.elements.settings.panes[e],
          r = null,
          s = t;
        switch (e) {
          case "captions":
            r = this.captions.active
              ? this.captions.language
              : os("disabled", this.config);
            break;
          default:
            if (
              ((r = $r.is.empty(n) ? this[e] : n),
              $r.is.empty(r) && (r = this.config[e].default),
              !$r.is.empty(this.options[e]) && !this.options[e].includes(r))
            )
              return void this.debug.warn(
                "Unsupported value of '" + r + "' for " + e
              );
            if (!this.config[e].options.includes(r))
              return void this.debug.warn(
                "Disabled value of '" + r + "' for " + e
              );
        }
        ($r.is.element(s) || (s = i && i.querySelector("ul")),
        $r.is.empty(r)) ||
          (this.elements.settings.tabs[e].querySelector(
            "." + this.config.classNames.menu.value
          ).innerHTML = us.getLabel.call(this, e, r));
        var o = s && s.querySelector('input[value="' + r + '"]');
        $r.is.element(o) && (o.checked = !0);
      },
      getLanguage: function () {
        if (!this.supported.ui) return null;
        if (
          Xr.textTracks &&
          ss.getTracks.call(this).length &&
          this.captions.active
        ) {
          var e = ss.getCurrentTrack.call(this);
          if ($r.is.track(e)) return e.label;
        }
        return os("disabled", this.config);
      },
      setCaptionsMenu: function () {
        var e = this,
          t = this.elements.settings.panes.captions.querySelector("ul"),
          n = ss.getTracks.call(this).length;
        if ((us.toggleTab.call(this, "captions", n), $r.emptyElement(t), n)) {
          var i = ss.getTracks.call(this).map(function (e) {
            return {
              language: e.language,
              label: $r.is.empty(e.label) ? e.language.toUpperCase() : e.label,
            };
          });
          i.unshift({ language: "", label: os("disabled", this.config) }),
            i.forEach(function (n) {
              us.createMenuItem.call(
                e,
                n.language,
                t,
                "language",
                n.label || n.language,
                us.createBadge.call(e, n.language.toUpperCase()),
                n.language.toLowerCase() === e.captions.language.toLowerCase()
              );
            }),
            us.updateSetting.call(this, "captions", t);
        }
      },
      setSpeedMenu: function (e) {
        var t = this;
        if (
          this.config.controls.includes("settings") &&
          this.config.settings.includes("speed") &&
          $r.is.element(this.elements.settings.panes.speed)
        ) {
          $r.is.array(e)
            ? (this.options.speed = e)
            : (this.isHTML5 || this.isVimeo) &&
              (this.options.speed = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]),
            (this.options.speed = this.options.speed.filter(function (e) {
              return t.config.speed.options.includes(e);
            }));
          var n =
            !$r.is.empty(this.options.speed) && this.options.speed.length > 1;
          if (
            (us.toggleTab.call(this, "speed", n), us.checkMenu.call(this), n)
          ) {
            var i = this.elements.settings.panes.speed.querySelector("ul");
            $r.toggleHidden(this.elements.settings.tabs.speed, !1),
              $r.toggleHidden(this.elements.settings.panes.speed, !1),
              $r.emptyElement(i),
              this.options.speed.forEach(function (e) {
                var n = us.getLabel.call(t, "speed", e);
                us.createMenuItem.call(t, e, i, "speed", n);
              }),
              us.updateSetting.call(this, "speed", i);
          }
        }
      },
      checkMenu: function () {
        var e = this.elements.settings.tabs,
          t =
            !$r.is.empty(e) &&
            Object.values(e).some(function (e) {
              return !e.hidden;
            });
        $r.toggleHidden(this.elements.settings.menu, !t);
      },
      toggleMenu: function (e) {
        var t = this.elements.settings.form,
          n = this.elements.buttons.settings;
        if ($r.is.element(t) && $r.is.element(n)) {
          var i = $r.is.boolean(e)
            ? e
            : $r.is.element(t) && "true" === t.getAttribute("aria-hidden");
          if ($r.is.event(e)) {
            var r = $r.is.element(t) && t.contains(e.target),
              s = e.target === this.elements.buttons.settings;
            if (r || (!r && !s && i)) return;
            s && e.stopPropagation();
          }
          $r.is.element(n) && n.setAttribute("aria-expanded", i),
            $r.is.element(t) &&
              (t.setAttribute("aria-hidden", !i),
              $r.toggleClass(
                this.elements.container,
                this.config.classNames.menu.open,
                i
              ),
              i
                ? t.removeAttribute("tabindex")
                : t.setAttribute("tabindex", -1));
        }
      },
      getTabSize: function (e) {
        var t = e.cloneNode(!0);
        (t.style.position = "absolute"),
          (t.style.opacity = 0),
          t.setAttribute("aria-hidden", !1),
          Array.from(t.querySelectorAll("input[name]")).forEach(function (e) {
            var t = e.getAttribute("name");
            e.setAttribute("name", t + "-clone");
          }),
          e.parentNode.appendChild(t);
        var n = t.scrollWidth,
          i = t.scrollHeight;
        return $r.removeElement(t), { width: n, height: i };
      },
      showTab: function (e) {
        var t = this.elements.settings.menu,
          n = e.target,
          i = "false" === n.getAttribute("aria-expanded"),
          r = document.getElementById(n.getAttribute("aria-controls"));
        if ($r.is.element(r) && "tabpanel" === r.getAttribute("role")) {
          var s = t.querySelector('[role="tabpanel"][aria-hidden="false"]'),
            o = s.parentNode;
          if (
            (Array.from(
              t.querySelectorAll(
                '[aria-controls="' + s.getAttribute("id") + '"]'
              )
            ).forEach(function (e) {
              e.setAttribute("aria-expanded", !1);
            }),
            Xr.transitions && !Xr.reducedMotion)
          ) {
            (o.style.width = s.scrollWidth + "px"),
              (o.style.height = s.scrollHeight + "px");
            var a = us.getTabSize.call(this, r);
            $r.on(o, $r.transitionEndEvent, function e(t) {
              t.target === o &&
                ["width", "height"].includes(t.propertyName) &&
                ((o.style.width = ""),
                (o.style.height = ""),
                $r.off(o, $r.transitionEndEvent, e));
            }),
              (o.style.width = a.width + "px"),
              (o.style.height = a.height + "px");
          }
          s.setAttribute("aria-hidden", !0),
            s.setAttribute("tabindex", -1),
            r.setAttribute("aria-hidden", !i),
            n.setAttribute("aria-expanded", i),
            r.removeAttribute("tabindex"),
            r
              .querySelectorAll(
                "button:not(:disabled), input:not(:disabled), [tabindex]"
              )[0]
              .focus();
        }
      },
      create: function (e) {
        var t = this;
        if ($r.is.empty(this.config.controls)) return null;
        var n = $r.createElement(
          "div",
          $r.getAttributesFromSelector(this.config.selectors.controls.wrapper)
        );
        if (
          (this.config.controls.includes("restart") &&
            n.appendChild(us.createButton.call(this, "restart")),
          this.config.controls.includes("rewind") &&
            n.appendChild(us.createButton.call(this, "rewind")),
          this.config.controls.includes("play") &&
            n.appendChild(us.createButton.call(this, "play")),
          this.config.controls.includes("fast-forward") &&
            n.appendChild(us.createButton.call(this, "fast-forward")),
          this.config.controls.includes("progress"))
        ) {
          var i = $r.createElement(
              "div",
              $r.getAttributesFromSelector(this.config.selectors.progress)
            ),
            r = us.createRange.call(this, "seek", { id: "plyr-seek-" + e.id });
          if (
            (i.appendChild(r.label),
            i.appendChild(r.input),
            i.appendChild(us.createProgress.call(this, "buffer")),
            this.config.tooltips.seek)
          ) {
            var s = $r.createElement(
              "span",
              { role: "tooltip", class: this.config.classNames.tooltip },
              "00:00"
            );
            i.appendChild(s), (this.elements.display.seekTooltip = s);
          }
          (this.elements.progress = i), n.appendChild(this.elements.progress);
        }
        if (
          (this.config.controls.includes("current-time") &&
            n.appendChild(us.createTime.call(this, "currentTime")),
          this.config.controls.includes("duration") &&
            n.appendChild(us.createTime.call(this, "duration")),
          this.config.controls.includes("mute") &&
            n.appendChild(us.createButton.call(this, "mute")),
          this.config.controls.includes("volume"))
        ) {
          var o = $r.createElement("div", { class: "plyr__volume" }),
            a = { max: 1, step: 0.05, value: this.config.volume },
            l = us.createRange.call(
              this,
              "volume",
              $r.extend(a, { id: "plyr-volume-" + e.id })
            );
          o.appendChild(l.label),
            o.appendChild(l.input),
            (this.elements.volume = o),
            n.appendChild(o);
        }
        if (
          (this.config.controls.includes("captions") &&
            n.appendChild(us.createButton.call(this, "captions")),
          this.config.controls.includes("settings") &&
            !$r.is.empty(this.config.settings))
        ) {
          var c = $r.createElement("div", { class: "plyr__menu", hidden: "" });
          c.appendChild(
            us.createButton.call(this, "settings", {
              id: "plyr-settings-toggle-" + e.id,
              "aria-haspopup": !0,
              "aria-controls": "plyr-settings-" + e.id,
              "aria-expanded": !1,
            })
          );
          var u = $r.createElement("form", {
              class: "plyr__menu__container",
              id: "plyr-settings-" + e.id,
              "aria-hidden": !0,
              "aria-labelled-by": "plyr-settings-toggle-" + e.id,
              role: "tablist",
              tabindex: -1,
            }),
            d = $r.createElement("div"),
            h = $r.createElement("div", {
              id: "plyr-settings-" + e.id + "-home",
              "aria-hidden": !1,
              "aria-labelled-by": "plyr-settings-toggle-" + e.id,
              role: "tabpanel",
            }),
            f = $r.createElement("ul", { role: "tablist" });
          this.config.settings.forEach(function (n) {
            var i = $r.createElement("li", { role: "tab", hidden: "" }),
              r = $r.createElement(
                "button",
                $r.extend(
                  $r.getAttributesFromSelector(
                    t.config.selectors.buttons.settings
                  ),
                  {
                    type: "button",
                    class:
                      t.config.classNames.control +
                      " " +
                      t.config.classNames.control +
                      "--forward",
                    id: "plyr-settings-" + e.id + "-" + n + "-tab",
                    "aria-haspopup": !0,
                    "aria-controls": "plyr-settings-" + e.id + "-" + n,
                    "aria-expanded": !1,
                  }
                ),
                os(n, t.config)
              ),
              s = $r.createElement("span", {
                class: t.config.classNames.menu.value,
              });
            (s.innerHTML = e[n]),
              r.appendChild(s),
              i.appendChild(r),
              f.appendChild(i),
              (t.elements.settings.tabs[n] = i);
          }),
            h.appendChild(f),
            d.appendChild(h),
            this.config.settings.forEach(function (n) {
              var i = $r.createElement("div", {
                  id: "plyr-settings-" + e.id + "-" + n,
                  "aria-hidden": !0,
                  "aria-labelled-by":
                    "plyr-settings-" + e.id + "-" + n + "-tab",
                  role: "tabpanel",
                  tabindex: -1,
                  hidden: "",
                }),
                r = $r.createElement(
                  "button",
                  {
                    type: "button",
                    class:
                      t.config.classNames.control +
                      " " +
                      t.config.classNames.control +
                      "--back",
                    "aria-haspopup": !0,
                    "aria-controls": "plyr-settings-" + e.id + "-home",
                    "aria-expanded": !1,
                  },
                  os(n, t.config)
                );
              i.appendChild(r);
              var s = $r.createElement("ul");
              i.appendChild(s),
                d.appendChild(i),
                (t.elements.settings.panes[n] = i);
            }),
            u.appendChild(d),
            c.appendChild(u),
            n.appendChild(c),
            (this.elements.settings.form = u),
            (this.elements.settings.menu = c);
        }
        return (
          this.config.controls.includes("pip") &&
            Xr.pip &&
            n.appendChild(us.createButton.call(this, "pip")),
          this.config.controls.includes("airplay") &&
            Xr.airplay &&
            n.appendChild(us.createButton.call(this, "airplay")),
          this.config.controls.includes("fullscreen") &&
            n.appendChild(us.createButton.call(this, "fullscreen")),
          this.config.controls.includes("play-large") &&
            this.elements.container.appendChild(
              us.createButton.call(this, "play-large")
            ),
          (this.elements.controls = n),
          this.isHTML5 &&
            us.setQualityMenu.call(this, ls.getQualityOptions.call(this)),
          us.setSpeedMenu.call(this),
          n
        );
      },
      inject: function () {
        var e = this;
        if (this.config.loadSprite) {
          var t = us.getIconUrl.call(this);
          t.absolute && $r.loadSprite(t.url, "sprite-plyr");
        }
        this.id = Math.floor(1e4 * Math.random());
        var n = null;
        (this.elements.controls = null),
          (n =
            $r.is.string(this.config.controls) ||
            $r.is.element(this.config.controls)
              ? this.config.controls
              : $r.is.function(this.config.controls)
              ? this.config.controls({
                  id: this.id,
                  seektime: this.config.seekTime,
                  title: this.config.title,
                })
              : us.create.call(this, {
                  id: this.id,
                  seektime: this.config.seekTime,
                  speed: this.speed,
                  quality: this.quality,
                  captions: us.getLanguage.call(this),
                }));
        var i = void 0;
        if (
          ($r.is.string(this.config.selectors.controls.container) &&
            (i = document.querySelector(
              this.config.selectors.controls.container
            )),
          $r.is.element(i) || (i = this.elements.container),
          $r.is.element(n)
            ? i.appendChild(n)
            : i.insertAdjacentHTML("beforeend", n),
          $r.is.element(this.elements.controls) || $r.findElements.call(this),
          window.navigator.userAgent.includes("Edge") && $r.repaint(i),
          this.config.tooltips.controls)
        ) {
          var r = $r.getElements.call(
            this,
            [
              this.config.selectors.controls.wrapper,
              " ",
              this.config.selectors.labels,
              " .",
              this.config.classNames.hidden,
            ].join("")
          );
          Array.from(r).forEach(function (t) {
            $r.toggleClass(t, e.config.classNames.hidden, !1),
              $r.toggleClass(t, e.config.classNames.tooltip, !0),
              t.setAttribute("role", "tooltip");
          });
        }
      },
    },
    ds = $r.getBrowser(),
    hs = (function () {
      function e(t) {
        Kr(this, e),
          (this.player = t),
          (this.lastKey = null),
          (this.handleKey = this.handleKey.bind(this)),
          (this.toggleMenu = this.toggleMenu.bind(this)),
          (this.firstTouch = this.firstTouch.bind(this));
      }
      return (
        Yr(e, [
          {
            key: "handleKey",
            value: function (e) {
              var t = this,
                n = e.keyCode ? e.keyCode : e.which,
                i = "keydown" === e.type,
                r = i && n === this.lastKey;
              if (
                !(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) &&
                $r.is.number(n)
              ) {
                if (i) {
                  var s = $r.getFocusElement();
                  if (
                    $r.is.element(s) &&
                    $r.matches(s, this.player.config.selectors.editable)
                  )
                    return;
                  switch (
                    ([
                      48, 49, 50, 51, 52, 53, 54, 56, 57, 32, 75, 38, 40, 77,
                      39, 37, 70, 67, 73, 76, 79,
                    ].includes(n) && (e.preventDefault(), e.stopPropagation()),
                    n)
                  ) {
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                      r ||
                        (t.player.currentTime =
                          (t.player.duration / 10) * (n - 48));
                      break;
                    case 32:
                    case 75:
                      r || this.player.togglePlay();
                      break;
                    case 38:
                      this.player.increaseVolume(0.1);
                      break;
                    case 40:
                      this.player.decreaseVolume(0.1);
                      break;
                    case 77:
                      r || (this.player.muted = !this.player.muted);
                      break;
                    case 39:
                      this.player.forward();
                      break;
                    case 37:
                      this.player.rewind();
                      break;
                    case 70:
                      this.player.fullscreen.toggle();
                      break;
                    case 67:
                      r || this.player.toggleCaptions();
                      break;
                    case 76:
                      this.player.loop = !this.player.loop;
                  }
                  !this.player.fullscreen.enabled &&
                    this.player.fullscreen.active &&
                    27 === n &&
                    this.player.fullscreen.toggle(),
                    (this.lastKey = n);
                } else this.lastKey = null;
              }
            },
          },
          {
            key: "toggleMenu",
            value: function (e) {
              us.toggleMenu.call(this.player, e);
            },
          },
          {
            key: "firstTouch",
            value: function () {
              (this.player.touch = !0),
                $r.toggleClass(
                  this.player.elements.container,
                  this.player.config.classNames.isTouch,
                  !0
                ),
                $r.off(document.body, "touchstart", this.firstTouch);
            },
          },
          {
            key: "global",
            value: function () {
              var e =
                !(arguments.length > 0 && void 0 !== arguments[0]) ||
                arguments[0];
              this.player.config.keyboard.global &&
                $r.toggleListener(
                  window,
                  "keydown keyup",
                  this.handleKey,
                  e,
                  !1
                ),
                $r.toggleListener(document.body, "click", this.toggleMenu, e),
                $r.on(document.body, "touchstart", this.firstTouch);
            },
          },
          {
            key: "container",
            value: function () {
              var e = this;
              !this.player.config.keyboard.global &&
                this.player.config.keyboard.focused &&
                $r.on(
                  this.player.elements.container,
                  "keydown keyup",
                  this.handleKey,
                  !1
                ),
                $r.on(this.player.elements.container, "focusout", function (t) {
                  $r.toggleClass(
                    t.target,
                    e.player.config.classNames.tabFocus,
                    !1
                  );
                }),
                $r.on(this.player.elements.container, "keydown", function (t) {
                  9 === t.keyCode &&
                    setTimeout(function () {
                      $r.toggleClass(
                        $r.getFocusElement(),
                        e.player.config.classNames.tabFocus,
                        !0
                      );
                    }, 0);
                }),
                this.player.config.hideControls &&
                  $r.on(
                    this.player.elements.container,
                    "mouseenter mouseleave mousemove touchstart touchend touchmove enterfullscreen exitfullscreen",
                    function (t) {
                      e.player.toggleControls(t);
                    }
                  );
            },
          },
          {
            key: "media",
            value: function () {
              var e = this;
              if (
                ($r.on(this.player.media, "timeupdate seeking", function (t) {
                  return as.timeUpdate.call(e.player, t);
                }),
                $r.on(
                  this.player.media,
                  "durationchange loadedmetadata",
                  function (t) {
                    return as.durationUpdate.call(e.player, t);
                  }
                ),
                $r.on(this.player.media, "loadeddata", function () {
                  $r.toggleHidden(e.player.elements.volume, !e.player.hasAudio),
                    $r.toggleHidden(
                      e.player.elements.buttons.mute,
                      !e.player.hasAudio
                    );
                }),
                $r.on(this.player.media, "ended", function () {
                  e.player.isHTML5 &&
                    e.player.isVideo &&
                    e.player.config.showPosterOnEnd &&
                    (e.player.restart(), e.player.media.load());
                }),
                $r.on(this.player.media, "progress playing", function (t) {
                  return as.updateProgress.call(e.player, t);
                }),
                $r.on(this.player.media, "volumechange", function (t) {
                  return as.updateVolume.call(e.player, t);
                }),
                $r.on(
                  this.player.media,
                  "playing play pause ended emptied",
                  function (t) {
                    return as.checkPlaying.call(e.player, t);
                  }
                ),
                $r.on(
                  this.player.media,
                  "waiting canplay seeked playing",
                  function (t) {
                    return as.checkLoading.call(e.player, t);
                  }
                ),
                $r.on(this.player.media, "playing", function () {
                  e.player.ads.enabled &&
                    !e.player.ads.initialized &&
                    e.player.ads.managerPromise
                      .then(function () {
                        return e.player.ads.play();
                      })
                      .catch(function () {
                        return e.player.play();
                      });
                }),
                this.player.supported.ui &&
                  this.player.config.clickToPlay &&
                  !this.player.isAudio)
              ) {
                var t = $r.getElement.call(
                  this.player,
                  "." + this.player.config.classNames.video
                );
                if (!$r.is.element(t)) return;
                $r.on(t, "click", function () {
                  (e.player.config.hideControls &&
                    e.player.touch &&
                    !e.player.paused) ||
                    (e.player.paused
                      ? e.player.play()
                      : e.player.ended
                      ? (e.player.restart(), e.player.play())
                      : e.player.pause());
                });
              }
              this.player.supported.ui &&
                this.player.config.disableContextMenu &&
                $r.on(
                  this.player.media,
                  "contextmenu",
                  function (e) {
                    e.preventDefault();
                  },
                  !1
                ),
                $r.on(this.player.media, "volumechange", function () {
                  e.player.storage.set({
                    volume: e.player.volume,
                    muted: e.player.muted,
                  });
                }),
                $r.on(this.player.media, "ratechange", function () {
                  us.updateSetting.call(e.player, "speed"),
                    e.player.storage.set({ speed: e.player.speed });
                }),
                $r.on(this.player.media, "qualityrequested", function (t) {
                  e.player.storage.set({ quality: t.detail.quality });
                }),
                $r.on(this.player.media, "qualitychange", function (t) {
                  us.updateSetting.call(
                    e.player,
                    "quality",
                    null,
                    t.detail.quality
                  );
                }),
                $r.on(this.player.media, "languagechange", function () {
                  us.updateSetting.call(e.player, "captions"),
                    e.player.storage.set({ language: e.player.language });
                }),
                $r.on(
                  this.player.media,
                  "captionsenabled captionsdisabled",
                  function () {
                    us.updateSetting.call(e.player, "captions"),
                      e.player.storage.set({
                        captions: e.player.captions.active,
                      });
                  }
                ),
                $r.on(
                  this.player.media,
                  this.player.config.events
                    .concat(["keyup", "keydown"])
                    .join(" "),
                  function (t) {
                    var n = {};
                    "error" === t.type && (n = e.player.media.error),
                      $r.dispatchEvent.call(
                        e.player,
                        e.player.elements.container,
                        t.type,
                        !0,
                        n
                      );
                  }
                );
            },
          },
          {
            key: "controls",
            value: function () {
              var e = this,
                t = ds.isIE ? "change" : "input",
                n = function (t, n, i) {
                  var r = e.player.config.listeners[i],
                    s = !0;
                  $r.is.function(r) && (s = r.call(e.player, t)),
                    s && $r.is.function(n) && n.call(e.player, t);
                },
                i = function (t, i, r, s) {
                  var o =
                      !(arguments.length > 4 && void 0 !== arguments[4]) ||
                      arguments[4],
                    a = e.player.config.listeners[s],
                    l = $r.is.function(a);
                  $r.on(
                    t,
                    i,
                    function (e) {
                      return n(e, r, s);
                    },
                    o && !l
                  );
                };
              i(
                this.player.elements.buttons.play,
                "click",
                this.player.togglePlay,
                "play"
              ),
                i(
                  this.player.elements.buttons.restart,
                  "click",
                  this.player.restart,
                  "restart"
                ),
                i(
                  this.player.elements.buttons.rewind,
                  "click",
                  this.player.rewind,
                  "rewind"
                ),
                i(
                  this.player.elements.buttons.fastForward,
                  "click",
                  this.player.forward,
                  "fastForward"
                ),
                i(
                  this.player.elements.buttons.mute,
                  "click",
                  function () {
                    e.player.muted = !e.player.muted;
                  },
                  "mute"
                ),
                i(
                  this.player.elements.buttons.captions,
                  "click",
                  this.player.toggleCaptions
                ),
                i(
                  this.player.elements.buttons.fullscreen,
                  "click",
                  function () {
                    e.player.fullscreen.toggle();
                  },
                  "fullscreen"
                ),
                i(
                  this.player.elements.buttons.pip,
                  "click",
                  function () {
                    e.player.pip = "toggle";
                  },
                  "pip"
                ),
                i(
                  this.player.elements.buttons.airplay,
                  "click",
                  this.player.airplay,
                  "airplay"
                ),
                i(this.player.elements.buttons.settings, "click", function (t) {
                  us.toggleMenu.call(e.player, t);
                }),
                i(this.player.elements.settings.form, "click", function (t) {
                  t.stopPropagation(),
                    $r.matches(
                      t.target,
                      e.player.config.selectors.inputs.language
                    )
                      ? n(
                          t,
                          function () {
                            e.player.language = t.target.value;
                          },
                          "language"
                        )
                      : $r.matches(
                          t.target,
                          e.player.config.selectors.inputs.quality
                        )
                      ? n(
                          t,
                          function () {
                            e.player.quality = t.target.value;
                          },
                          "quality"
                        )
                      : $r.matches(
                          t.target,
                          e.player.config.selectors.inputs.speed
                        )
                      ? n(
                          t,
                          function () {
                            e.player.speed = parseFloat(t.target.value);
                          },
                          "speed"
                        )
                      : us.showTab.call(e.player, t);
                }),
                i(
                  this.player.elements.inputs.seek,
                  t,
                  function (t) {
                    e.player.currentTime =
                      (t.target.value / t.target.max) * e.player.duration;
                  },
                  "seek"
                ),
                this.player.config.toggleInvert &&
                  !$r.is.element(this.player.elements.display.duration) &&
                  i(
                    this.player.elements.display.currentTime,
                    "click",
                    function () {
                      0 !== e.player.currentTime &&
                        ((e.player.config.invertTime =
                          !e.player.config.invertTime),
                        as.timeUpdate.call(e.player));
                    }
                  ),
                i(
                  this.player.elements.inputs.volume,
                  t,
                  function (t) {
                    e.player.volume = t.target.value;
                  },
                  "volume"
                ),
                ds.isWebkit &&
                  i(
                    $r.getElements.call(this.player, 'input[type="range"]'),
                    "input",
                    function (t) {
                      us.updateRangeFill.call(e.player, t.target);
                    }
                  ),
                i(
                  this.player.elements.progress,
                  "mouseenter mouseleave mousemove",
                  function (t) {
                    return us.updateSeekTooltip.call(e.player, t);
                  }
                ),
                this.player.config.hideControls &&
                  (i(
                    this.player.elements.controls,
                    "mouseenter mouseleave",
                    function (t) {
                      e.player.elements.controls.hover =
                        !e.player.touch && "mouseenter" === t.type;
                    }
                  ),
                  i(
                    this.player.elements.controls,
                    "mousedown mouseup touchstart touchend touchcancel",
                    function (t) {
                      e.player.elements.controls.pressed = [
                        "mousedown",
                        "touchstart",
                      ].includes(t.type);
                    }
                  ),
                  i(
                    this.player.elements.controls,
                    "focusin focusout",
                    function (t) {
                      e.player.toggleControls(t);
                    }
                  )),
                i(
                  this.player.elements.inputs.volume,
                  "wheel",
                  function (t) {
                    var n = t.webkitDirectionInvertedFromDevice,
                      i = 0;
                    (t.deltaY < 0 || t.deltaX > 0) &&
                      (n
                        ? (e.player.decreaseVolume(0.02), (i = -1))
                        : (e.player.increaseVolume(0.02), (i = 1))),
                      (t.deltaY > 0 || t.deltaX < 0) &&
                        (n
                          ? (e.player.increaseVolume(0.02), (i = 1))
                          : (e.player.decreaseVolume(0.02), (i = -1))),
                      ((1 === i && e.player.media.volume < 1) ||
                        (-1 === i && e.player.media.volume > 0)) &&
                        t.preventDefault();
                  },
                  "volume",
                  !1
                );
            },
          },
          {
            key: "clear",
            value: function () {
              this.global(!1);
            },
          },
        ]),
        e
      );
    })(),
    fs = (function () {
      function e(t) {
        Kr(this, e),
          (this.enabled = t.config.storage.enabled),
          (this.key = t.config.storage.key);
      }
      return (
        Yr(
          e,
          [
            {
              key: "get",
              value: function (t) {
                if (!e.supported) return null;
                var n = window.localStorage.getItem(this.key);
                if ($r.is.empty(n)) return null;
                var i = JSON.parse(n);
                return $r.is.string(t) && t.length ? i[t] : i;
              },
            },
            {
              key: "set",
              value: function (t) {
                if (e.supported && this.enabled && $r.is.object(t)) {
                  var n = this.get();
                  $r.is.empty(n) && (n = {}),
                    $r.extend(n, t),
                    window.localStorage.setItem(this.key, JSON.stringify(n));
                }
              },
            },
          ],
          [
            {
              key: "supported",
              get: function () {
                try {
                  if (!("localStorage" in window)) return !1;
                  return (
                    window.localStorage.setItem("___test", "___test"),
                    window.localStorage.removeItem("___test"),
                    !0
                  );
                } catch (e) {
                  return !1;
                }
              },
            },
          ]
        ),
        e
      );
    })(),
    ps = (function () {
      function e(t) {
        var n = this;
        Kr(this, e),
          (this.player = t),
          (this.publisherId = t.config.ads.publisherId),
          (this.enabled =
            t.isHTML5 &&
            t.isVideo &&
            t.config.ads.enabled &&
            $r.is.string(this.publisherId) &&
            this.publisherId.length),
          (this.playing = !1),
          (this.initialized = !1),
          (this.elements = { container: null, displayContainer: null }),
          (this.manager = null),
          (this.loader = null),
          (this.cuePoints = null),
          (this.events = {}),
          (this.safetyTimer = null),
          (this.countdownTimer = null),
          (this.managerPromise = new Promise(function (e, t) {
            n.on("loaded", e), n.on("error", t);
          })),
          this.load();
      }
      return (
        Yr(e, [
          {
            key: "load",
            value: function () {
              var e = this;
              this.enabled &&
                ($r.is.object(window.google) && $r.is.object(window.google.ima)
                  ? this.ready()
                  : $r
                      .loadScript(this.player.config.urls.googleIMA.api)
                      .then(function () {
                        e.ready();
                      })
                      .catch(function () {
                        e.trigger(
                          "error",
                          new Error("Google IMA SDK failed to load")
                        );
                      }));
            },
          },
          {
            key: "ready",
            value: function () {
              var e = this;
              this.startSafetyTimer(12e3, "ready()"),
                this.managerPromise.then(function () {
                  e.clearSafetyTimer("onAdsManagerLoaded()");
                }),
                this.listeners(),
                this.setupIMA();
            },
          },
          {
            key: "setupIMA",
            value: function () {
              (this.elements.container = $r.createElement("div", {
                class: this.player.config.classNames.ads,
              })),
                this.player.elements.container.appendChild(
                  this.elements.container
                ),
                google.ima.settings.setVpaidMode(
                  google.ima.ImaSdkSettings.VpaidMode.ENABLED
                ),
                google.ima.settings.setLocale(this.player.config.ads.language),
                (this.elements.displayContainer =
                  new google.ima.AdDisplayContainer(this.elements.container)),
                this.requestAds();
            },
          },
          {
            key: "requestAds",
            value: function () {
              var e = this,
                t = this.player.elements.container;
              try {
                (this.loader = new google.ima.AdsLoader(
                  this.elements.displayContainer
                )),
                  this.loader.addEventListener(
                    google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
                    function (t) {
                      return e.onAdsManagerLoaded(t);
                    },
                    !1
                  ),
                  this.loader.addEventListener(
                    google.ima.AdErrorEvent.Type.AD_ERROR,
                    function (t) {
                      return e.onAdError(t);
                    },
                    !1
                  );
                var n = new google.ima.AdsRequest();
                (n.adTagUrl = this.tagUrl),
                  (n.linearAdSlotWidth = t.offsetWidth),
                  (n.linearAdSlotHeight = t.offsetHeight),
                  (n.nonLinearAdSlotWidth = t.offsetWidth),
                  (n.nonLinearAdSlotHeight = t.offsetHeight),
                  (n.forceNonLinearFullSlot = !1),
                  this.loader.requestAds(n);
              } catch (e) {
                this.onAdError(e);
              }
            },
          },
          {
            key: "pollCountdown",
            value: function () {
              var e = this;
              if (
                !(
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0]
                )
              )
                return (
                  clearInterval(this.countdownTimer),
                  void this.elements.container.removeAttribute(
                    "data-badge-text"
                  )
                );
              this.countdownTimer = setInterval(function () {
                var t = $r.formatTime(
                    Math.max(e.manager.getRemainingTime(), 0)
                  ),
                  n = os("advertisement", e.player.config) + " - " + t;
                e.elements.container.setAttribute("data-badge-text", n);
              }, 100);
            },
          },
          {
            key: "onAdsManagerLoaded",
            value: function (e) {
              var t = this,
                n = new google.ima.AdsRenderingSettings();
              (n.restoreCustomPlaybackStateOnAdBreakComplete = !0),
                (n.enablePreloading = !0),
                (this.manager = e.getAdsManager(this.player, n)),
                (this.cuePoints = this.manager.getCuePoints()),
                $r.is.empty(this.cuePoints) ||
                  this.cuePoints.forEach(function (e) {
                    if (0 !== e && -1 !== e && e < t.player.duration) {
                      var n = t.player.elements.progress;
                      if ($r.is.element(n)) {
                        var i = (100 / t.player.duration) * e,
                          r = $r.createElement("span", {
                            class: t.player.config.classNames.cues,
                          });
                        (r.style.left = i.toString() + "%"), n.appendChild(r);
                      }
                    }
                  }),
                this.manager.setVolume(this.player.volume),
                this.manager.addEventListener(
                  google.ima.AdErrorEvent.Type.AD_ERROR,
                  function (e) {
                    return t.onAdError(e);
                  }
                ),
                Object.keys(google.ima.AdEvent.Type).forEach(function (e) {
                  t.manager.addEventListener(
                    google.ima.AdEvent.Type[e],
                    function (e) {
                      return t.onAdEvent(e);
                    }
                  );
                }),
                this.trigger("loaded");
            },
          },
          {
            key: "onAdEvent",
            value: function (e) {
              var t = this,
                n = this.player.elements.container,
                i = e.getAd(),
                r = function (e) {
                  var n = "ads" + e.replace(/_/g, "").toLowerCase();
                  $r.dispatchEvent.call(t.player, t.player.media, n);
                };
              switch (e.type) {
                case google.ima.AdEvent.Type.LOADED:
                  this.trigger("loaded"),
                    r(e.type),
                    this.pollCountdown(!0),
                    i.isLinear() ||
                      ((i.width = n.offsetWidth), (i.height = n.offsetHeight));
                  break;
                case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                  r(e.type), this.loadAds();
                  break;
                case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                  r(e.type), this.pauseContent();
                  break;
                case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                  r(e.type), this.pollCountdown(), this.resumeContent();
                  break;
                case google.ima.AdEvent.Type.STARTED:
                case google.ima.AdEvent.Type.MIDPOINT:
                case google.ima.AdEvent.Type.COMPLETE:
                case google.ima.AdEvent.Type.IMPRESSION:
                case google.ima.AdEvent.Type.CLICK:
                  r(e.type);
              }
            },
          },
          {
            key: "onAdError",
            value: function (e) {
              this.cancel(), this.player.debug.warn("Ads error", e);
            },
          },
          {
            key: "listeners",
            value: function () {
              var e = this,
                t = this.player.elements.container,
                n = void 0;
              this.player.on("ended", function () {
                e.loader.contentComplete();
              }),
                this.player.on("seeking", function () {
                  return (n = e.player.currentTime);
                }),
                this.player.on("seeked", function () {
                  var t = e.player.currentTime;
                  $r.is.empty(e.cuePoints) ||
                    e.cuePoints.forEach(function (i, r) {
                      n < i &&
                        i < t &&
                        (e.manager.discardAdBreak(), e.cuePoints.splice(r, 1));
                    });
                }),
                window.addEventListener("resize", function () {
                  e.manager &&
                    e.manager.resize(
                      t.offsetWidth,
                      t.offsetHeight,
                      google.ima.ViewMode.NORMAL
                    );
                });
            },
          },
          {
            key: "play",
            value: function () {
              var e = this,
                t = this.player.elements.container;
              this.managerPromise || this.resumeContent(),
                this.managerPromise
                  .then(function () {
                    e.elements.displayContainer.initialize();
                    try {
                      e.initialized ||
                        (e.manager.init(
                          t.offsetWidth,
                          t.offsetHeight,
                          google.ima.ViewMode.NORMAL
                        ),
                        e.manager.start()),
                        (e.initialized = !0);
                    } catch (t) {
                      e.onAdError(t);
                    }
                  })
                  .catch(function () {});
            },
          },
          {
            key: "resumeContent",
            value: function () {
              (this.elements.container.style.zIndex = ""),
                (this.playing = !1),
                this.player.currentTime < this.player.duration &&
                  this.player.play();
            },
          },
          {
            key: "pauseContent",
            value: function () {
              (this.elements.container.style.zIndex = 3),
                (this.playing = !0),
                this.player.pause();
            },
          },
          {
            key: "cancel",
            value: function () {
              this.initialized && this.resumeContent(),
                this.trigger("error"),
                this.loadAds();
            },
          },
          {
            key: "loadAds",
            value: function () {
              var e = this;
              this.managerPromise
                .then(function () {
                  e.manager && e.manager.destroy(),
                    (e.managerPromise = new Promise(function (t) {
                      e.on("loaded", t), e.player.debug.log(e.manager);
                    })),
                    e.requestAds();
                })
                .catch(function () {});
            },
          },
          {
            key: "trigger",
            value: function (e) {
              for (
                var t = this,
                  n = arguments.length,
                  i = Array(n > 1 ? n - 1 : 0),
                  r = 1;
                r < n;
                r++
              )
                i[r - 1] = arguments[r];
              var s = this.events[e];
              $r.is.array(s) &&
                s.forEach(function (e) {
                  $r.is.function(e) && e.apply(t, i);
                });
            },
          },
          {
            key: "on",
            value: function (e, t) {
              return (
                $r.is.array(this.events[e]) || (this.events[e] = []),
                this.events[e].push(t),
                this
              );
            },
          },
          {
            key: "startSafetyTimer",
            value: function (e, t) {
              var n = this;
              this.player.debug.log("Safety timer invoked from: " + t),
                (this.safetyTimer = setTimeout(function () {
                  n.cancel(), n.clearSafetyTimer("startSafetyTimer()");
                }, e));
            },
          },
          {
            key: "clearSafetyTimer",
            value: function (e) {
              $r.is.nullOrUndefined(this.safetyTimer) ||
                (this.player.debug.log("Safety timer cleared from: " + e),
                clearTimeout(this.safetyTimer),
                (this.safetyTimer = null));
            },
          },
          {
            key: "tagUrl",
            get: function () {
              var e = {
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: this.publisherId,
              };
              return (
                "https://go.aniview.com/api/adserver6/vast/?" +
                $r.buildUrlParams(e)
              );
            },
          },
        ]),
        e
      );
    })();
  function gs(e) {
    switch (e) {
      case "hd2160":
        return 2160;
      case 2160:
        return "hd2160";
      case "hd1440":
        return 1440;
      case 1440:
        return "hd1440";
      case "hd1080":
        return 1080;
      case 1080:
        return "hd1080";
      case "hd720":
        return 720;
      case 720:
        return "hd720";
      case "large":
        return 480;
      case 480:
        return "large";
      case "medium":
        return 360;
      case 360:
        return "medium";
      case "small":
        return 240;
      case 240:
        return "small";
      default:
        return "default";
    }
  }
  var ms = {
      setup: function () {
        var e = this;
        $r.toggleClass(this.elements.wrapper, this.config.classNames.embed, !0),
          ms.setAspectRatio.call(this),
          $r.is.object(window.YT) && $r.is.function(window.YT.Player)
            ? ms.ready.call(this)
            : ($r.loadScript(this.config.urls.youtube.api).catch(function (t) {
                e.debug.warn("YouTube API failed to load", t);
              }),
              (window.onYouTubeReadyCallbacks =
                window.onYouTubeReadyCallbacks || []),
              window.onYouTubeReadyCallbacks.push(function () {
                ms.ready.call(e);
              }),
              (window.onYouTubeIframeAPIReady = function () {
                window.onYouTubeReadyCallbacks.forEach(function (e) {
                  e();
                });
              }));
      },
      getTitle: function (e) {
        var t = this;
        if ($r.is.function(this.embed.getVideoData)) {
          var n = this.embed.getVideoData().title;
          if ($r.is.empty(n))
            return (this.config.title = n), void as.setTitle.call(this);
        }
        var i = this.config.keys.google;
        if ($r.is.string(i) && !$r.is.empty(i)) {
          var r =
            "https://www.googleapis.com/youtube/v3/videos?id=" +
            e +
            "&key=" +
            i +
            "&fields=items(snippet(title))&part=snippet";
          $r.fetch(r)
            .then(function (e) {
              $r.is.object(e) &&
                ((t.config.title = e.items[0].snippet.title),
                as.setTitle.call(t));
            })
            .catch(function () {});
        }
      },
      setAspectRatio: function () {
        var e = this.config.ratio.split(":");
        this.elements.wrapper.style.paddingBottom = (100 / e[0]) * e[1] + "%";
      },
      ready: function () {
        var e = this,
          t = e.media.getAttribute("id");
        if ($r.is.empty(t) || !t.startsWith("youtube-")) {
          var n = e.media.getAttribute("src");
          $r.is.empty(n) &&
            (n = e.media.getAttribute(this.config.attributes.embed.id));
          var i = $r.parseYouTubeId(n),
            r = $r.generateId(e.provider),
            s = $r.createElement("div", { id: r });
          (e.media = $r.replaceElement(s, e.media)),
            (e.embed = new window.YT.Player(r, {
              videoId: i,
              playerVars: {
                autoplay: e.config.autoplay ? 1 : 0,
                controls: e.supported.ui ? 0 : 1,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                disablekb: 1,
                playsinline: 1,
                widget_referrer: window ? window.location.href : null,
                cc_load_policy: e.captions.active ? 1 : 0,
                cc_lang_pref: e.config.captions.language,
              },
              events: {
                onError: function (t) {
                  if (!$r.is.object(e.media.error)) {
                    var n = { code: t.data };
                    switch (t.data) {
                      case 2:
                        n.message =
                          "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.";
                        break;
                      case 5:
                        n.message =
                          "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.";
                        break;
                      case 100:
                        n.message =
                          "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.";
                        break;
                      case 101:
                      case 150:
                        n.message =
                          "The owner of the requested video does not allow it to be played in embedded players.";
                        break;
                      default:
                        n.message = "An unknown error occured";
                    }
                    (e.media.error = n),
                      $r.dispatchEvent.call(e, e.media, "error");
                  }
                },
                onPlaybackQualityChange: function () {
                  $r.dispatchEvent.call(e, e.media, "qualitychange", !1, {
                    quality: e.media.quality,
                  });
                },
                onPlaybackRateChange: function (t) {
                  var n = t.target;
                  (e.media.playbackRate = n.getPlaybackRate()),
                    $r.dispatchEvent.call(e, e.media, "ratechange");
                },
                onReady: function (t) {
                  var n = t.target;
                  ms.getTitle.call(e, i),
                    (e.media.play = function () {
                      n.playVideo();
                    }),
                    (e.media.pause = function () {
                      n.pauseVideo();
                    }),
                    (e.media.stop = function () {
                      n.stopVideo();
                    }),
                    (e.media.duration = n.getDuration()),
                    (e.media.paused = !0),
                    (e.media.currentTime = 0),
                    Object.defineProperty(e.media, "currentTime", {
                      get: function () {
                        return Number(n.getCurrentTime());
                      },
                      set: function (t) {
                        (e.media.seeking = !0),
                          $r.dispatchEvent.call(e, e.media, "seeking"),
                          n.seekTo(t);
                      },
                    }),
                    Object.defineProperty(e.media, "playbackRate", {
                      get: function () {
                        return n.getPlaybackRate();
                      },
                      set: function (e) {
                        n.setPlaybackRate(e);
                      },
                    }),
                    Object.defineProperty(e.media, "quality", {
                      get: function () {
                        return gs(n.getPlaybackQuality());
                      },
                      set: function (t) {
                        var i = t;
                        n.setPlaybackQuality(gs(i)),
                          $r.dispatchEvent.call(
                            e,
                            e.media,
                            "qualityrequested",
                            !1,
                            { quality: i }
                          );
                      },
                    });
                  var r = e.config.volume;
                  Object.defineProperty(e.media, "volume", {
                    get: function () {
                      return r;
                    },
                    set: function (t) {
                      (r = t),
                        n.setVolume(100 * r),
                        $r.dispatchEvent.call(e, e.media, "volumechange");
                    },
                  });
                  var s = e.config.muted;
                  Object.defineProperty(e.media, "muted", {
                    get: function () {
                      return s;
                    },
                    set: function (t) {
                      var i = $r.is.boolean(t) ? t : s;
                      (s = i),
                        n[i ? "mute" : "unMute"](),
                        $r.dispatchEvent.call(e, e.media, "volumechange");
                    },
                  }),
                    Object.defineProperty(e.media, "currentSrc", {
                      get: function () {
                        return n.getVideoUrl();
                      },
                    }),
                    Object.defineProperty(e.media, "ended", {
                      get: function () {
                        return e.currentTime === e.duration;
                      },
                    }),
                    (e.options.speed = n.getAvailablePlaybackRates()),
                    e.supported.ui && e.media.setAttribute("tabindex", -1),
                    $r.dispatchEvent.call(e, e.media, "timeupdate"),
                    $r.dispatchEvent.call(e, e.media, "durationchange"),
                    clearInterval(e.timers.buffering),
                    (e.timers.buffering = setInterval(function () {
                      (e.media.buffered = n.getVideoLoadedFraction()),
                        (null === e.media.lastBuffered ||
                          e.media.lastBuffered < e.media.buffered) &&
                          $r.dispatchEvent.call(e, e.media, "progress"),
                        (e.media.lastBuffered = e.media.buffered),
                        1 === e.media.buffered &&
                          (clearInterval(e.timers.buffering),
                          $r.dispatchEvent.call(e, e.media, "canplaythrough"));
                    }, 200)),
                    setTimeout(function () {
                      return as.build.call(e);
                    }, 50);
                },
                onStateChange: function (t) {
                  var n,
                    i = t.target;
                  switch ((clearInterval(e.timers.playing), t.data)) {
                    case -1:
                      $r.dispatchEvent.call(e, e.media, "timeupdate"),
                        (e.media.buffered = i.getVideoLoadedFraction()),
                        $r.dispatchEvent.call(e, e.media, "progress");
                      break;
                    case 0:
                      (e.media.paused = !0),
                        e.media.loop
                          ? (i.stopVideo(), i.playVideo())
                          : $r.dispatchEvent.call(e, e.media, "ended");
                      break;
                    case 1:
                      e.media.seeking &&
                        $r.dispatchEvent.call(e, e.media, "seeked"),
                        (e.media.seeking = !1),
                        e.media.paused &&
                          $r.dispatchEvent.call(e, e.media, "play"),
                        (e.media.paused = !1),
                        $r.dispatchEvent.call(e, e.media, "playing"),
                        (e.timers.playing = setInterval(function () {
                          $r.dispatchEvent.call(e, e.media, "timeupdate");
                        }, 50)),
                        e.media.duration !== i.getDuration() &&
                          ((e.media.duration = i.getDuration()),
                          $r.dispatchEvent.call(e, e.media, "durationchange")),
                        us.setQualityMenu.call(
                          e,
                          ((n = i.getAvailableQualityLevels()),
                          $r.is.empty(n)
                            ? n
                            : $r.dedupe(
                                n.map(function (e) {
                                  return gs(e);
                                })
                              ))
                        );
                      break;
                    case 2:
                      (e.media.paused = !0),
                        $r.dispatchEvent.call(e, e.media, "pause");
                  }
                  $r.dispatchEvent.call(
                    e,
                    e.elements.container,
                    "statechange",
                    !1,
                    { code: t.data }
                  );
                },
              },
            }));
        }
      },
    },
    ys = {
      setup: function () {
        var e = this;
        $r.toggleClass(this.elements.wrapper, this.config.classNames.embed, !0),
          ys.setAspectRatio.call(this),
          $r.is.object(window.Vimeo)
            ? ys.ready.call(this)
            : $r
                .loadScript(this.config.urls.vimeo.api)
                .then(function () {
                  ys.ready.call(e);
                })
                .catch(function (t) {
                  e.debug.warn("Vimeo API failed to load", t);
                });
      },
      setAspectRatio: function (e) {
        var t = $r.is.string(e) ? e.split(":") : this.config.ratio.split(":"),
          n = (100 / t[0]) * t[1],
          i = (240 - n) / 4.8;
        (this.elements.wrapper.style.paddingBottom = n + "%"),
          (this.media.style.transform = "translateY(-" + i + "%)");
      },
      ready: function () {
        var e = this,
          t = this,
          n = {
            loop: t.config.loop.active,
            autoplay: t.autoplay,
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: 0,
            gesture: "media",
          },
          i = $r.buildUrlParams(n),
          r = t.media.getAttribute("src");
        $r.is.empty(r) &&
          (r = t.media.getAttribute(this.config.attributes.embed.id));
        var s = $r.parseVimeoId(r),
          o = $r.createElement("iframe"),
          a = "https://player.vimeo.com/video/" + s + "?" + i;
        o.setAttribute("src", a),
          o.setAttribute("allowfullscreen", ""),
          o.setAttribute("allowtransparency", ""),
          o.setAttribute("allow", "autoplay");
        var l = $r.createElement("div");
        l.appendChild(o),
          (t.media = $r.replaceElement(l, t.media)),
          (t.embed = new window.Vimeo.Player(o)),
          (t.media.paused = !0),
          (t.media.currentTime = 0),
          (t.media.play = function () {
            t.embed.play().then(function () {
              t.media.paused = !1;
            });
          }),
          (t.media.pause = function () {
            t.embed.pause().then(function () {
              t.media.paused = !0;
            });
          }),
          (t.media.stop = function () {
            t.pause(), (t.currentTime = 0);
          });
        var c = t.media.currentTime;
        Object.defineProperty(t.media, "currentTime", {
          get: function () {
            return c;
          },
          set: function (e) {
            var n = t.media.paused;
            (t.media.seeking = !0),
              $r.dispatchEvent.call(t, t.media, "seeking"),
              t.embed.setCurrentTime(e),
              n && t.pause();
          },
        });
        var u = t.config.speed.selected;
        Object.defineProperty(t.media, "playbackRate", {
          get: function () {
            return u;
          },
          set: function (e) {
            t.embed
              .setPlaybackRate(e)
              .then(function () {
                (u = e), $r.dispatchEvent.call(t, t.media, "ratechange");
              })
              .catch(function (e) {
                "Error" === e.name && us.setSpeedMenu.call(t, []);
              });
          },
        });
        var d = t.config.volume;
        Object.defineProperty(t.media, "volume", {
          get: function () {
            return d;
          },
          set: function (e) {
            t.embed.setVolume(e).then(function () {
              (d = e), $r.dispatchEvent.call(t, t.media, "volumechange");
            });
          },
        });
        var h = t.config.muted;
        Object.defineProperty(t.media, "muted", {
          get: function () {
            return h;
          },
          set: function (e) {
            var n = !!$r.is.boolean(e) && e;
            t.embed.setVolume(n ? 0 : t.config.volume).then(function () {
              (h = n), $r.dispatchEvent.call(t, t.media, "volumechange");
            });
          },
        });
        var f = t.config.loop;
        Object.defineProperty(t.media, "loop", {
          get: function () {
            return f;
          },
          set: function (e) {
            var n = $r.is.boolean(e) ? e : t.config.loop.active;
            t.embed.setLoop(n).then(function () {
              f = n;
            });
          },
        });
        var p = void 0;
        t.embed
          .getVideoUrl()
          .then(function (e) {
            p = e;
          })
          .catch(function (t) {
            e.debug.warn(t);
          }),
          Object.defineProperty(t.media, "currentSrc", {
            get: function () {
              return p;
            },
          }),
          Object.defineProperty(t.media, "ended", {
            get: function () {
              return t.currentTime === t.duration;
            },
          }),
          Promise.all([t.embed.getVideoWidth(), t.embed.getVideoHeight()]).then(
            function (t) {
              var n = $r.getAspectRatio(t[0], t[1]);
              ys.setAspectRatio.call(e, n);
            }
          ),
          t.embed.setAutopause(t.config.autopause).then(function (e) {
            t.config.autopause = e;
          }),
          t.embed.getVideoTitle().then(function (n) {
            (t.config.title = n), as.setTitle.call(e);
          }),
          t.embed.getCurrentTime().then(function (e) {
            (c = e), $r.dispatchEvent.call(t, t.media, "timeupdate");
          }),
          t.embed.getDuration().then(function (e) {
            (t.media.duration = e),
              $r.dispatchEvent.call(t, t.media, "durationchange");
          }),
          t.embed.getTextTracks().then(function (e) {
            (t.media.textTracks = e), ss.setup.call(t);
          }),
          t.embed.on("cuechange", function (e) {
            var n = null;
            e.cues.length && (n = $r.stripHTML(e.cues[0].text)),
              ss.setText.call(t, n);
          }),
          t.embed.on("loaded", function () {
            $r.is.element(t.embed.element) &&
              t.supported.ui &&
              t.embed.element.setAttribute("tabindex", -1);
          }),
          t.embed.on("play", function () {
            t.media.paused && $r.dispatchEvent.call(t, t.media, "play"),
              (t.media.paused = !1),
              $r.dispatchEvent.call(t, t.media, "playing");
          }),
          t.embed.on("pause", function () {
            (t.media.paused = !0), $r.dispatchEvent.call(t, t.media, "pause");
          }),
          t.embed.on("timeupdate", function (e) {
            (t.media.seeking = !1),
              (c = e.seconds),
              $r.dispatchEvent.call(t, t.media, "timeupdate");
          }),
          t.embed.on("progress", function (e) {
            (t.media.buffered = e.percent),
              $r.dispatchEvent.call(t, t.media, "progress"),
              1 === parseInt(e.percent, 10) &&
                $r.dispatchEvent.call(t, t.media, "canplaythrough");
          }),
          t.embed.on("seeked", function () {
            (t.media.seeking = !1),
              $r.dispatchEvent.call(t, t.media, "seeked"),
              $r.dispatchEvent.call(t, t.media, "play");
          }),
          t.embed.on("ended", function () {
            (t.media.paused = !0), $r.dispatchEvent.call(t, t.media, "ended");
          }),
          t.embed.on("error", function (e) {
            (t.media.error = e), $r.dispatchEvent.call(t, t.media, "error");
          }),
          setTimeout(function () {
            return as.build.call(t);
          }, 0);
      },
    },
    vs = $r.getBrowser(),
    bs = {
      setup: function () {
        if (this.media)
          if (
            ($r.toggleClass(
              this.elements.container,
              this.config.classNames.type.replace("{0}", this.type),
              !0
            ),
            $r.toggleClass(
              this.elements.container,
              this.config.classNames.provider.replace("{0}", this.provider),
              !0
            ),
            this.isEmbed &&
              $r.toggleClass(
                this.elements.container,
                this.config.classNames.type.replace("{0}", "video"),
                !0
              ),
            this.supported.ui &&
              ($r.toggleClass(
                this.elements.container,
                this.config.classNames.pip.supported,
                Xr.pip && this.isHTML5 && this.isVideo
              ),
              $r.toggleClass(
                this.elements.container,
                this.config.classNames.airplay.supported,
                Xr.airplay && this.isHTML5
              ),
              $r.toggleClass(
                this.elements.container,
                this.config.classNames.stopped,
                this.config.autoplay
              ),
              $r.toggleClass(
                this.elements.container,
                this.config.classNames.isIos,
                vs.isIos
              ),
              $r.toggleClass(
                this.elements.container,
                this.config.classNames.isTouch,
                this.touch
              )),
            this.isVideo &&
              ((this.elements.wrapper = $r.createElement("div", {
                class: this.config.classNames.video,
              })),
              $r.wrap(this.media, this.elements.wrapper)),
            this.isEmbed)
          )
            switch (this.provider) {
              case "youtube":
                ms.setup.call(this);
                break;
              case "vimeo":
                ys.setup.call(this);
            }
          else this.isHTML5 && (as.setTitle.call(this), ls.extend.call(this));
        else this.debug.warn("No media element found!");
      },
    },
    ws = {
      insertElements: function (e, t) {
        var n = this;
        $r.is.string(t)
          ? $r.insertElement(e, this.media, { src: t })
          : $r.is.array(t) &&
            t.forEach(function (t) {
              $r.insertElement(e, n.media, t);
            });
      },
      change: function (e) {
        var t = this;
        $r.is.object(e) && "sources" in e && e.sources.length
          ? (ls.cancelRequests.call(this),
            this.destroy.call(
              this,
              function () {
                switch (
                  ((t.options.quality = []),
                  $r.removeElement(t.media),
                  (t.media = null),
                  $r.is.element(t.elements.container) &&
                    t.elements.container.removeAttribute("class"),
                  (t.type = e.type),
                  (t.provider = $r.is.empty(e.sources[0].provider)
                    ? Hr.html5
                    : e.sources[0].provider),
                  (t.supported = Xr.check(t.type, t.provider, t.config.inline)),
                  t.provider + ":" + t.type)
                ) {
                  case "html5:video":
                    t.media = $r.createElement("video");
                    break;
                  case "html5:audio":
                    t.media = $r.createElement("audio");
                    break;
                  case "youtube:video":
                  case "vimeo:video":
                    t.media = $r.createElement("div", {
                      src: e.sources[0].src,
                    });
                }
                t.elements.container.appendChild(t.media),
                  $r.is.boolean(e.autoplay) && (t.config.autoplay = e.autoplay),
                  t.isHTML5 &&
                    (t.config.crossorigin &&
                      t.media.setAttribute("crossorigin", ""),
                    t.config.autoplay && t.media.setAttribute("autoplay", ""),
                    "poster" in e && t.media.setAttribute("poster", e.poster),
                    t.config.loop.active && t.media.setAttribute("loop", ""),
                    t.config.muted && t.media.setAttribute("muted", ""),
                    t.config.inline && t.media.setAttribute("playsinline", "")),
                  as.addStyleHook.call(t),
                  t.isHTML5 && ws.insertElements.call(t, "source", e.sources),
                  (t.config.title = e.title),
                  bs.setup.call(t),
                  t.isHTML5 &&
                    ("tracks" in e &&
                      ws.insertElements.call(t, "track", e.tracks),
                    t.media.load()),
                  (t.isHTML5 || (t.isEmbed && !t.supported.ui)) &&
                    as.build.call(t),
                  t.fullscreen.update();
              },
              !0
            ))
          : this.debug.warn("Invalid source format");
      },
    };
  return (function () {
    function e(t, n) {
      var i = this;
      if (
        (Kr(this, e),
        (this.timers = {}),
        (this.ready = !1),
        (this.loading = !1),
        (this.failed = !1),
        (this.touch = Xr.touch),
        (this.media = t),
        $r.is.string(this.media) &&
          (this.media = document.querySelectorAll(this.media)),
        ((window.jQuery && this.media instanceof jQuery) ||
          $r.is.nodeList(this.media) ||
          $r.is.array(this.media)) &&
          (this.media = this.media[0]),
        (this.config = $r.extend(
          {},
          zr,
          n,
          (function () {
            try {
              return JSON.parse(i.media.getAttribute("data-plyr-config"));
            } catch (e) {
              return {};
            }
          })()
        )),
        (this.elements = {
          container: null,
          buttons: {},
          display: {},
          progress: {},
          inputs: {},
          settings: { menu: null, panes: {}, tabs: {} },
          captions: null,
        }),
        (this.captions = { active: null, currentTrack: null }),
        (this.fullscreen = { active: !1 }),
        (this.options = { speed: [], quality: [] }),
        (this.debug = new es(this.config.debug)),
        this.debug.log("Config", this.config),
        this.debug.log("Support", Xr),
        !$r.is.nullOrUndefined(this.media) && $r.is.element(this.media))
      )
        if (this.media.plyr) this.debug.warn("Target already setup");
        else if (this.config.enabled)
          if (Xr.check().api) {
            setTimeout(function () {
              var e = i.media.cloneNode(!0);
              e.getAttribute("autoplay") && e.pause(),
                (i.elements.original = e);
            }, 0);
            var r = this.media.tagName.toLowerCase(),
              s = null,
              o = null,
              a = null;
            switch (r) {
              case "div":
                if (
                  ((s = this.media.querySelector("iframe")), $r.is.element(s))
                ) {
                  if (
                    ((o = s.getAttribute("src")),
                    (this.provider = $r.getProviderByUrl(o)),
                    (this.elements.container = this.media),
                    (this.media = s),
                    (this.elements.container.className = ""),
                    (a = $r.getUrlParams(o)),
                    !$r.is.empty(a))
                  ) {
                    var l = ["1", "true"];
                    l.includes(a.autoplay) && (this.config.autoplay = !0),
                      l.includes(a.playsinline) && (this.config.inline = !0),
                      l.includes(a.loop) && (this.config.loop.active = !0);
                  }
                } else
                  (this.provider = this.media.getAttribute(
                    this.config.attributes.embed.provider
                  )),
                    this.media.removeAttribute(
                      this.config.attributes.embed.provider
                    );
                if (
                  $r.is.empty(this.provider) ||
                  !Object.keys(Hr).includes(this.provider)
                )
                  return void this.debug.error(
                    "Setup failed: Invalid provider"
                  );
                this.type = Wr.video;
                break;
              case "video":
              case "audio":
                (this.type = r),
                  (this.provider = Hr.html5),
                  this.media.hasAttribute("crossorigin") &&
                    (this.config.crossorigin = !0),
                  this.media.hasAttribute("autoplay") &&
                    (this.config.autoplay = !0),
                  this.media.hasAttribute("playsinline") &&
                    (this.config.inline = !0),
                  this.media.hasAttribute("muted") && (this.config.muted = !0),
                  this.media.hasAttribute("loop") &&
                    (this.config.loop.active = !0);
                break;
              default:
                return void this.debug.error("Setup failed: unsupported type");
            }
            (this.supported = Xr.check(
              this.type,
              this.provider,
              this.config.inline
            )),
              this.supported.api
                ? ((this.listeners = new hs(this)),
                  (this.storage = new fs(this)),
                  (this.media.plyr = this),
                  $r.is.element(this.elements.container) ||
                    ((this.elements.container = $r.createElement("div")),
                    $r.wrap(this.media, this.elements.container)),
                  this.elements.container.setAttribute("tabindex", 0),
                  as.addStyleHook.call(this),
                  bs.setup.call(this),
                  this.config.debug &&
                    $r.on(
                      this.elements.container,
                      this.config.events.join(" "),
                      function (e) {
                        i.debug.log("event: " + e.type);
                      }
                    ),
                  (this.isHTML5 || (this.isEmbed && !this.supported.ui)) &&
                    as.build.call(this),
                  this.listeners.container(),
                  this.listeners.global(),
                  (this.fullscreen = new rs(this)),
                  (this.ads = new ps(this)),
                  this.config.autoplay && this.play())
                : this.debug.error("Setup failed: no support");
          } else this.debug.error("Setup failed: no support");
        else this.debug.error("Setup failed: disabled by config");
      else this.debug.error("Setup failed: no suitable element passed");
    }
    return (
      Yr(
        e,
        [
          {
            key: "play",
            value: function () {
              return $r.is.function(this.media.play) ? this.media.play() : null;
            },
          },
          {
            key: "pause",
            value: function () {
              this.playing &&
                $r.is.function(this.media.pause) &&
                this.media.pause();
            },
          },
          {
            key: "togglePlay",
            value: function (e) {
              ($r.is.boolean(e) ? e : !this.playing)
                ? this.play()
                : this.pause();
            },
          },
          {
            key: "stop",
            value: function () {
              this.isHTML5
                ? this.media.load()
                : $r.is.function(this.media.stop) && this.media.stop();
            },
          },
          {
            key: "restart",
            value: function () {
              this.currentTime = 0;
            },
          },
          {
            key: "rewind",
            value: function (e) {
              this.currentTime =
                this.currentTime - ($r.is.number(e) ? e : this.config.seekTime);
            },
          },
          {
            key: "forward",
            value: function (e) {
              this.currentTime =
                this.currentTime + ($r.is.number(e) ? e : this.config.seekTime);
            },
          },
          {
            key: "increaseVolume",
            value: function (e) {
              var t = this.media.muted ? 0 : this.volume;
              this.volume = t + ($r.is.number(e) ? e : 1);
            },
          },
          {
            key: "decreaseVolume",
            value: function (e) {
              var t = this.media.muted ? 0 : this.volume;
              this.volume = t - ($r.is.number(e) ? e : 1);
            },
          },
          {
            key: "toggleCaptions",
            value: function (e) {
              if (
                this.supported.ui &&
                $r.is.element(this.elements.buttons.captions)
              ) {
                var t = $r.is.boolean(e)
                  ? e
                  : -1 ===
                    this.elements.container.className.indexOf(
                      this.config.classNames.captions.active
                    );
                this.captions.active !== t &&
                  ((this.captions.active = t),
                  $r.toggleState(
                    this.elements.buttons.captions,
                    this.captions.active
                  ),
                  $r.toggleClass(
                    this.elements.container,
                    this.config.classNames.captions.active,
                    this.captions.active
                  ),
                  $r.dispatchEvent.call(
                    this,
                    this.media,
                    this.captions.active
                      ? "captionsenabled"
                      : "captionsdisabled"
                  ));
              }
            },
          },
          {
            key: "airplay",
            value: function () {
              Xr.airplay && this.media.webkitShowPlaybackTargetPicker();
            },
          },
          {
            key: "toggleControls",
            value: function (e) {
              var t = this;
              if (
                $r.is.element(this.elements.controls) &&
                this.supported.ui &&
                !this.isAudio
              ) {
                var n = 0,
                  i = e,
                  r = !1;
                if (!$r.is.boolean(e))
                  if ($r.is.event(e)) {
                    r = "enterfullscreen" === e.type;
                    (i = [
                      "touchstart",
                      "touchmove",
                      "mouseenter",
                      "mousemove",
                      "focusin",
                    ].includes(e.type)),
                      ["touchmove", "touchend", "mousemove"].includes(e.type) &&
                        (n = 2e3),
                      this.touch ||
                        "focusin" !== e.type ||
                        ((n = 3e3),
                        $r.toggleClass(
                          this.elements.controls,
                          this.config.classNames.noTransition,
                          !0
                        ));
                  } else
                    i = $r.hasClass(
                      this.elements.container,
                      this.config.classNames.hideControls
                    );
                if (
                  (clearTimeout(this.timers.controls),
                  i || this.paused || this.loading)
                ) {
                  if (
                    ($r.toggleClass(
                      this.elements.container,
                      this.config.classNames.hideControls,
                      !1
                    ) &&
                      $r.dispatchEvent.call(this, this.media, "controlsshown"),
                    this.paused || this.loading)
                  )
                    return;
                  this.touch && (n = 3e3);
                }
                (i && !this.playing) ||
                  (this.timers.controls = setTimeout(function () {
                    $r.is.element(t.elements.controls) &&
                      ((!t.elements.controls.pressed &&
                        !t.elements.controls.hover) ||
                        r) &&
                      ($r.hasClass(
                        t.elements.container,
                        t.config.classNames.hideControls
                      ) ||
                        $r.toggleClass(
                          t.elements.controls,
                          t.config.classNames.noTransition,
                          !1
                        ),
                      $r.toggleClass(
                        t.elements.container,
                        t.config.classNames.hideControls,
                        !0
                      ) &&
                        ($r.dispatchEvent.call(t, t.media, "controlshidden"),
                        t.config.controls.includes("settings") &&
                          !$r.is.empty(t.config.settings) &&
                          us.toggleMenu.call(t, !1)));
                  }, n));
              }
            },
          },
          {
            key: "on",
            value: function (e, t) {
              $r.on(this.elements.container, e, t);
            },
          },
          {
            key: "off",
            value: function (e, t) {
              $r.off(this.elements.container, e, t);
            },
          },
          {
            key: "destroy",
            value: function (e) {
              var t = this,
                n =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1];
              if (this.ready) {
                var i = function () {
                  (document.body.style.overflow = ""),
                    (t.embed = null),
                    n
                      ? (Object.keys(t.elements).length &&
                          ($r.removeElement(t.elements.buttons.play),
                          $r.removeElement(t.elements.captions),
                          $r.removeElement(t.elements.controls),
                          $r.removeElement(t.elements.wrapper),
                          (t.elements.buttons.play = null),
                          (t.elements.captions = null),
                          (t.elements.controls = null),
                          (t.elements.wrapper = null)),
                        $r.is.function(e) && e())
                      : (t.listeners.clear(),
                        $r.replaceElement(
                          t.elements.original,
                          t.elements.container
                        ),
                        $r.dispatchEvent.call(
                          t,
                          t.elements.original,
                          "destroyed",
                          !0
                        ),
                        $r.is.function(e) && e.call(t.elements.original),
                        (t.ready = !1),
                        setTimeout(function () {
                          (t.elements = null), (t.media = null);
                        }, 200));
                };
                switch ((this.stop(), this.provider + ":" + this.type)) {
                  case "html5:video":
                  case "html5:audio":
                    clearTimeout(this.timers.loading),
                      as.toggleNativeControls.call(this, !0),
                      i();
                    break;
                  case "youtube:video":
                    clearInterval(this.timers.buffering),
                      clearInterval(this.timers.playing),
                      null !== this.embed &&
                        $r.is.function(this.embed.destroy) &&
                        this.embed.destroy(),
                      i();
                    break;
                  case "vimeo:video":
                    null !== this.embed && this.embed.unload().then(i),
                      setTimeout(i, 200);
                }
              }
            },
          },
          {
            key: "supports",
            value: function (e) {
              return Xr.mime.call(this, e);
            },
          },
          {
            key: "isHTML5",
            get: function () {
              return Boolean(this.provider === Hr.html5);
            },
          },
          {
            key: "isEmbed",
            get: function () {
              return Boolean(this.isYouTube || this.isVimeo);
            },
          },
          {
            key: "isYouTube",
            get: function () {
              return Boolean(this.provider === Hr.youtube);
            },
          },
          {
            key: "isVimeo",
            get: function () {
              return Boolean(this.provider === Hr.vimeo);
            },
          },
          {
            key: "isVideo",
            get: function () {
              return Boolean(this.type === Wr.video);
            },
          },
          {
            key: "isAudio",
            get: function () {
              return Boolean(this.type === Wr.audio);
            },
          },
          {
            key: "paused",
            get: function () {
              return Boolean(this.media.paused);
            },
          },
          {
            key: "playing",
            get: function () {
              return Boolean(
                !this.paused &&
                  !this.ended &&
                  (!this.isHTML5 || this.media.readyState > 2)
              );
            },
          },
          {
            key: "ended",
            get: function () {
              return Boolean(this.media.ended);
            },
          },
          {
            key: "currentTime",
            set: function (e) {
              var t = 0;
              $r.is.number(e) && (t = e),
                t < 0 ? (t = 0) : t > this.duration && (t = this.duration),
                (this.media.currentTime = parseFloat(t.toFixed(4))),
                this.debug.log("Seeking to " + this.currentTime + " seconds");
            },
            get: function () {
              return Number(this.media.currentTime);
            },
          },
          {
            key: "buffered",
            get: function () {
              var e = this.media.buffered;
              return $r.is.number(e)
                ? e
                : e && e.length && this.duration > 0
                ? e.end(0) / this.duration
                : 0;
            },
          },
          {
            key: "seeking",
            get: function () {
              return Boolean(this.media.seeking);
            },
          },
          {
            key: "duration",
            get: function () {
              var e = parseInt(this.config.duration, 10),
                t = this.media ? Number(this.media.duration) : 0;
              return Number.isNaN(e) ? t : e;
            },
          },
          {
            key: "volume",
            set: function (e) {
              var t = e;
              $r.is.string(t) && (t = Number(t)),
                $r.is.number(t) || (t = this.storage.get("volume")),
                $r.is.number(t) || (t = this.config.volume),
                t > 1 && (t = 1),
                t < 0 && (t = 0),
                (this.config.volume = t),
                (this.media.volume = t),
                !$r.is.empty(e) && this.muted && t > 0 && (this.muted = !1);
            },
            get: function () {
              return Number(this.media.volume);
            },
          },
          {
            key: "muted",
            set: function (e) {
              var t = e;
              $r.is.boolean(t) || (t = this.storage.get("muted")),
                $r.is.boolean(t) || (t = this.config.muted),
                (this.config.muted = t),
                (this.media.muted = t);
            },
            get: function () {
              return Boolean(this.media.muted);
            },
          },
          {
            key: "hasAudio",
            get: function () {
              return (
                !this.isHTML5 ||
                !!this.isAudio ||
                Boolean(this.media.mozHasAudio) ||
                Boolean(this.media.webkitAudioDecodedByteCount) ||
                Boolean(this.media.audioTracks && this.media.audioTracks.length)
              );
            },
          },
          {
            key: "speed",
            set: function (e) {
              var t = null;
              $r.is.number(e) && (t = e),
                $r.is.number(t) || (t = this.storage.get("speed")),
                $r.is.number(t) || (t = this.config.speed.selected),
                t < 0.1 && (t = 0.1),
                t > 2 && (t = 2),
                this.config.speed.options.includes(t)
                  ? ((this.config.speed.selected = t),
                    (this.media.playbackRate = t))
                  : this.debug.warn("Unsupported speed (" + t + ")");
            },
            get: function () {
              return Number(this.media.playbackRate);
            },
          },
          {
            key: "quality",
            set: function (e) {
              var t = null;
              if (
                ($r.is.empty(e) || (t = Number(e)),
                ($r.is.number(t) && 0 !== t) ||
                  (t = this.storage.get("quality")),
                $r.is.number(t) || (t = this.config.quality.selected),
                $r.is.number(t) || (t = this.config.quality.default),
                this.options.quality.length)
              ) {
                if (!this.options.quality.includes(t)) {
                  var n = $r.closest(this.options.quality, t);
                  this.debug.warn(
                    "Unsupported quality option: " +
                      t +
                      ", using " +
                      n +
                      " instead"
                  ),
                    (t = n);
                }
                (this.config.quality.selected = t), (this.media.quality = t);
              }
            },
            get: function () {
              return this.media.quality;
            },
          },
          {
            key: "loop",
            set: function (e) {
              var t = $r.is.boolean(e) ? e : this.config.loop.active;
              (this.config.loop.active = t), (this.media.loop = t);
            },
            get: function () {
              return Boolean(this.media.loop);
            },
          },
          {
            key: "source",
            set: function (e) {
              ws.change.call(this, e);
            },
            get: function () {
              return this.media.currentSrc;
            },
          },
          {
            key: "poster",
            set: function (e) {
              this.isHTML5 && this.isVideo
                ? $r.is.string(e) && this.media.setAttribute("poster", e)
                : this.debug.warn("Poster can only be set on HTML5 video");
            },
            get: function () {
              return this.isHTML5 && this.isVideo
                ? this.media.getAttribute("poster")
                : null;
            },
          },
          {
            key: "autoplay",
            set: function (e) {
              var t = $r.is.boolean(e) ? e : this.config.autoplay;
              this.config.autoplay = t;
            },
            get: function () {
              return Boolean(this.config.autoplay);
            },
          },
          {
            key: "language",
            set: function (e) {
              if (
                $r.is.string(e) &&
                (this.toggleCaptions(!$r.is.empty(e)), !$r.is.empty(e))
              ) {
                var t = e.toLowerCase();
                this.language !== t &&
                  ((this.captions.language = t),
                  ss.setText.call(this, null),
                  ss.setLanguage.call(this),
                  $r.dispatchEvent.call(this, this.media, "languagechange"));
              }
            },
            get: function () {
              return this.captions.language;
            },
          },
          {
            key: "pip",
            set: function (e) {
              var t = "picture-in-picture",
                n = "inline";
              if (Xr.pip) {
                var i = $r.is.boolean(e) ? e : this.pip === n;
                this.media.webkitSetPresentationMode(i ? t : n);
              }
            },
            get: function () {
              return Xr.pip ? this.media.webkitPresentationMode : null;
            },
          },
        ],
        [
          {
            key: "supported",
            value: function (e, t, n) {
              return Xr.check(e, t, n);
            },
          },
          {
            key: "loadSprite",
            value: function (e, t) {
              return $r.loadSprite(e, t);
            },
          },
        ]
      ),
      e
    );
  })();
});
//# sourceMappingURL=plyr.polyfilled.js.map

/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!(function (a, b, c, d) {
  function e(b, c) {
    (this.settings = null),
      (this.options = a.extend({}, e.Defaults, c)),
      (this.$element = a(b)),
      (this._handlers = {}),
      (this._plugins = {}),
      (this._supress = {}),
      (this._current = null),
      (this._speed = null),
      (this._coordinates = []),
      (this._breakpoint = null),
      (this._width = null),
      (this._items = []),
      (this._clones = []),
      (this._mergers = []),
      (this._widths = []),
      (this._invalidated = {}),
      (this._pipe = []),
      (this._drag = {
        time: null,
        target: null,
        pointer: null,
        stage: { start: null, current: null },
        direction: null,
      }),
      (this._states = {
        current: {},
        tags: {
          initializing: ["busy"],
          animating: ["busy"],
          dragging: ["interacting"],
        },
      }),
      a.each(
        ["onResize", "onThrottledResize"],
        a.proxy(function (b, c) {
          this._handlers[c] = a.proxy(this[c], this);
        }, this)
      ),
      a.each(
        e.Plugins,
        a.proxy(function (a, b) {
          this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
        }, this)
      ),
      a.each(
        e.Workers,
        a.proxy(function (b, c) {
          this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
        }, this)
      ),
      this.setup(),
      this.initialize();
  }
  (e.Defaults = {
    items: 3,
    loop: !1,
    center: !1,
    rewind: !1,
    checkVisibility: !0,
    mouseDrag: !0,
    touchDrag: !0,
    pullDrag: !0,
    freeDrag: !1,
    margin: 0,
    stagePadding: 0,
    merge: !1,
    mergeFit: !0,
    autoWidth: !1,
    startPosition: 0,
    rtl: !1,
    smartSpeed: 250,
    fluidSpeed: !1,
    dragEndSpeed: !1,
    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: b,
    fallbackEasing: "swing",
    slideTransition: "",
    info: !1,
    nestedItemSelector: !1,
    itemElement: "div",
    stageElement: "div",
    refreshClass: "owl-refresh",
    loadedClass: "owl-loaded",
    loadingClass: "owl-loading",
    rtlClass: "owl-rtl",
    responsiveClass: "owl-responsive",
    dragClass: "owl-drag",
    itemClass: "owl-item",
    stageClass: "owl-stage",
    stageOuterClass: "owl-stage-outer",
    grabClass: "owl-grab",
  }),
    (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
    (e.Type = { Event: "event", State: "state" }),
    (e.Plugins = {}),
    (e.Workers = [
      {
        filter: ["width", "settings"],
        run: function () {
          this._width = this.$element.width();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          a.current = this._items && this._items[this.relative(this._current)];
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          this.$stage.children(".cloned").remove();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this.settings.margin || "",
            c = !this.settings.autoWidth,
            d = this.settings.rtl,
            e = {
              width: "auto",
              "margin-left": d ? b : "",
              "margin-right": d ? "" : b,
            };
          !c && this.$stage.children().css(e), (a.css = e);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b =
              (this.width() / this.settings.items).toFixed(3) -
              this.settings.margin,
            c = null,
            d = this._items.length,
            e = !this.settings.autoWidth,
            f = [];
          for (a.items = { merge: !1, width: b }; d--; )
            (c = this._mergers[d]),
              (c =
                (this.settings.mergeFit && Math.min(c, this.settings.items)) ||
                c),
              (a.items.merge = c > 1 || a.items.merge),
              (f[d] = e ? b * c : this._items[d].width());
          this._widths = f;
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          var b = [],
            c = this._items,
            d = this.settings,
            e = Math.max(2 * d.items, 4),
            f = 2 * Math.ceil(c.length / 2),
            g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
            h = "",
            i = "";
          for (g /= 2; g > 0; )
            b.push(this.normalize(b.length / 2, !0)),
              (h += c[b[b.length - 1]][0].outerHTML),
              b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
              (i = c[b[b.length - 1]][0].outerHTML + i),
              (g -= 1);
          (this._clones = b),
            a(h).addClass("cloned").appendTo(this.$stage),
            a(i).addClass("cloned").prependTo(this.$stage);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          for (
            var a = this.settings.rtl ? 1 : -1,
              b = this._clones.length + this._items.length,
              c = -1,
              d = 0,
              e = 0,
              f = [];
            ++c < b;

          )
            (d = f[c - 1] || 0),
              (e = this._widths[this.relative(c)] + this.settings.margin),
              f.push(d + e * a);
          this._coordinates = f;
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          var a = this.settings.stagePadding,
            b = this._coordinates,
            c = {
              width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
              "padding-left": a || "",
              "padding-right": a || "",
            };
          this.$stage.css(c);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this._coordinates.length,
            c = !this.settings.autoWidth,
            d = this.$stage.children();
          if (c && a.items.merge)
            for (; b--; )
              (a.css.width = this._widths[this.relative(b)]),
                d.eq(b).css(a.css);
          else c && ((a.css.width = a.items.width), d.css(a.css));
        },
      },
      {
        filter: ["items"],
        run: function () {
          this._coordinates.length < 1 && this.$stage.removeAttr("style");
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          (a.current = a.current ? this.$stage.children().index(a.current) : 0),
            (a.current = Math.max(
              this.minimum(),
              Math.min(this.maximum(), a.current)
            )),
            this.reset(a.current);
        },
      },
      {
        filter: ["position"],
        run: function () {
          this.animate(this.coordinates(this._current));
        },
      },
      {
        filter: ["width", "position", "items", "settings"],
        run: function () {
          var a,
            b,
            c,
            d,
            e = this.settings.rtl ? 1 : -1,
            f = 2 * this.settings.stagePadding,
            g = this.coordinates(this.current()) + f,
            h = g + this.width() * e,
            i = [];
          for (c = 0, d = this._coordinates.length; c < d; c++)
            (a = this._coordinates[c - 1] || 0),
              (b = Math.abs(this._coordinates[c]) + f * e),
              ((this.op(a, "<=", g) && this.op(a, ">", h)) ||
                (this.op(b, "<", g) && this.op(b, ">", h))) &&
                i.push(c);
          this.$stage.children(".active").removeClass("active"),
            this.$stage
              .children(":eq(" + i.join("), :eq(") + ")")
              .addClass("active"),
            this.$stage.children(".center").removeClass("center"),
            this.settings.center &&
              this.$stage.children().eq(this.current()).addClass("center");
        },
      },
    ]),
    (e.prototype.initializeStage = function () {
      (this.$stage = this.$element.find("." + this.settings.stageClass)),
        this.$stage.length ||
          (this.$element.addClass(this.options.loadingClass),
          (this.$stage = a("<" + this.settings.stageElement + ">", {
            class: this.settings.stageClass,
          }).wrap(a("<div/>", { class: this.settings.stageOuterClass }))),
          this.$element.append(this.$stage.parent()));
    }),
    (e.prototype.initializeItems = function () {
      var b = this.$element.find(".owl-item");
      if (b.length)
        return (
          (this._items = b.get().map(function (b) {
            return a(b);
          })),
          (this._mergers = this._items.map(function () {
            return 1;
          })),
          void this.refresh()
        );
      this.replace(this.$element.children().not(this.$stage.parent())),
        this.isVisible() ? this.refresh() : this.invalidate("width"),
        this.$element
          .removeClass(this.options.loadingClass)
          .addClass(this.options.loadedClass);
    }),
    (e.prototype.initialize = function () {
      if (
        (this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading"))
      ) {
        var a, b, c;
        (a = this.$element.find("img")),
          (b = this.settings.nestedItemSelector
            ? "." + this.settings.nestedItemSelector
            : d),
          (c = this.$element.children(b).width()),
          a.length && c <= 0 && this.preloadAutoWidthImages(a);
      }
      this.initializeStage(),
        this.initializeItems(),
        this.registerEventHandlers(),
        this.leave("initializing"),
        this.trigger("initialized");
    }),
    (e.prototype.isVisible = function () {
      return !this.settings.checkVisibility || this.$element.is(":visible");
    }),
    (e.prototype.setup = function () {
      var b = this.viewport(),
        c = this.options.responsive,
        d = -1,
        e = null;
      c
        ? (a.each(c, function (a) {
            a <= b && a > d && (d = Number(a));
          }),
          (e = a.extend({}, this.options, c[d])),
          "function" == typeof e.stagePadding &&
            (e.stagePadding = e.stagePadding()),
          delete e.responsive,
          e.responsiveClass &&
            this.$element.attr(
              "class",
              this.$element
                .attr("class")
                .replace(
                  new RegExp(
                    "(" + this.options.responsiveClass + "-)\\S+\\s",
                    "g"
                  ),
                  "$1" + d
                )
            ))
        : (e = a.extend({}, this.options)),
        this.trigger("change", { property: { name: "settings", value: e } }),
        (this._breakpoint = d),
        (this.settings = e),
        this.invalidate("settings"),
        this.trigger("changed", {
          property: { name: "settings", value: this.settings },
        });
    }),
    (e.prototype.optionsLogic = function () {
      this.settings.autoWidth &&
        ((this.settings.stagePadding = !1), (this.settings.merge = !1));
    }),
    (e.prototype.prepare = function (b) {
      var c = this.trigger("prepare", { content: b });
      return (
        c.data ||
          (c.data = a("<" + this.settings.itemElement + "/>")
            .addClass(this.options.itemClass)
            .append(b)),
        this.trigger("prepared", { content: c.data }),
        c.data
      );
    }),
    (e.prototype.update = function () {
      for (
        var b = 0,
          c = this._pipe.length,
          d = a.proxy(function (a) {
            return this[a];
          }, this._invalidated),
          e = {};
        b < c;

      )
        (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) &&
          this._pipe[b].run(e),
          b++;
      (this._invalidated = {}), !this.is("valid") && this.enter("valid");
    }),
    (e.prototype.width = function (a) {
      switch ((a = a || e.Width.Default)) {
        case e.Width.Inner:
        case e.Width.Outer:
          return this._width;
        default:
          return (
            this._width - 2 * this.settings.stagePadding + this.settings.margin
          );
      }
    }),
    (e.prototype.refresh = function () {
      this.enter("refreshing"),
        this.trigger("refresh"),
        this.setup(),
        this.optionsLogic(),
        this.$element.addClass(this.options.refreshClass),
        this.update(),
        this.$element.removeClass(this.options.refreshClass),
        this.leave("refreshing"),
        this.trigger("refreshed");
    }),
    (e.prototype.onThrottledResize = function () {
      b.clearTimeout(this.resizeTimer),
        (this.resizeTimer = b.setTimeout(
          this._handlers.onResize,
          this.settings.responsiveRefreshRate
        ));
    }),
    (e.prototype.onResize = function () {
      return (
        !!this._items.length &&
        this._width !== this.$element.width() &&
        !!this.isVisible() &&
        (this.enter("resizing"),
        this.trigger("resize").isDefaultPrevented()
          ? (this.leave("resizing"), !1)
          : (this.invalidate("width"),
            this.refresh(),
            this.leave("resizing"),
            void this.trigger("resized")))
      );
    }),
    (e.prototype.registerEventHandlers = function () {
      a.support.transition &&
        this.$stage.on(
          a.support.transition.end + ".owl.core",
          a.proxy(this.onTransitionEnd, this)
        ),
        !1 !== this.settings.responsive &&
          this.on(b, "resize", this._handlers.onThrottledResize),
        this.settings.mouseDrag &&
          (this.$element.addClass(this.options.dragClass),
          this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
          this.$stage.on(
            "dragstart.owl.core selectstart.owl.core",
            function () {
              return !1;
            }
          )),
        this.settings.touchDrag &&
          (this.$stage.on(
            "touchstart.owl.core",
            a.proxy(this.onDragStart, this)
          ),
          this.$stage.on(
            "touchcancel.owl.core",
            a.proxy(this.onDragEnd, this)
          ));
    }),
    (e.prototype.onDragStart = function (b) {
      var d = null;
      3 !== b.which &&
        (a.support.transform
          ? ((d = this.$stage
              .css("transform")
              .replace(/.*\(|\)| /g, "")
              .split(",")),
            (d = {
              x: d[16 === d.length ? 12 : 4],
              y: d[16 === d.length ? 13 : 5],
            }))
          : ((d = this.$stage.position()),
            (d = {
              x: this.settings.rtl
                ? d.left +
                  this.$stage.width() -
                  this.width() +
                  this.settings.margin
                : d.left,
              y: d.top,
            })),
        this.is("animating") &&
          (a.support.transform ? this.animate(d.x) : this.$stage.stop(),
          this.invalidate("position")),
        this.$element.toggleClass(
          this.options.grabClass,
          "mousedown" === b.type
        ),
        this.speed(0),
        (this._drag.time = new Date().getTime()),
        (this._drag.target = a(b.target)),
        (this._drag.stage.start = d),
        (this._drag.stage.current = d),
        (this._drag.pointer = this.pointer(b)),
        a(c).on(
          "mouseup.owl.core touchend.owl.core",
          a.proxy(this.onDragEnd, this)
        ),
        a(c).one(
          "mousemove.owl.core touchmove.owl.core",
          a.proxy(function (b) {
            var d = this.difference(this._drag.pointer, this.pointer(b));
            a(c).on(
              "mousemove.owl.core touchmove.owl.core",
              a.proxy(this.onDragMove, this)
            ),
              (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) ||
                (b.preventDefault(),
                this.enter("dragging"),
                this.trigger("drag"));
          }, this)
        ));
    }),
    (e.prototype.onDragMove = function (a) {
      var b = null,
        c = null,
        d = null,
        e = this.difference(this._drag.pointer, this.pointer(a)),
        f = this.difference(this._drag.stage.start, e);
      this.is("dragging") &&
        (a.preventDefault(),
        this.settings.loop
          ? ((b = this.coordinates(this.minimum())),
            (c = this.coordinates(this.maximum() + 1) - b),
            (f.x = ((((f.x - b) % c) + c) % c) + b))
          : ((b = this.settings.rtl
              ? this.coordinates(this.maximum())
              : this.coordinates(this.minimum())),
            (c = this.settings.rtl
              ? this.coordinates(this.minimum())
              : this.coordinates(this.maximum())),
            (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
            (f.x = Math.max(Math.min(f.x, b + d), c + d))),
        (this._drag.stage.current = f),
        this.animate(f.x));
    }),
    (e.prototype.onDragEnd = function (b) {
      var d = this.difference(this._drag.pointer, this.pointer(b)),
        e = this._drag.stage.current,
        f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
      a(c).off(".owl.core"),
        this.$element.removeClass(this.options.grabClass),
        ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
          (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
          this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
          this.invalidate("position"),
          this.update(),
          (this._drag.direction = f),
          (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
            this._drag.target.one("click.owl.core", function () {
              return !1;
            })),
        this.is("dragging") &&
          (this.leave("dragging"), this.trigger("dragged"));
    }),
    (e.prototype.closest = function (b, c) {
      var e = -1,
        f = 30,
        g = this.width(),
        h = this.coordinates();
      return (
        this.settings.freeDrag ||
          a.each(
            h,
            a.proxy(function (a, i) {
              return (
                "left" === c && b > i - f && b < i + f
                  ? (e = a)
                  : "right" === c && b > i - g - f && b < i - g + f
                  ? (e = a + 1)
                  : this.op(b, "<", i) &&
                    this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) &&
                    (e = "left" === c ? a + 1 : a),
                -1 === e
              );
            }, this)
          ),
        this.settings.loop ||
          (this.op(b, ">", h[this.minimum()])
            ? (e = b = this.minimum())
            : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())),
        e
      );
    }),
    (e.prototype.animate = function (b) {
      var c = this.speed() > 0;
      this.is("animating") && this.onTransitionEnd(),
        c && (this.enter("animating"), this.trigger("translate")),
        a.support.transform3d && a.support.transition
          ? this.$stage.css({
              transform: "translate3d(" + b + "px,0px,0px)",
              transition:
                this.speed() / 1e3 +
                "s" +
                (this.settings.slideTransition
                  ? " " + this.settings.slideTransition
                  : ""),
            })
          : c
          ? this.$stage.animate(
              { left: b + "px" },
              this.speed(),
              this.settings.fallbackEasing,
              a.proxy(this.onTransitionEnd, this)
            )
          : this.$stage.css({ left: b + "px" });
    }),
    (e.prototype.is = function (a) {
      return this._states.current[a] && this._states.current[a] > 0;
    }),
    (e.prototype.current = function (a) {
      if (a === d) return this._current;
      if (0 === this._items.length) return d;
      if (((a = this.normalize(a)), this._current !== a)) {
        var b = this.trigger("change", {
          property: { name: "position", value: a },
        });
        b.data !== d && (a = this.normalize(b.data)),
          (this._current = a),
          this.invalidate("position"),
          this.trigger("changed", {
            property: { name: "position", value: this._current },
          });
      }
      return this._current;
    }),
    (e.prototype.invalidate = function (b) {
      return (
        "string" === a.type(b) &&
          ((this._invalidated[b] = !0),
          this.is("valid") && this.leave("valid")),
        a.map(this._invalidated, function (a, b) {
          return b;
        })
      );
    }),
    (e.prototype.reset = function (a) {
      (a = this.normalize(a)) !== d &&
        ((this._speed = 0),
        (this._current = a),
        this.suppress(["translate", "translated"]),
        this.animate(this.coordinates(a)),
        this.release(["translate", "translated"]));
    }),
    (e.prototype.normalize = function (a, b) {
      var c = this._items.length,
        e = b ? 0 : this._clones.length;
      return (
        !this.isNumeric(a) || c < 1
          ? (a = d)
          : (a < 0 || a >= c + e) &&
            (a = ((((a - e / 2) % c) + c) % c) + e / 2),
        a
      );
    }),
    (e.prototype.relative = function (a) {
      return (a -= this._clones.length / 2), this.normalize(a, !0);
    }),
    (e.prototype.maximum = function (a) {
      var b,
        c,
        d,
        e = this.settings,
        f = this._coordinates.length;
      if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
      else if (e.autoWidth || e.merge) {
        if ((b = this._items.length))
          for (
            c = this._items[--b].width(), d = this.$element.width();
            b-- && !((c += this._items[b].width() + this.settings.margin) > d);

          );
        f = b + 1;
      } else
        f = e.center ? this._items.length - 1 : this._items.length - e.items;
      return a && (f -= this._clones.length / 2), Math.max(f, 0);
    }),
    (e.prototype.minimum = function (a) {
      return a ? 0 : this._clones.length / 2;
    }),
    (e.prototype.items = function (a) {
      return a === d
        ? this._items.slice()
        : ((a = this.normalize(a, !0)), this._items[a]);
    }),
    (e.prototype.mergers = function (a) {
      return a === d
        ? this._mergers.slice()
        : ((a = this.normalize(a, !0)), this._mergers[a]);
    }),
    (e.prototype.clones = function (b) {
      var c = this._clones.length / 2,
        e = c + this._items.length,
        f = function (a) {
          return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2;
        };
      return b === d
        ? a.map(this._clones, function (a, b) {
            return f(b);
          })
        : a.map(this._clones, function (a, c) {
            return a === b ? f(c) : null;
          });
    }),
    (e.prototype.speed = function (a) {
      return a !== d && (this._speed = a), this._speed;
    }),
    (e.prototype.coordinates = function (b) {
      var c,
        e = 1,
        f = b - 1;
      return b === d
        ? a.map(
            this._coordinates,
            a.proxy(function (a, b) {
              return this.coordinates(b);
            }, this)
          )
        : (this.settings.center
            ? (this.settings.rtl && ((e = -1), (f = b + 1)),
              (c = this._coordinates[b]),
              (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
            : (c = this._coordinates[f] || 0),
          (c = Math.ceil(c)));
    }),
    (e.prototype.duration = function (a, b, c) {
      return 0 === c
        ? 0
        : Math.min(Math.max(Math.abs(b - a), 1), 6) *
            Math.abs(c || this.settings.smartSpeed);
    }),
    (e.prototype.to = function (a, b) {
      var c = this.current(),
        d = null,
        e = a - this.relative(c),
        f = (e > 0) - (e < 0),
        g = this._items.length,
        h = this.minimum(),
        i = this.maximum();
      this.settings.loop
        ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g),
          (a = c + e),
          (d = ((((a - h) % g) + g) % g) + h) !== a &&
            d - e <= i &&
            d - e > 0 &&
            ((c = d - e), (a = d), this.reset(c)))
        : this.settings.rewind
        ? ((i += 1), (a = ((a % i) + i) % i))
        : (a = Math.max(h, Math.min(i, a))),
        this.speed(this.duration(c, a, b)),
        this.current(a),
        this.isVisible() && this.update();
    }),
    (e.prototype.next = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) + 1, a);
    }),
    (e.prototype.prev = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) - 1, a);
    }),
    (e.prototype.onTransitionEnd = function (a) {
      if (
        a !== d &&
        (a.stopPropagation(),
        (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))
      )
        return !1;
      this.leave("animating"), this.trigger("translated");
    }),
    (e.prototype.viewport = function () {
      var d;
      return (
        this.options.responsiveBaseElement !== b
          ? (d = a(this.options.responsiveBaseElement).width())
          : b.innerWidth
          ? (d = b.innerWidth)
          : c.documentElement && c.documentElement.clientWidth
          ? (d = c.documentElement.clientWidth)
          : console.warn("Can not detect viewport width."),
        d
      );
    }),
    (e.prototype.replace = function (b) {
      this.$stage.empty(),
        (this._items = []),
        b && (b = b instanceof jQuery ? b : a(b)),
        this.settings.nestedItemSelector &&
          (b = b.find("." + this.settings.nestedItemSelector)),
        b
          .filter(function () {
            return 1 === this.nodeType;
          })
          .each(
            a.proxy(function (a, b) {
              (b = this.prepare(b)),
                this.$stage.append(b),
                this._items.push(b),
                this._mergers.push(
                  1 *
                    b
                      .find("[data-merge]")
                      .addBack("[data-merge]")
                      .attr("data-merge") || 1
                );
            }, this)
          ),
        this.reset(
          this.isNumeric(this.settings.startPosition)
            ? this.settings.startPosition
            : 0
        ),
        this.invalidate("items");
    }),
    (e.prototype.add = function (b, c) {
      var e = this.relative(this._current);
      (c = c === d ? this._items.length : this.normalize(c, !0)),
        (b = b instanceof jQuery ? b : a(b)),
        this.trigger("add", { content: b, position: c }),
        (b = this.prepare(b)),
        0 === this._items.length || c === this._items.length
          ? (0 === this._items.length && this.$stage.append(b),
            0 !== this._items.length && this._items[c - 1].after(b),
            this._items.push(b),
            this._mergers.push(
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            ))
          : (this._items[c].before(b),
            this._items.splice(c, 0, b),
            this._mergers.splice(
              c,
              0,
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            )),
        this._items[e] && this.reset(this._items[e].index()),
        this.invalidate("items"),
        this.trigger("added", { content: b, position: c });
    }),
    (e.prototype.remove = function (a) {
      (a = this.normalize(a, !0)) !== d &&
        (this.trigger("remove", { content: this._items[a], position: a }),
        this._items[a].remove(),
        this._items.splice(a, 1),
        this._mergers.splice(a, 1),
        this.invalidate("items"),
        this.trigger("removed", { content: null, position: a }));
    }),
    (e.prototype.preloadAutoWidthImages = function (b) {
      b.each(
        a.proxy(function (b, c) {
          this.enter("pre-loading"),
            (c = a(c)),
            a(new Image())
              .one(
                "load",
                a.proxy(function (a) {
                  c.attr("src", a.target.src),
                    c.css("opacity", 1),
                    this.leave("pre-loading"),
                    !this.is("pre-loading") &&
                      !this.is("initializing") &&
                      this.refresh();
                }, this)
              )
              .attr(
                "src",
                c.attr("src") || c.attr("data-src") || c.attr("data-src-retina")
              );
        }, this)
      );
    }),
    (e.prototype.destroy = function () {
      this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        a(c).off(".owl.core"),
        !1 !== this.settings.responsive &&
          (b.clearTimeout(this.resizeTimer),
          this.off(b, "resize", this._handlers.onThrottledResize));
      for (var d in this._plugins) this._plugins[d].destroy();
      this.$stage.children(".cloned").remove(),
        this.$stage.unwrap(),
        this.$stage.children().contents().unwrap(),
        this.$stage.children().unwrap(),
        this.$stage.remove(),
        this.$element
          .removeClass(this.options.refreshClass)
          .removeClass(this.options.loadingClass)
          .removeClass(this.options.loadedClass)
          .removeClass(this.options.rtlClass)
          .removeClass(this.options.dragClass)
          .removeClass(this.options.grabClass)
          .attr(
            "class",
            this.$element
              .attr("class")
              .replace(
                new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"),
                ""
              )
          )
          .removeData("owl.carousel");
    }),
    (e.prototype.op = function (a, b, c) {
      var d = this.settings.rtl;
      switch (b) {
        case "<":
          return d ? a > c : a < c;
        case ">":
          return d ? a < c : a > c;
        case ">=":
          return d ? a <= c : a >= c;
        case "<=":
          return d ? a >= c : a <= c;
      }
    }),
    (e.prototype.on = function (a, b, c, d) {
      a.addEventListener
        ? a.addEventListener(b, c, d)
        : a.attachEvent && a.attachEvent("on" + b, c);
    }),
    (e.prototype.off = function (a, b, c, d) {
      a.removeEventListener
        ? a.removeEventListener(b, c, d)
        : a.detachEvent && a.detachEvent("on" + b, c);
    }),
    (e.prototype.trigger = function (b, c, d, f, g) {
      var h = { item: { count: this._items.length, index: this.current() } },
        i = a.camelCase(
          a
            .grep(["on", b, d], function (a) {
              return a;
            })
            .join("-")
            .toLowerCase()
        ),
        j = a.Event(
          [b, "owl", d || "carousel"].join(".").toLowerCase(),
          a.extend({ relatedTarget: this }, h, c)
        );
      return (
        this._supress[b] ||
          (a.each(this._plugins, function (a, b) {
            b.onTrigger && b.onTrigger(j);
          }),
          this.register({ type: e.Type.Event, name: b }),
          this.$element.trigger(j),
          this.settings &&
            "function" == typeof this.settings[i] &&
            this.settings[i].call(this, j)),
        j
      );
    }),
    (e.prototype.enter = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b] === d && (this._states.current[b] = 0),
            this._states.current[b]++;
        }, this)
      );
    }),
    (e.prototype.leave = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b]--;
        }, this)
      );
    }),
    (e.prototype.register = function (b) {
      if (b.type === e.Type.Event) {
        if (
          (a.event.special[b.name] || (a.event.special[b.name] = {}),
          !a.event.special[b.name].owl)
        ) {
          var c = a.event.special[b.name]._default;
          (a.event.special[b.name]._default = function (a) {
            return !c ||
              !c.apply ||
              (a.namespace && -1 !== a.namespace.indexOf("owl"))
              ? a.namespace && a.namespace.indexOf("owl") > -1
              : c.apply(this, arguments);
          }),
            (a.event.special[b.name].owl = !0);
        }
      } else
        b.type === e.Type.State &&
          (this._states.tags[b.name]
            ? (this._states.tags[b.name] = this._states.tags[b.name].concat(
                b.tags
              ))
            : (this._states.tags[b.name] = b.tags),
          (this._states.tags[b.name] = a.grep(
            this._states.tags[b.name],
            a.proxy(function (c, d) {
              return a.inArray(c, this._states.tags[b.name]) === d;
            }, this)
          )));
    }),
    (e.prototype.suppress = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          this._supress[b] = !0;
        }, this)
      );
    }),
    (e.prototype.release = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          delete this._supress[b];
        }, this)
      );
    }),
    (e.prototype.pointer = function (a) {
      var c = { x: null, y: null };
      return (
        (a = a.originalEvent || a || b.event),
        (a =
          a.touches && a.touches.length
            ? a.touches[0]
            : a.changedTouches && a.changedTouches.length
            ? a.changedTouches[0]
            : a),
        a.pageX
          ? ((c.x = a.pageX), (c.y = a.pageY))
          : ((c.x = a.clientX), (c.y = a.clientY)),
        c
      );
    }),
    (e.prototype.isNumeric = function (a) {
      return !isNaN(parseFloat(a));
    }),
    (e.prototype.difference = function (a, b) {
      return { x: a.x - b.x, y: a.y - b.y };
    }),
    (a.fn.owlCarousel = function (b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return this.each(function () {
        var d = a(this),
          f = d.data("owl.carousel");
        f ||
          ((f = new e(this, "object" == typeof b && b)),
          d.data("owl.carousel", f),
          a.each(
            [
              "next",
              "prev",
              "to",
              "destroy",
              "refresh",
              "replace",
              "add",
              "remove",
            ],
            function (b, c) {
              f.register({ type: e.Type.Event, name: c }),
                f.$element.on(
                  c + ".owl.carousel.core",
                  a.proxy(function (a) {
                    a.namespace &&
                      a.relatedTarget !== this &&
                      (this.suppress([c]),
                      f[c].apply(this, [].slice.call(arguments, 1)),
                      this.release([c]));
                  }, f)
                );
            }
          )),
          "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
      });
    }),
    (a.fn.owlCarousel.Constructor = e);
})(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._interval = null),
        (this._visible = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoRefresh && this.watch();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
      (e.prototype.watch = function () {
        this._interval ||
          ((this._visible = this._core.isVisible()),
          (this._interval = b.setInterval(
            a.proxy(this.refresh, this),
            this._core.settings.autoRefreshInterval
          )));
      }),
      (e.prototype.refresh = function () {
        this._core.isVisible() !== this._visible &&
          ((this._visible = !this._visible),
          this._core.$element.toggleClass("owl-hidden", !this._visible),
          this._visible &&
            this._core.invalidate("width") &&
            this._core.refresh());
      }),
      (e.prototype.destroy = function () {
        var a, c;
        b.clearInterval(this._interval);
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._loaded = []),
        (this._handlers = {
          "initialized.owl.carousel change.owl.carousel resized.owl.carousel":
            a.proxy(function (b) {
              if (
                b.namespace &&
                this._core.settings &&
                this._core.settings.lazyLoad &&
                ((b.property && "position" == b.property.name) ||
                  "initialized" == b.type)
              ) {
                var c = this._core.settings,
                  e = (c.center && Math.ceil(c.items / 2)) || c.items,
                  f = (c.center && -1 * e) || 0,
                  g =
                    (b.property && b.property.value !== d
                      ? b.property.value
                      : this._core.current()) + f,
                  h = this._core.clones().length,
                  i = a.proxy(function (a, b) {
                    this.load(b);
                  }, this);
                for (
                  c.lazyLoadEager > 0 &&
                  ((e += c.lazyLoadEager),
                  c.loop && ((g -= c.lazyLoadEager), e++));
                  f++ < e;

                )
                  this.load(h / 2 + this._core.relative(g)),
                    h && a.each(this._core.clones(this._core.relative(g)), i),
                    g++;
              }
            }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
      (e.prototype.load = function (c) {
        var d = this._core.$stage.children().eq(c),
          e = d && d.find(".owl-lazy");
        !e ||
          a.inArray(d.get(0), this._loaded) > -1 ||
          (e.each(
            a.proxy(function (c, d) {
              var e,
                f = a(d),
                g =
                  (b.devicePixelRatio > 1 && f.attr("data-src-retina")) ||
                  f.attr("data-src") ||
                  f.attr("data-srcset");
              this._core.trigger("load", { element: f, url: g }, "lazy"),
                f.is("img")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          f.css("opacity", 1),
                            this._core.trigger(
                              "loaded",
                              { element: f, url: g },
                              "lazy"
                            );
                        }, this)
                      )
                      .attr("src", g)
                  : f.is("source")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          this._core.trigger(
                            "loaded",
                            { element: f, url: g },
                            "lazy"
                          );
                        }, this)
                      )
                      .attr("srcset", g)
                  : ((e = new Image()),
                    (e.onload = a.proxy(function () {
                      f.css({
                        "background-image": 'url("' + g + '")',
                        opacity: "1",
                      }),
                        this._core.trigger(
                          "loaded",
                          { element: f, url: g },
                          "lazy"
                        );
                    }, this)),
                    (e.src = g));
            }, this)
          ),
          this._loaded.push(d.get(0)));
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (c) {
      (this._core = c),
        (this._previousHeight = null),
        (this._handlers = {
          "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (
            a
          ) {
            a.namespace && this._core.settings.autoHeight && this.update();
          },
          this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              "position" === a.property.name &&
              this.update();
          }, this),
          "loaded.owl.lazy": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              a.element.closest("." + this._core.settings.itemClass).index() ===
                this._core.current() &&
              this.update();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        (this._intervalId = null);
      var d = this;
      a(b).on("load", function () {
        d._core.settings.autoHeight && d.update();
      }),
        a(b).resize(function () {
          d._core.settings.autoHeight &&
            (null != d._intervalId && clearTimeout(d._intervalId),
            (d._intervalId = setTimeout(function () {
              d.update();
            }, 250)));
        });
    };
    (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
      (e.prototype.update = function () {
        var b = this._core._current,
          c = b + this._core.settings.items,
          d = this._core.settings.lazyLoad,
          e = this._core.$stage.children().toArray().slice(b, c),
          f = [],
          g = 0;
        a.each(e, function (b, c) {
          f.push(a(c).height());
        }),
          (g = Math.max.apply(null, f)),
          g <= 1 && d && this._previousHeight && (g = this._previousHeight),
          (this._previousHeight = g),
          this._core.$stage
            .parent()
            .height(g)
            .addClass(this._core.settings.autoHeightClass);
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._videos = {}),
        (this._playing = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.register({
                type: "state",
                name: "playing",
                tags: ["interacting"],
              });
          }, this),
          "resize.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.video &&
              this.isInFullScreen() &&
              a.preventDefault();
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.is("resizing") &&
              this._core.$stage.find(".cloned .owl-video-frame").remove();
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" === a.property.name &&
              this._playing &&
              this.stop();
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content).find(".owl-video");
              c.length &&
                (c.css("display", "none"), this.fetch(c, a(b.content)));
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        this._core.$element.on(
          "click.owl.video",
          ".owl-video-play-icon",
          a.proxy(function (a) {
            this.play(a);
          }, this)
        );
    };
    (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
      (e.prototype.fetch = function (a, b) {
        var c = (function () {
            return a.attr("data-vimeo-id")
              ? "vimeo"
              : a.attr("data-vzaar-id")
              ? "vzaar"
              : "youtube";
          })(),
          d =
            a.attr("data-vimeo-id") ||
            a.attr("data-youtube-id") ||
            a.attr("data-vzaar-id"),
          e = a.attr("data-width") || this._core.settings.videoWidth,
          f = a.attr("data-height") || this._core.settings.videoHeight,
          g = a.attr("href");
        if (!g) throw new Error("Missing video URL.");
        if (
          ((d = g.match(
            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
          )),
          d[3].indexOf("youtu") > -1)
        )
          c = "youtube";
        else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
        else {
          if (!(d[3].indexOf("vzaar") > -1))
            throw new Error("Video URL not supported.");
          c = "vzaar";
        }
        (d = d[6]),
          (this._videos[g] = { type: c, id: d, width: e, height: f }),
          b.attr("data-video", g),
          this.thumbnail(a, this._videos[g]);
      }),
      (e.prototype.thumbnail = function (b, c) {
        var d,
          e,
          f,
          g =
            c.width && c.height
              ? "width:" + c.width + "px;height:" + c.height + "px;"
              : "",
          h = b.find("img"),
          i = "src",
          j = "",
          k = this._core.settings,
          l = function (c) {
            (e = '<div class="owl-video-play-icon"></div>'),
              (d = k.lazyLoad
                ? a("<div/>", { class: "owl-video-tn " + j, srcType: c })
                : a("<div/>", {
                    class: "owl-video-tn",
                    style: "opacity:1;background-image:url(" + c + ")",
                  })),
              b.after(d),
              b.after(e);
          };
        if (
          (b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })),
          this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")),
          h.length)
        )
          return l(h.attr(i)), h.remove(), !1;
        "youtube" === c.type
          ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
          : "vimeo" === c.type
          ? a.ajax({
              type: "GET",
              url: "//vimeo.com/api/v2/video/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                (f = a[0].thumbnail_large), l(f);
              },
            })
          : "vzaar" === c.type &&
            a.ajax({
              type: "GET",
              url: "//vzaar.com/api/videos/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                (f = a.framegrab_url), l(f);
              },
            });
      }),
      (e.prototype.stop = function () {
        this._core.trigger("stop", null, "video"),
          this._playing.find(".owl-video-frame").remove(),
          this._playing.removeClass("owl-video-playing"),
          (this._playing = null),
          this._core.leave("playing"),
          this._core.trigger("stopped", null, "video");
      }),
      (e.prototype.play = function (b) {
        var c,
          d = a(b.target),
          e = d.closest("." + this._core.settings.itemClass),
          f = this._videos[e.attr("data-video")],
          g = f.width || "100%",
          h = f.height || this._core.$stage.height();
        this._playing ||
          (this._core.enter("playing"),
          this._core.trigger("play", null, "video"),
          (e = this._core.items(this._core.relative(e.index()))),
          this._core.reset(e.index()),
          (c = a(
            '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
          )),
          c.attr("height", h),
          c.attr("width", g),
          "youtube" === f.type
            ? c.attr(
                "src",
                "//www.youtube.com/embed/" +
                  f.id +
                  "?autoplay=1&rel=0&v=" +
                  f.id
              )
            : "vimeo" === f.type
            ? c.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1")
            : "vzaar" === f.type &&
              c.attr(
                "src",
                "//view.vzaar.com/" + f.id + "/player?autoplay=true"
              ),
          a(c)
            .wrap('<div class="owl-video-frame" />')
            .insertAfter(e.find(".owl-video")),
          (this._playing = e.addClass("owl-video-playing")));
      }),
      (e.prototype.isInFullScreen = function () {
        var b =
          c.fullscreenElement ||
          c.mozFullScreenElement ||
          c.webkitFullscreenElement;
        return b && a(b).parent().hasClass("owl-video-frame");
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this._core.$element.off("click.owl.video");
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Video = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this.core = b),
        (this.core.options = a.extend({}, e.Defaults, this.core.options)),
        (this.swapping = !0),
        (this.previous = d),
        (this.next = d),
        (this.handlers = {
          "change.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" == a.property.name &&
              ((this.previous = this.core.current()),
              (this.next = a.property.value));
          }, this),
          "drag.owl.carousel dragged.owl.carousel translated.owl.carousel":
            a.proxy(function (a) {
              a.namespace && (this.swapping = "translated" == a.type);
            }, this),
          "translate.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this.swapping &&
              (this.core.options.animateOut || this.core.options.animateIn) &&
              this.swap();
          }, this),
        }),
        this.core.$element.on(this.handlers);
    };
    (e.Defaults = { animateOut: !1, animateIn: !1 }),
      (e.prototype.swap = function () {
        if (
          1 === this.core.settings.items &&
          a.support.animation &&
          a.support.transition
        ) {
          this.core.speed(0);
          var b,
            c = a.proxy(this.clear, this),
            d = this.core.$stage.children().eq(this.previous),
            e = this.core.$stage.children().eq(this.next),
            f = this.core.settings.animateIn,
            g = this.core.settings.animateOut;
          this.core.current() !== this.previous &&
            (g &&
              ((b =
                this.core.coordinates(this.previous) -
                this.core.coordinates(this.next)),
              d
                .one(a.support.animation.end, c)
                .css({ left: b + "px" })
                .addClass("animated owl-animated-out")
                .addClass(g)),
            f &&
              e
                .one(a.support.animation.end, c)
                .addClass("animated owl-animated-in")
                .addClass(f));
        }
      }),
      (e.prototype.clear = function (b) {
        a(b.target)
          .css({ left: "" })
          .removeClass("animated owl-animated-out owl-animated-in")
          .removeClass(this.core.settings.animateIn)
          .removeClass(this.core.settings.animateOut),
          this.core.onTransitionEnd();
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._call = null),
        (this._time = 0),
        (this._timeout = 0),
        (this._paused = !0),
        (this._handlers = {
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "settings" === a.property.name
              ? this._core.settings.autoplay
                ? this.play()
                : this.stop()
              : a.namespace &&
                "position" === a.property.name &&
                this._paused &&
                (this._time = 0);
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoplay && this.play();
          }, this),
          "play.owl.autoplay": a.proxy(function (a, b, c) {
            a.namespace && this.play(b, c);
          }, this),
          "stop.owl.autoplay": a.proxy(function (a) {
            a.namespace && this.stop();
          }, this),
          "mouseover.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "mouseleave.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.play();
          }, this),
          "touchstart.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "touchend.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this.play();
          }, this),
        }),
        this._core.$element.on(this._handlers),
        (this._core.options = a.extend({}, e.Defaults, this._core.options));
    };
    (e.Defaults = {
      autoplay: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !1,
      autoplaySpeed: !1,
    }),
      (e.prototype._next = function (d) {
        (this._call = b.setTimeout(
          a.proxy(this._next, this, d),
          this._timeout * (Math.round(this.read() / this._timeout) + 1) -
            this.read()
        )),
          this._core.is("interacting") ||
            c.hidden ||
            this._core.next(d || this._core.settings.autoplaySpeed);
      }),
      (e.prototype.read = function () {
        return new Date().getTime() - this._time;
      }),
      (e.prototype.play = function (c, d) {
        var e;
        this._core.is("rotating") || this._core.enter("rotating"),
          (c = c || this._core.settings.autoplayTimeout),
          (e = Math.min(this._time % (this._timeout || c), c)),
          this._paused
            ? ((this._time = this.read()), (this._paused = !1))
            : b.clearTimeout(this._call),
          (this._time += (this.read() % c) - e),
          (this._timeout = c),
          (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e));
      }),
      (e.prototype.stop = function () {
        this._core.is("rotating") &&
          ((this._time = 0),
          (this._paused = !0),
          b.clearTimeout(this._call),
          this._core.leave("rotating"));
      }),
      (e.prototype.pause = function () {
        this._core.is("rotating") &&
          !this._paused &&
          ((this._time = this.read()),
          (this._paused = !0),
          b.clearTimeout(this._call));
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this.stop();
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (b) {
      (this._core = b),
        (this._initialized = !1),
        (this._pages = []),
        (this._controls = {}),
        (this._templates = []),
        (this.$element = this._core.$element),
        (this._overrides = {
          next: this._core.next,
          prev: this._core.prev,
          to: this._core.to,
        }),
        (this._handlers = {
          "prepared.owl.carousel": a.proxy(function (b) {
            b.namespace &&
              this._core.settings.dotsData &&
              this._templates.push(
                '<div class="' +
                  this._core.settings.dotClass +
                  '">' +
                  a(b.content)
                    .find("[data-dot]")
                    .addBack("[data-dot]")
                    .attr("data-dot") +
                  "</div>"
              );
          }, this),
          "added.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 0, this._templates.pop());
          }, this),
          "remove.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 1);
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "position" == a.property.name && this.draw();
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              !this._initialized &&
              (this._core.trigger("initialize", null, "navigation"),
              this.initialize(),
              this.update(),
              this.draw(),
              (this._initialized = !0),
              this._core.trigger("initialized", null, "navigation"));
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._initialized &&
              (this._core.trigger("refresh", null, "navigation"),
              this.update(),
              this.draw(),
              this._core.trigger("refreshed", null, "navigation"));
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers);
    };
    (e.Defaults = {
      nav: !1,
      navText: [
        '<span aria-label="Previous">&#x2039;</span>',
        '<span aria-label="Next">&#x203a;</span>',
      ],
      navSpeed: !1,
      navElement: 'button type="button" role="presentation"',
      navContainer: !1,
      navContainerClass: "owl-nav",
      navClass: ["owl-prev", "owl-next"],
      slideBy: 1,
      dotClass: "owl-dot",
      dotsClass: "owl-dots",
      dots: !0,
      dotsEach: !1,
      dotsData: !1,
      dotsSpeed: !1,
      dotsContainer: !1,
    }),
      (e.prototype.initialize = function () {
        var b,
          c = this._core.settings;
        (this._controls.$relative = (
          c.navContainer
            ? a(c.navContainer)
            : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)
        ).addClass("disabled")),
          (this._controls.$previous = a("<" + c.navElement + ">")
            .addClass(c.navClass[0])
            .html(c.navText[0])
            .prependTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.prev(c.navSpeed);
              }, this)
            )),
          (this._controls.$next = a("<" + c.navElement + ">")
            .addClass(c.navClass[1])
            .html(c.navText[1])
            .appendTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.next(c.navSpeed);
              }, this)
            )),
          c.dotsData ||
            (this._templates = [
              a('<button role="button">')
                .addClass(c.dotClass)
                .append(a("<span>"))
                .prop("outerHTML"),
            ]),
          (this._controls.$absolute = (
            c.dotsContainer
              ? a(c.dotsContainer)
              : a("<div>").addClass(c.dotsClass).appendTo(this.$element)
          ).addClass("disabled")),
          this._controls.$absolute.on(
            "click",
            "button",
            a.proxy(function (b) {
              var d = a(b.target).parent().is(this._controls.$absolute)
                ? a(b.target).index()
                : a(b.target).parent().index();
              b.preventDefault(), this.to(d, c.dotsSpeed);
            }, this)
          );
        for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
      }),
      (e.prototype.destroy = function () {
        var a, b, c, d, e;
        e = this._core.settings;
        for (a in this._handlers) this.$element.off(a, this._handlers[a]);
        for (b in this._controls)
          "$relative" === b && e.navContainer
            ? this._controls[b].html("")
            : this._controls[b].remove();
        for (d in this.overides) this._core[d] = this._overrides[d];
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (e.prototype.update = function () {
        var a,
          b,
          c,
          d = this._core.clones().length / 2,
          e = d + this._core.items().length,
          f = this._core.maximum(!0),
          g = this._core.settings,
          h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
        if (
          ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)),
          g.dots || "page" == g.slideBy)
        )
          for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
            if (b >= h || 0 === b) {
              if (
                (this._pages.push({
                  start: Math.min(f, a - d),
                  end: a - d + h - 1,
                }),
                Math.min(f, a - d) === f)
              )
                break;
              (b = 0), ++c;
            }
            b += this._core.mergers(this._core.relative(a));
          }
      }),
      (e.prototype.draw = function () {
        var b,
          c = this._core.settings,
          d = this._core.items().length <= c.items,
          e = this._core.relative(this._core.current()),
          f = c.loop || c.rewind;
        this._controls.$relative.toggleClass("disabled", !c.nav || d),
          c.nav &&
            (this._controls.$previous.toggleClass(
              "disabled",
              !f && e <= this._core.minimum(!0)
            ),
            this._controls.$next.toggleClass(
              "disabled",
              !f && e >= this._core.maximum(!0)
            )),
          this._controls.$absolute.toggleClass("disabled", !c.dots || d),
          c.dots &&
            ((b =
              this._pages.length - this._controls.$absolute.children().length),
            c.dotsData && 0 !== b
              ? this._controls.$absolute.html(this._templates.join(""))
              : b > 0
              ? this._controls.$absolute.append(
                  new Array(b + 1).join(this._templates[0])
                )
              : b < 0 && this._controls.$absolute.children().slice(b).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute
              .children()
              .eq(a.inArray(this.current(), this._pages))
              .addClass("active"));
      }),
      (e.prototype.onTrigger = function (b) {
        var c = this._core.settings;
        b.page = {
          index: a.inArray(this.current(), this._pages),
          count: this._pages.length,
          size:
            c &&
            (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items),
        };
      }),
      (e.prototype.current = function () {
        var b = this._core.relative(this._core.current());
        return a
          .grep(
            this._pages,
            a.proxy(function (a, c) {
              return a.start <= b && a.end >= b;
            }, this)
          )
          .pop();
      }),
      (e.prototype.getPosition = function (b) {
        var c,
          d,
          e = this._core.settings;
        return (
          "page" == e.slideBy
            ? ((c = a.inArray(this.current(), this._pages)),
              (d = this._pages.length),
              b ? ++c : --c,
              (c = this._pages[((c % d) + d) % d].start))
            : ((c = this._core.relative(this._core.current())),
              (d = this._core.items().length),
              b ? (c += e.slideBy) : (c -= e.slideBy)),
          c
        );
      }),
      (e.prototype.next = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
      }),
      (e.prototype.prev = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
      }),
      (e.prototype.to = function (b, c, d) {
        var e;
        !d && this._pages.length
          ? ((e = this._pages.length),
            a.proxy(this._overrides.to, this._core)(
              this._pages[((b % e) + e) % e].start,
              c
            ))
          : a.proxy(this._overrides.to, this._core)(b, c);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (c) {
      (this._core = c),
        (this._hashes = {}),
        (this.$element = this._core.$element),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (c) {
            c.namespace &&
              "URLHash" === this._core.settings.startPosition &&
              a(b).trigger("hashchange.owl.navigation");
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content)
                .find("[data-hash]")
                .addBack("[data-hash]")
                .attr("data-hash");
              if (!c) return;
              this._hashes[c] = b.content;
            }
          }, this),
          "changed.owl.carousel": a.proxy(function (c) {
            if (c.namespace && "position" === c.property.name) {
              var d = this._core.items(
                  this._core.relative(this._core.current())
                ),
                e = a
                  .map(this._hashes, function (a, b) {
                    return a === d ? b : null;
                  })
                  .join();
              if (!e || b.location.hash.slice(1) === e) return;
              b.location.hash = e;
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers),
        a(b).on(
          "hashchange.owl.navigation",
          a.proxy(function (a) {
            var c = b.location.hash.substring(1),
              e = this._core.$stage.children(),
              f = this._hashes[c] && e.index(this._hashes[c]);
            f !== d &&
              f !== this._core.current() &&
              this._core.to(this._core.relative(f), !1, !0);
          }, this)
        );
    };
    (e.Defaults = { URLhashListener: !1 }),
      (e.prototype.destroy = function () {
        var c, d;
        a(b).off("hashchange.owl.navigation");
        for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
        for (d in Object.getOwnPropertyNames(this))
          "function" != typeof this[d] && (this[d] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    function e(b, c) {
      var e = !1,
        f = b.charAt(0).toUpperCase() + b.slice(1);
      return (
        a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
          if (g[b] !== d) return (e = !c || b), !1;
        }),
        e
      );
    }
    function f(a) {
      return e(a, !0);
    }
    var g = a("<support>").get(0).style,
      h = "Webkit Moz O ms".split(" "),
      i = {
        transition: {
          end: {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            transition: "transitionend",
          },
        },
        animation: {
          end: {
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "animationend",
            OAnimation: "oAnimationEnd",
            animation: "animationend",
          },
        },
      },
      j = {
        csstransforms: function () {
          return !!e("transform");
        },
        csstransforms3d: function () {
          return !!e("perspective");
        },
        csstransitions: function () {
          return !!e("transition");
        },
        cssanimations: function () {
          return !!e("animation");
        },
      };
    j.csstransitions() &&
      ((a.support.transition = new String(f("transition"))),
      (a.support.transition.end = i.transition.end[a.support.transition])),
      j.cssanimations() &&
        ((a.support.animation = new String(f("animation"))),
        (a.support.animation.end = i.animation.end[a.support.animation])),
      j.csstransforms() &&
        ((a.support.transform = new String(f("transform"))),
        (a.support.transform3d = j.csstransforms3d()));
  })(window.Zepto || window.jQuery, window, document);

// ==================================================
// fancyBox v3.5.7
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2019 fancyApps
//
// ==================================================
!(function (t, e, n, o) {
  "use strict";
  function i(t, e) {
    var o,
      i,
      a,
      s = [],
      r = 0;
    (t && t.isDefaultPrevented()) ||
      (t.preventDefault(),
      (e = e || {}),
      t && t.data && (e = h(t.data.options, e)),
      (o = e.$target || n(t.currentTarget).trigger("blur")),
      ((a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o)) ||
        (e.selector
          ? (s = n(e.selector))
          : ((i = o.attr("data-fancybox") || ""),
            i
              ? ((s = t.data ? t.data.items : []),
                (s = s.length
                  ? s.filter('[data-fancybox="' + i + '"]')
                  : n('[data-fancybox="' + i + '"]')))
              : (s = [o])),
        (r = n(s).index(o)),
        r < 0 && (r = 0),
        (a = n.fancybox.open(s, e, r)),
        (a.$trigger = o)));
  }
  if (((t.console = t.console || { info: function (t) {} }), n)) {
    if (n.fn.fancybox) return void console.info("fancyBox already initialized");
    var a = {
        closeExisting: !1,
        loop: !1,
        gutter: 50,
        keyboard: !0,
        preventCaptionOverlap: !0,
        arrows: !0,
        infobar: !0,
        smallBtn: "auto",
        toolbar: "auto",
        buttons: ["zoom", "slideShow", "thumbs", "close"],
        idleTime: 3,
        protect: !1,
        modal: !1,
        image: { preload: !1 },
        ajax: { settings: { data: { fancybox: !0 } } },
        iframe: {
          tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
          preload: !0,
          css: {},
          attr: { scrolling: "auto" },
        },
        video: {
          tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
          format: "",
          autoStart: !0,
        },
        defaultType: "image",
        animationEffect: "zoom",
        animationDuration: 366,
        zoomOpacity: "auto",
        transitionEffect: "fade",
        transitionDuration: 366,
        slideClass: "",
        baseClass: "",
        baseTpl:
          '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
        spinnerTpl: '<div class="fancybox-loading"></div>',
        errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
        btnTpl: {
          download:
            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
          zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
          close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
          smallBtn:
            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
        },
        parentEl: "body",
        hideScrollbar: !0,
        autoFocus: !0,
        backFocus: !0,
        trapFocus: !0,
        fullScreen: { autoStart: !1 },
        touch: { vertical: !0, momentum: !0 },
        hash: null,
        media: {},
        slideShow: { autoStart: !1, speed: 3e3 },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
        wheel: "auto",
        onInit: n.noop,
        beforeLoad: n.noop,
        afterLoad: n.noop,
        beforeShow: n.noop,
        afterShow: n.noop,
        beforeClose: n.noop,
        afterClose: n.noop,
        onActivate: n.noop,
        onDeactivate: n.noop,
        clickContent: function (t, e) {
          return "image" === t.type && "zoom";
        },
        clickSlide: "close",
        clickOutside: "close",
        dblclickContent: !1,
        dblclickSlide: !1,
        dblclickOutside: !1,
        mobile: {
          preventCaptionOverlap: !1,
          idleTime: !1,
          clickContent: function (t, e) {
            return "image" === t.type && "toggleControls";
          },
          clickSlide: function (t, e) {
            return "image" === t.type ? "toggleControls" : "close";
          },
          dblclickContent: function (t, e) {
            return "image" === t.type && "zoom";
          },
          dblclickSlide: function (t, e) {
            return "image" === t.type && "zoom";
          },
        },
        lang: "en",
        i18n: {
          en: {
            CLOSE: "Close",
            NEXT: "Next",
            PREV: "Previous",
            ERROR:
              "The requested content cannot be loaded. <br/> Please try again later.",
            PLAY_START: "Start slideshow",
            PLAY_STOP: "Pause slideshow",
            FULL_SCREEN: "Full screen",
            THUMBS: "Thumbnails",
            DOWNLOAD: "Download",
            SHARE: "Share",
            ZOOM: "Zoom",
          },
          de: {
            CLOSE: "Schlie&szlig;en",
            NEXT: "Weiter",
            PREV: "Zur&uuml;ck",
            ERROR:
              "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
            PLAY_START: "Diaschau starten",
            PLAY_STOP: "Diaschau beenden",
            FULL_SCREEN: "Vollbild",
            THUMBS: "Vorschaubilder",
            DOWNLOAD: "Herunterladen",
            SHARE: "Teilen",
            ZOOM: "Vergr&ouml;&szlig;ern",
          },
        },
      },
      s = n(t),
      r = n(e),
      c = 0,
      l = function (t) {
        return t && t.hasOwnProperty && t instanceof n;
      },
      d = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      u = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      f = (function () {
        var t,
          n = e.createElement("fakeelement"),
          o = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
          };
        for (t in o) if (void 0 !== n.style[t]) return o[t];
        return "transitionend";
      })(),
      p = function (t) {
        return t && t.length && t[0].offsetHeight;
      },
      h = function (t, e) {
        var o = n.extend(!0, {}, t, e);
        return (
          n.each(e, function (t, e) {
            n.isArray(e) && (o[t] = e);
          }),
          o
        );
      },
      g = function (t) {
        var o, i;
        return (
          !(!t || t.ownerDocument !== e) &&
          (n(".fancybox-container").css("pointer-events", "none"),
          (o = {
            x: t.getBoundingClientRect().left + t.offsetWidth / 2,
            y: t.getBoundingClientRect().top + t.offsetHeight / 2,
          }),
          (i = e.elementFromPoint(o.x, o.y) === t),
          n(".fancybox-container").css("pointer-events", ""),
          i)
        );
      },
      b = function (t, e, o) {
        var i = this;
        (i.opts = h({ index: o }, n.fancybox.defaults)),
          n.isPlainObject(e) && (i.opts = h(i.opts, e)),
          n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)),
          (i.id = i.opts.id || ++c),
          (i.currIndex = parseInt(i.opts.index, 10) || 0),
          (i.prevIndex = null),
          (i.prevPos = null),
          (i.currPos = 0),
          (i.firstRun = !0),
          (i.group = []),
          (i.slides = {}),
          i.addContent(t),
          i.group.length && i.init();
      };
    n.extend(b.prototype, {
      init: function () {
        var o,
          i,
          a = this,
          s = a.group[a.currIndex],
          r = s.opts;
        r.closeExisting && n.fancybox.close(!0),
          n("body").addClass("fancybox-active"),
          !n.fancybox.getInstance() &&
            !1 !== r.hideScrollbar &&
            !n.fancybox.isMobile &&
            e.body.scrollHeight > t.innerHeight &&
            (n("head").append(
              '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
                (t.innerWidth - e.documentElement.clientWidth) +
                "px;}</style>"
            ),
            n("body").addClass("compensate-for-scrollbar")),
          (i = ""),
          n.each(r.buttons, function (t, e) {
            i += r.btnTpl[e] || "";
          }),
          (o = n(
            a.translate(
              a,
              r.baseTpl
                .replace("{{buttons}}", i)
                .replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight)
            )
          )
            .attr("id", "fancybox-container-" + a.id)
            .addClass(r.baseClass)
            .data("FancyBox", a)
            .appendTo(r.parentEl)),
          (a.$refs = { container: o }),
          [
            "bg",
            "inner",
            "infobar",
            "toolbar",
            "stage",
            "caption",
            "navigation",
          ].forEach(function (t) {
            a.$refs[t] = o.find(".fancybox-" + t);
          }),
          a.trigger("onInit"),
          a.activate(),
          a.jumpTo(a.currIndex);
      },
      translate: function (t, e) {
        var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
        return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
          return void 0 === n[e] ? t : n[e];
        });
      },
      addContent: function (t) {
        var e,
          o = this,
          i = n.makeArray(t);
        n.each(i, function (t, e) {
          var i,
            a,
            s,
            r,
            c,
            l = {},
            d = {};
          n.isPlainObject(e)
            ? ((l = e), (d = e.opts || e))
            : "object" === n.type(e) && n(e).length
            ? ((i = n(e)),
              (d = i.data() || {}),
              (d = n.extend(!0, {}, d, d.options)),
              (d.$orig = i),
              (l.src = o.opts.src || d.src || i.attr("href")),
              l.type || l.src || ((l.type = "inline"), (l.src = e)))
            : (l = { type: "html", src: e + "" }),
            (l.opts = n.extend(!0, {}, o.opts, d)),
            n.isArray(d.buttons) && (l.opts.buttons = d.buttons),
            n.fancybox.isMobile &&
              l.opts.mobile &&
              (l.opts = h(l.opts, l.opts.mobile)),
            (a = l.type || l.opts.type),
            (r = l.src || ""),
            !a &&
              r &&
              ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                ? ((a = "video"),
                  l.opts.video.format ||
                    (l.opts.video.format =
                      "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                : r.match(
                    /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i
                  )
                ? (a = "image")
                : r.match(/\.(pdf)((\?|#).*)?$/i)
                ? ((a = "iframe"),
                  (l = n.extend(!0, l, {
                    contentType: "pdf",
                    opts: { iframe: { preload: !1 } },
                  })))
                : "#" === r.charAt(0) && (a = "inline")),
            a ? (l.type = a) : o.trigger("objectNeedsType", l),
            l.contentType ||
              (l.contentType =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1
                  ? "html"
                  : l.type),
            (l.index = o.group.length),
            "auto" == l.opts.smallBtn &&
              (l.opts.smallBtn =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1),
            "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn),
            (l.$thumb = l.opts.$thumb || null),
            l.opts.$trigger &&
              l.index === o.opts.index &&
              ((l.$thumb = l.opts.$trigger.find("img:first")),
              l.$thumb.length && (l.opts.$orig = l.opts.$trigger)),
            (l.$thumb && l.$thumb.length) ||
              !l.opts.$orig ||
              (l.$thumb = l.opts.$orig.find("img:first")),
            l.$thumb && !l.$thumb.length && (l.$thumb = null),
            (l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null)),
            "function" === n.type(l.opts.caption) &&
              (l.opts.caption = l.opts.caption.apply(e, [o, l])),
            "function" === n.type(o.opts.caption) &&
              (l.opts.caption = o.opts.caption.apply(e, [o, l])),
            l.opts.caption instanceof n ||
              (l.opts.caption =
                void 0 === l.opts.caption ? "" : l.opts.caption + ""),
            "ajax" === l.type &&
              ((c = r.split(/\s+/, 2)),
              c.length > 1 &&
                ((l.src = c.shift()), (l.opts.filter = c.shift()))),
            l.opts.modal &&
              (l.opts = n.extend(!0, l.opts, {
                trapFocus: !0,
                infobar: 0,
                toolbar: 0,
                smallBtn: 0,
                keyboard: 0,
                slideShow: 0,
                fullScreen: 0,
                thumbs: 0,
                touch: 0,
                clickContent: !1,
                clickSlide: !1,
                clickOutside: !1,
                dblclickContent: !1,
                dblclickSlide: !1,
                dblclickOutside: !1,
              })),
            o.group.push(l);
        }),
          Object.keys(o.slides).length &&
            (o.updateControls(),
            (e = o.Thumbs) && e.isActive && (e.create(), e.focus()));
      },
      addEvents: function () {
        var e = this;
        e.removeEvents(),
          e.$refs.container
            .on("click.fb-close", "[data-fancybox-close]", function (t) {
              t.stopPropagation(), t.preventDefault(), e.close(t);
            })
            .on(
              "touchstart.fb-prev click.fb-prev",
              "[data-fancybox-prev]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.previous();
              }
            )
            .on(
              "touchstart.fb-next click.fb-next",
              "[data-fancybox-next]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.next();
              }
            )
            .on("click.fb", "[data-fancybox-zoom]", function (t) {
              e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
            }),
          s.on("orientationchange.fb resize.fb", function (t) {
            t && t.originalEvent && "resize" === t.originalEvent.type
              ? (e.requestId && u(e.requestId),
                (e.requestId = d(function () {
                  e.update(t);
                })))
              : (e.current &&
                  "iframe" === e.current.type &&
                  e.$refs.stage.hide(),
                setTimeout(
                  function () {
                    e.$refs.stage.show(), e.update(t);
                  },
                  n.fancybox.isMobile ? 600 : 250
                ));
          }),
          r.on("keydown.fb", function (t) {
            var o = n.fancybox ? n.fancybox.getInstance() : null,
              i = o.current,
              a = t.keyCode || t.which;
            if (9 == a) return void (i.opts.trapFocus && e.focus(t));
            if (
              !(
                !i.opts.keyboard ||
                t.ctrlKey ||
                t.altKey ||
                t.shiftKey ||
                n(t.target).is("input,textarea,video,audio,select")
              )
            )
              return 8 === a || 27 === a
                ? (t.preventDefault(), void e.close(t))
                : 37 === a || 38 === a
                ? (t.preventDefault(), void e.previous())
                : 39 === a || 40 === a
                ? (t.preventDefault(), void e.next())
                : void e.trigger("afterKeydown", t, a);
          }),
          e.group[e.currIndex].opts.idleTime &&
            ((e.idleSecondsCounter = 0),
            r.on(
              "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
              function (t) {
                (e.idleSecondsCounter = 0),
                  e.isIdle && e.showControls(),
                  (e.isIdle = !1);
              }
            ),
            (e.idleInterval = t.setInterval(function () {
              ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime &&
                !e.isDragging &&
                ((e.isIdle = !0), (e.idleSecondsCounter = 0), e.hideControls());
            }, 1e3)));
      },
      removeEvents: function () {
        var e = this;
        s.off("orientationchange.fb resize.fb"),
          r.off("keydown.fb .fb-idle"),
          this.$refs.container.off(".fb-close .fb-prev .fb-next"),
          e.idleInterval &&
            (t.clearInterval(e.idleInterval), (e.idleInterval = null));
      },
      previous: function (t) {
        return this.jumpTo(this.currPos - 1, t);
      },
      next: function (t) {
        return this.jumpTo(this.currPos + 1, t);
      },
      jumpTo: function (t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          d,
          u,
          f = this,
          h = f.group.length;
        if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
          if (
            ((t = parseInt(t, 10)),
            !(a = f.current ? f.current.opts.loop : f.opts.loop) &&
              (t < 0 || t >= h))
          )
            return !1;
          if (
            ((o = f.firstRun = !Object.keys(f.slides).length),
            (r = f.current),
            (f.prevIndex = f.currIndex),
            (f.prevPos = f.currPos),
            (s = f.createSlide(t)),
            h > 1 &&
              ((a || s.index < h - 1) && f.createSlide(t + 1),
              (a || s.index > 0) && f.createSlide(t - 1)),
            (f.current = s),
            (f.currIndex = s.index),
            (f.currPos = s.pos),
            f.trigger("beforeShow", o),
            f.updateControls(),
            (s.forcedDuration = void 0),
            n.isNumeric(e)
              ? (s.forcedDuration = e)
              : (e = s.opts[o ? "animationDuration" : "transitionDuration"]),
            (e = parseInt(e, 10)),
            (i = f.isMoved(s)),
            s.$slide.addClass("fancybox-slide--current"),
            o)
          )
            return (
              s.opts.animationEffect &&
                e &&
                f.$refs.container.css("transition-duration", e + "ms"),
              f.$refs.container.addClass("fancybox-is-open").trigger("focus"),
              f.loadSlide(s),
              void f.preload("image")
            );
          (c = n.fancybox.getTranslate(r.$slide)),
            (l = n.fancybox.getTranslate(f.$refs.stage)),
            n.each(f.slides, function (t, e) {
              n.fancybox.stop(e.$slide, !0);
            }),
            r.pos !== s.pos && (r.isComplete = !1),
            r.$slide.removeClass(
              "fancybox-slide--complete fancybox-slide--current"
            ),
            i
              ? ((u = c.left - (r.pos * c.width + r.pos * r.opts.gutter)),
                n.each(f.slides, function (t, o) {
                  o.$slide
                    .removeClass("fancybox-animated")
                    .removeClass(function (t, e) {
                      return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(
                        " "
                      );
                    });
                  var i = o.pos * c.width + o.pos * o.opts.gutter;
                  n.fancybox.setTranslate(o.$slide, {
                    top: 0,
                    left: i - l.left + u,
                  }),
                    o.pos !== s.pos &&
                      o.$slide.addClass(
                        "fancybox-slide--" +
                          (o.pos > s.pos ? "next" : "previous")
                      ),
                    p(o.$slide),
                    n.fancybox.animate(
                      o.$slide,
                      {
                        top: 0,
                        left:
                          (o.pos - s.pos) * c.width +
                          (o.pos - s.pos) * o.opts.gutter,
                      },
                      e,
                      function () {
                        o.$slide
                          .css({ transform: "", opacity: "" })
                          .removeClass(
                            "fancybox-slide--next fancybox-slide--previous"
                          ),
                          o.pos === f.currPos && f.complete();
                      }
                    );
                }))
              : e &&
                s.opts.transitionEffect &&
                ((d =
                  "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                r.$slide.addClass(
                  "fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")
                ),
                n.fancybox.animate(
                  r.$slide,
                  d,
                  e,
                  function () {
                    r.$slide
                      .removeClass(d)
                      .removeClass(
                        "fancybox-slide--next fancybox-slide--previous"
                      );
                  },
                  !1
                )),
            s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
            f.preload("image");
        }
      },
      createSlide: function (t) {
        var e,
          o,
          i = this;
        return (
          (o = t % i.group.length),
          (o = o < 0 ? i.group.length + o : o),
          !i.slides[t] &&
            i.group[o] &&
            ((e = n('<div class="fancybox-slide"></div>').appendTo(
              i.$refs.stage
            )),
            (i.slides[t] = n.extend(!0, {}, i.group[o], {
              pos: t,
              $slide: e,
              isLoaded: !1,
            })),
            i.updateSlide(i.slides[t])),
          i.slides[t]
        );
      },
      scaleToActual: function (t, e, o) {
        var i,
          a,
          s,
          r,
          c,
          l = this,
          d = l.current,
          u = d.$content,
          f = n.fancybox.getTranslate(d.$slide).width,
          p = n.fancybox.getTranslate(d.$slide).height,
          h = d.width,
          g = d.height;
        l.isAnimating ||
          l.isMoved() ||
          !u ||
          "image" != d.type ||
          !d.isLoaded ||
          d.hasError ||
          ((l.isAnimating = !0),
          n.fancybox.stop(u),
          (t = void 0 === t ? 0.5 * f : t),
          (e = void 0 === e ? 0.5 * p : e),
          (i = n.fancybox.getTranslate(u)),
          (i.top -= n.fancybox.getTranslate(d.$slide).top),
          (i.left -= n.fancybox.getTranslate(d.$slide).left),
          (r = h / i.width),
          (c = g / i.height),
          (a = 0.5 * f - 0.5 * h),
          (s = 0.5 * p - 0.5 * g),
          h > f &&
            ((a = i.left * r - (t * r - t)),
            a > 0 && (a = 0),
            a < f - h && (a = f - h)),
          g > p &&
            ((s = i.top * c - (e * c - e)),
            s > 0 && (s = 0),
            s < p - g && (s = p - g)),
          l.updateCursor(h, g),
          n.fancybox.animate(
            u,
            { top: s, left: a, scaleX: r, scaleY: c },
            o || 366,
            function () {
              l.isAnimating = !1;
            }
          ),
          l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
      },
      scaleToFit: function (t) {
        var e,
          o = this,
          i = o.current,
          a = i.$content;
        o.isAnimating ||
          o.isMoved() ||
          !a ||
          "image" != i.type ||
          !i.isLoaded ||
          i.hasError ||
          ((o.isAnimating = !0),
          n.fancybox.stop(a),
          (e = o.getFitPos(i)),
          o.updateCursor(e.width, e.height),
          n.fancybox.animate(
            a,
            {
              top: e.top,
              left: e.left,
              scaleX: e.width / a.width(),
              scaleY: e.height / a.height(),
            },
            t || 366,
            function () {
              o.isAnimating = !1;
            }
          ));
      },
      getFitPos: function (t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$content,
          c = t.$slide,
          l = t.width || t.opts.width,
          d = t.height || t.opts.height,
          u = {};
        return (
          !!(t.isLoaded && r && r.length) &&
          ((e = n.fancybox.getTranslate(s.$refs.stage).width),
          (o = n.fancybox.getTranslate(s.$refs.stage).height),
          (e -=
            parseFloat(c.css("paddingLeft")) +
            parseFloat(c.css("paddingRight")) +
            parseFloat(r.css("marginLeft")) +
            parseFloat(r.css("marginRight"))),
          (o -=
            parseFloat(c.css("paddingTop")) +
            parseFloat(c.css("paddingBottom")) +
            parseFloat(r.css("marginTop")) +
            parseFloat(r.css("marginBottom"))),
          (l && d) || ((l = e), (d = o)),
          (i = Math.min(1, e / l, o / d)),
          (l *= i),
          (d *= i),
          l > e - 0.5 && (l = e),
          d > o - 0.5 && (d = o),
          "image" === t.type
            ? ((u.top =
                Math.floor(0.5 * (o - d)) + parseFloat(c.css("paddingTop"))),
              (u.left =
                Math.floor(0.5 * (e - l)) + parseFloat(c.css("paddingLeft"))))
            : "video" === t.contentType &&
              ((a =
                t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9),
              d > l / a ? (d = l / a) : l > d * a && (l = d * a)),
          (u.width = l),
          (u.height = d),
          u)
        );
      },
      update: function (t) {
        var e = this;
        n.each(e.slides, function (n, o) {
          e.updateSlide(o, t);
        });
      },
      updateSlide: function (t, e) {
        var o = this,
          i = t && t.$content,
          a = t.width || t.opts.width,
          s = t.height || t.opts.height,
          r = t.$slide;
        o.adjustCaption(t),
          i &&
            (a || s || "video" === t.contentType) &&
            !t.hasError &&
            (n.fancybox.stop(i),
            n.fancybox.setTranslate(i, o.getFitPos(t)),
            t.pos === o.currPos && ((o.isAnimating = !1), o.updateCursor())),
          o.adjustLayout(t),
          r.length &&
            (r.trigger("refresh"),
            t.pos === o.currPos &&
              o.$refs.toolbar
                .add(o.$refs.navigation.find(".fancybox-button--arrow_right"))
                .toggleClass(
                  "compensate-for-scrollbar",
                  r.get(0).scrollHeight > r.get(0).clientHeight
                )),
          o.trigger("onUpdate", t, e);
      },
      centerSlide: function (t) {
        var e = this,
          o = e.current,
          i = o.$slide;
        !e.isClosing &&
          o &&
          (i.siblings().css({ transform: "", opacity: "" }),
          i
            .parent()
            .children()
            .removeClass("fancybox-slide--previous fancybox-slide--next"),
          n.fancybox.animate(
            i,
            { top: 0, left: 0, opacity: 1 },
            void 0 === t ? 0 : t,
            function () {
              i.css({ transform: "", opacity: "" }),
                o.isComplete || e.complete();
            },
            !1
          ));
      },
      isMoved: function (t) {
        var e,
          o,
          i = t || this.current;
        return (
          !!i &&
          ((o = n.fancybox.getTranslate(this.$refs.stage)),
          (e = n.fancybox.getTranslate(i.$slide)),
          !i.$slide.hasClass("fancybox-animated") &&
            (Math.abs(e.top - o.top) > 0.5 || Math.abs(e.left - o.left) > 0.5))
        );
      },
      updateCursor: function (t, e) {
        var o,
          i,
          a = this,
          s = a.current,
          r = a.$refs.container;
        s &&
          !a.isClosing &&
          a.Guestures &&
          (r.removeClass(
            "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"
          ),
          (o = a.canPan(t, e)),
          (i = !!o || a.isZoomable()),
          r.toggleClass("fancybox-is-zoomable", i),
          n("[data-fancybox-zoom]").prop("disabled", !i),
          o
            ? r.addClass("fancybox-can-pan")
            : i &&
              ("zoom" === s.opts.clickContent ||
                (n.isFunction(s.opts.clickContent) &&
                  "zoom" == s.opts.clickContent(s)))
            ? r.addClass("fancybox-can-zoomIn")
            : s.opts.touch &&
              (s.opts.touch.vertical || a.group.length > 1) &&
              "video" !== s.contentType &&
              r.addClass("fancybox-can-swipe"));
      },
      isZoomable: function () {
        var t,
          e = this,
          n = e.current;
        if (n && !e.isClosing && "image" === n.type && !n.hasError) {
          if (!n.isLoaded) return !0;
          if (
            (t = e.getFitPos(n)) &&
            (n.width > t.width || n.height > t.height)
          )
            return !0;
        }
        return !1;
      },
      isScaledDown: function (t, e) {
        var o = this,
          i = !1,
          a = o.current,
          s = a.$content;
        return (
          void 0 !== t && void 0 !== e
            ? (i = t < a.width && e < a.height)
            : s &&
              ((i = n.fancybox.getTranslate(s)),
              (i = i.width < a.width && i.height < a.height)),
          i
        );
      },
      canPan: function (t, e) {
        var o = this,
          i = o.current,
          a = null,
          s = !1;
        return (
          "image" === i.type &&
            (i.isComplete || (t && e)) &&
            !i.hasError &&
            ((s = o.getFitPos(i)),
            void 0 !== t && void 0 !== e
              ? (a = { width: t, height: e })
              : i.isComplete && (a = n.fancybox.getTranslate(i.$content)),
            a &&
              s &&
              (s =
                Math.abs(a.width - s.width) > 1.5 ||
                Math.abs(a.height - s.height) > 1.5)),
          s
        );
      },
      loadSlide: function (t) {
        var e,
          o,
          i,
          a = this;
        if (!t.isLoading && !t.isLoaded) {
          if (((t.isLoading = !0), !1 === a.trigger("beforeLoad", t)))
            return (t.isLoading = !1), !1;
          switch (
            ((e = t.type),
            (o = t.$slide),
            o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),
            e)
          ) {
            case "image":
              a.setImage(t);
              break;
            case "iframe":
              a.setIframe(t);
              break;
            case "html":
              a.setContent(t, t.src || t.content);
              break;
            case "video":
              a.setContent(
                t,
                t.opts.video.tpl
                  .replace(/\{\{src\}\}/gi, t.src)
                  .replace(
                    "{{format}}",
                    t.opts.videoFormat || t.opts.video.format || ""
                  )
                  .replace("{{poster}}", t.thumb || "")
              );
              break;
            case "inline":
              n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
              break;
            case "ajax":
              a.showLoading(t),
                (i = n.ajax(
                  n.extend({}, t.opts.ajax.settings, {
                    url: t.src,
                    success: function (e, n) {
                      "success" === n && a.setContent(t, e);
                    },
                    error: function (e, n) {
                      e && "abort" !== n && a.setError(t);
                    },
                  })
                )),
                o.one("onReset", function () {
                  i.abort();
                });
              break;
            default:
              a.setError(t);
          }
          return !0;
        }
      },
      setImage: function (t) {
        var o,
          i = this;
        setTimeout(function () {
          var e = t.$image;
          i.isClosing ||
            !t.isLoading ||
            (e && e.length && e[0].complete) ||
            t.hasError ||
            i.showLoading(t);
        }, 50),
          i.checkSrcset(t),
          (t.$content = n('<div class="fancybox-content"></div>')
            .addClass("fancybox-is-hidden")
            .appendTo(t.$slide.addClass("fancybox-slide--image"))),
          !1 !== t.opts.preload &&
            t.opts.width &&
            t.opts.height &&
            t.thumb &&
            ((t.width = t.opts.width),
            (t.height = t.opts.height),
            (o = e.createElement("img")),
            (o.onerror = function () {
              n(this).remove(), (t.$ghost = null);
            }),
            (o.onload = function () {
              i.afterLoad(t);
            }),
            (t.$ghost = n(o)
              .addClass("fancybox-image")
              .appendTo(t.$content)
              .attr("src", t.thumb))),
          i.setBigImage(t);
      },
      checkSrcset: function (e) {
        var n,
          o,
          i,
          a,
          s = e.opts.srcset || e.opts.image.srcset;
        if (s) {
          (i = t.devicePixelRatio || 1),
            (a = t.innerWidth * i),
            (o = s.split(",").map(function (t) {
              var e = {};
              return (
                t
                  .trim()
                  .split(/\s+/)
                  .forEach(function (t, n) {
                    var o = parseInt(t.substring(0, t.length - 1), 10);
                    if (0 === n) return (e.url = t);
                    o && ((e.value = o), (e.postfix = t[t.length - 1]));
                  }),
                e
              );
            })),
            o.sort(function (t, e) {
              return t.value - e.value;
            });
          for (var r = 0; r < o.length; r++) {
            var c = o[r];
            if (
              ("w" === c.postfix && c.value >= a) ||
              ("x" === c.postfix && c.value >= i)
            ) {
              n = c;
              break;
            }
          }
          !n && o.length && (n = o[o.length - 1]),
            n &&
              ((e.src = n.url),
              e.width &&
                e.height &&
                "w" == n.postfix &&
                ((e.height = (e.width / e.height) * n.value),
                (e.width = n.value)),
              (e.opts.srcset = s));
        }
      },
      setBigImage: function (t) {
        var o = this,
          i = e.createElement("img"),
          a = n(i);
        (t.$image = a
          .one("error", function () {
            o.setError(t);
          })
          .one("load", function () {
            var e;
            t.$ghost ||
              (o.resolveImageSlideSize(
                t,
                this.naturalWidth,
                this.naturalHeight
              ),
              o.afterLoad(t)),
              o.isClosing ||
                (t.opts.srcset &&
                  ((e = t.opts.sizes),
                  (e && "auto" !== e) ||
                    (e =
                      (t.width / t.height > 1 && s.width() / s.height() > 1
                        ? "100"
                        : Math.round((t.width / t.height) * 100)) + "vw"),
                  a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                t.$ghost &&
                  setTimeout(function () {
                    t.$ghost && !o.isClosing && t.$ghost.hide();
                  }, Math.min(300, Math.max(1e3, t.height / 1600))),
                o.hideLoading(t));
          })
          .addClass("fancybox-image")
          .attr("src", t.src)
          .appendTo(t.$content)),
          (i.complete || "complete" == i.readyState) &&
          a.naturalWidth &&
          a.naturalHeight
            ? a.trigger("load")
            : i.error && a.trigger("error");
      },
      resolveImageSlideSize: function (t, e, n) {
        var o = parseInt(t.opts.width, 10),
          i = parseInt(t.opts.height, 10);
        (t.width = e),
          (t.height = n),
          o > 0 && ((t.width = o), (t.height = Math.floor((o * n) / e))),
          i > 0 && ((t.width = Math.floor((i * e) / n)), (t.height = i));
      },
      setIframe: function (t) {
        var e,
          o = this,
          i = t.opts.iframe,
          a = t.$slide;
        (t.$content = n(
          '<div class="fancybox-content' +
            (i.preload ? " fancybox-is-hidden" : "") +
            '"></div>'
        )
          .css(i.css)
          .appendTo(a)),
          a.addClass("fancybox-slide--" + t.contentType),
          (t.$iframe = e =
            n(i.tpl.replace(/\{rnd\}/g, new Date().getTime()))
              .attr(i.attr)
              .appendTo(t.$content)),
          i.preload
            ? (o.showLoading(t),
              e.on("load.fb error.fb", function (e) {
                (this.isReady = 1), t.$slide.trigger("refresh"), o.afterLoad(t);
              }),
              a.on("refresh.fb", function () {
                var n,
                  o,
                  s = t.$content,
                  r = i.css.width,
                  c = i.css.height;
                if (1 === e[0].isReady) {
                  try {
                    (n = e.contents()), (o = n.find("body"));
                  } catch (t) {}
                  o &&
                    o.length &&
                    o.children().length &&
                    (a.css("overflow", "visible"),
                    s.css({
                      width: "100%",
                      "max-width": "100%",
                      height: "9999px",
                    }),
                    void 0 === r &&
                      (r = Math.ceil(
                        Math.max(o[0].clientWidth, o.outerWidth(!0))
                      )),
                    s.css("width", r || "").css("max-width", ""),
                    void 0 === c &&
                      (c = Math.ceil(
                        Math.max(o[0].clientHeight, o.outerHeight(!0))
                      )),
                    s.css("height", c || ""),
                    a.css("overflow", "auto")),
                    s.removeClass("fancybox-is-hidden");
                }
              }))
            : o.afterLoad(t),
          e.attr("src", t.src),
          a.one("onReset", function () {
            try {
              n(this)
                .find("iframe")
                .hide()
                .unbind()
                .attr("src", "//about:blank");
            } catch (t) {}
            n(this).off("refresh.fb").empty(),
              (t.isLoaded = !1),
              (t.isRevealed = !1);
          });
      },
      setContent: function (t, e) {
        var o = this;
        o.isClosing ||
          (o.hideLoading(t),
          t.$content && n.fancybox.stop(t.$content),
          t.$slide.empty(),
          l(e) && e.parent().length
            ? ((e.hasClass("fancybox-content") ||
                e.parent().hasClass("fancybox-content")) &&
                e.parents(".fancybox-slide").trigger("onReset"),
              (t.$placeholder = n("<div>").hide().insertAfter(e)),
              e.css("display", "inline-block"))
            : t.hasError ||
              ("string" === n.type(e) &&
                (e = n("<div>").append(n.trim(e)).contents()),
              t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
          t.$slide.one("onReset", function () {
            n(this).find("video,audio").trigger("pause"),
              t.$placeholder &&
                (t.$placeholder
                  .after(e.removeClass("fancybox-content").hide())
                  .remove(),
                (t.$placeholder = null)),
              t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
              t.hasError ||
                (n(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1));
          }),
          n(e).appendTo(t.$slide),
          n(e).is("video,audio") &&
            (n(e).addClass("fancybox-video"),
            n(e).wrap("<div></div>"),
            (t.contentType = "video"),
            (t.opts.width = t.opts.width || n(e).attr("width")),
            (t.opts.height = t.opts.height || n(e).attr("height"))),
          (t.$content = t.$slide
            .children()
            .filter("div,form,main,video,audio,article,.fancybox-content")
            .first()),
          t.$content.siblings().hide(),
          t.$content.length ||
            (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
          t.$content.addClass("fancybox-content"),
          t.$slide.addClass("fancybox-slide--" + t.contentType),
          o.afterLoad(t));
      },
      setError: function (t) {
        (t.hasError = !0),
          t.$slide
            .trigger("onReset")
            .removeClass("fancybox-slide--" + t.contentType)
            .addClass("fancybox-slide--error"),
          (t.contentType = "html"),
          this.setContent(t, this.translate(t, t.opts.errorTpl)),
          t.pos === this.currPos && (this.isAnimating = !1);
      },
      showLoading: function (t) {
        var e = this;
        (t = t || e.current) &&
          !t.$spinner &&
          (t.$spinner = n(e.translate(e, e.opts.spinnerTpl))
            .appendTo(t.$slide)
            .hide()
            .fadeIn("fast"));
      },
      hideLoading: function (t) {
        var e = this;
        (t = t || e.current) &&
          t.$spinner &&
          (t.$spinner.stop().remove(), delete t.$spinner);
      },
      afterLoad: function (t) {
        var e = this;
        e.isClosing ||
          ((t.isLoading = !1),
          (t.isLoaded = !0),
          e.trigger("afterLoad", t),
          e.hideLoading(t),
          !t.opts.smallBtn ||
            (t.$smallBtn && t.$smallBtn.length) ||
            (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(
              t.$content
            )),
          t.opts.protect &&
            t.$content &&
            !t.hasError &&
            (t.$content.on("contextmenu.fb", function (t) {
              return 2 == t.button && t.preventDefault(), !0;
            }),
            "image" === t.type &&
              n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
          e.adjustCaption(t),
          e.adjustLayout(t),
          t.pos === e.currPos && e.updateCursor(),
          e.revealContent(t));
      },
      adjustCaption: function (t) {
        var e,
          n = this,
          o = t || n.current,
          i = o.opts.caption,
          a = o.opts.preventCaptionOverlap,
          s = n.$refs.caption,
          r = !1;
        s.toggleClass("fancybox-caption--separate", a),
          a &&
            i &&
            i.length &&
            (o.pos !== n.currPos
              ? ((e = s.clone().appendTo(s.parent())),
                e.children().eq(0).empty().html(i),
                (r = e.outerHeight(!0)),
                e.empty().remove())
              : n.$caption && (r = n.$caption.outerHeight(!0)),
            o.$slide.css("padding-bottom", r || ""));
      },
      adjustLayout: function (t) {
        var e,
          n,
          o,
          i,
          a = this,
          s = t || a.current;
        s.isLoaded &&
          !0 !== s.opts.disableLayoutFix &&
          (s.$content.css("margin-bottom", ""),
          s.$content.outerHeight() > s.$slide.height() + 0.5 &&
            ((o = s.$slide[0].style["padding-bottom"]),
            (i = s.$slide.css("padding-bottom")),
            parseFloat(i) > 0 &&
              ((e = s.$slide[0].scrollHeight),
              s.$slide.css("padding-bottom", 0),
              Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i),
              s.$slide.css("padding-bottom", o))),
          s.$content.css("margin-bottom", n));
      },
      revealContent: function (t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$slide,
          c = !1,
          l = !1,
          d = s.isMoved(t),
          u = t.isRevealed;
        return (
          (t.isRevealed = !0),
          (e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
          (i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
          (i = parseInt(
            void 0 === t.forcedDuration ? i : t.forcedDuration,
            10
          )),
          (!d && t.pos === s.currPos && i) || (e = !1),
          "zoom" === e &&
            (t.pos === s.currPos &&
            i &&
            "image" === t.type &&
            !t.hasError &&
            (l = s.getThumbPos(t))
              ? (c = s.getFitPos(t))
              : (e = "fade")),
          "zoom" === e
            ? ((s.isAnimating = !0),
              (c.scaleX = c.width / l.width),
              (c.scaleY = c.height / l.height),
              (a = t.opts.zoomOpacity),
              "auto" == a &&
                (a = Math.abs(t.width / t.height - l.width / l.height) > 0.1),
              a && ((l.opacity = 0.1), (c.opacity = 1)),
              n.fancybox.setTranslate(
                t.$content.removeClass("fancybox-is-hidden"),
                l
              ),
              p(t.$content),
              void n.fancybox.animate(t.$content, c, i, function () {
                (s.isAnimating = !1), s.complete();
              }))
            : (s.updateSlide(t),
              e
                ? (n.fancybox.stop(r),
                  (o =
                    "fancybox-slide--" +
                    (t.pos >= s.prevPos ? "next" : "previous") +
                    " fancybox-animated fancybox-fx-" +
                    e),
                  r.addClass(o).removeClass("fancybox-slide--current"),
                  t.$content.removeClass("fancybox-is-hidden"),
                  p(r),
                  "image" !== t.type && t.$content.hide().show(0),
                  void n.fancybox.animate(
                    r,
                    "fancybox-slide--current",
                    i,
                    function () {
                      r.removeClass(o).css({ transform: "", opacity: "" }),
                        t.pos === s.currPos && s.complete();
                    },
                    !0
                  ))
                : (t.$content.removeClass("fancybox-is-hidden"),
                  u ||
                    !d ||
                    "image" !== t.type ||
                    t.hasError ||
                    t.$content.hide().fadeIn("fast"),
                  void (t.pos === s.currPos && s.complete())))
        );
      },
      getThumbPos: function (t) {
        var e,
          o,
          i,
          a,
          s,
          r = !1,
          c = t.$thumb;
        return (
          !(!c || !g(c[0])) &&
          ((e = n.fancybox.getTranslate(c)),
          (o = parseFloat(c.css("border-top-width") || 0)),
          (i = parseFloat(c.css("border-right-width") || 0)),
          (a = parseFloat(c.css("border-bottom-width") || 0)),
          (s = parseFloat(c.css("border-left-width") || 0)),
          (r = {
            top: e.top + o,
            left: e.left + s,
            width: e.width - i - s,
            height: e.height - o - a,
            scaleX: 1,
            scaleY: 1,
          }),
          e.width > 0 && e.height > 0 && r)
        );
      },
      complete: function () {
        var t,
          e = this,
          o = e.current,
          i = {};
        !e.isMoved() &&
          o.isLoaded &&
          (o.isComplete ||
            ((o.isComplete = !0),
            o.$slide.siblings().trigger("onReset"),
            e.preload("inline"),
            p(o.$slide),
            o.$slide.addClass("fancybox-slide--complete"),
            n.each(e.slides, function (t, o) {
              o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1
                ? (i[o.pos] = o)
                : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
            }),
            (e.slides = i)),
          (e.isAnimating = !1),
          e.updateCursor(),
          e.trigger("afterShow"),
          o.opts.video.autoStart &&
            o.$slide
              .find("video,audio")
              .filter(":visible:first")
              .trigger("play")
              .one("ended", function () {
                Document.exitFullscreen
                  ? Document.exitFullscreen()
                  : this.webkitExitFullscreen && this.webkitExitFullscreen(),
                  e.next();
              }),
          o.opts.autoFocus &&
            "html" === o.contentType &&
            ((t = o.$content.find("input[autofocus]:enabled:visible:first")),
            t.length ? t.trigger("focus") : e.focus(null, !0)),
          o.$slide.scrollTop(0).scrollLeft(0));
      },
      preload: function (t) {
        var e,
          n,
          o = this;
        o.group.length < 2 ||
          ((n = o.slides[o.currPos + 1]),
          (e = o.slides[o.currPos - 1]),
          e && e.type === t && o.loadSlide(e),
          n && n.type === t && o.loadSlide(n));
      },
      focus: function (t, o) {
        var i,
          a,
          s = this,
          r = [
            "a[href]",
            "area[href]",
            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
            "select:not([disabled]):not([aria-hidden])",
            "textarea:not([disabled]):not([aria-hidden])",
            "button:not([disabled]):not([aria-hidden])",
            "iframe",
            "object",
            "embed",
            "video",
            "audio",
            "[contenteditable]",
            '[tabindex]:not([tabindex^="-"])',
          ].join(",");
        s.isClosing ||
          ((i =
            !t && s.current && s.current.isComplete
              ? s.current.$slide.find(
                  "*:visible" + (o ? ":not(.fancybox-close-small)" : "")
                )
              : s.$refs.container.find("*:visible")),
          (i = i.filter(r).filter(function () {
            return (
              "hidden" !== n(this).css("visibility") &&
              !n(this).hasClass("disabled")
            );
          })),
          i.length
            ? ((a = i.index(e.activeElement)),
              t && t.shiftKey
                ? (a < 0 || 0 == a) &&
                  (t.preventDefault(), i.eq(i.length - 1).trigger("focus"))
                : (a < 0 || a == i.length - 1) &&
                  (t && t.preventDefault(), i.eq(0).trigger("focus")))
            : s.$refs.container.trigger("focus"));
      },
      activate: function () {
        var t = this;
        n(".fancybox-container").each(function () {
          var e = n(this).data("FancyBox");
          e &&
            e.id !== t.id &&
            !e.isClosing &&
            (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
        }),
          (t.isVisible = !0),
          (t.current || t.isIdle) && (t.update(), t.updateControls()),
          t.trigger("onActivate"),
          t.addEvents();
      },
      close: function (t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          u = this,
          f = u.current,
          h = function () {
            u.cleanUp(t);
          };
        return (
          !u.isClosing &&
          ((u.isClosing = !0),
          !1 === u.trigger("beforeClose", t)
            ? ((u.isClosing = !1),
              d(function () {
                u.update();
              }),
              !1)
            : (u.removeEvents(),
              (a = f.$content),
              (o = f.opts.animationEffect),
              (i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0),
              f.$slide.removeClass(
                "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"
              ),
              !0 !== t ? n.fancybox.stop(f.$slide) : (o = !1),
              f.$slide.siblings().trigger("onReset").remove(),
              i &&
                u.$refs.container
                  .removeClass("fancybox-is-open")
                  .addClass("fancybox-is-closing")
                  .css("transition-duration", i + "ms"),
              u.hideLoading(f),
              u.hideControls(!0),
              u.updateCursor(),
              "zoom" !== o ||
                (a &&
                  i &&
                  "image" === f.type &&
                  !u.isMoved() &&
                  !f.hasError &&
                  (l = u.getThumbPos(f))) ||
                (o = "fade"),
              "zoom" === o
                ? (n.fancybox.stop(a),
                  (s = n.fancybox.getTranslate(a)),
                  (c = {
                    top: s.top,
                    left: s.left,
                    scaleX: s.width / l.width,
                    scaleY: s.height / l.height,
                    width: l.width,
                    height: l.height,
                  }),
                  (r = f.opts.zoomOpacity),
                  "auto" == r &&
                    (r =
                      Math.abs(f.width / f.height - l.width / l.height) > 0.1),
                  r && (l.opacity = 0),
                  n.fancybox.setTranslate(a, c),
                  p(a),
                  n.fancybox.animate(a, l, i, h),
                  !0)
                : (o && i
                    ? n.fancybox.animate(
                        f.$slide
                          .addClass("fancybox-slide--previous")
                          .removeClass("fancybox-slide--current"),
                        "fancybox-animated fancybox-fx-" + o,
                        i,
                        h
                      )
                    : !0 === t
                    ? setTimeout(h, i)
                    : h(),
                  !0)))
        );
      },
      cleanUp: function (e) {
        var o,
          i,
          a,
          s = this,
          r = s.current.opts.$orig;
        s.current.$slide.trigger("onReset"),
          s.$refs.container.empty().remove(),
          s.trigger("afterClose", e),
          s.current.opts.backFocus &&
            ((r && r.length && r.is(":visible")) || (r = s.$trigger),
            r &&
              r.length &&
              ((i = t.scrollX),
              (a = t.scrollY),
              r.trigger("focus"),
              n("html, body").scrollTop(a).scrollLeft(i))),
          (s.current = null),
          (o = n.fancybox.getInstance()),
          o
            ? o.activate()
            : (n("body").removeClass(
                "fancybox-active compensate-for-scrollbar"
              ),
              n("#fancybox-style-noscroll").remove());
      },
      trigger: function (t, e) {
        var o,
          i = Array.prototype.slice.call(arguments, 1),
          a = this,
          s = e && e.opts ? e : a.current;
        if (
          (s ? i.unshift(s) : (s = a),
          i.unshift(a),
          n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)),
          !1 === o)
        )
          return o;
        "afterClose" !== t && a.$refs
          ? a.$refs.container.trigger(t + ".fb", i)
          : r.trigger(t + ".fb", i);
      },
      updateControls: function () {
        var t = this,
          o = t.current,
          i = o.index,
          a = t.$refs.container,
          s = t.$refs.caption,
          r = o.opts.caption;
        o.$slide.trigger("refresh"),
          r && r.length
            ? ((t.$caption = s), s.children().eq(0).html(r))
            : (t.$caption = null),
          t.hasHiddenControls || t.isIdle || t.showControls(),
          a.find("[data-fancybox-count]").html(t.group.length),
          a.find("[data-fancybox-index]").html(i + 1),
          a
            .find("[data-fancybox-prev]")
            .prop("disabled", !o.opts.loop && i <= 0),
          a
            .find("[data-fancybox-next]")
            .prop("disabled", !o.opts.loop && i >= t.group.length - 1),
          "image" === o.type
            ? a
                .find("[data-fancybox-zoom]")
                .show()
                .end()
                .find("[data-fancybox-download]")
                .attr("href", o.opts.image.src || o.src)
                .show()
            : o.opts.toolbar &&
              a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
          n(e.activeElement).is(":hidden,[disabled]") &&
            t.$refs.container.trigger("focus");
      },
      hideControls: function (t) {
        var e = this,
          n = ["infobar", "toolbar", "nav"];
        (!t && e.current.opts.preventCaptionOverlap) || n.push("caption"),
          this.$refs.container.removeClass(
            n
              .map(function (t) {
                return "fancybox-show-" + t;
              })
              .join(" ")
          ),
          (this.hasHiddenControls = !0);
      },
      showControls: function () {
        var t = this,
          e = t.current ? t.current.opts : t.opts,
          n = t.$refs.container;
        (t.hasHiddenControls = !1),
          (t.idleSecondsCounter = 0),
          n
            .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
            .toggleClass(
              "fancybox-show-infobar",
              !!(e.infobar && t.group.length > 1)
            )
            .toggleClass("fancybox-show-caption", !!t.$caption)
            .toggleClass(
              "fancybox-show-nav",
              !!(e.arrows && t.group.length > 1)
            )
            .toggleClass("fancybox-is-modal", !!e.modal);
      },
      toggleControls: function () {
        this.hasHiddenControls ? this.showControls() : this.hideControls();
      },
    }),
      (n.fancybox = {
        version: "3.5.7",
        defaults: a,
        getInstance: function (t) {
          var e = n(
              '.fancybox-container:not(".fancybox-is-closing"):last'
            ).data("FancyBox"),
            o = Array.prototype.slice.call(arguments, 1);
          return (
            e instanceof b &&
            ("string" === n.type(t)
              ? e[t].apply(e, o)
              : "function" === n.type(t) && t.apply(e, o),
            e)
          );
        },
        open: function (t, e, n) {
          return new b(t, e, n);
        },
        close: function (t) {
          var e = this.getInstance();
          e && (e.close(), !0 === t && this.close(t));
        },
        destroy: function () {
          this.close(!0), r.add("body").off("click.fb-start", "**");
        },
        isMobile:
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          ),
        use3d: (function () {
          var n = e.createElement("div");
          return (
            t.getComputedStyle &&
            t.getComputedStyle(n) &&
            t.getComputedStyle(n).getPropertyValue("transform") &&
            !(e.documentMode && e.documentMode < 11)
          );
        })(),
        getTranslate: function (t) {
          var e;
          return (
            !(!t || !t.length) &&
            ((e = t[0].getBoundingClientRect()),
            {
              top: e.top || 0,
              left: e.left || 0,
              width: e.width,
              height: e.height,
              opacity: parseFloat(t.css("opacity")),
            })
          );
        },
        setTranslate: function (t, e) {
          var n = "",
            o = {};
          if (t && e)
            return (
              (void 0 === e.left && void 0 === e.top) ||
                ((n =
                  (void 0 === e.left ? t.position().left : e.left) +
                  "px, " +
                  (void 0 === e.top ? t.position().top : e.top) +
                  "px"),
                (n = this.use3d
                  ? "translate3d(" + n + ", 0px)"
                  : "translate(" + n + ")")),
              void 0 !== e.scaleX && void 0 !== e.scaleY
                ? (n += " scale(" + e.scaleX + ", " + e.scaleY + ")")
                : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
              n.length && (o.transform = n),
              void 0 !== e.opacity && (o.opacity = e.opacity),
              void 0 !== e.width && (o.width = e.width),
              void 0 !== e.height && (o.height = e.height),
              t.css(o)
            );
        },
        animate: function (t, e, o, i, a) {
          var s,
            r = this;
          n.isFunction(o) && ((i = o), (o = null)),
            r.stop(t),
            (s = r.getTranslate(t)),
            t.on(f, function (c) {
              (!c ||
                !c.originalEvent ||
                (t.is(c.originalEvent.target) &&
                  "z-index" != c.originalEvent.propertyName)) &&
                (r.stop(t),
                n.isNumeric(o) && t.css("transition-duration", ""),
                n.isPlainObject(e)
                  ? void 0 !== e.scaleX &&
                    void 0 !== e.scaleY &&
                    r.setTranslate(t, {
                      top: e.top,
                      left: e.left,
                      width: s.width * e.scaleX,
                      height: s.height * e.scaleY,
                      scaleX: 1,
                      scaleY: 1,
                    })
                  : !0 !== a && t.removeClass(e),
                n.isFunction(i) && i(c));
            }),
            n.isNumeric(o) && t.css("transition-duration", o + "ms"),
            n.isPlainObject(e)
              ? (void 0 !== e.scaleX &&
                  void 0 !== e.scaleY &&
                  (delete e.width,
                  delete e.height,
                  t.parent().hasClass("fancybox-slide--image") &&
                    t.parent().addClass("fancybox-is-scaling")),
                n.fancybox.setTranslate(t, e))
              : t.addClass(e),
            t.data(
              "timer",
              setTimeout(function () {
                t.trigger(f);
              }, o + 33)
            );
        },
        stop: function (t, e) {
          t &&
            t.length &&
            (clearTimeout(t.data("timer")),
            e && t.trigger(f),
            t.off(f).css("transition-duration", ""),
            t.parent().removeClass("fancybox-is-scaling"));
        },
      }),
      (n.fn.fancybox = function (t) {
        var e;
        return (
          (t = t || {}),
          (e = t.selector || !1),
          e
            ? n("body")
                .off("click.fb-start", e)
                .on("click.fb-start", e, { options: t }, i)
            : this.off("click.fb-start").on(
                "click.fb-start",
                { items: this, options: t },
                i
              ),
          this
        );
      }),
      r.on("click.fb-start", "[data-fancybox]", i),
      r.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
        n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
          .eq(n(this).attr("data-fancybox-index") || 0)
          .trigger("click.fb-start", { $trigger: n(this) });
      }),
      (function () {
        var t = null;
        r.on("mousedown mouseup focus blur", ".fancybox-button", function (e) {
          switch (e.type) {
            case "mousedown":
              t = n(this);
              break;
            case "mouseup":
              t = null;
              break;
            case "focusin":
              n(".fancybox-button").removeClass("fancybox-focus"),
                n(this).is(t) ||
                  n(this).is("[disabled]") ||
                  n(this).addClass("fancybox-focus");
              break;
            case "focusout":
              n(".fancybox-button").removeClass("fancybox-focus");
          }
        });
      })();
  }
})(window, document, jQuery),
  (function (t) {
    "use strict";
    var e = {
        youtube: {
          matcher:
            /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
          params: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: "transparent",
            enablejsapi: 1,
            html5: 1,
          },
          paramPlace: 8,
          type: "iframe",
          url: "https://www.youtube-nocookie.com/embed/$4",
          thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
        },
        vimeo: {
          matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
          params: {
            autoplay: 1,
            hd: 1,
            show_title: 1,
            show_byline: 1,
            show_portrait: 0,
            fullscreen: 1,
          },
          paramPlace: 3,
          type: "iframe",
          url: "//player.vimeo.com/video/$2",
        },
        instagram: {
          matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
          type: "image",
          url: "//$1/p/$2/media/?size=l",
        },
        gmap_place: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/?ll=" +
              (t[9]
                ? t[9] +
                  "&z=" +
                  Math.floor(t[10]) +
                  (t[12] ? t[12].replace(/^\//, "&") : "")
                : t[12] + ""
              ).replace(/\?/, "&") +
              "&output=" +
              (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            );
          },
        },
        gmap_search: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/maps?q=" +
              t[5].replace("query=", "q=").replace("api=1", "") +
              "&output=embed"
            );
          },
        },
      },
      n = function (e, n, o) {
        if (e)
          return (
            (o = o || ""),
            "object" === t.type(o) && (o = t.param(o, !0)),
            t.each(n, function (t, n) {
              e = e.replace("$" + t, n || "");
            }),
            o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
            e
          );
      };
    t(document).on("objectNeedsType.fb", function (o, i, a) {
      var s,
        r,
        c,
        l,
        d,
        u,
        f,
        p = a.src || "",
        h = !1;
      (s = t.extend(!0, {}, e, a.opts.media)),
        t.each(s, function (e, o) {
          if ((c = p.match(o.matcher))) {
            if (
              ((h = o.type), (f = e), (u = {}), o.paramPlace && c[o.paramPlace])
            ) {
              (d = c[o.paramPlace]),
                "?" == d[0] && (d = d.substring(1)),
                (d = d.split("&"));
              for (var i = 0; i < d.length; ++i) {
                var s = d[i].split("=", 2);
                2 == s.length &&
                  (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
              }
            }
            return (
              (l = t.extend(!0, {}, o.params, a.opts[e], u)),
              (p =
                "function" === t.type(o.url)
                  ? o.url.call(this, c, l, a)
                  : n(o.url, c, l)),
              (r =
                "function" === t.type(o.thumb)
                  ? o.thumb.call(this, c, l, a)
                  : n(o.thumb, c)),
              "youtube" === e
                ? (p = p.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, o) {
                    return (
                      "&start=" +
                      ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10))
                    );
                  }))
                : "vimeo" === e && (p = p.replace("&%23", "#")),
              !1
            );
          }
        }),
        h
          ? (a.opts.thumb ||
              (a.opts.$thumb && a.opts.$thumb.length) ||
              (a.opts.thumb = r),
            "iframe" === h &&
              (a.opts = t.extend(!0, a.opts, {
                iframe: { preload: !1, attr: { scrolling: "no" } },
              })),
            t.extend(a, {
              type: h,
              src: p,
              origSrc: a.src,
              contentSource: f,
              contentType:
                "image" === h
                  ? "image"
                  : "gmap_place" == f || "gmap_search" == f
                  ? "map"
                  : "video",
            }))
          : p && (a.type = a.opts.defaultType);
    });
    var o = {
      youtube: {
        src: "https://www.youtube.com/iframe_api",
        class: "YT",
        loading: !1,
        loaded: !1,
      },
      vimeo: {
        src: "https://player.vimeo.com/api/player.js",
        class: "Vimeo",
        loading: !1,
        loaded: !1,
      },
      load: function (t) {
        var e,
          n = this;
        if (this[t].loaded)
          return void setTimeout(function () {
            n.done(t);
          });
        this[t].loading ||
          ((this[t].loading = !0),
          (e = document.createElement("script")),
          (e.type = "text/javascript"),
          (e.src = this[t].src),
          "youtube" === t
            ? (window.onYouTubeIframeAPIReady = function () {
                (n[t].loaded = !0), n.done(t);
              })
            : (e.onload = function () {
                (n[t].loaded = !0), n.done(t);
              }),
          document.body.appendChild(e));
      },
      done: function (e) {
        var n, o, i;
        "youtube" === e && delete window.onYouTubeIframeAPIReady,
          (n = t.fancybox.getInstance()) &&
            ((o = n.current.$content.find("iframe")),
            "youtube" === e && void 0 !== YT && YT
              ? (i = new YT.Player(o.attr("id"), {
                  events: {
                    onStateChange: function (t) {
                      0 == t.data && n.next();
                    },
                  },
                }))
              : "vimeo" === e &&
                void 0 !== Vimeo &&
                Vimeo &&
                ((i = new Vimeo.Player(o)),
                i.on("ended", function () {
                  n.next();
                })));
      },
    };
    t(document).on({
      "afterShow.fb": function (t, e, n) {
        e.group.length > 1 &&
          ("youtube" === n.contentSource || "vimeo" === n.contentSource) &&
          o.load(n.contentSource);
      },
    });
  })(jQuery),
  (function (t, e, n) {
    "use strict";
    var o = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      i = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      a = function (e) {
        var n = [];
        (e = e.originalEvent || e || t.e),
          (e =
            e.touches && e.touches.length
              ? e.touches
              : e.changedTouches && e.changedTouches.length
              ? e.changedTouches
              : [e]);
        for (var o in e)
          e[o].pageX
            ? n.push({ x: e[o].pageX, y: e[o].pageY })
            : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
        return n;
      },
      s = function (t, e, n) {
        return e && t
          ? "x" === n
            ? t.x - e.x
            : "y" === n
            ? t.y - e.y
            : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
          : 0;
      },
      r = function (t) {
        if (
          t.is(
            'a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe'
          ) ||
          n.isFunction(t.get(0).onclick) ||
          t.data("selectable")
        )
          return !0;
        for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++)
          if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
        return !1;
      },
      c = function (e) {
        var n = t.getComputedStyle(e)["overflow-y"],
          o = t.getComputedStyle(e)["overflow-x"],
          i =
            ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
          a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
        return i || a;
      },
      l = function (t) {
        for (var e = !1; ; ) {
          if ((e = c(t.get(0)))) break;
          if (
            ((t = t.parent()),
            !t.length || t.hasClass("fancybox-stage") || t.is("body"))
          )
            break;
        }
        return e;
      },
      d = function (t) {
        var e = this;
        (e.instance = t),
          (e.$bg = t.$refs.bg),
          (e.$stage = t.$refs.stage),
          (e.$container = t.$refs.container),
          e.destroy(),
          e.$container.on(
            "touchstart.fb.touch mousedown.fb.touch",
            n.proxy(e, "ontouchstart")
          );
      };
    (d.prototype.destroy = function () {
      var t = this;
      t.$container.off(".fb.touch"),
        n(e).off(".fb.touch"),
        t.requestId && (i(t.requestId), (t.requestId = null)),
        t.tapped && (clearTimeout(t.tapped), (t.tapped = null));
    }),
      (d.prototype.ontouchstart = function (o) {
        var i = this,
          c = n(o.target),
          d = i.instance,
          u = d.current,
          f = u.$slide,
          p = u.$content,
          h = "touchstart" == o.type;
        if (
          (h && i.$container.off("mousedown.fb.touch"),
          (!o.originalEvent || 2 != o.originalEvent.button) &&
            f.length &&
            c.length &&
            !r(c) &&
            !r(c.parent()) &&
            (c.is("img") ||
              !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left)))
        ) {
          if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated"))
            return o.stopPropagation(), void o.preventDefault();
          (i.realPoints = i.startPoints = a(o)),
            i.startPoints.length &&
              (u.touch && o.stopPropagation(),
              (i.startEvent = o),
              (i.canTap = !0),
              (i.$target = c),
              (i.$content = p),
              (i.opts = u.opts.touch),
              (i.isPanning = !1),
              (i.isSwiping = !1),
              (i.isZooming = !1),
              (i.isScrolling = !1),
              (i.canPan = d.canPan()),
              (i.startTime = new Date().getTime()),
              (i.distanceX = i.distanceY = i.distance = 0),
              (i.canvasWidth = Math.round(f[0].clientWidth)),
              (i.canvasHeight = Math.round(f[0].clientHeight)),
              (i.contentLastPos = null),
              (i.contentStartPos = n.fancybox.getTranslate(i.$content) || {
                top: 0,
                left: 0,
              }),
              (i.sliderStartPos = n.fancybox.getTranslate(f)),
              (i.stagePos = n.fancybox.getTranslate(d.$refs.stage)),
              (i.sliderStartPos.top -= i.stagePos.top),
              (i.sliderStartPos.left -= i.stagePos.left),
              (i.contentStartPos.top -= i.stagePos.top),
              (i.contentStartPos.left -= i.stagePos.left),
              n(e)
                .off(".fb.touch")
                .on(
                  h
                    ? "touchend.fb.touch touchcancel.fb.touch"
                    : "mouseup.fb.touch mouseleave.fb.touch",
                  n.proxy(i, "ontouchend")
                )
                .on(
                  h ? "touchmove.fb.touch" : "mousemove.fb.touch",
                  n.proxy(i, "ontouchmove")
                ),
              n.fancybox.isMobile &&
                e.addEventListener("scroll", i.onscroll, !0),
              (((i.opts || i.canPan) &&
                (c.is(i.$stage) || i.$stage.find(c).length)) ||
                (c.is(".fancybox-image") && o.preventDefault(),
                n.fancybox.isMobile &&
                  c.parents(".fancybox-caption").length)) &&
                ((i.isScrollable = l(c) || l(c.parent())),
                (n.fancybox.isMobile && i.isScrollable) || o.preventDefault(),
                (1 === i.startPoints.length || u.hasError) &&
                  (i.canPan
                    ? (n.fancybox.stop(i.$content), (i.isPanning = !0))
                    : (i.isSwiping = !0),
                  i.$container.addClass("fancybox-is-grabbing")),
                2 === i.startPoints.length &&
                  "image" === u.type &&
                  (u.isLoaded || u.$ghost) &&
                  ((i.canTap = !1),
                  (i.isSwiping = !1),
                  (i.isPanning = !1),
                  (i.isZooming = !0),
                  n.fancybox.stop(i.$content),
                  (i.centerPointStartX =
                    0.5 * (i.startPoints[0].x + i.startPoints[1].x) -
                    n(t).scrollLeft()),
                  (i.centerPointStartY =
                    0.5 * (i.startPoints[0].y + i.startPoints[1].y) -
                    n(t).scrollTop()),
                  (i.percentageOfImageAtPinchPointX =
                    (i.centerPointStartX - i.contentStartPos.left) /
                    i.contentStartPos.width),
                  (i.percentageOfImageAtPinchPointY =
                    (i.centerPointStartY - i.contentStartPos.top) /
                    i.contentStartPos.height),
                  (i.startDistanceBetweenFingers = s(
                    i.startPoints[0],
                    i.startPoints[1]
                  )))));
        }
      }),
      (d.prototype.onscroll = function (t) {
        var n = this;
        (n.isScrolling = !0), e.removeEventListener("scroll", n.onscroll, !0);
      }),
      (d.prototype.ontouchmove = function (t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons &&
          0 === t.originalEvent.buttons
          ? void e.ontouchend(t)
          : e.isScrolling
          ? void (e.canTap = !1)
          : ((e.newPoints = a(t)),
            void (
              (e.opts || e.canPan) &&
              e.newPoints.length &&
              e.newPoints.length &&
              ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
              (e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
              (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
              (e.distance = s(e.newPoints[0], e.startPoints[0])),
              e.distance > 0 &&
                (e.isSwiping
                  ? e.onSwipe(t)
                  : e.isPanning
                  ? e.onPan()
                  : e.isZooming && e.onZoom()))
            ));
      }),
      (d.prototype.onSwipe = function (e) {
        var a,
          s = this,
          r = s.instance,
          c = s.isSwiping,
          l = s.sliderStartPos.left || 0;
        if (!0 !== c)
          "x" == c &&
            (s.distanceX > 0 &&
            (s.instance.group.length < 2 ||
              (0 === s.instance.current.index && !s.instance.current.opts.loop))
              ? (l += Math.pow(s.distanceX, 0.8))
              : s.distanceX < 0 &&
                (s.instance.group.length < 2 ||
                  (s.instance.current.index === s.instance.group.length - 1 &&
                    !s.instance.current.opts.loop))
              ? (l -= Math.pow(-s.distanceX, 0.8))
              : (l += s.distanceX)),
            (s.sliderLastPos = {
              top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY,
              left: l,
            }),
            s.requestId && (i(s.requestId), (s.requestId = null)),
            (s.requestId = o(function () {
              s.sliderLastPos &&
                (n.each(s.instance.slides, function (t, e) {
                  var o = e.pos - s.instance.currPos;
                  n.fancybox.setTranslate(e.$slide, {
                    top: s.sliderLastPos.top,
                    left:
                      s.sliderLastPos.left +
                      o * s.canvasWidth +
                      o * e.opts.gutter,
                  });
                }),
                s.$container.addClass("fancybox-is-sliding"));
            }));
        else if (Math.abs(s.distance) > 10) {
          if (
            ((s.canTap = !1),
            r.group.length < 2 && s.opts.vertical
              ? (s.isSwiping = "y")
              : r.isDragging ||
                !1 === s.opts.vertical ||
                ("auto" === s.opts.vertical && n(t).width() > 800)
              ? (s.isSwiping = "x")
              : ((a = Math.abs(
                  (180 * Math.atan2(s.distanceY, s.distanceX)) / Math.PI
                )),
                (s.isSwiping = a > 45 && a < 135 ? "y" : "x")),
            "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
          )
            return void (s.isScrolling = !0);
          (r.isDragging = s.isSwiping),
            (s.startPoints = s.newPoints),
            n.each(r.slides, function (t, e) {
              var o, i;
              n.fancybox.stop(e.$slide),
                (o = n.fancybox.getTranslate(e.$slide)),
                (i = n.fancybox.getTranslate(r.$refs.stage)),
                e.$slide
                  .css({
                    transform: "",
                    opacity: "",
                    "transition-duration": "",
                  })
                  .removeClass("fancybox-animated")
                  .removeClass(function (t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                  }),
                e.pos === r.current.pos &&
                  ((s.sliderStartPos.top = o.top - i.top),
                  (s.sliderStartPos.left = o.left - i.left)),
                n.fancybox.setTranslate(e.$slide, {
                  top: o.top - i.top,
                  left: o.left - i.left,
                });
            }),
            r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop();
        }
      }),
      (d.prototype.onPan = function () {
        var t = this;
        if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5))
          return void (t.startPoints = t.newPoints);
        (t.canTap = !1),
          (t.contentLastPos = t.limitMovement()),
          t.requestId && i(t.requestId),
          (t.requestId = o(function () {
            n.fancybox.setTranslate(t.$content, t.contentLastPos);
          }));
      }),
      (d.prototype.limitMovement = function () {
        var t,
          e,
          n,
          o,
          i,
          a,
          s = this,
          r = s.canvasWidth,
          c = s.canvasHeight,
          l = s.distanceX,
          d = s.distanceY,
          u = s.contentStartPos,
          f = u.left,
          p = u.top,
          h = u.width,
          g = u.height;
        return (
          (i = h > r ? f + l : f),
          (a = p + d),
          (t = Math.max(0, 0.5 * r - 0.5 * h)),
          (e = Math.max(0, 0.5 * c - 0.5 * g)),
          (n = Math.min(r - h, 0.5 * r - 0.5 * h)),
          (o = Math.min(c - g, 0.5 * c - 0.5 * g)),
          l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, 0.8) || 0),
          l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, 0.8) || 0),
          d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, 0.8) || 0),
          d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, 0.8) || 0),
          { top: a, left: i }
        );
      }),
      (d.prototype.limitPosition = function (t, e, n, o) {
        var i = this,
          a = i.canvasWidth,
          s = i.canvasHeight;
        return (
          n > a
            ? ((t = t > 0 ? 0 : t), (t = t < a - n ? a - n : t))
            : (t = Math.max(0, a / 2 - n / 2)),
          o > s
            ? ((e = e > 0 ? 0 : e), (e = e < s - o ? s - o : e))
            : (e = Math.max(0, s / 2 - o / 2)),
          { top: e, left: t }
        );
      }),
      (d.prototype.onZoom = function () {
        var e = this,
          a = e.contentStartPos,
          r = a.width,
          c = a.height,
          l = a.left,
          d = a.top,
          u = s(e.newPoints[0], e.newPoints[1]),
          f = u / e.startDistanceBetweenFingers,
          p = Math.floor(r * f),
          h = Math.floor(c * f),
          g = (r - p) * e.percentageOfImageAtPinchPointX,
          b = (c - h) * e.percentageOfImageAtPinchPointY,
          m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
          v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
          y = m - e.centerPointStartX,
          x = v - e.centerPointStartY,
          w = l + (g + y),
          $ = d + (b + x),
          S = { top: $, left: w, scaleX: f, scaleY: f };
        (e.canTap = !1),
          (e.newWidth = p),
          (e.newHeight = h),
          (e.contentLastPos = S),
          e.requestId && i(e.requestId),
          (e.requestId = o(function () {
            n.fancybox.setTranslate(e.$content, e.contentLastPos);
          }));
      }),
      (d.prototype.ontouchend = function (t) {
        var o = this,
          s = o.isSwiping,
          r = o.isPanning,
          c = o.isZooming,
          l = o.isScrolling;
        if (
          ((o.endPoints = a(t)),
          (o.dMs = Math.max(new Date().getTime() - o.startTime, 1)),
          o.$container.removeClass("fancybox-is-grabbing"),
          n(e).off(".fb.touch"),
          e.removeEventListener("scroll", o.onscroll, !0),
          o.requestId && (i(o.requestId), (o.requestId = null)),
          (o.isSwiping = !1),
          (o.isPanning = !1),
          (o.isZooming = !1),
          (o.isScrolling = !1),
          (o.instance.isDragging = !1),
          o.canTap)
        )
          return o.onTap(t);
        (o.speed = 100),
          (o.velocityX = (o.distanceX / o.dMs) * 0.5),
          (o.velocityY = (o.distanceY / o.dMs) * 0.5),
          r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l);
      }),
      (d.prototype.endSwiping = function (t, e) {
        var o = this,
          i = !1,
          a = o.instance.group.length,
          s = Math.abs(o.distanceX),
          r = "x" == t && a > 1 && ((o.dMs > 130 && s > 10) || s > 50);
        (o.sliderLastPos = null),
          "y" == t && !e && Math.abs(o.distanceY) > 50
            ? (n.fancybox.animate(
                o.instance.current.$slide,
                {
                  top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY,
                  opacity: 0,
                },
                200
              ),
              (i = o.instance.close(!0, 250)))
            : r && o.distanceX > 0
            ? (i = o.instance.previous(300))
            : r && o.distanceX < 0 && (i = o.instance.next(300)),
          !1 !== i || ("x" != t && "y" != t) || o.instance.centerSlide(200),
          o.$container.removeClass("fancybox-is-sliding");
      }),
      (d.prototype.endPanning = function () {
        var t,
          e,
          o,
          i = this;
        i.contentLastPos &&
          (!1 === i.opts.momentum || i.dMs > 350
            ? ((t = i.contentLastPos.left), (e = i.contentLastPos.top))
            : ((t = i.contentLastPos.left + 500 * i.velocityX),
              (e = i.contentLastPos.top + 500 * i.velocityY)),
          (o = i.limitPosition(
            t,
            e,
            i.contentStartPos.width,
            i.contentStartPos.height
          )),
          (o.width = i.contentStartPos.width),
          (o.height = i.contentStartPos.height),
          n.fancybox.animate(i.$content, o, 366));
      }),
      (d.prototype.endZooming = function () {
        var t,
          e,
          o,
          i,
          a = this,
          s = a.instance.current,
          r = a.newWidth,
          c = a.newHeight;
        a.contentLastPos &&
          ((t = a.contentLastPos.left),
          (e = a.contentLastPos.top),
          (i = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }),
          n.fancybox.setTranslate(a.$content, i),
          r < a.canvasWidth && c < a.canvasHeight
            ? a.instance.scaleToFit(150)
            : r > s.width || c > s.height
            ? a.instance.scaleToActual(
                a.centerPointStartX,
                a.centerPointStartY,
                150
              )
            : ((o = a.limitPosition(t, e, r, c)),
              n.fancybox.animate(a.$content, o, 150)));
      }),
      (d.prototype.onTap = function (e) {
        var o,
          i = this,
          s = n(e.target),
          r = i.instance,
          c = r.current,
          l = (e && a(e)) || i.startPoints,
          d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0,
          u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0,
          f = function (t) {
            var o = c.opts[t];
            if ((n.isFunction(o) && (o = o.apply(r, [c, e])), o))
              switch (o) {
                case "close":
                  r.close(i.startEvent);
                  break;
                case "toggleControls":
                  r.toggleControls();
                  break;
                case "next":
                  r.next();
                  break;
                case "nextOrClose":
                  r.group.length > 1 ? r.next() : r.close(i.startEvent);
                  break;
                case "zoom":
                  "image" == c.type &&
                    (c.isLoaded || c.$ghost) &&
                    (r.canPan()
                      ? r.scaleToFit()
                      : r.isScaledDown()
                      ? r.scaleToActual(d, u)
                      : r.group.length < 2 && r.close(i.startEvent));
              }
          };
        if (
          (!e.originalEvent || 2 != e.originalEvent.button) &&
          (s.is("img") || !(d > s[0].clientWidth + s.offset().left))
        ) {
          if (
            s.is(
              ".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"
            )
          )
            o = "Outside";
          else if (s.is(".fancybox-slide")) o = "Slide";
          else {
            if (
              !r.current.$content ||
              !r.current.$content.find(s).addBack().filter(s).length
            )
              return;
            o = "Content";
          }
          if (i.tapped) {
            if (
              (clearTimeout(i.tapped),
              (i.tapped = null),
              Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50)
            )
              return this;
            f("dblclick" + o);
          } else
            (i.tapX = d),
              (i.tapY = u),
              c.opts["dblclick" + o] &&
              c.opts["dblclick" + o] !== c.opts["click" + o]
                ? (i.tapped = setTimeout(function () {
                    (i.tapped = null), r.isAnimating || f("click" + o);
                  }, 500))
                : f("click" + o);
          return this;
        }
      }),
      n(e)
        .on("onActivate.fb", function (t, e) {
          e && !e.Guestures && (e.Guestures = new d(e));
        })
        .on("beforeClose.fb", function (t, e) {
          e && e.Guestures && e.Guestures.destroy();
        });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        slideShow:
          '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
      },
      slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
    });
    var n = function (t) {
      (this.instance = t), this.init();
    };
    e.extend(n.prototype, {
      timer: null,
      isActive: !1,
      $button: null,
      init: function () {
        var t = this,
          n = t.instance,
          o = n.group[n.currIndex].opts.slideShow;
        (t.$button = n.$refs.toolbar
          .find("[data-fancybox-play]")
          .on("click", function () {
            t.toggle();
          })),
          n.group.length < 2 || !o
            ? t.$button.hide()
            : o.progress &&
              (t.$progress = e(
                '<div class="fancybox-progress"></div>'
              ).appendTo(n.$refs.inner));
      },
      set: function (t) {
        var n = this,
          o = n.instance,
          i = o.current;
        i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1)
          ? n.isActive &&
            "video" !== i.contentType &&
            (n.$progress &&
              e.fancybox.animate(
                n.$progress.show(),
                { scaleX: 1 },
                i.opts.slideShow.speed
              ),
            (n.timer = setTimeout(function () {
              o.current.opts.loop || o.current.index != o.group.length - 1
                ? o.next()
                : o.jumpTo(0);
            }, i.opts.slideShow.speed)))
          : (n.stop(), (o.idleSecondsCounter = 0), o.showControls());
      },
      clear: function () {
        var t = this;
        clearTimeout(t.timer),
          (t.timer = null),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      start: function () {
        var t = this,
          e = t.instance.current;
        e &&
          (t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP
            )
            .removeClass("fancybox-button--play")
            .addClass("fancybox-button--pause"),
          (t.isActive = !0),
          e.isComplete && t.set(!0),
          t.instance.trigger("onSlideShowChange", !0));
      },
      stop: function () {
        var t = this,
          e = t.instance.current;
        t.clear(),
          t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START
            )
            .removeClass("fancybox-button--pause")
            .addClass("fancybox-button--play"),
          (t.isActive = !1),
          t.instance.trigger("onSlideShowChange", !1),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      toggle: function () {
        var t = this;
        t.isActive ? t.stop() : t.start();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          e && !e.SlideShow && (e.SlideShow = new n(e));
        },
        "beforeShow.fb": function (t, e, n, o) {
          var i = e && e.SlideShow;
          o
            ? i && n.opts.slideShow.autoStart && i.start()
            : i && i.isActive && i.clear();
        },
        "afterShow.fb": function (t, e, n) {
          var o = e && e.SlideShow;
          o && o.isActive && o.set();
        },
        "afterKeydown.fb": function (n, o, i, a, s) {
          var r = o && o.SlideShow;
          !r ||
            !i.opts.slideShow ||
            (80 !== s && 32 !== s) ||
            e(t.activeElement).is("button,a,input") ||
            (a.preventDefault(), r.toggle());
        },
        "beforeClose.fb onDeactivate.fb": function (t, e) {
          var n = e && e.SlideShow;
          n && n.stop();
        },
      }),
      e(t).on("visibilitychange", function () {
        var n = e.fancybox.getInstance(),
          o = n && n.SlideShow;
        o && o.isActive && (t.hidden ? o.clear() : o.set());
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    var n = (function () {
      for (
        var e = [
            [
              "requestFullscreen",
              "exitFullscreen",
              "fullscreenElement",
              "fullscreenEnabled",
              "fullscreenchange",
              "fullscreenerror",
            ],
            [
              "webkitRequestFullscreen",
              "webkitExitFullscreen",
              "webkitFullscreenElement",
              "webkitFullscreenEnabled",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "webkitRequestFullScreen",
              "webkitCancelFullScreen",
              "webkitCurrentFullScreenElement",
              "webkitCancelFullScreen",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "mozRequestFullScreen",
              "mozCancelFullScreen",
              "mozFullScreenElement",
              "mozFullScreenEnabled",
              "mozfullscreenchange",
              "mozfullscreenerror",
            ],
            [
              "msRequestFullscreen",
              "msExitFullscreen",
              "msFullscreenElement",
              "msFullscreenEnabled",
              "MSFullscreenChange",
              "MSFullscreenError",
            ],
          ],
          n = {},
          o = 0;
        o < e.length;
        o++
      ) {
        var i = e[o];
        if (i && i[1] in t) {
          for (var a = 0; a < i.length; a++) n[e[0][a]] = i[a];
          return n;
        }
      }
      return !1;
    })();
    if (n) {
      var o = {
        request: function (e) {
          (e = e || t.documentElement),
            e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
        },
        exit: function () {
          t[n.exitFullscreen]();
        },
        toggle: function (e) {
          (e = e || t.documentElement),
            this.isFullscreen() ? this.exit() : this.request(e);
        },
        isFullscreen: function () {
          return Boolean(t[n.fullscreenElement]);
        },
        enabled: function () {
          return Boolean(t[n.fullscreenEnabled]);
        },
      };
      e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
          fullScreen:
            '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
        },
        fullScreen: { autoStart: !1 },
      }),
        e(t).on(n.fullscreenchange, function () {
          var t = o.isFullscreen(),
            n = e.fancybox.getInstance();
          n &&
            (n.current &&
              "image" === n.current.type &&
              n.isAnimating &&
              ((n.isAnimating = !1),
              n.update(!0, !0, 0),
              n.isComplete || n.complete()),
            n.trigger("onFullscreenChange", t),
            n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
            n.$refs.toolbar
              .find("[data-fancybox-fullscreen]")
              .toggleClass("fancybox-button--fsenter", !t)
              .toggleClass("fancybox-button--fsexit", t));
        });
    }
    e(t).on({
      "onInit.fb": function (t, e) {
        var i;
        if (!n)
          return void e.$refs.toolbar
            .find("[data-fancybox-fullscreen]")
            .remove();
        e && e.group[e.currIndex].opts.fullScreen
          ? ((i = e.$refs.container),
            i.on(
              "click.fb-fullscreen",
              "[data-fancybox-fullscreen]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), o.toggle();
              }
            ),
            e.opts.fullScreen &&
              !0 === e.opts.fullScreen.autoStart &&
              o.request(),
            (e.FullScreen = o))
          : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
      },
      "afterKeydown.fb": function (t, e, n, o, i) {
        e &&
          e.FullScreen &&
          70 === i &&
          (o.preventDefault(), e.FullScreen.toggle());
      },
      "beforeClose.fb": function (t, e) {
        e &&
          e.FullScreen &&
          e.$refs.container.hasClass("fancybox-is-fullscreen") &&
          o.exit();
      },
    });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    var n = "fancybox-thumbs";
    e.fancybox.defaults = e.extend(
      !0,
      {
        btnTpl: {
          thumbs:
            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
        },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
      },
      e.fancybox.defaults
    );
    var o = function (t) {
      this.init(t);
    };
    e.extend(o.prototype, {
      $button: null,
      $grid: null,
      $list: null,
      isVisible: !1,
      isActive: !1,
      init: function (t) {
        var e = this,
          n = t.group,
          o = 0;
        (e.instance = t),
          (e.opts = n[t.currIndex].opts.thumbs),
          (t.Thumbs = e),
          (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]"));
        for (
          var i = 0, a = n.length;
          i < a && (n[i].thumb && o++, !(o > 1));
          i++
        );
        o > 1 && e.opts
          ? (e.$button.removeAttr("style").on("click", function () {
              e.toggle();
            }),
            (e.isActive = !0))
          : e.$button.hide();
      },
      create: function () {
        var t,
          o = this,
          i = o.instance,
          a = o.opts.parentEl,
          s = [];
        o.$grid ||
          ((o.$grid = e(
            '<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>'
          ).appendTo(i.$refs.container.find(a).addBack().filter(a))),
          o.$grid.on("click", "a", function () {
            i.jumpTo(e(this).attr("data-index"));
          })),
          o.$list ||
            (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)),
          e.each(i.group, function (e, n) {
            (t = n.thumb),
              t || "image" !== n.type || (t = n.src),
              s.push(
                '<a href="javascript:;" tabindex="0" data-index="' +
                  e +
                  '"' +
                  (t && t.length
                    ? ' style="background-image:url(' + t + ')"'
                    : 'class="fancybox-thumbs-missing"') +
                  "></a>"
              );
          }),
          (o.$list[0].innerHTML = s.join("")),
          "x" === o.opts.axis &&
            o.$list.width(
              parseInt(o.$grid.css("padding-right"), 10) +
                i.group.length * o.$list.children().eq(0).outerWidth(!0)
            );
      },
      focus: function (t) {
        var e,
          n,
          o = this,
          i = o.$list,
          a = o.$grid;
        o.instance.current &&
          ((e = i
            .children()
            .removeClass("fancybox-thumbs-active")
            .filter('[data-index="' + o.instance.current.index + '"]')
            .addClass("fancybox-thumbs-active")),
          (n = e.position()),
          "y" === o.opts.axis &&
          (n.top < 0 || n.top > i.height() - e.outerHeight())
            ? i.stop().animate({ scrollTop: i.scrollTop() + n.top }, t)
            : "x" === o.opts.axis &&
              (n.left < a.scrollLeft() ||
                n.left > a.scrollLeft() + (a.width() - e.outerWidth())) &&
              i.parent().stop().animate({ scrollLeft: n.left }, t));
      },
      update: function () {
        var t = this;
        t.instance.$refs.container.toggleClass(
          "fancybox-show-thumbs",
          this.isVisible
        ),
          t.isVisible
            ? (t.$grid || t.create(),
              t.instance.trigger("onThumbsShow"),
              t.focus(0))
            : t.$grid && t.instance.trigger("onThumbsHide"),
          t.instance.update();
      },
      hide: function () {
        (this.isVisible = !1), this.update();
      },
      show: function () {
        (this.isVisible = !0), this.update();
      },
      toggle: function () {
        (this.isVisible = !this.isVisible), this.update();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          var n;
          e &&
            !e.Thumbs &&
            ((n = new o(e)), n.isActive && !0 === n.opts.autoStart && n.show());
        },
        "beforeShow.fb": function (t, e, n, o) {
          var i = e && e.Thumbs;
          i && i.isVisible && i.focus(o ? 0 : 250);
        },
        "afterKeydown.fb": function (t, e, n, o, i) {
          var a = e && e.Thumbs;
          a && a.isActive && 71 === i && (o.preventDefault(), a.toggle());
        },
        "beforeClose.fb": function (t, e) {
          var n = e && e.Thumbs;
          n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
        },
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    function n(t) {
      var e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;",
      };
      return String(t).replace(/[&<>"'`=\/]/g, function (t) {
        return e[t];
      });
    }
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        share:
          '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
      },
      share: {
        url: function (t, e) {
          return (
            (!t.currentHash &&
              "inline" !== e.type &&
              "html" !== e.type &&
              (e.origSrc || e.src)) ||
            window.location
          );
        },
        tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
      },
    }),
      e(t).on("click", "[data-fancybox-share]", function () {
        var t,
          o,
          i = e.fancybox.getInstance(),
          a = i.current || null;
        a &&
          ("function" === e.type(a.opts.share.url) &&
            (t = a.opts.share.url.apply(a, [i, a])),
          (o = a.opts.share.tpl
            .replace(
              /\{\{media\}\}/g,
              "image" === a.type ? encodeURIComponent(a.src) : ""
            )
            .replace(/\{\{url\}\}/g, encodeURIComponent(t))
            .replace(/\{\{url_raw\}\}/g, n(t))
            .replace(
              /\{\{descr\}\}/g,
              i.$caption ? encodeURIComponent(i.$caption.text()) : ""
            )),
          e.fancybox.open({
            src: i.translate(i, o),
            type: "html",
            opts: {
              touch: !1,
              animationEffect: !1,
              afterLoad: function (t, e) {
                i.$refs.container.one("beforeClose.fb", function () {
                  t.close(null, 0);
                }),
                  e.$content.find(".fancybox-share__button").click(function () {
                    return (
                      window.open(this.href, "Share", "width=550, height=450"),
                      !1
                    );
                  });
              },
              mobile: { autoFocus: !1 },
            },
          }));
      });
  })(document, jQuery),
  (function (t, e, n) {
    "use strict";
    function o() {
      var e = t.location.hash.substr(1),
        n = e.split("-"),
        o =
          n.length > 1 && /^\+?\d+$/.test(n[n.length - 1])
            ? parseInt(n.pop(-1), 10) || 1
            : 1,
        i = n.join("-");
      return { hash: e, index: o < 1 ? 1 : o, gallery: i };
    }
    function i(t) {
      "" !== t.gallery &&
        n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']")
          .eq(t.index - 1)
          .focus()
          .trigger("click.fb-start");
    }
    function a(t) {
      var e, n;
      return (
        !!t &&
        ((e = t.current ? t.current.opts : t.opts),
        "" !==
          (n =
            e.hash ||
            (e.$orig
              ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger")
              : "")) && n)
      );
    }
    n.escapeSelector ||
      (n.escapeSelector = function (t) {
        return (t + "").replace(
          /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
          function (t, e) {
            return e
              ? "\0" === t
                ? "�"
                : t.slice(0, -1) +
                  "\\" +
                  t.charCodeAt(t.length - 1).toString(16) +
                  " "
              : "\\" + t;
          }
        );
      }),
      n(function () {
        !1 !== n.fancybox.defaults.hash &&
          (n(e).on({
            "onInit.fb": function (t, e) {
              var n, i;
              !1 !== e.group[e.currIndex].opts.hash &&
                ((n = o()),
                (i = a(e)) &&
                  n.gallery &&
                  i == n.gallery &&
                  (e.currIndex = n.index - 1));
            },
            "beforeShow.fb": function (n, o, i, s) {
              var r;
              i &&
                !1 !== i.opts.hash &&
                (r = a(o)) &&
                ((o.currentHash =
                  r + (o.group.length > 1 ? "-" + (i.index + 1) : "")),
                t.location.hash !== "#" + o.currentHash &&
                  (s && !o.origHash && (o.origHash = t.location.hash),
                  o.hashTimer && clearTimeout(o.hashTimer),
                  (o.hashTimer = setTimeout(function () {
                    "replaceState" in t.history
                      ? (t.history[s ? "pushState" : "replaceState"](
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            "#" +
                            o.currentHash
                        ),
                        s && (o.hasCreatedHistory = !0))
                      : (t.location.hash = o.currentHash),
                      (o.hashTimer = null);
                  }, 300))));
            },
            "beforeClose.fb": function (n, o, i) {
              i &&
                !1 !== i.opts.hash &&
                (clearTimeout(o.hashTimer),
                o.currentHash && o.hasCreatedHistory
                  ? t.history.back()
                  : o.currentHash &&
                    ("replaceState" in t.history
                      ? t.history.replaceState(
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            (o.origHash || "")
                        )
                      : (t.location.hash = o.origHash)),
                (o.currentHash = null));
            },
          }),
          n(t).on("hashchange.fb", function () {
            var t = o(),
              e = null;
            n.each(n(".fancybox-container").get().reverse(), function (t, o) {
              var i = n(o).data("FancyBox");
              if (i && i.currentHash) return (e = i), !1;
            }),
              e
                ? e.currentHash === t.gallery + "-" + t.index ||
                  (1 === t.index && e.currentHash == t.gallery) ||
                  ((e.currentHash = null), e.close())
                : "" !== t.gallery && i(t);
          }),
          setTimeout(function () {
            n.fancybox.getInstance() || i(o());
          }, 50));
      });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";
    var n = new Date().getTime();
    e(t).on({
      "onInit.fb": function (t, e, o) {
        e.$refs.stage.on(
          "mousewheel DOMMouseScroll wheel MozMousePixelScroll",
          function (t) {
            var o = e.current,
              i = new Date().getTime();
            e.group.length < 2 ||
              !1 === o.opts.wheel ||
              ("auto" === o.opts.wheel && "image" !== o.type) ||
              (t.preventDefault(),
              t.stopPropagation(),
              o.$slide.hasClass("fancybox-animated") ||
                ((t = t.originalEvent || t),
                i - n < 250 ||
                  ((n = i),
                  e[
                    (-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0
                      ? "next"
                      : "previous"
                  ]())));
          }
        );
      },
    });
  })(document, jQuery);

// Generated by CoffeeScript 1.9.3
(function () {
  var e;
  (e = (function () {
    function e(e, t) {
      var n, r;
      this.options = {
        target: "instafeed",
        get: "popular",
        resolution: "thumbnail",
        sortBy: "none",
        links: !0,
        mock: !1,
        useHttp: !1,
      };
      if (typeof e == "object") for (n in e) (r = e[n]), (this.options[n] = r);
      (this.context = t != null ? t : this), (this.unique = this._genKey());
    }
    return (
      (e.prototype.hasNext = function () {
        return (
          typeof this.context.nextUrl == "string" &&
          this.context.nextUrl.length > 0
        );
      }),
      (e.prototype.next = function () {
        return this.hasNext() ? this.run(this.context.nextUrl) : !1;
      }),
      (e.prototype.run = function (t) {
        var n, r, i;
        if (
          typeof this.options.clientId != "string" &&
          typeof this.options.accessToken != "string"
        )
          throw new Error("Missing clientId or accessToken.");
        if (
          typeof this.options.accessToken != "string" &&
          typeof this.options.clientId != "string"
        )
          throw new Error("Missing clientId or accessToken.");
        return (
          this.options.before != null &&
            typeof this.options.before == "function" &&
            this.options.before.call(this),
          typeof document != "undefined" &&
            document !== null &&
            ((i = document.createElement("script")),
            (i.id = "instafeed-fetcher"),
            (i.src = t || this._buildUrl()),
            (n = document.getElementsByTagName("head")),
            n[0].appendChild(i),
            (r = "instafeedCache" + this.unique),
            (window[r] = new e(this.options, this)),
            (window[r].unique = this.unique)),
          !0
        );
      }),
      (e.prototype.parse = function (e) {
        var t,
          n,
          r,
          i,
          s,
          o,
          u,
          a,
          f,
          l,
          c,
          h,
          p,
          d,
          v,
          m,
          g,
          y,
          b,
          w,
          E,
          S,
          x,
          T,
          N,
          C,
          k,
          L,
          A,
          O,
          M,
          _,
          D;
        if (typeof e != "object") {
          if (
            this.options.error != null &&
            typeof this.options.error == "function"
          )
            return this.options.error.call(this, "Invalid JSON data"), !1;
          throw new Error("Invalid JSON response");
        }
        if (e.meta.code !== 200) {
          if (
            this.options.error != null &&
            typeof this.options.error == "function"
          )
            return this.options.error.call(this, e.meta.error_message), !1;
          throw new Error("Error from Instagram: " + e.meta.error_message);
        }
        if (e.data.length === 0) {
          if (
            this.options.error != null &&
            typeof this.options.error == "function"
          )
            return (
              this.options.error.call(
                this,
                "No images were returned from Instagram"
              ),
              !1
            );
          throw new Error("No images were returned from Instagram");
        }
        this.options.success != null &&
          typeof this.options.success == "function" &&
          this.options.success.call(this, e),
          (this.context.nextUrl = ""),
          e.pagination != null &&
            (this.context.nextUrl = e.pagination.next_url);
        if (this.options.sortBy !== "none") {
          this.options.sortBy === "random"
            ? (M = ["", "random"])
            : (M = this.options.sortBy.split("-")),
            (O = M[0] === "least" ? !0 : !1);
          switch (M[1]) {
            case "random":
              e.data.sort(function () {
                return 0.5 - Math.random();
              });
              break;
            case "recent":
              e.data = this._sortBy(e.data, "created_time", O);
              break;
            case "liked":
              e.data = this._sortBy(e.data, "likes.count", O);
              break;
            case "commented":
              e.data = this._sortBy(e.data, "comments.count", O);
              break;
            default:
              throw new Error(
                "Invalid option for sortBy: '" + this.options.sortBy + "'."
              );
          }
        }
        if (
          typeof document != "undefined" &&
          document !== null &&
          this.options.mock === !1
        ) {
          (m = e.data),
            (A = parseInt(this.options.limit, 10)),
            this.options.limit != null && m.length > A && (m = m.slice(0, A)),
            (u = document.createDocumentFragment()),
            this.options.filter != null &&
              typeof this.options.filter == "function" &&
              (m = this._filter(m, this.options.filter));
          if (
            this.options.template != null &&
            typeof this.options.template == "string"
          ) {
            (f = ""), (d = ""), (w = ""), (D = document.createElement("div"));
            for (c = 0, N = m.length; c < N; c++) {
              (h = m[c]), (p = h.images[this.options.resolution]);
              if (typeof p != "object")
                throw (
                  ((o =
                    "No image found for resolution: " +
                    this.options.resolution +
                    "."),
                  new Error(o))
                );
              (E = p.width),
                (y = p.height),
                (b = "square"),
                E > y && (b = "landscape"),
                E < y && (b = "portrait"),
                (v = p.url),
                (l = window.location.protocol.indexOf("http") >= 0),
                l &&
                  !this.options.useHttp &&
                  (v = v.replace(/https?:\/\//, "//")),
                (d = this._makeTemplate(this.options.template, {
                  model: h,
                  id: h.id,
                  link: h.link,
                  type: h.type,
                  image: v,
                  width: E,
                  height: y,
                  orientation: b,
                  caption: this._getObjectProperty(h, "caption.text"),
                  likes: h.likes.count,
                  comments: h.comments.count,
                  location: this._getObjectProperty(h, "location.name"),
                })),
                (f += d);
            }
            (D.innerHTML = f), (i = []), (r = 0), (n = D.childNodes.length);
            while (r < n) i.push(D.childNodes[r]), (r += 1);
            for (x = 0, C = i.length; x < C; x++) (L = i[x]), u.appendChild(L);
          } else
            for (T = 0, k = m.length; T < k; T++) {
              (h = m[T]),
                (g = document.createElement("img")),
                (p = h.images[this.options.resolution]);
              if (typeof p != "object")
                throw (
                  ((o =
                    "No image found for resolution: " +
                    this.options.resolution +
                    "."),
                  new Error(o))
                );
              (v = p.url),
                (l = window.location.protocol.indexOf("http") >= 0),
                l &&
                  !this.options.useHttp &&
                  (v = v.replace(/https?:\/\//, "//")),
                (g.src = v),
                this.options.links === !0
                  ? ((t = document.createElement("a")),
                    (t.href = h.link),
                    t.appendChild(g),
                    u.appendChild(t))
                  : u.appendChild(g);
            }
          (_ = this.options.target),
            typeof _ == "string" && (_ = document.getElementById(_));
          if (_ == null)
            throw (
              ((o =
                'No element with id="' + this.options.target + '" on page.'),
              new Error(o))
            );
          _.appendChild(u),
            (a = document.getElementsByTagName("head")[0]),
            a.removeChild(document.getElementById("instafeed-fetcher")),
            (S = "instafeedCache" + this.unique),
            (window[S] = void 0);
          try {
            delete window[S];
          } catch (P) {
            s = P;
          }
        }
        return (
          this.options.after != null &&
            typeof this.options.after == "function" &&
            this.options.after.call(this),
          !0
        );
      }),
      (e.prototype._buildUrl = function () {
        var e, t, n;
        e = "https://api.instagram.com/v1";
        switch (this.options.get) {
          case "popular":
            t = "media/popular";
            break;
          case "tagged":
            if (!this.options.tagName)
              throw new Error(
                "No tag name specified. Use the 'tagName' option."
              );
            t = "tags/" + this.options.tagName + "/media/recent";
            break;
          case "location":
            if (!this.options.locationId)
              throw new Error(
                "No location specified. Use the 'locationId' option."
              );
            t = "locations/" + this.options.locationId + "/media/recent";
            break;
          case "user":
            if (!this.options.userId)
              throw new Error("No user specified. Use the 'userId' option.");
            t = "users/" + this.options.userId + "/media/recent";
            break;
          default:
            throw new Error(
              "Invalid option for get: '" + this.options.get + "'."
            );
        }
        return (
          (n = e + "/" + t),
          this.options.accessToken != null
            ? (n += "?access_token=" + this.options.accessToken)
            : (n += "?client_id=" + this.options.clientId),
          this.options.limit != null && (n += "&count=" + this.options.limit),
          (n += "&callback=instafeedCache" + this.unique + ".parse"),
          n
        );
      }),
      (e.prototype._genKey = function () {
        var e;
        return (
          (e = function () {
            return (((1 + Math.random()) * 65536) | 0)
              .toString(16)
              .substring(1);
          }),
          "" + e() + e() + e() + e()
        );
      }),
      (e.prototype._makeTemplate = function (e, t) {
        var n, r, i, s, o;
        (r = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/), (n = e);
        while (r.test(n))
          (s = n.match(r)[1]),
            (o = (i = this._getObjectProperty(t, s)) != null ? i : ""),
            (n = n.replace(r, function () {
              return "" + o;
            }));
        return n;
      }),
      (e.prototype._getObjectProperty = function (e, t) {
        var n, r;
        (t = t.replace(/\[(\w+)\]/g, ".$1")), (r = t.split("."));
        while (r.length) {
          n = r.shift();
          if (!(e != null && n in e)) return null;
          e = e[n];
        }
        return e;
      }),
      (e.prototype._sortBy = function (e, t, n) {
        var r;
        return (
          (r = function (e, r) {
            var i, s;
            return (
              (i = this._getObjectProperty(e, t)),
              (s = this._getObjectProperty(r, t)),
              n ? (i > s ? 1 : -1) : i < s ? 1 : -1
            );
          }),
          e.sort(r.bind(this)),
          e
        );
      }),
      (e.prototype._filter = function (e, t) {
        var n, r, i, s, o;
        (n = []),
          (r = function (e) {
            if (t(e)) return n.push(e);
          });
        for (i = 0, o = e.length; i < o; i++) (s = e[i]), r(s);
        return n;
      }),
      e
    );
  })()),
    (function (e, t) {
      return typeof define == "function" && define.amd
        ? define([], t)
        : typeof module == "object" && module.exports
        ? (module.exports = t())
        : (e.Instafeed = t());
    })(this, function () {
      return e;
    });
}).call(this);
